/* ============================================================
   CRÉATION D'UNE RESSOURCE LAÉ
   ------------------------------------------------------------
   Un outil de mise en page : le confort de Word, la liberté de
   Canva, et un gabarit Laé qui reste toujours propre.

   Le principe à retenir :
     • une ressource contient TROIS niveaux (1, 2, 3) ;
     • chaque niveau est une suite de pages ;
     • la version Prof, c'est la même page que la version Élève,
       plus les éléments marqués « corrigé ». Il n'y a donc jamais
       deux mises en page à tenir à jour.

   Les positions sont en millimètres, les tailles de texte en
   points : exactement les unités du papier. Ce qui est à l'écran
   est donc ce qui sort de l'imprimante, sans conversion.
   ============================================================ */
/* Docs Laé : fonctions globales */

/* ---------- raccourcis ---------- */
function $(s,r){return (r||document).querySelector(s);}
function $$(s,r){return [].slice.call((r||document).querySelectorAll(s));}
function esc(t){return String(t==null?'':t).replace(/&/g,'&amp;').replace(/</g,'&lt;')
  .replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function uid(p){return (p||'e')+Math.random().toString(36).slice(2,9);}
function clone(o){return JSON.parse(JSON.stringify(o));}
function borne(v,a,b){return Math.max(a,Math.min(b,v));}
function arrondi(v,p){p=p||10;return Math.round(v*p)/p;}
function poigneeDe(t){
  return String(t||'ressource').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'')
    .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,60)||'ressource';
}

/* ---------- le papier ----------
   Chaque page a SON format : on peut mélanger A4 portrait et A3
   paysage dans la même ressource, comme dans Word.                */
var FORMATS={a4:[210,297], a3:[297,420]};
var MARGE=14, HAUT=48, BAS=28;       /* marges, en-tête, pied (mm) */

function fmtDe(p){var f=(p&&p.f)||{};return {t:f.t||'a4',o:f.o||'portrait'};}
function dimDe(p){
  var f=fmtDe(p), d=FORMATS[f.t]||FORMATS.a4;
  return f.o==='paysage'?[d[1],d[0]]:[d[0],d[1]];
}
function PL(p){return dimDe(p||pageCourante())[0];}
function PH(p){return dimDe(p||pageCourante())[1];}
function larg(p){return PL(p)-2*MARGE;}

/* ---------- la palette : celle de ressourceslae.com ----------
   Première rangée : les pastels, pour les fonds.
   Deuxième rangée : les couleurs franches, pour les traits.       */
var TEINTES=['#ffe1ea','#ffe8d6','#fdf8cf','#dff3e7','#cfe6fb','#ece8fb','#fdf0eb','#ffffff',
             '#f0265c','#fa5a3c','#ff8a3d','#1c5b4a','#2f80c8','#6e5fd8','#14142b','#8b8299'];

/* ---------- le classement du tableau de bord ---------- */
var MATIERES=['Mathématiques','Français','Éveil','Sciences','Histoire','Géographie',
              'Anglais','Néerlandais','Arts','Éducation physique','Religion / Morale','Autre'];
/* ---------- le programme du site ----------
   Les mêmes matières et les mêmes sujets que ressourceslae.com
   (recherche de la page d'accueil, sections/lae-hero-search.liquid).
   Le sujet choisi devient l'étiquette domaine_… de la boutique :
   en le prenant dans cette liste, il s'écrit toujours pareil.     */
var PROGRAMME=(function(){
  var LA1=["Compréhension orale","Expression orale","Vocabulaire","Prononciation","Culture"];
  var LA2=["Compréhension orale","Expression orale","Lecture","Écriture","Vocabulaire","Culture"];
  var LA3=["Compréhension orale","Expression orale","Lecture","Écriture","Vocabulaire","Grammaire","Culture"];
  var LA4=["Compréhension orale","Expression orale","Interaction","Lecture","Écriture","Vocabulaire","Grammaire","Culture"];
  var LA5=["Compréhension orale","Expression orale","Interaction","Lecture","Écriture","Grammaire","Culture","Argumentation"];
  var LA6=LA5.concat(["Examens"]);
  function LGG(L){return [["Anglais",L],["Néerlandais",L],["Allemand",L],["Espagnol",L]];}
  return {
  "P1":[["Mathématiques",["Nombres","Calcul","Problèmes","Géométrie","Mesures","Données"]],["Français",["Lecture","Compréhension","Écriture","Langage oral","Vocabulaire","Grammaire","Orthographe"]],["Anglais",LA1],["Néerlandais",LA1],["Éveil / Sciences",["Animaux et végétaux","Corps humain","Matière et objets","Eau et air","Saisons","Environnement"]],["Géographie",["Repérage","École et quartier","Plans","Paysages","Habitat"]],["Histoire",["Repères temporels","Passé et présent","Histoire familiale","Vie quotidienne"]],["Art et bricolage",["Dessin","Peinture","Collage","Bricolage","Modelage","Fêtes et saisons","Artistes"]],["Activités autonomes",["Coloriages magiques","Mots mêlés","Mots croisés","Labyrinthes","Énigmes","Défis logiques","Jeux de calcul","Lecture plaisir"]]],
  "P2":[["Mathématiques",["Nombres","Calcul","Problèmes","Fractions","Géométrie","Mesures","Données"]],["Français",["Lecture","Fluidité","Compréhension","Écriture","Production écrite","Vocabulaire","Grammaire","Conjugaison","Orthographe"]],["Anglais",LA2],["Néerlandais",LA2],["Éveil / Sciences",["Animaux et végétaux","Cycles de vie","Corps humain","Matière","Eau et air","Lumière et son","Environnement"]],["Géographie",["Orientation","Quartier","Plans","Paysages","Ville et campagne"]],["Histoire",["Chronologie","Générations","Vie quotidienne","Objets d'hier","Patrimoine"]],["Art et bricolage",["Dessin","Peinture","Collage","Bricolage","Modelage","Fêtes et saisons","Artistes"]],["Activités autonomes",["Coloriages magiques","Mots mêlés","Mots croisés","Labyrinthes","Énigmes","Défis logiques","Jeux de calcul","Lecture plaisir"]]],
  "P3":[["Mathématiques",["Nombres","Calcul","Problèmes","Fractions","Décimaux","Géométrie","Mesures","Données"]],["Français",["Lecture","Compréhension","Production écrite","Langage oral","Vocabulaire","Grammaire","Conjugaison","Orthographe","Littérature"]],["Anglais",LA3],["Néerlandais",LA3],["Éveil / Sciences",["Monde vivant","Corps humain","Matière","Énergie","Électricité","Terre et espace","Environnement"]],["Géographie",["Cartes et plans","Orientation","Paysages","Relief","Population","Activités humaines"]],["Histoire",["Préhistoire","Civilisations","Histoire nationale","Inventions","Patrimoine"]],["Art et bricolage",["Dessin","Peinture","Collage","Bricolage","Modelage","Fêtes et saisons","Artistes"]],["Activités autonomes",["Coloriages magiques","Mots mêlés","Mots croisés","Labyrinthes","Énigmes","Défis logiques","Jeux de calcul","Lecture plaisir"]]],
  "P4":[["Mathématiques",["Nombres","Calcul","Problèmes","Fractions et décimaux","Proportionnalité","Géométrie","Mesures","Statistiques"]],["Français",["Lecture","Compréhension","Production écrite","Langage oral","Vocabulaire","Grammaire","Conjugaison","Orthographe","Littérature"]],["Anglais",LA4],["Néerlandais",LA4],["Éveil / Sciences",["Monde vivant","Biodiversité","Corps humain","Matière","Énergie","Électricité","Forces","Terre et espace"]],["Géographie",["Cartographie","Relief","Climat","Population","Villes et campagnes","Économie"]],["Histoire",["Préhistoire","Antiquité","Moyen Âge","Histoire nationale","Pouvoirs et sociétés","Patrimoine"]],["Art et bricolage",["Dessin","Peinture","Collage","Bricolage","Modelage","Fêtes et saisons","Artistes"]],["Activités autonomes",["Coloriages magiques","Mots mêlés","Mots croisés","Labyrinthes","Énigmes","Défis logiques","Jeux de calcul","Lecture plaisir"]]],
  "P5":[["Mathématiques",["Nombres","Calcul","Problèmes","Fractions et décimaux","Pourcentages","Proportionnalité","Géométrie","Statistiques"]],["Français",["Lecture","Compréhension","Production écrite","Langage oral","Grammaire","Conjugaison","Orthographe","Littérature","Argumentation"]],["Anglais",LA4],["Néerlandais",LA4],["Éveil / Sciences",["Corps humain","Écosystèmes","Biodiversité","Matière","Énergie","Électricité","Forces","Terre et espace","Climat"]],["Géographie",["Continents et pays","Migrations","Relief et climats","Économie","Transports","Ressources"]],["Histoire",["Moyen Âge","Temps modernes","Renaissance","Explorations","Révolutions","Industrialisation","Histoire nationale"]],["Art et bricolage",["Dessin","Peinture","Collage","Bricolage","Modelage","Fêtes et saisons","Artistes"]],["Activités autonomes",["Coloriages magiques","Mots mêlés","Mots croisés","Labyrinthes","Énigmes","Défis logiques","Jeux de calcul","Lecture plaisir"]]],
  "P6":[["Mathématiques",["Nombres","Calcul","Problèmes","Fractions et décimaux","Pourcentages","Proportionnalité","Algèbre","Géométrie","Statistiques"]],["Français",["Lecture","Compréhension","Production écrite","Langage oral","Grammaire","Conjugaison","Orthographe","Littérature","Argumentation","Synthèse"]],["Anglais",LA4],["Néerlandais",LA4],["Éveil / Sciences",["Cellules","Corps humain","Reproduction","Écosystèmes","Matière","Énergie","Électricité","Terre et espace","Climat"]],["Géographie",["Monde","Migrations","Urbanisation","Mondialisation","Ressources","Risques","Climat"]],["Histoire",["Temps modernes","Révolutions","Industrialisation","Colonisation","Guerres mondiales","Époque contemporaine"]],["Art et bricolage",["Dessin","Peinture","Collage","Bricolage","Modelage","Fêtes et saisons","Artistes"]],["Activités autonomes",["Coloriages magiques","Mots mêlés","Mots croisés","Labyrinthes","Énigmes","Défis logiques","Jeux de calcul","Lecture plaisir"]]],
  "S1":[["Mathématiques",["Nombres","Calcul","Fractions et décimaux","Algèbre","Proportionnalité","Géométrie","Statistiques","Problèmes"]],["Français",["Lecture","Compréhension","Écriture","Expression orale","Grammaire","Conjugaison","Orthographe","Littérature"]],["Anglais",LA4],["Néerlandais",LA4],["Sciences",["Biologie","Corps humain","Matière","Forces et mouvement","Énergie","Électricité","Terre et espace","Environnement"]],["Histoire",["Préhistoire","Antiquité","Moyen Âge","Histoire nationale","Histoire mondiale","Pouvoirs et sociétés"]],["Géographie",["Cartographie","Milieux naturels","Climat","Population","Urbanisation","Ressources","Activités humaines"]],["Latin",["Vocabulaire","Déclinaisons","Conjugaison","Traduction","Mythologie","Civilisation romaine"]],["Éducation artistique",["Arts plastiques","Musique","Théâtre","Danse","Histoire de l'art","Photo et vidéo"]],["Éducation physique",["Jeux collectifs","Athlétisme","Gymnastique","Natation","Santé et hygiène de vie","Fair-play"]],["Philosophie et citoyenneté",["Questionner","Argumenter","Débattre","Émotions","Vivre ensemble","Droits et devoirs","Démocratie"]],["Informatique",["Algorithmique","Programmation","Données","Tableur","Web","Réseaux","Cybersécurité"]]],
  "S2":[["Mathématiques",["Nombres rationnels","Calcul","Algèbre","Équations","Fonctions","Géométrie","Statistiques","Probabilités"]],["Français",["Lecture","Compréhension","Écriture","Expression orale","Grammaire","Conjugaison","Orthographe","Littérature","Argumentation"]],["Anglais",LA4],["Néerlandais",LA4],["Sciences",["Biologie","Corps humain","Écologie","Atomes et molécules","Forces","Énergie","Électricité","Ondes"]],["Histoire",["Moyen Âge","Renaissance","Explorations","Colonisation","Lumières","Révolutions","Histoire nationale"]],["Géographie",["Population","Migrations","Urbanisation","Développement","Économie","Climat","Risques naturels"]],["Latin",["Vocabulaire","Déclinaisons","Conjugaison","Traduction","Mythologie","Civilisation romaine"]],["Éducation artistique",["Arts plastiques","Musique","Théâtre","Danse","Histoire de l'art","Photo et vidéo"]],["Éducation physique",["Jeux collectifs","Athlétisme","Gymnastique","Natation","Santé et hygiène de vie","Fair-play"]],["Philosophie et citoyenneté",["Questionner","Argumenter","Débattre","Émotions","Vivre ensemble","Droits et devoirs","Démocratie"]],["Informatique",["Algorithmique","Programmation","Données","Tableur","Web","Réseaux","Cybersécurité"]]],
  "S3":[["Mathématiques",["Calcul","Algèbre","Équations","Fonctions","Géométrie","Trigonométrie","Statistiques","Probabilités"]],["Français",["Lecture","Analyse de texte","Écriture","Expression orale","Grammaire","Orthographe","Littérature","Argumentation","Synthèse"]],["Anglais",LA4],["Néerlandais",LA4],["Sciences",["Cellules","Corps humain","Génétique","Écologie","Atomes et molécules","Réactions chimiques","Forces et mouvement","Énergie","Électricité","Lumière et son"]],["Histoire",["Révolutions","Industrialisation","Colonisation","Guerres mondiales","Histoire nationale","Histoire mondiale"]],["Géographie",["Population","Migrations","Urbanisation","Mondialisation","Développement","Climat","Énergie","Ressources"]],["Latin",["Vocabulaire","Déclinaisons","Conjugaison","Traduction","Mythologie","Civilisation romaine"]],["Éducation artistique",["Arts plastiques","Musique","Théâtre","Danse","Histoire de l'art","Photo et vidéo"]],["Éducation physique",["Jeux collectifs","Athlétisme","Gymnastique","Natation","Santé et hygiène de vie","Fair-play"]],["Philosophie et citoyenneté",["Questionner","Argumenter","Débattre","Émotions","Vivre ensemble","Droits et devoirs","Démocratie"]],["Informatique",["Algorithmique","Programmation","Données","Tableur","Web","Réseaux","Cybersécurité"]]],
  "S4":[["Mathématiques",["Algèbre","Équations","Fonctions","Géométrie","Trigonométrie","Vecteurs","Statistiques","Probabilités"]],["Français",["Expression écrite","Expression orale","Grammaire","Orthographe","Vocabulaire","Argumentation","Synthèse","Analyse littéraire","Roman","Nouvelle","Poésie","Théâtre","Figures de style","Histoire littéraire"]],["Anglais",LA4],["Néerlandais",LA4],["Biologie",["Cellules","Génétique","Reproduction","Anatomie","Évolution","Écologie","Biodiversité"]],["Chimie",["Structure de la matière","Tableau périodique","Liaisons","Réactions","Solutions","Concentrations","Acides et bases"]],["Physique",["Mécanique","Forces","Énergie","Travail et puissance","Électricité","Ondes","Optique","Thermique"]],["Histoire",["Renaissance","Explorations","Colonisation","Lumières","Révolutions","Industrialisation","Histoire nationale"]],["Géographie",["Population","Migrations","Urbanisation","Mondialisation","Développement","Ressources","Climat","Géopolitique"]],["Éducation physique",["Jeux collectifs","Athlétisme","Gymnastique","Natation","Santé et hygiène de vie","Fair-play"]],["Philosophie et citoyenneté",["Conscience","Vérité","Liberté","Responsabilité","Bonheur","Morale","Justice","Politique","Citoyenneté","Démocratie"]],["Sciences économiques",["Consommation","Production","Entreprise","Marchés","Travail et emploi","Monnaie","Inégalités"]],["Sciences sociales",["Sociologie","Psychologie","Méthodes d'enquête","Groupes et institutions","Médias","Inégalités","Citoyenneté"]],["Latin",["Vocabulaire","Grammaire","Traduction","Auteurs latins","Mythologie","Civilisation romaine","Étymologie"]],["Grec",["Alphabet","Vocabulaire","Grammaire","Traduction","Mythologie","Civilisation grecque","Étymologie"]],["Allemand",LA4],["Espagnol",LA4],["Italien",LA4],["Informatique",["Algorithmique","Programmation","Données","Bases de données","Web","Réseaux","Cybersécurité"]],["Éducation artistique",["Arts plastiques","Musique","Théâtre","Danse","Histoire de l'art","Photo et vidéo"]]],
  "S5":[["Mathématiques",["Algèbre","Fonctions","Suites","Dérivation","Trigonométrie","Géométrie analytique","Statistiques","Probabilités"]],["Français",["Expression écrite","Expression orale","Argumentation","Dissertation","Commentaire","Résumé","Synthèse","Analyse littéraire","Roman","Poésie","Théâtre","Essai","Mouvements littéraires","Littérature francophone"]],["Anglais",LA5],["Néerlandais",LA5],["Biologie",["Cellules","Biochimie","Métabolisme","Génétique","Anatomie","Évolution","Écologie"]],["Chimie",["Réactions","Stœchiométrie","Thermochimie","Cinétique","Équilibres","Acides et bases","Chimie organique"]],["Physique",["Mécanique","Mouvement","Forces","Énergie","Électricité","Magnétisme","Ondes","Optique"]],["Histoire",["Industrialisation","Nationalismes","Colonisation","1re Guerre mondiale","Totalitarismes","2de Guerre mondiale"]],["Géographie",["Mondialisation","Population","Migrations","Métropolisation","Développement","Commerce","Énergie","Climat"]],["Éducation physique",["Jeux collectifs","Athlétisme","Gymnastique","Natation","Santé et hygiène de vie","Fair-play"]],["Philosophie et citoyenneté",["Conscience","Vérité","Liberté","Responsabilité","Bonheur","Morale","Justice","Politique","Citoyenneté","Démocratie"]],["Sciences économiques",["Marchés","Entreprise","Travail et emploi","Monnaie","Inflation","Croissance","État","Inégalités"]],["Sciences sociales",["Sociologie","Psychologie","Méthodes d'enquête","Groupes et institutions","Médias","Inégalités","Citoyenneté"]],["Latin",["Vocabulaire","Grammaire","Traduction","Auteurs latins","Mythologie","Civilisation romaine","Étymologie"]],["Grec",["Alphabet","Vocabulaire","Grammaire","Traduction","Mythologie","Civilisation grecque","Étymologie"]],["Allemand",LA5],["Espagnol",LA5],["Italien",LA5],["Informatique",["Algorithmique","Programmation","Structures de données","Bases de données","Web","Réseaux","Cybersécurité","Intelligence artificielle"]],["Éducation artistique",["Arts plastiques","Musique","Théâtre","Danse","Histoire de l'art","Photo et vidéo"]]],
  "S6":[["Mathématiques",["Algèbre","Fonctions","Suites","Limites","Dérivation","Intégration","Géométrie analytique","Statistiques","Probabilités"]],["Français",["Expression écrite","Expression orale","Argumentation","Dissertation","Commentaire","Résumé","Synthèse","Examens","Analyse littéraire","Roman","Poésie","Théâtre","Essai","Mouvements littéraires","Littérature francophone","Littérature comparée"]],["Anglais",LA6],["Néerlandais",LA6],["Biologie",["Cellules","Biochimie","Génétique","Anatomie","Immunologie","Évolution","Écologie","Biotechnologies"]],["Chimie",["Réactions","Thermochimie","Cinétique","Équilibres","Acides et bases","Oxydoréduction","Chimie organique"]],["Physique",["Mécanique","Gravitation","Énergie","Électricité","Magnétisme","Ondes","Optique","Physique nucléaire"]],["Histoire",["Guerres mondiales","Totalitarismes","Guerre froide","Décolonisation","Europe","Époque contemporaine"]],["Géographie",["Mondialisation","Population","Migrations","Métropolisation","Développement","Ressources","Géopolitique","Climat"]],["Éducation physique",["Jeux collectifs","Athlétisme","Gymnastique","Natation","Santé et hygiène de vie","Fair-play"]],["Philosophie et citoyenneté",["Conscience","Connaissance","Vérité","Science","Liberté","Morale","Justice","Politique","Art","Religion","Citoyenneté","Démocratie"]],["Sciences économiques",["Croissance","Inflation","Chômage","Politiques économiques","Monnaie","Finance","Travail","Commerce mondial"]],["Sciences sociales",["Sociologie","Psychologie","Méthodes d'enquête","Groupes et institutions","Médias","Inégalités","Citoyenneté"]],["Latin",["Vocabulaire","Grammaire","Traduction","Auteurs latins","Mythologie","Civilisation romaine","Étymologie"]],["Grec",["Alphabet","Vocabulaire","Grammaire","Traduction","Mythologie","Civilisation grecque","Étymologie"]],["Allemand",LA6],["Espagnol",LA6],["Italien",LA6],["Informatique",["Algorithmique","Programmation","Structures de données","Bases de données","Applications","Réseaux","Cybersécurité","Intelligence artificielle"]],["Éducation artistique",["Arts plastiques","Musique","Théâtre","Danse","Histoire de l'art","Photo et vidéo"]]]
  };
})();
/* sujets déjà en ligne sur la boutique, à garder écrits ainsi */
var SUJETS_BOUTIQUE={'Mathématiques':['Calcul écrit','Calcul mental','Géométrie']};
function matieresDe(niv){
  var l=[];
  Object.keys(PROGRAMME).forEach(function(k){
    if(niv&&k!==niv.toUpperCase())return;
    PROGRAMME[k].forEach(function(m){if(l.indexOf(m[0])<0)l.push(m[0]);});
  });
  return l;
}
function sujetsDe(niv,mat){
  var l=[];
  function ajoute(x){if(x&&l.indexOf(x)<0)l.push(x);}
  Object.keys(PROGRAMME).forEach(function(k){
    if(niv&&k!==niv.toUpperCase())return;
    PROGRAMME[k].forEach(function(m){if(m[0]===mat)m[1].forEach(ajoute);});
  });
  (SUJETS_BOUTIQUE[mat]||[]).forEach(ajoute);
  /* et ceux déjà utilisés dans vos ressources, écrits à l'identique */
  LISTE.forEach(function(x){if(x.matiere===mat)ajoute(x.sujet);});
  return l.sort(function(a,b){return a.localeCompare(b,'fr');});
}

var CLASSES=[
  {cle:'primaire',nom:'Primaire',niveaux:[['p1','Primaire 1'],['p2','Primaire 2'],['p3','Primaire 3'],
    ['p4','Primaire 4'],['p5','Primaire 5'],['p6','Primaire 6']]},
  {cle:'secondaire',nom:'Secondaire',niveaux:[['s1','Secondaire 1'],['s2','Secondaire 2'],
    ['s3','Secondaire 3'],['s4','Secondaire 4'],['s5','Secondaire 5'],['s6','Secondaire 6']]}
];

/* ============================================================
   L'ÉTAT
   ============================================================ */
var sb=null, moi=null;
var LISTE=[];                                   /* les ressources du tableau de bord */
var FILTRE={cycle:null,niveau:null,matiere:null,texte:'',tri:'maj'};
var R=null;                                     /* la ressource ouverte */
var NIV='1', ROLE='eleve', PAGE=0;              /* la version affichée */
var SEL=[];                                     /* identifiants sélectionnés */
var ZOOM=1, OUTIL='blocs';
/* Le panneau montre les propriétés quand on CLIQUE un élément sur la page,
   et reste sur la bibliothèque quand on vient d'en poser un : on peut ainsi
   enchaîner les blocs sans revenir en arrière à chaque fois. */
var PROPS=false;
/* les cases de tableau choisies, pour les fusionner */
var CEL=null;
/* le prochain fichier choisi est-il le logo du gabarit ? */
var POUR_LOGO=false;
/* le prochain fichier choisi est-il la vignette de la boutique ? */
var POUR_COVER=false;
var PILE=[], PILE_POS=-1, minuteur=null, pretPourPile=true;

/* ============================================================
   LE DOCUMENT VIERGE
   ============================================================ */
function docVierge(){
  var d={v:2,gabarit:{entete:true,pied:true,lettre:'L',titre:'',sousTitre:''},niveaux:{}};
  ['1','2','3'].forEach(function(n){
    d.niveaux[n]={pages:[{el:[],f:{t:'a4',o:'portrait'}}],lie:n!=='1'};
  });
  return d;
}

/* ============================================================
   LA LIAISON DES NIVEAUX
   ------------------------------------------------------------
   Au départ, les niveaux 2 et 3 sont « liés » au niveau 1 : tout
   ce que vous faites dans le 1 s'y recopie tout seul. Dès que
   vous touchez directement au 2 (ou au 3), ce niveau se détache
   et vit sa vie — sinon votre travail serait écrasé.
   Le bouton « Actualiser » sert à repousser le niveau courant
   vers les autres, même détachés, quand vous le décidez.
   ============================================================ */
function estLie(n){return R.doc.niveaux[n]&&R.doc.niveaux[n].lie===true;}

function recopierNiveau(de,vers){
  var src=clone(R.doc.niveaux[de]);
  src.pages.forEach(function(p){p.el.forEach(function(e){e.id=uid();});});
  R.doc.niveaux[vers]={pages:src.pages,lie:R.doc.niveaux[vers].lie};
}

/* appelée après chaque geste terminé */
function propager(){
  if(NIV==='1'){
    ['2','3'].forEach(function(n){if(estLie(n))recopierNiveau('1',n);});
  }else if(estLie(NIV)){
    R.doc.niveaux[NIV].lie=false;   /* on y a touché : il se détache */
  }
}
function niveauCourant(){return R.doc.niveaux[NIV]||(R.doc.niveaux[NIV]={pages:[{el:[]}]});}
function pages(){return niveauCourant().pages;}
function pageCourante(){var p=pages();return p[Math.min(PAGE,p.length-1)]||p[0];}
function elements(){return pageCourante().el;}
function elementPar(id){
  var t=null;pages().forEach(function(p){p.el.forEach(function(e){if(e.id===id)t=e;});});return t;
}

/* ============================================================
   LES BLOCS PÉDAGOGIQUES
   Chacun arrive prêt à l'emploi, déjà bien placé et bien habillé.
   ============================================================ */
/* ------------------------------------------------------------
   Une rangée de lignes a une HAUTEUR FIXE : ajouter ou retirer
   des rangées change la hauteur du bloc, jamais la taille des
   lignes elles-mêmes. C'est ce qu'on attend d'un cahier.
   ------------------------------------------------------------ */
var HL={maison:20, couleurs:20, quatre:20, seyes:10, simple:9, pointille:9};
function hauteurBloc(e){
  var n=Math.max(1,e.nb||1), hl=e.hl||HL[e.lignage||'simple']||10;
  return arrondi(n*hl+(n-1)*(e.ecart==null?0:e.ecart));
}
function ligneNeuve(g){
  var e={type:'lignes',x:MARGE,w:larg(),lignage:g,nb:1,
         hl:HL[g]||10, ecart:/maison|couleurs|quatre/.test(g)?4:1.5};
  e.h=hauteurBloc(e);
  return e;
}

var BLOCS={
  nametag:{nom:'Étiquette prénom',icone:'',faire:function(){return {type:'nametag',w:82,h:14,
    label:'Prénom',teinte:'#f0265c',lettre:'L'};}},
  titre:{nom:'Titre',icone:'H',faire:function(){return {type:'texte',w:larg(),h:15,
    texte:'Titre du document',taille:26,police:'titre',align:'center',couleur:'#14142b',gras:true};}},
  soustitre:{nom:'Sous-titre',icone:'h',faire:function(){return {type:'texte',w:larg(),h:9,
    texte:'Sous-titre ou objectif',taille:12.5,police:'texte',align:'center',couleur:'#8b8299',
    gras:true};}},
  paragraphe:{nom:'Paragraphe',icone:'¶',faire:function(){return {type:'texte',w:larg(),h:24,
    texte:'Écris ton texte ici.',taille:12,police:'texte',align:'left',couleur:'#14142b'};}},
  consigne:{nom:'Consigne',icone:'➊',faire:function(){return {type:'consigne',w:larg(),h:13,
    texte:'Lis l’énoncé puis réponds.',taille:12,numero:1,fond:'#ffe1ea',couleur:'#14142b',
    puce:true,gras:true};}},
  trous:{nom:'Texte à trous',icone:'▭',faire:function(){
    var r=[{t:'Le chat '},trou(),{t:' sur le toit. Il '},trou(),{t:' très haut.'}];
    return {type:'texte',w:larg(),h:24,texte:r.map(function(x){return x.t;}).join(''),riche:r,
      taille:12.5,police:'texte',align:'left',couleur:'#14142b',interligne:2.2};}},
  maison:{nom:'Lignes maison',icone:'',faire:function(){return ligneNeuve('maison');}},
  maisonc:{nom:'Lignes couleurs',icone:'',faire:function(){return ligneNeuve('couleurs');}},
  quatre:{nom:'4 lignes simples',icone:'≣',faire:function(){return ligneNeuve('quatre');}},
  lignes:{nom:'Lignes simples',icone:'≡',faire:function(){return ligneNeuve('simple');}},
  tableau:{nom:'Tableau',icone:'▦',faire:function(){return {type:'tableau',w:larg(),h:38,
    cols:3,rows:3,tete:true,cellules:null,fusions:[]};}},
  colonne:{nom:'Calcul en colonne',icone:'＋',faire:function(){return {type:'texte',w:46,h:32,
    texte:'   2 4 7\n+  1 3 8\n————————\n',taille:15,police:'mono',align:'right',couleur:'#14142b',
    interligne:1.5};}},
  cases:{nom:'Cases à cocher',icone:'☐',faire:function(){return {type:'cases',w:92,h:28,
    lignes:['Première proposition','Deuxième proposition','Troisième proposition'],taille:12};}},
  etiquettes:{nom:'Étiquettes à découper',icone:'',faire:function(){return {type:'tableau',
    w:larg(),h:20,cols:4,rows:1,tete:false,fusions:[],
    cellules:[['mot 1','mot 2','mot 3','mot 4']]};}},
  retiens:{nom:'Je retiens',icone:'★',faire:function(){return {type:'retiens',w:larg(),h:30,
    etiquette:'Je retiens',texte:'La règle à retenir par cœur.',taille:12,teinte:'#6e5fd8',
    fondBoite:'#f3f0fe'};}},
  bulle:{nom:'Bulle de personnage',icone:'',faire:function(){return {type:'forme',w:76,h:26,
    forme:'bulle',remplissage:'#cfe6fb',trait:'#2f80c8',epaisseur:.6,
    texte:'Bravo, continue !',taille:13,police:'main',couleur:'#14142b',gras:true};}},
  dessin:{nom:'Zone de dessin',icone:'✎',faire:function(){return {type:'forme',w:larg(),h:56,
    forme:'rect',remplissage:'#ffffff',trait:'#c9bfc9',epaisseur:.8,rayon:4,
    texte:'Dessine ici',taille:11,couleur:'#bbb0a4',police:'titre'};}},
  bareme:{nom:'Barème / note',icone:'20',faire:function(){return {type:'bareme',w:28,h:28,
    total:20,texte:'',couleur:'#f0265c'};}}
};

/* ============================================================
   LE MODE DÉMO
   ------------------------------------------------------------
   Avec « /ressources?demo=1 », l'outil tourne sans base de
   données : tout est gardé dans ce navigateur, sur cet
   ordinateur. Pratique pour essayer, ou pour travailler avant
   d'avoir lancé le script SQL. Rien n'est partagé.
   ============================================================ */
function baseLocale(){
  var T={ressources:[],ressource_images:[],ressource_notes:[],ressource_versions:[]};
  try{var v=JSON.parse((window.DOCS_LS||localStorage).getItem(window.DOCS?DOCS.cle:'lae_res_demo')||'null');if(v)T=v;}catch(e){}
  function garder(){try{(window.DOCS_LS||localStorage).setItem(window.DOCS?DOCS.cle:'lae_res_demo',window.DOCS&&window.serialiser127?serialiser127(T):JSON.stringify(T));}catch(e){}}
  if(window.DOCS){var G8=0, P8=0;window.DOCS_BASE8={lire:function(){return T;},ecrire:function(n){if(n&&n!==T)T=n;clearTimeout(G8);G8=0;P8=0;garder();},plusTard:function(){var t=Date.now();if(!P8)P8=t;if(G8===-1)return;clearTimeout(G8);G8=setTimeout(function(){G8=-1;(window.requestIdleCallback||function(f){return setTimeout(f,0);})(function(){if(G8===-1){G8=0;P8=0;garder();}},{timeout:2000});},t-P8>8000?0:1200);},maintenant:function(){if(G8){clearTimeout(G8);G8=0;P8=0;garder();}}};addEventListener('pagehide',function(){DOCS_BASE8.maintenant();});document.addEventListener('visibilitychange',function(){if(document.hidden)DOCS_BASE8.maintenant();});}
  function suivant(t){var m=0;T[t].forEach(function(x){m=Math.max(m,+x.id||0);});return m+1;}

  function requete(table){
    var q={_f:[],_ordre:null,_asc:true,_limite:0,_un:false,_action:'select',_valeurs:null};
    function finir(){
      var l=T[table].filter(function(x){
        return q._f.every(function(f){return String(x[f[0]])===String(f[1]);});
      });
      if(q._action==='insert'){
        var ajout=[].concat(q._valeurs).map(function(o){
          var n=JSON.parse(JSON.stringify(o));
          n.id=suivant(table);n.created_at=new Date().toISOString();
          n.maj_le=n.created_at;T[table].push(n);return n;});
        if(window.DOCS_BASE8&&DOCS_BASE8.plusTard)DOCS_BASE8.plusTard();else garder();
        return {data:q._un?ajout[0]:ajout,error:null};
      }
      if(q._action==='update'){
        l.forEach(function(x){
          Object.keys(q._valeurs).forEach(function(k){x[k]=q._valeurs[k];});
          x.maj_le=new Date().toISOString();});
        if(window.DOCS_BASE8&&DOCS_BASE8.plusTard)DOCS_BASE8.plusTard();else garder();return {data:l,error:null};
      }
      if(q._action==='delete'){
        T[table]=T[table].filter(function(x){return l.indexOf(x)<0;});
        garder();return {data:null,error:null};
      }
      if(q._ordre)l=l.slice().sort(function(a,b){
        var x=a[q._ordre],y=b[q._ordre];
        return (x<y?-1:x>y?1:0)*(q._asc?1:-1);});
      if(q._limite)l=l.slice(0,q._limite);
      return {data:q._un?(l[0]||null):l,
        error:(q._un&&!l.length)?{message:'Introuvable'}:null};
    }
    q.select=function(){return q;};
    q.eq=function(c,v){q._f.push([c,v]);return q;};
    q.order=function(c,o){q._ordre=c;q._asc=!o||o.ascending!==false;return q;};
    q.limit=function(n){q._limite=n;return q;};
    q.single=function(){q._un=true;return q;};
    q.insert=function(v){q._action='insert';q._valeurs=v;q._un=true;return q;};
    q.update=function(v){q._action='update';q._valeurs=v;return q;};
    q.delete=function(){q._action='delete';return q;};
    q.then=function(ok,ko){return Promise.resolve().then(finir).then(ok,ko);};
    q.catch=function(ko){return q.then(null,ko);};
    return q;
  }
  return {
    from:requete,
    auth:{getSession:function(){
      return Promise.resolve({data:{session:{user:{id:'demo'}}}});}},
    storage:{from:function(){return {
      upload:function(){return Promise.resolve({error:{message:'Indisponible en mode démo'}});},
      getPublicUrl:function(c){return {data:{publicUrl:c}};}};}}
  };
}

/* ============================================================
   LES DÉCORS DU GABARIT
   Tout est en SVG écrit dans la page : contrairement à une image
   de fond, un SVG sort toujours à l'impression, et il reste net
   quelle que soit la taille.
   ============================================================ */

/* L'étiquette prénom de l'Académie Laé : c'est elle qui ouvre la
   feuille, en haut à gauche. Un autre fichier peut la remplacer
   pour une ressource donnée (Gabarit → Remplacer l'étiquette). */
/* Le ?v= force le navigateur à relire l'image : le serveur les garde
   en cache 30 jours, sans ça une étiquette remplacée ne changerait pas
   avant un mois. À incrémenter quand l'image change. */
var NAMETAG=(window.DOCS&&DOCS.img.nametag)||'/images/nametag-lae.png?v=3';
function nametagSrc(g){return (g&&g.nametag)||NAMETAG;}

/* ============================================================
   LE HAUT ET LE BAS DE LA FEUILLE
   ------------------------------------------------------------
   Le bandeau du haut reprend LE CIEL de la page d'accueil de
   ressourceslae.com — la vraie image, pas une imitation.
   Le bas de ce bandeau et le haut du pied de page suivent la
   même courbe douce : la feuille se tient.

   La courbe n'est pas un masque CSS (qui ne s'imprime pas) :
   c'est une forme blanche posée PAR-DESSUS l'image. Elle sort
   donc toujours, à l'écran comme au PDF.
   ============================================================ */
var CIEL=(window.DOCS&&DOCS.img.ciel)||'/images/ciel-lae.jpg?v=2';
function cielSrc(g){return (g&&g.ciel)||CIEL;}

/* le bas du bandeau : la courbe descend doucement au centre */
function courbeHaut(){
  return '<svg class="courbe" viewBox="0 0 400 100" preserveAspectRatio="none">'
    +'<path d="M0 58 C 76 84, 154 91, 228 84 C 302 77, 350 64, 400 68 '
    +'L400 100 L0 100 Z" fill="#ffffff"/></svg>';
}

/* le haut du pied : la même courbe, en miroir */
function fondPied(){
  return '<svg viewBox="0 0 400 100" preserveAspectRatio="none">'
    +'<defs><linearGradient id="gp" x1="0" y1="0" x2="0.82" y2="1">'
      +'<stop offset="0" stop-color="#f0265c"/>'
      +'<stop offset="0.48" stop-color="#fa5a3c"/>'
      +'<stop offset="1" stop-color="#ff8a3d"/></linearGradient></defs>'
    +'<path d="M0 32 C 50 12, 98 5, 172 14 C 246 23, 330 30, 400 14 '
    +'L400 100 L0 100 Z" fill="url(#gp)"/></svg>';
}

/* le petit décor des lignes d'écriture : maison, soleil, fleur, ver */
function decorMaison(){
  return '<svg viewBox="0 0 100 100" preserveAspectRatio="xMinYMid meet">'
    /* soleil */
    +'<g stroke="#f2b705" stroke-width="1.7" stroke-linecap="round">'
      +'<line x1="14" y1="1" x2="14" y2="5"/><line x1="4" y1="11" x2="0.5" y2="11"/>'
      +'<line x1="6.5" y1="4" x2="4" y2="1.6"/><line x1="21.5" y1="4" x2="24" y2="1.6"/>'
      +'<line x1="6.5" y1="18" x2="4" y2="20.4"/></g>'
    +'<circle cx="14" cy="11" r="6" fill="#ffd93d" stroke="#f2b705" stroke-width="1.2"/>'
    /* maison */
    +'<rect x="30" y="16.5" width="5" height="10" fill="#9ec4ea" stroke="#5b8fd0" stroke-width="1.1"/>'
    +'<path d="M20 29 L42 11 L64 29 Z" fill="#9ec4ea" stroke="#5b8fd0" stroke-width="1.4" '
      +'stroke-linejoin="round"/>'
    +'<rect x="26" y="29" width="32" height="41" fill="#ffe84d" stroke="#f2b705" stroke-width="1.4"/>'
    +'<rect x="36" y="46" width="13" height="24" fill="none" stroke="#f2b705" stroke-width="1.2"/>'
    /* fleur */
    +'<line x1="12" y1="46" x2="12" y2="70" stroke="#2f9e5e" stroke-width="1.3"/>'
    +'<g fill="#ff6b8a"><circle cx="12" cy="42" r="3.4"/><circle cx="7.6" cy="45" r="3.2"/>'
      +'<circle cx="16.4" cy="45" r="3.2"/><circle cx="9.4" cy="50" r="3.2"/>'
      +'<circle cx="14.6" cy="50" r="3.2"/></g>'
    +'<circle cx="12" cy="46" r="2.6" fill="#ffd93d"/>'
    /* herbe sur la ligne verte */
    +'<g stroke="#2f9e5e" stroke-width="1.2" stroke-linecap="round" fill="none">'
      +'<path d="M4 70 C 4 65, 6 63, 7 61"/><path d="M9 70 C 9 66, 11 64, 13 62"/>'
      +'<path d="M20 70 C 20 66, 22 64, 23 62"/><path d="M62 70 C 62 66, 64 64, 66 62"/>'
      +'<path d="M68 70 C 68 65, 70 63, 71 61"/></g>'
    /* marches dans la terre */
    +'<path d="M26 70 L26 92 L58 92 L58 70 Z" fill="#c89b63" stroke="#8a6436" stroke-width="1.2"/>'
    +'<path d="M34 78 L42 78 L42 85 L50 85" fill="none" stroke="#8a6436" stroke-width="1.2"/>'
    /* ver de terre */
    +'<path d="M5 86 C 8 82, 12 82, 14 86 C 16 90, 12 92, 9 90" fill="none" stroke="#e58fa8" '
      +'stroke-width="2" stroke-linecap="round"/>'
    +'<circle cx="5.6" cy="86.4" r="1" fill="#14142b"/></svg>';
}

/* ============================================================
   DÉMARRAGE
   ============================================================ */
function demarrer(){
  if(window.DOCS){sb=baseLocale();moi=DOCS.moi;$('#gate').hidden=true;$('#bord').hidden=false;brancher();return charger();}
  if(/[?&]demo=1/.test(location.search)){
    sb=baseLocale();moi='demo';
    $('#gate').hidden=true;$('#bord').hidden=false;
    document.title='Ressources Laé — démo';
    brancher();bandeauDemo();
    return charger();
  }
  var cfg=window.JOURNAL_CONFIG;
  if(!cfg||!cfg.SUPABASE_URL||!window.supabase)return refus('La connexion à la base n’est pas configurée.');
  sb=window.supabase.createClient(cfg.SUPABASE_URL,cfg.SUPABASE_ANON_KEY);
  sb.auth.getSession().then(function(r){
    var s=r.data&&r.data.session;
    if(!s)return refus('Connectez-vous depuis le Journal, puis revenez sur cette page.'
      +' Pour simplement essayer l’outil : ajoutez ?demo=1 à l’adresse.');
    moi=s.user&&s.user.id;
    $('#gate').hidden=true;$('#bord').hidden=false;
    brancher();
    return charger();
  }).catch(function(e){refus('Erreur : '+(e.message||e));});
}
function refus(m){$('#gate').hidden=false;$('#gateMsg').textContent=m;}
function bandeauDemo(){
  var d=document.createElement('div');
  d.textContent='Mode démo — tout est gardé uniquement dans ce navigateur, rien n’est partagé.';
  d.style.cssText='position:fixed;left:50%;bottom:14px;transform:translateX(-50%);z-index:99;'
    +'background:#14142b;color:#fff;padding:8px 16px;border-radius:99px;font-size:12.5px;'
    +'font-weight:600;box-shadow:0 10px 30px rgba(20,20,43,.3);pointer-events:none';
  document.body.appendChild(d);
  setTimeout(function(){d.style.transition='.6s';d.style.opacity='0';},6000);
}
function etat(t,fige){
  var e=$('#etat');if(!e)return;e.textContent=t||'';
  if(!fige){clearTimeout(etat.t);etat.t=setTimeout(function(){e.textContent='';},2400);}
}

/* ============================================================
   LE TABLEAU DE BORD
   ============================================================ */
function charger(){
  return sb.from('ressources')
    .select('id,titre,poignee,etat,cycle,niveau,matiere,sujet,description,tags,cover,maj_le')
    .order('maj_le',{ascending:false})
    .then(function(r){
      if(r.error)throw r.error;
      LISTE=r.data||[];peindreNav();peindreListe();
    });
}

function peindreNav(){
  var h='<h4>Tout</h4><button data-f="tout" class="'+(!FILTRE.cycle?'on':'')+'">'
    +'<span class="n">Toutes les ressources</span><span class="c">'+LISTE.length+'</span></button>';
  CLASSES.forEach(function(c){
    var nC=LISTE.filter(function(x){return cyclesDe(x).indexOf(c.cle)>=0;}).length;
    h+='<h4>'+c.nom+'</h4>';
    h+='<button data-cycle="'+c.cle+'" class="'+(FILTRE.cycle===c.cle&&!FILTRE.niveau?'on':'')+'">'
      +'<span class="n">Tout le '+c.nom.toLowerCase()+'</span><span class="c">'+nC+'</span></button>';
    c.niveaux.forEach(function(n){
      var dans=LISTE.filter(function(x){return classesDe(x).indexOf(n[0])>=0;});
      h+='<div class="sous"><button data-cycle="'+c.cle+'" data-niveau="'+n[0]+'" class="'
        +(FILTRE.niveau===n[0]&&!FILTRE.matiere?'on':'')+'">'
        +'<span class="n">'+n[1]+'</span><span class="c">'+dans.length+'</span></button>';
      if(FILTRE.niveau===n[0]){
        var mats={};dans.forEach(function(x){if(x.matiere)mats[x.matiere]=(mats[x.matiere]||0)+1;});
        Object.keys(mats).sort().forEach(function(m){
          h+='<div class="sous"><button data-cycle="'+c.cle+'" data-niveau="'+n[0]+'" data-matiere="'
            +esc(m)+'" class="'+(FILTRE.matiere===m?'on':'')+'">'
            +'<span class="n">'+esc(m)+'</span><span class="c">'+mats[m]+'</span></button></div>';
        });
      }
      h+='</div>';
    });
  });
  $('#nav').innerHTML=h;
}

function filtrees(){
  var t=FILTRE.texte.toLowerCase().trim();
  var l=LISTE.filter(function(x){
    if(FILTRE.cycle&&cyclesDe(x).indexOf(FILTRE.cycle)<0)return false;
    if(FILTRE.niveau&&classesDe(x).indexOf(FILTRE.niveau)<0)return false;
    if(FILTRE.matiere&&x.matiere!==FILTRE.matiere)return false;
    if(t){
      var sac=[x.titre,x.matiere,x.sujet,(x.tags||[]).join(' ')].join(' ').toLowerCase();
      if(sac.indexOf(t)<0)return false;
    }
    return true;
  });
  if(FILTRE.tri==='titre')l.sort(function(a,b){return (a.titre||'').localeCompare(b.titre||'');});
  else if(FILTRE.tri==='etat')l.sort(function(a,b){return (a.etat||'').localeCompare(b.etat||'');});
  return l;
}

/* Une ressource peut servir dans plusieurs classes (P1 et P2…).
   R.niveau = la première (colonne de la base) ; toutes sont dans
   R.doc.classes et dans les étiquettes niveau_… (R.tags). */
var ORDRE_CL=[];CLASSES.forEach(function(c){c.niveaux.forEach(function(v){ORDRE_CL.push(v[0]);});});
function trierClasses(l){
  var u=[];l.forEach(function(n){if(n&&u.indexOf(n)<0&&ORDRE_CL.indexOf(n)>=0)u.push(n);});
  return u.sort(function(a,b){return ORDRE_CL.indexOf(a)-ORDRE_CL.indexOf(b);});
}
/* les classes d'une fiche du tableau de bord (x) ou de la ressource ouverte (R) */
function classesDe(x){
  if(!x)return [];
  if(x.doc&&Array.isArray(x.doc.classes))return trierClasses(x.doc.classes);
  var l=(x.tags||[]).filter(function(t){return /^niveau_[ps][1-6]$/.test(t);}).map(function(t){return t.slice(7);});
  if(x.niveau)l.unshift(x.niveau);
  return trierClasses(l);
}
function cyclesDe(x){
  var c=[];classesDe(x).forEach(function(n){var k=n[0]==='p'?'primaire':'secondaire';if(c.indexOf(k)<0)c.push(k);});
  if(!c.length&&x&&x.cycle)c.push(x.cycle);
  return c;
}
/* « Primaire 1 », « Primaire 1, 2 et 3 », « Primaire 1 à 6 » */
function nomClasses(l){
  l=trierClasses(l||[]);if(!l.length)return '';if(l.length===1)return nomClasse(l[0]);
  var out=[];['p','s'].forEach(function(c){
    var n=l.filter(function(x){return x[0]===c;}).map(function(x){return +x[1];});if(!n.length)return;
    var suite=n[n.length-1]-n[0]===n.length-1&&n.length>2;
    out.push((c==='p'?'Primaire ':'Secondaire ')+(n.length===1?n[0]:suite?n[0]+' à '+n[n.length-1]
      :n.slice(0,-1).join(', ')+' et '+n[n.length-1]));
  });
  return out.join(' · ');
}
function nomClasse(x){
  var n='';CLASSES.forEach(function(c){c.niveaux.forEach(function(v){if(v[0]===x)n=v[1];});});
  return n;
}
function jour(d){
  if(!d)return '';var t=new Date(d);
  return ('0'+t.getDate()).slice(-2)+'/'+('0'+(t.getMonth()+1)).slice(-2);
}

function peindreListe(){
  var l=filtrees();
  var titre=FILTRE.matiere||nomClasse(FILTRE.niveau)||
    (FILTRE.cycle===('primaire')?'Primaire':FILTRE.cycle==='secondaire'?'Secondaire':'Toutes les ressources');
  var h='<div class="haut"><h2>'+esc(titre)+'</h2>'
    +'<span class="sous">'+l.length+' ressource'+(l.length>1?'s':'')+'</span></div>';
  h+='<div class="grille">';
  h+='<button class="carte neuve" data-neuve><span class="plus">＋</span>Nouvelle ressource</button>';
  l.forEach(function(x){
    h+='<article class="carte" data-ouvrir="'+x.id+'">'
      +'<div class="vue">'+(x.cover?'<img src="'+esc(x.cover)+'" alt="">':'<span class="rien">'+DX_I('docs')+'</span>')
      +'<div class="outils">'
        +'<button data-copier="'+x.id+'" title="Dupliquer">'+DX_I('dupliquer')+'</button>'
        +'<button data-suppr="'+x.id+'" title="Supprimer">'+DX_I('poubelle')+'</button>'
      +'</div></div>'
      +'<div class="bas"><h3>'+esc(x.titre||'Sans titre')+'</h3>'
      +'<span class="pastille '+(x.etat||'brouillon')+'" style="align-self:flex-start">'
        +({brouillon:'Brouillon',pret:'Prêt',en_ligne:'En ligne'}[x.etat]||'Brouillon')+'</span>'
      +'<div class="meta">'+esc([nomClasse(x.niveau),x.matiere].filter(Boolean).join(' · ')||'Non classée')
        +' — '+jour(x.maj_le)+'</div></div></article>';
  });
  h+='</div>';
  if(!l.length)h+='<div class="vide-liste"><h3>Rien ici pour l’instant</h3>'
    +'<p>Créez votre première ressource : elle sera classée automatiquement.</p></div>';
  $('#liste').innerHTML=h;
}

/* ---------- créer, ouvrir, dupliquer, supprimer ---------- */
function creer(){
  var ligne={titre:'Nouvelle ressource',etat:'brouillon',doc:docVierge(),
    cycle:FILTRE.cycle||null,niveau:FILTRE.niveau||null,matiere:FILTRE.matiere||null,
    tags:[],auteur:moi};
  ligne.poignee=poigneeDe(ligne.titre)+'-'+Date.now().toString(36).slice(-4);
  return sb.from('ressources').insert(ligne).select().single().then(function(r){
    if(r.error)throw r.error;
    LISTE.unshift(r.data);ouvrir(r.data.id);
  }).catch(function(e){alert('Création impossible : '+(e.message||e));});
}

function ouvrir(id){
  return sb.from('ressources').select('*').eq('id',id).single().then(function(r){
    if(r.error)throw r.error;
    R=r.data;CONFLIT=false;
    if(!R.doc||!R.doc.niveaux)R.doc=docVierge();
    ['1','2','3'].forEach(function(n){
      var v=R.doc.niveaux[n];
      if(!v)v=R.doc.niveaux[n]={pages:[{el:[]}]};
      if(!v.pages||!v.pages.length)v.pages=[{el:[]}];
      v.pages.forEach(function(p){if(!p.f)p.f={t:'a4',o:'portrait'};if(!p.el)p.el=[];});
      /* un document d'avant la liaison : un niveau encore vide est lié */
      if(v.lie===undefined)v.lie=(n!=='1'&&!v.pages.some(function(p){return p.el.length;}));
    });
    NIV='1';ROLE='eleve';PAGE=0;SEL=[];PILE=[];PILE_POS=-1;
    $('#bord').hidden=true;$('#atelier').hidden=false;
    $('#nomRes').value=R.titre||'';
    var repares=reparerSeries();
    empiler('ouverture');
    garderVersion(R,'à l’ouverture');
    if(repares){enregistrer(true);setTimeout(function(){etat('Calculs cachés remis en place');},400);}
    ajusterZoom();peindreTout();
  }).catch(function(e){alert('Ouverture impossible : '+(e.message||e));});
}

function fermer(){
  enregistrer(true);
  R=null;$('#atelier').hidden=true;$('#bord').hidden=false;
  charger();
}

function dupliquer(id){
  sb.from('ressources').select('*').eq('id',id).single().then(function(r){
    if(r.error)throw r.error;
    var c=r.data;delete c.id;delete c.created_at;delete c.maj_le;
    c.titre=(c.titre||'Ressource')+' (copie)';
    c.poignee=poigneeDe(c.titre)+'-'+Date.now().toString(36).slice(-4);
    c.etat='brouillon';c.auteur=moi;
    /* la copie est une NOUVELLE fiche : elle ne doit pas reprendre le
       produit Shopify de l'original, sinon les deux s'écrasent */
    c.shopify_id=null;
    /* la miniature garde sa mise en page, mais reprend le nouveau titre */
    if(c.doc&&c.doc.mini){c.doc.mini.titre=null;c.doc.mini.sous=null;}
    return sb.from('ressources').insert(c).select().single();
  }).then(function(r){if(r&&!r.error){LISTE.unshift(r.data);peindreNav();peindreListe();}})
  .catch(function(e){alert('Duplication impossible : '+(e.message||e));});
}

function supprimer(id){
  var x=LISTE.filter(function(v){return String(v.id)===String(id);})[0];
  if(!confirm('Supprimer définitivement « '+((x&&x.titre)||'cette ressource')+' » ?\n\nCette action est irréversible.'))return;
  sb.from('ressources').delete().eq('id',id).then(function(){
    LISTE=LISTE.filter(function(v){return String(v.id)!==String(id);});
    peindreNav();peindreListe();
  });
}

/* ============================================================
   L'ENREGISTREMENT AUTOMATIQUE
   ============================================================ */
/* Trois garde-fous, pour qu'une fiche ne se perde plus jamais :
   1. les envois partent UN PAR UN, dans l'ordre (file ENR) ;
   2. chaque envoi dit « je pars de la version du jj/mm hh:mm:ss »
      (maj_le). Si la fiche a changé entre-temps ailleurs — un autre
      onglet, un autre ordinateur — rien n'est écrasé : cet onglet
      s'arrête d'enregistrer et le dit (voir conflit) ;
   3. une copie de la fiche part dans l'historique à l'ouverture,
      puis toutes les 5 minutes de travail (voir garderVersion). */
var ENR=Promise.resolve(), CONFLIT=false;
function enregistrer(tout_de_suite){
  if(!R||CONFLIT)return;
  clearTimeout(minuteur);
  if(!tout_de_suite){etat('Modifications…',true);minuteur=setTimeout(function(){enregistrer(true);},1400);return;}
  etat('Enregistrement…',true);
  var cible=R;
  ENR=ENR.then(function(){return envoyer(cible);}).catch(function(e){console.warn(e);});
  return ENR;
}
function envoyer(cible){
  if(CONFLIT)return;
  var p={titre:cible.titre,poignee:cible.poignee,doc:cible.doc,etat:cible.etat,cycle:cible.cycle,
    niveau:cible.niveau,matiere:cible.matiere,sujet:cible.sujet,description:cible.description,
    tags:cible.tags||[],cover:cible.cover,shopify_id:cible.shopify_id||null};
  var q=sb.from('ressources').update(p).eq('id',cible.id);
  if(cible.maj_le)q=q.eq('maj_le',cible.maj_le);
  return q.select('maj_le').then(function(r){
    if(r.error){etat('Non enregistré !');console.warn(r.error);return;}
    var l=r.data||[];
    if(!l.length)return conflit(cible);
    cible.maj_le=l[0].maj_le;
    etat('Enregistré');
    versionAuto(cible);
  });
}
/* la fiche a été enregistrée ailleurs depuis qu'on l'a ouverte ici */
function conflit(cible){
  CONFLIT=true;clearTimeout(minuteur);
  /* ce qu'on avait ici n'est pas perdu : il part dans l'historique */
  garderVersion(cible,'cet onglet, avant rechargement');
  etat('Pas enregistré : document modifié ailleurs',true);
  var v=fenetre('<h3>Ce document a été modifié ailleurs</h3>'
    +'<p class="sous">Elle a été enregistrée depuis un autre onglet ou un autre ordinateur '
    +'pendant qu’elle était ouverte ici. Pour ne rien écraser, cet onglet n’enregistre plus.</p>'
    +'<p class="aide">Ce que vous aviez ici est gardé dans l’<b>historique</b> (bouton horloge, '
    +'en haut) : vous pourrez le restaurer si besoin.</p>'
    +'<div class="fin"><button class="b p" data-recharger>Recharger le document</button></div>');
  v.addEventListener('click',function(ev){
    if(ev.target.closest('[data-recharger]')){v.remove();ouvrir(cible.id);}
  });
}

/* ---------- l'historique des versions ---------- */
var DERNIERE_VERSION={};
function garderVersion(cible,etiquette){
  if(!cible||!cible.id)return Promise.resolve();
  DERNIERE_VERSION[cible.id]=Date.now();
  return sb.from('ressource_versions').insert({ressource_id:cible.id,doc:cible.doc,
      etiquette:etiquette+' · '+(cible.titre||''),auteur:moi})
    .then(function(r){if(r&&r.error){console.warn(r.error);etat('Historique indisponible !');}});
}
function versionAuto(cible){
  if(Date.now()-(DERNIERE_VERSION[cible.id]||0)>=5*60000)garderVersion(cible,'automatique');
}
function fenetreHistorique(){
  if(!R)return;
  var v=fenetre('<h3>Historique</h3><p class="sous">Chargement…</p>');
  var boite=v.querySelector('.boite');
  sb.from('ressource_versions').select('id,etiquette,created_at').eq('ressource_id',R.id)
    .order('created_at',{ascending:false}).limit(80).then(function(r){
      var l=(r&&r.data)||[];
      boite.innerHTML='<h3>Historique</h3>'
        +'<p class="sous">Une copie du document est gardée à chaque ouverture et toutes les '
        +'5 minutes de travail. Restaurer garde d’abord la version actuelle : on peut toujours '
        +'revenir en arrière.</p>'
        +(r&&r.error?'<p class="aide" style="color:var(--g1)">'+esc(r.error.message)+'</p>':'')
        +(l.length?'<div class="liste-export">'+l.map(function(x){
          var d=new Date(x.created_at);
          return '<div><span style="flex:1"><b>'+d.toLocaleDateString('fr-BE')+' '
            +d.toLocaleTimeString('fr-BE',{hour:'2-digit',minute:'2-digit'})+'</b> · '
            +esc(x.etiquette||'')+'</span>'
            +'<button class="b sm" data-restaurer="'+x.id+'">Restaurer</button></div>';
        }).join('')+'</div>':'<p class="aide">Aucune version gardée pour l’instant.</p>')
        +'<div class="fin"><button class="b" data-x>Fermer</button></div>';
    });
  v.addEventListener('click',function(ev){
    var b=ev.target.closest('[data-restaurer]');if(!b)return;
    if(!confirm('Remplacer le document par cette version ?\n\nLa version actuelle est gardée '
      +'dans l’historique avant.'))return;
    b.disabled=true;b.textContent='…';
    garderVersion(R,'avant restauration').then(function(){
      return sb.from('ressource_versions').select('doc').eq('id',b.dataset.restaurer).single();
    }).then(function(r){
      if(r.error||!r.data||!r.data.doc)throw r.error||new Error('Version vide');
      R.doc=r.data.doc;
      ['1','2','3'].forEach(function(n){
        var w=R.doc.niveaux[n]||(R.doc.niveaux[n]={pages:[{el:[]}]});
        if(!w.pages||!w.pages.length)w.pages=[{el:[]}];
      });
      v.remove();SEL=[];empiler();peindreTout();enregistrer(true);etat('Version restaurée');
    }).catch(function(e){alert('Restauration impossible : '+(e.message||e));});
  });
}

/* ============================================================
   ANNULER / RÉTABLIR
   On garde une photo du document à chaque geste terminé.
   ============================================================ */
/* ============================================================
   LA NUMÉROTATION AUTOMATIQUE
   Après chaque modification, les numéros se remettent d'aplomb :
   • les calculs d'un même GROUPE (en colonne ou en ligne) se suivent
     dans l'ordre de lecture, d'une page à l'autre : grouper deux
     séries de 20 donne 1 à 40 ;
   • les consignes de la fiche se numérotent 1, 2, 3… dans l'ordre de
     lecture, sauf celles dont on a tapé le numéro soi-même.
   ============================================================ */
function ordreLecture(a,b){
  if(a.pi!==b.pi)return a.pi-b.pi;
  if(Math.abs(a.e.y-b.e.y)>3)return a.e.y-b.e.y;
  return a.e.x-b.e.x;
}
/* « 3)  12 + 5 = » : renumérote le début de chaque ligne à partir de k */
function renumLignes(e,k){
  var debut=true;
  (e.riche||[]).forEach(function(r){
    if(debut&&/^\d+\)\s/.test(r.t))r.t=r.t.replace(/^\d+\)/,String(++k)+')');
    debut=/\n$/.test(r.t);
  });
  if(e.riche)e.texte=e.riche.map(function(r){return r.t;}).join('');
  return k;
}
function numeroter(){
  if(!R)return;
  ['1','2','3'].forEach(function(n){
    var pg=((R.doc.niveaux[n]||{}).pages)||[], groupes={}, consignes=[];
    pg.forEach(function(p,pi){(p.el||[]).forEach(function(e){
      if(e.type==='consigne'&&e.puce!==false)consignes.push({e:e,pi:pi});
      if(!e.grp)return;
      if(e.num!=null||(e.type==='texte'&&e.numLignes))
        (groupes[e.grp]=groupes[e.grp]||[]).push({e:e,pi:pi});
    });});
    Object.keys(groupes).forEach(function(g){
      var k=0;
      groupes[g].sort(ordreLecture).forEach(function(o){
        if(o.e.type==='texte'&&o.e.numLignes)k=renumLignes(o.e,k);
        else if(o.e.type==='dessin'&&o.e.ancres&&o.e.ancres.length){o.e.num=k+1;k+=o.e.ancres.length;}
        else o.e.num=++k;});
    });
    var k=0;
    consignes.sort(ordreLecture).forEach(function(o){
      if(o.e.numeroManuel)k=+o.e.numero||k;else o.e.numero=++k;});
  });
}
function empiler(){
  if(!R||!pretPourPile)return;
  numeroter();
  propager();
  PILE=PILE.slice(0,PILE_POS+1);
  PILE.push(JSON.stringify(R.doc));
  if(PILE.length>60)PILE.shift();
  PILE_POS=PILE.length-1;
  majBoutonsPile();
}
function majBoutonsPile(){
  var a=$('#annuler'),b=$('#refaire');
  if(a)a.disabled=PILE_POS<=0;
  if(b)b.disabled=PILE_POS>=PILE.length-1;
}
function reculer(){
  if(PILE_POS<=0)return;
  PILE_POS--;R.doc=JSON.parse(PILE[PILE_POS]);SEL=[];
  majBoutonsPile();peindreTout();enregistrer();
}
function avancer(){
  if(PILE_POS>=PILE.length-1)return;
  PILE_POS++;R.doc=JSON.parse(PILE[PILE_POS]);SEL=[];
  majBoutonsPile();peindreTout();enregistrer();
}

/* ============================================================
   LE RENDU DES PAGES
   ============================================================ */
function peindreTout(){
  peindrePages();peindrePanneau();peindreVersion();peindreMinis();
  if($('#grille'))peindreGrille();
}

/* ============================================================
   LE PARCOURS
   Six versions, dans l'ordre où on les fait :
     Niveau 1 Élève → Niveau 1 Prof → Niveau 2 Élève → … → Niveau 3 Prof
   • Le niveau 1 Élève est la base.
   • Chaque version Prof se fait toute seule : c'est la version
     Élève + ce qui est marqué « Prof seul ».
   • Les niveaux 2 et 3 suivent le niveau 1 tout seuls (« auto »)
     jusqu'à ce qu'on les modifie ; on peut les relier à nouveau.
   • Une version peut être « non créée » : elle ne sort pas en PDF.
   ============================================================ */
var ETAPES=[['1','eleve'],['1','prof'],['2','eleve'],['2','prof'],['3','eleve'],['3','prof']];
function versionActive(n,role){return (R.doc.actives||{})[n+'-'+role]!==false;}
function compteVues(n){
  var c={prof:0,eleve:0};
  ((R.doc.niveaux[n]||{}).pages||[]).forEach(function(p){
    (p.el||[]).forEach(function(e){
      if(e.corrige)c.prof++;if(e.eleveSeul)c.eleve++;
      passagesDe(e).forEach(function(r){if(r.v&&r.t.trim())c[r.v]++;});
    });
  });
  return c;
}
function nivRempli(n){
  return ((R.doc.niveaux[n]||{}).pages||[]).some(function(p){return (p.el||[]).length;});
}
function statutEtape(n,role){
  if(!versionActive(n,role))return {t:'non créée',k:'off'};
  if(role==='prof'){
    var c=compteVues(n).prof;
    return c?{t:'auto · '+c+' réponse'+(c>1?'s':''),k:'ok'}:{t:'auto · aucune réponse',k:'todo'};
  }
  if(n==='1')return nivRempli('1')?{t:'la base',k:'ok'}:{t:'à faire',k:'todo'};
  return estLie(n)?{t:'auto · suit le niveau 1',k:'auto'}:{t:'personnalisé',k:'ok'};
}
/* le menu d'un niveau : ses deux versions, et ce qu'on peut en faire */
function menuNiveau(n){
  var h='<h6>Niveau '+n+'</h6>';
  ['eleve','prof'].forEach(function(r){
    var st=statutEtape(n,r), on=n===NIV&&r===ROLE;
    h+='<button class="ligne '+st.k+(on?' on':'')+'" data-aller="'+n+'|'+r+'"><b>'
      +(r==='prof'?'Prof':'Élève')+'</b><small>'+st.t+'</small></button>';
  });
  var act=[], a=versionActive(n,'eleve');
  if(!a){
    h+='<p>Ce niveau n’est pas créé : il ne sort pas dans le .zip.</p>';
    act.push('<button class="b sm p" data-pc="activer" data-n="'+n+'">Créer ce niveau</button>');
  }else{
    if(n==='1')h+='<p><b>La base.</b> Tout ce que vous y faites se recopie tout seul dans les '
      +'niveaux en « auto ».</p>';
    else if(estLie(n))h+='<p><b>Auto</b> : suit le niveau 1. Modifiez-le pour l’adapter : il devient '
      +'« personnalisé » et ne bouge plus.</p>';
    else{
      h+='<p><b>Personnalisé</b> : ne suit plus le niveau 1.</p>';
      act.push('<button class="b sm" data-pc="relier" data-n="'+n+'">Remettre en auto</button>');
    }
    h+='<p>La version <b>Prof</b> se fait toute seule : la version Élève + ce qui est en '
      +'« Prof ».</p>';
    act.push(versionActive(n,'prof')
      ?'<button class="b sm" data-pc="prof-off" data-n="'+n+'">Pas de version Prof</button>'
      :'<button class="b sm" data-pc="prof-on" data-n="'+n+'">Créer la version Prof</button>');
    if(n!=='1')act.push('<button class="b sm" data-pc="desactiver" data-n="'+n+'">Ne pas faire ce niveau</button>');
  }
  return h+'<div class="act">'+act.join('')+'</div>';
}
function peindreParcours(){
  var z=$('#selVersion');if(!z||!R)return;
  z.hidden=false;
  z.innerHTML=['1','2','3'].map(function(n){
    var on=n===NIV, a=versionActive(n,'eleve');
    var k=!a?'off':n==='1'?'ok':estLie(n)?'auto':'ok';
    return '<button data-nivmenu="'+n+'" class="'+(on?'on ':'')+k+'"><i class="pt"></i>Niveau '+n
      +(on?' · <span>'+(ROLE==='prof'?'Prof':'Élève')+'</span>':'')+' ▾</button>';
  }).join('');
  var m=$('#menuNiv');if(m)m.innerHTML=menuNiveau(m.dataset.n);
}
function ouvrirMenuNiveau(b){
  var m=$('#menuNiv'), n=b.dataset.nivmenu;
  if(m&&m.dataset.n===n){m.remove();return;}
  if(m)m.remove();
  m=document.createElement('div');m.id='menuNiv';m.className='menu-niv';m.dataset.n=n;
  m.innerHTML=menuNiveau(n);document.body.appendChild(m);
  var r=b.getBoundingClientRect();
  m.style.top=(r.bottom+8)+'px';
  m.style.left=Math.max(8,Math.min(r.left,window.innerWidth-m.offsetWidth-8))+'px';
}
function allerA(n,role){NIV=n;ROLE=role;PAGE=0;SEL=[];peindreTout();}
function actionParcours(a,n){
  R.doc.actives=R.doc.actives||{};
  var A=R.doc.actives;
  if(a==='activer'){A[n+'-eleve']=true;A[n+'-prof']=true;}
  if(a==='desactiver'){A[n+'-eleve']=false;A[n+'-prof']=false;}
  if(a==='prof-on')A[n+'-prof']=true;
  if(a==='prof-off')A[n+'-prof']=false;
  if(a==='relier'){
    if(!confirm('Le niveau '+n+' va être remplacé par une copie du niveau 1, '
      +'puis le suivra tout seul. Continuer ?'))return;
    recopierNiveau('1',n);R.doc.niveaux[n].lie=true;etat('Niveau '+n+' en auto');
  }
  /* ces réglages ne sont pas une modification du niveau : il ne doit
     pas se détacher du niveau 1 pour autant (pas de propager()) */
  PILE=PILE.slice(0,PILE_POS+1);PILE.push(JSON.stringify(R.doc));PILE_POS=PILE.length-1;
  majBoutonsPile();peindreTout();enregistrer();
}

function peindreVersion(){
  peindreParcours();
  var a=$('#btnActualiser');
  if(a)a.hidden=false;
  var s=$('#scene');
  s.classList.toggle('prof',ROLE==='prof');
  s.classList.toggle('reel',REEL);
  var ap=$('#btnApercu');if(ap)ap.classList.toggle('on',REEL);
}
/* « Aperçu » : ce qui est masqué dans cette version disparaît vraiment,
   exactement comme dans le PDF. Sinon, il reste en pâle pour qu'on
   puisse le voir et le modifier. */
var REEL=false;

function peindreMinis(){
  var n=pages().length,h='';
  for(var i=0;i<n;i++)h+='<button data-page="'+i+'" class="'+(i===PAGE?'on':'')+'">'+(i+1)+'</button>';
  $('#minis').innerHTML=h;
}

var POLICES={
  titre:["'Baloo 2',sans-serif",'Baloo 2 (titres)'],
  texte:["'Nunito',sans-serif",'Nunito (texte)'],
  main:["'Caveat',cursive",'Caveat (manuscrite)'],
  ecole:["'Andika','Nunito',sans-serif",'Andika (écriture scolaire)'],
  mono:['ui-monospace,Menlo,monospace','Chasse fixe (calculs)']
};
function styleTexte(e){
  var f=(POLICES[e.police]||POLICES.texte)[0];
  var s='font-family:'+f+';font-size:'+(e.taille||11)+'pt;color:'+(e.couleur||'#14142b')
    +';text-align:'+(e.align||'left')+';line-height:'+(e.interligne||1.4)+';';
  if(e.gras)s+='font-weight:700;';
  if(e.italique)s+='font-style:italic;';
  if(e.souligne)s+='text-decoration:underline;';
  if(e.fond)s+='background:'+e.fond+';';
  if(e.rayon)s+='border-radius:'+e.rayon+'mm;';
  if(e.padding)s+='padding:'+e.padding+'mm;';
  return s;
}

/* ============================================================
   LE TEXTE ENRICHI
   ------------------------------------------------------------
   Un mot peut être en gras, en couleur, plus grand… sans toucher
   au reste du bloc. Le bloc garde ses réglages (taille, couleur,
   gras…) ; seuls les passages modifiés sont notés à part :
     e.riche = [{t:'Le ', g:true, i:false, u:true, c:'#f0265c', z:16}, …]
   g gras, i italique, u souligné, c couleur, z taille en points,
   '\n' = retour à la ligne. e.texte reste toujours le texte brut.
   ============================================================ */
var RICHES=/^(texte|consigne|retiens|forme|cases)$/;

/* ------------------------------------------------------------
   QUI VOIT QUOI
   Un élément entier, ou seulement un passage de texte, peut être
   réservé à une version :
     • « Prof seul »  (le corrigé)  → e.corrige / passage v:'prof'
     • « Élève seul »               → e.eleveSeul / passage v:'eleve'
   Un passage « Prof seul » laisse sa place vide sur la fiche de
   l'élève (la réponse s'écrit dans le trou) ; s'il est collé à un
   passage « Élève seul » (les pointillés, par exemple), les deux
   s'échangent simplement d'une version à l'autre.
   ------------------------------------------------------------ */
function visibleDans(e,role){return role==='prof'?!e.eleveSeul:!e.corrige;}
function voisin(runs,i,pas){
  for(var j=i+pas;j>=0&&j<runs.length;j+=pas)if(runs[j].t.trim())return runs[j];
  return null;
}
/* ce que devient un passage dans une version : 'voit', 'blanc' (place gardée) ou 'cache' */
function sortDuPassage(runs,i,role){
  var r=runs[i];
  if(!r.v||r.v===role)return 'voit';
  if(r.v==='eleve')return 'cache';
  var a=voisin(runs,i,-1), b=voisin(runs,i,1);
  return (a&&a.v==='eleve')||(b&&b.v==='eleve')?'cache':'blanc';
}
function richeHtml(runs){
  return runs.map(function(r,i){
    var s='';
    if(r.g===true)s+='font-weight:700;';else if(r.g===false)s+='font-weight:500;';
    if(r.i===true)s+='font-style:italic;';else if(r.i===false)s+='font-style:normal;';
    if(r.u)s+='text-decoration:underline;';
    if(r.c)s+='color:'+r.c+';';
    if(r.z)s+='font-size:'+r.z+'pt;';
    var t=esc(r.t).replace(/\n/g,'<br>');
    if(r.l)t='<span class="lien" data-href="'+esc(r.l)+'" title="'+esc(r.l)+' — ⌘ + clic pour l’ouvrir">'+t+'</span>';
    if(r.v){
      var so=sortDuPassage(runs,i,ROLE);
      return '<span class="rv v-'+r.v+(so==='voit'?'':' '+so)+'" data-v="'+r.v+'"'
        +(s?' style="'+s+'"':'')+'>'+t+'</span>';
    }
    return s?'<span style="'+s+'">'+t+'</span>':t;
  }).join('');
}
/* tous les passages enrichis d'un élément (texte et cases de tableau) */
function passagesDe(e){
  var l=(e.riche||[]).slice();
  Object.keys(e.celRiche||{}).forEach(function(k){l=l.concat(e.celRiche[k]);});
  return l;
}
function contenu(e){return e.riche&&e.riche.length?richeHtml(e.riche):esc(e.texte||'');}
/* les cases à cocher : une liste de passages par ligne */
function lignesRiches(e){
  if(!e.riche||!e.riche.length)return (e.lignes||[]).map(function(x){return [{t:x}];});
  var out=[[]];
  e.riche.forEach(function(r){
    String(r.t).split('\n').forEach(function(p,k){
      if(k>0)out.push([]);
      if(p){var c=clone(r);c.t=p;out[out.length-1].push(c);}
    });
  });
  return out.filter(function(l){return l.some(function(r){return r.t.trim();});});
}
function hexDe(c){
  var m=String(c).match(/\d+(\.\d+)?/g);if(!m)return c;
  return '#'+m.slice(0,3).map(function(v){return ('0'+Math.round(+v).toString(16)).slice(-2);}).join('');
}
function memeStyle(a,b){return ['g','i','u','c','z','v','l'].every(function(k){return a[k]===b[k];});}
function lienDe(n,cible){
  for(var q=n.nodeType===3?n.parentElement:n;q&&q!==cible;q=q.parentElement)
    if(q.hasAttribute('data-href'))return q.getAttribute('data-href');
  return '';
}
/* la version à laquelle un bout de texte est réservé ('' = les deux) */
function vueDe(n,cible){
  for(var q=n.nodeType===3?n.parentElement:n;q&&q!==cible;q=q.parentElement)
    if(q.hasAttribute('data-v'))return q.getAttribute('data-v');
  return '';
}
/* relit ce qui a été tapé dans la page, avec les styles calculés par le
   navigateur : peu importe comment il a balisé le gras ou la couleur */
function lireRiche(cible){
  var base=getComputedStyle(cible), runs=[];
  var bG=+base.fontWeight>=600, bI=base.fontStyle==='italic', bC=base.color,
      bZ=parseFloat(base.fontSize);
  function souligne(p){
    for(;p&&p!==cible;p=p.parentElement){
      var cs=getComputedStyle(p);
      if(/underline/.test(cs.textDecorationLine||cs.textDecoration||'')||p.tagName==='U')return true;
    }
    return false;
  }
  function ajoute(t,st){
    var d=runs[runs.length-1];
    if(d&&(t==='\n'||memeStyle(d,st)))d.t+=t;
    else{st.t=t;runs.push(st);}
  }
  function texte(){return runs.map(function(r){return r.t;}).join('');}
  (function marche(n){
    for(var c=n.firstChild;c;c=c.nextSibling){
      if(c.nodeType===3){
        var t=c.nodeValue.replace(/\u00a0/g,' ');if(!t)continue;
        var p=c.parentElement, cs=getComputedStyle(p), st={};
        var g=+cs.fontWeight>=600;if(g!==bG)st.g=g;
        var i=cs.fontStyle==='italic';if(i!==bI)st.i=i;
        if(souligne(p))st.u=true;
        if(cs.color!==bC)st.c=hexDe(cs.color);
        var z=parseFloat(cs.fontSize);if(Math.abs(z-bZ)>.3)st.z=Math.round(z*.75*2)/2;
        var vv=vueDe(c,cible);if(vv)st.v=vv;
        var ll=lienDe(c,cible);if(ll)st.l=ll;
        ajoute(t,st);
      }else if(c.nodeType===1){
        if(c.tagName==='BR'){ajoute('\n',{});continue;}
        if(/^(DIV|P|LI)$/.test(c.tagName)&&texte()&&!/\n$/.test(texte()))ajoute('\n',{});
        marche(c);
      }
    }
  })(cible);
  /* on enlève les blancs du début et de la fin */
  while(runs.length&&!runs[0].t.replace(/^\s+/,'')){runs.shift();}
  if(runs.length)runs[0].t=runs[0].t.replace(/^[\n ]+/,'');
  while(runs.length&&!runs[runs.length-1].t.replace(/\s+$/,'')){runs.pop();}
  if(runs.length)runs[runs.length-1].t=runs[runs.length-1].t.replace(/\s+$/,'');
  return runs.filter(function(r){return r.t;});
}

/* ============================================================
   LES CALCULS EN COLONNE
   Un calcul se décrit en cases (comme sur un cahier quadrillé) :
   layoutCalcul() renvoie les chiffres, les traits et les cases à
   retenue ; l'écran (SVG) et le PDF dessinent la même chose.
   Les réponses (k:'rep') n'apparaissent que dans la version Prof.
   ============================================================ */
var SIGNES={'+':'+','-':'−','x':'×',':':':'};
/* de petites icônes nettes (plutôt que du texte) */
var ICO={
  grouper:'<rect x="2.5" y="2.5" width="19" height="19" rx="4"/><rect x="6.5" y="6.5" width="5" height="5" rx="1"/><rect x="12.5" y="12.5" width="5" height="5" rx="1"/>',
  degrouper:'<rect x="3" y="3" width="8" height="8" rx="2"/><rect x="13" y="13" width="8" height="8" rx="2"/>',
  cadenas:'<rect x="5" y="11" width="14" height="10" rx="2.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
  ouvert:'<rect x="5" y="11" width="14" height="10" rx="2.5"/><path d="M8 11V8a4 4 0 0 1 7.6-1.7"/>',
  regen:'<path d="M20 11a8 8 0 0 0-14.3-4.9L4 8"/><path d="M4 3v5h5"/><path d="M4 13a8 8 0 0 0 14.3 4.9L20 16"/><path d="M20 21v-5h-5"/>'
};
function ico(n){return '<svg class="ic" viewBox="0 0 24 24">'+ICO[n]+'</svg>';}
/* une couleur par rang, des unités aux centaines de mille : fond pâle
   de la colonne, et le nom du rang en couleur franche au-dessus */
var RANGS=[['U','#cfe9fb','#2f80c8'],['D','#fdf2b3','#c99700'],['C','#ffd7e2','#f0265c'],
  ['UM','#d5f2dc','#2f9e5e'],['DM','#e7defb','#6e5fd8'],['CM','#ffe2c9','#fa5a3c']];
function layoutCalcul(e){
  var op=e.op||'+', a=+e.a||0, b=+e.b||0, A=String(a), B=String(b);
  var cells=[], lignes=[], cases=[], fonds=[], cols, rows, r;
  /* le numéro du calcul, en haut à gauche (dans la colonne du signe) */
  function numero(){if(e.num)cells.push({c:0,r:0,t:String(e.num),k:'num'});}
  function chiffres(txt,finCol,ligne,k){
    String(txt).split('').forEach(function(ch,i){
      cells.push({c:finCol-txt.length+1+i,r:ligne,t:ch,k:k||'n'});});
  }
  if(op===':'){
    var q=Math.floor(a/(b||1)), R=a-(b||1)*q, Q=String(q);
    var L=A.length+1, W=Math.max(B.length,Q.length)+1, travail=Math.max(2,2*Q.length);
    cols=L+W;rows=1+travail;
    chiffres(A,A.length,0);
    chiffres(B,L+B.length,0);
    chiffres(Q,L+Q.length,1,'rep');
    lignes.push([L,0,L,rows],[L,1,cols,1]);
    chiffres(String(R),A.length,rows-1,'rep');
    cells.push({c:A.length-String(R).length,r:rows-1,t:'r',k:'repp'});
    numero();
    return {cols:cols,rows:rows,cells:cells,lignes:lignes,cases:cases,fonds:fonds};
  }
  var res=op==='+'?a+b:op==='-'?a-b:a*b, RS=String(res), parts=[];
  if(op==='x'&&B.length>1)
    B.split('').reverse().forEach(function(d,j){parts.push(String(a*(+d))+new Array(j+1).join('0'));});
  var n=Math.max(A.length,B.length,RS.length);
  parts.forEach(function(x){n=Math.max(n,x.length);});
  cols=n+1;r=0;
  var fin=cols-1, haut=0;
  if(e.cases){
    for(var j=1;j<fin;j++)cases.push([j,r]);
    if(op==='+'){
      var c=0, ra=A.split('').reverse(), rb=B.split('').reverse();
      for(var i=0;i<n;i++){
        var s2=(+(ra[i]||0))+(+(rb[i]||0))+c;c=Math.floor(s2/10);
        if(c&&i+1<n&&fin-(i+1)>=1)cells.push({c:fin-(i+1),r:r,t:String(c),k:'ret'});
      }
    }
    r++;
  }
  chiffres(A,fin,r);
  cells.push({c:0,r:r+1,t:SIGNES[op],k:'op'});
  chiffres(B,fin,r+1);
  lignes.push([0,r+2,cols,r+2]);
  r+=2;
  if(parts.length){
    parts.forEach(function(x,i){chiffres(x,fin,r+i,'rep');});
    r+=parts.length;
    cells.push({c:0,r:r,t:'+',k:'repp'});
    lignes.push([0,r,cols,r]);
  }
  chiffres(RS,fin,r,'rep');
  rows=r+1;
  if(e.couleurs)for(var jf=1;jf<=fin;jf++)
    fonds.push({c:jf,r0:haut,r1:rows,col:RANGS[Math.min(fin-jf,RANGS.length-1)][1]});
  numero();
  return {cols:cols,rows:rows,cells:cells,lignes:lignes,cases:cases,fonds:fonds};
}
function svgCalcul(e){
  var L=layoutCalcul(e), c=Math.min(e.w/L.cols,e.h/L.rows), W=L.cols*c, H=L.rows*c, h='';
  var f=(POLICES[e.police||'ecole']||POLICES.ecole)[0].replace(/"/g,"'");
  L.fonds.forEach(function(k){
    h+='<rect x="'+k.c*c+'" y="'+k.r0*c+'" width="'+c+'" height="'+(k.r1-k.r0)*c+'" fill="'+k.col+'"/>';});
  if(e.quad!==false){
    for(var i=0;i<=L.cols;i++)h+='<line x1="'+i*c+'" y1="0" x2="'+i*c+'" y2="'+H+'" class="q"/>';
    for(var j=0;j<=L.rows;j++)h+='<line x1="0" y1="'+j*c+'" x2="'+W+'" y2="'+j*c+'" class="q"/>';
  }
  L.cases.forEach(function(k){var s=c*.56;
    h+='<rect x="'+(k[0]*c+(c-s)/2)+'" y="'+(k[1]*c+(c-s)/2)+'" width="'+s+'" height="'+s+'" rx="'+s*.18+'" class="cb"/>';});
  L.lignes.forEach(function(l){
    h+='<line x1="'+l[0]*c+'" y1="'+l[1]*c+'" x2="'+l[2]*c+'" y2="'+l[3]*c+'" class="tr"/>';});
  L.cells.forEach(function(k){
    var pt=k.k==='ret'?c*.36:k.k==='repp'||k.k==='num'?c*.5:k.k==='lab'?c*.4:c*.64;
    var coul=/rep|ret/.test(k.k)?'#f0265c':k.k==='lab'?k.col:(e.couleur||'#14142b');
    h+='<text x="'+(k.c*c+c/2)+'" y="'+(k.r*c+c/2)+'" font-size="'+pt+'" class="'
      +(/rep|ret/.test(k.k)?'rep':'')+'" fill="'+coul+'"'
      +(k.k==='num'||k.k==='lab'?' font-weight="800"':'')+'>'+esc(k.t)+(k.k==='num'?'.':'')+'</text>';});
  return '<svg class="calc" viewBox="0 0 '+W+' '+H+'" width="'+W+'mm" height="'+H+'mm" style="font-family:'
    +f+'">'+h+'</svg>';
}

/* ---------- les générateurs ---------- */
var MATHS={op:'+',a:3,b:3,n:6,ret:'mix',quad:true,cases:true,coul:false,numeros:true,
  num:'Milliers',dec:0,rg:2};
/* Le hasard des générateurs est « rejouable » : chaque outil posé garde
   sa graine. Changer une option (sans couleurs, autre mode…) redessine
   alors exactement les mêmes nombres, heures, fractions. */
var HASARD=Math.random;
function graine(n){var a=n>>>0;return function(){a=a+0x6D2B79F5|0;var t=Math.imul(a^a>>>15,1|a);
  t=t+Math.imul(t^t>>>7,61|t)^t;return ((t^t>>>14)>>>0)/4294967296;};}
function alea(a,b){return a+Math.floor(HASARD()*(b-a+1));}
function nombre(d){return d<=1?alea(1,9):alea(Math.pow(10,d-1),Math.pow(10,d)-1);}
function rev(n){return String(n).split('').reverse().map(Number);}
function avecRetenue(a,b){var x=rev(a),y=rev(b),c=0;
  for(var i=0;i<Math.max(x.length,y.length);i++){var s=(x[i]||0)+(y[i]||0)+c;if(s>9)return true;c=0;}
  return false;}
function avecEmprunt(a,b){var x=rev(a),y=rev(b);
  for(var i=0;i<y.length;i++)if((x[i]||0)<y[i])return true;return false;}
/* un nombre de db chiffres qui n'entraîne ni retenue (+) ni emprunt (−) avec a */
function sansRetenue(a,db,op){
  var x=rev(a), d=[];
  for(var i=0;i<db;i++){
    var max=op==='+'?9-(x[i]||0):(x[i]||0), min=i===db-1?1:0;
    if(max<min)return null;
    d.push(alea(min,max));
  }
  return +d.reverse().join('');
}
function tirerCalcul(op,da,db,ret){
  if((op==='+'||op==='-')&&db>da){var t=da;da=db;db=t;}
  for(var k=0;k<800;k++){
    var a=nombre(da), b;
    if(op===':'){
      b=nombre(db);if(b<2)continue;
      if(ret==='sans'){
        var qmin=Math.max(1,Math.ceil(Math.pow(10,da-1)/b)), qmax=Math.floor((Math.pow(10,da)-1)/b);
        if(qmax<qmin)continue;a=b*alea(qmin,qmax);
      }else{if(a<b)continue;if(ret==='avec'&&a%b===0)continue;}
      return {a:a,b:b};
    }
    if((op==='+'||op==='-')&&ret==='sans'){b=sansRetenue(a,db,op);if(b==null)continue;
      if(op==='-'&&b>=a)continue;return {a:a,b:b};}
    b=nombre(db);
    if(op==='-'&&b>=a)continue;
    if(op==='+'&&ret==='avec'&&!avecRetenue(a,b))continue;
    if(op==='-'&&ret==='avec'&&!avecEmprunt(a,b))continue;
    if(op==='x'&&b<2)continue;
    return {a:a,b:b};
  }
  return {a:nombre(da),b:nombre(db)};
}
/* 34043 → « 34 043 » (espace insécable : le nombre ne se coupe jamais) */
function nb(n){return String(n).replace(/\B(?=(\d{3})+(?!\d))/g,'\u00a0');}
/* les réglages d'un calcul (pour régénérer ou changer un exercice déjà posé) */
function genDe(e){
  if(e.gen)return e.gen;
  if(e.type==='calcul')return {op:e.op||'+',a:String(e.a).length,b:String(e.b).length,ret:'mix'};
  return null;
}
/* les lignes « 34 + 27 = ____ » d'un calcul mental */
function runsLigne(liste,op,numeros,debut){
  var runs=[];
  liste.forEach(function(t,i){
    if(i)runs.push({t:'\n'});
    runs.push({t:(numeros?(debut+i)+')  ':'')+nb(t.a)+' '+SIGNES[op]+' '+nb(t.b)+' = '});
    runs.push(trou());
    runs.push({t:resultatTexte(op,t.a,t.b),v:'prof',c:'#f0265c'});
  });
  return runs;
}
function regenererCalcul(e,g){
  var t=tirerCalcul(g.op,g.a,g.b,g.ret), L0=layoutCalcul(e), c=e.w/L0.cols;
  e.op=g.op;e.a=t.a;e.b=t.b;e.gen=clone(g);
  if(g.op===':'){e.cases=false;e.couleurs=false;}
  var L1=layoutCalcul(e);e.w=arrondi(L1.cols*c);e.h=arrondi(L1.rows*c);
}
function regenererLigne(e,g){
  var n=(e.riche||[]).filter(function(r){return r.v==='prof';}).length||1, l=[];
  for(var i=0;i<n;i++)l.push(tirerCalcul(g.op,g.a,g.b,g.ret));
  e.riche=runsLigne(l,g.op,e.numLignes,1);
  e.texte=e.riche.map(function(r){return r.t;}).join('');e.gen=clone(g);
}
/* après un changement de taille, la série se remet en rangées propres,
   page après page : une rangée qui ne tient plus passe sur la page
   suivante (créée au même format si besoin), jamais sous le pied */
function reflowCalculs(els){
  els=els.filter(function(e){return e.type==='calcul';});
  if(els.length<2)return;
  var pg=pages();
  function pageDe(e){for(var i=0;i<pg.length;i++)if(pg[i].el.indexOf(e)>=0)return i;return -1;}
  var o=els.map(function(e){return {e:e,pi:pageDe(e)};}).filter(function(x){return x.pi>=0;}).sort(ordreLecture);
  if(o.length<2)return;
  function haut(p){return aEntete(p)?HAUT+5:MARGE;}
  function bas(p){return dimDe(p)[1]-(aPied(p)?BAS+3:MARGE);}
  var gap=10, mw=Math.max.apply(null,o.map(function(x){return x.e.w;})),
      mh=Math.max.apply(null,o.map(function(x){return x.e.h;}));
  var pi=o[0].pi, y=Math.min.apply(null,o.filter(function(x){return x.pi===pi;}).map(function(x){return x.e.y;}));
  /* on retire la série de ses pages, puis on la repose dans l'ordre */
  o.forEach(function(x){var l=pg[x.pi].el;l.splice(l.indexOf(x.e),1);});
  var parRang=1, col=0;
  function rangee(){
    var P=pg[pi], L=dimDe(P)[0]-2*MARGE;
    parRang=Math.max(1,Math.floor((L+gap)/(mw+gap)));
  }
  rangee();
  o.forEach(function(x,i){
    if(i>0&&col===0)y+=mh+gap;
    if(col===0&&y+mh>bas(pg[pi])+.5){
      pi++;
      if(!pg[pi])pg.splice(pi,0,{el:[],f:clone(fmtDe(pg[pi-1]))});
      /* sur la page suivante : sous ce qui n'appartient pas à la série */
      var b0=haut(pg[pi]);pg[pi].el.forEach(function(e){if(e.y<b0+5)b0=Math.max(b0,e.y+e.h+5);});
      y=b0;rangee();
    }
    var L=dimDe(pg[pi])[0]-2*MARGE, pas=(L-mw)/Math.max(1,parRang-1);
    x.e.x=arrondi(MARGE+(parRang>1?col*pas:(L-mw)/2)+(mw-x.e.w));x.e.y=arrondi(y);
    pg[pi].el.push(x.e);
    col=(col+1)%parRang;
  });
}
/* ------------------------------------------------------------
   LES ÉLÉMENTS CACHÉS
   Un élément dont le milieu tombe sous le pied de page, ou hors de
   la feuille, est invisible mais compte encore (numéros !). On le
   signale sous la page, et on le remet en place.
   ------------------------------------------------------------ */
function cachesDe(p){
  var d=dimDe(p), lim=d[1]-(aPied(p)?BAS:0);
  return (p.el||[]).filter(function(e){
    var cy=e.y+e.h/2, cx=e.x+e.w/2;
    return cy>lim||cy<0||cx<0||cx>d[0];
  });
}
/* remet en place les éléments cachés d'une page (niveau affiché) */
function remettreEnPlace(i){
  var pg=pages(), p=pg[i];if(!p)return 0;
  var caches=cachesDe(p), faits=0, grps={};
  caches.forEach(function(e){
    if(e.type==='calcul'&&e.grp){grps[e.grp]=1;return;}
    var d=dimDe(p), lim=d[1]-(aPied(p)?BAS+3:MARGE), haut=aEntete(p)?HAUT+5:MARGE;
    e.x=arrondi(borne(e.x,MARGE,Math.max(MARGE,d[0]-MARGE-e.w)));
    e.y=arrondi(borne(e.y,haut,Math.max(haut,lim-e.h)));faits++;
  });
  Object.keys(grps).forEach(function(g){
    var l=[];pg.forEach(function(q){(q.el||[]).forEach(function(e){if(e.grp===g)l.push(e);});});
    reflowCalculs(l);faits+=l.length;
  });
  return faits;
}
/* à l'ouverture : les séries de calculs cachées se remettent en rangées */
function reparerSeries(){
  var avant=NIV, n=0;
  ['1','2','3'].forEach(function(k){
    NIV=k;
    pages().forEach(function(p,i){
      if(cachesDe(p).some(function(e){return e.type==='calcul'&&e.grp;}))n+=remettreEnPlace(i);
    });
  });
  NIV=avant;
  return n;
}

/* Régénérer : même nombre d'exercices, mêmes réglages, autre contenu */
function regenererSel(){
  var n=0, calc=[];
  modifier(function(x){
    if(x.type==='calcul'){regenererCalcul(x,genDe(x));calc.push(x);n++;}
    else if(x.type==='texte'&&x.gen&&x.gen.type==='ligne'){regenererLigne(x,x.gen);n++;}
    else if(x.type==='dessin'&&x.outil){x.graine=Math.floor(Math.random()*1e9);regenerer(x,x.opts||{});n++;}
  });
  if(calc.length>1){reflowCalculs(calc);empiler();peindreTout();enregistrer();}
  etat(n?'Régénéré : nouveau contenu, mêmes réglages':'Rien à régénérer dans la sélection');
}
function regenerable(e){
  return e&&(e.type==='calcul'||(e.type==='texte'&&e.gen&&e.gen.type==='ligne')||(e.type==='dessin'&&e.outil));
}

function resultatTexte(op,a,b){
  if(op==='+')return nb(a+b);if(op==='-')return nb(a-b);if(op==='x')return nb(a*b);
  var q=Math.floor(a/b), r=a%b;return r?nb(q)+' reste '+nb(r):nb(q);
}
/* la place qui reste sous ce qui existe ; s'il n'y en a presque plus,
   on passe sur une page neuve et on prend toute la page */
function placeRestante(min){
  var bas=hautPage();elements().forEach(function(e){bas=Math.max(bas,e.y+e.h+5);});
  var reste=basPage()-bas;
  if(reste<min){if(elements().length){nouvellePage();}return basPage()-hautPage();}
  return reste;
}
function poserMaths(quoi,remplir){
  var M=MATHS, g='g'+uid(), neufs=[], z=zMax()+1, nAvant=M.n;
  if(M.n==='page'){remplir=true;M.n=6;}
  /* « Remplir la page » : on calcule combien d'exercices tiennent */
  /* en colonne : on tire largement, puis on garde ce qui tient (plus bas) */
  if(remplir&&quoi==='colonne')M.n=120;
  if(remplir&&quoi==='ligne'){
    var hl=14*PT*2.2, reste2=placeRestante(hl*2+4);
    M.n=Math.max(2,2*Math.floor((reste2-4)/hl));
  }
  function ajoute(e){e.id=uid();e.z=z++;e.grp=g;elements().push(e);neufs.push(e);}
  if(quoi==='colonne'){
    var c=7.5, lst=[];
    for(var i=0;i<M.n;i++){
      var t=tirerCalcul(M.op,M.a,M.b,M.ret);
      var e={type:'calcul',op:M.op,a:t.a,b:t.b,quad:M.quad,cases:M.cases&&M.op!==':',police:'ecole',
        gen:{op:M.op,a:M.a,b:M.b,ret:M.ret},
        couleurs:M.coul&&M.op!==':',num:M.numeros?i+1:null};
      var L=layoutCalcul(e);e.w=L.cols*c;e.h=L.rows*c;lst.push(e);
    }
    var mw=Math.max.apply(null,lst.map(function(e){return e.w;})),
        mh=Math.max.apply(null,lst.map(function(e){return e.h;})), gap=10;
    var parRang=Math.max(1,Math.floor((larg()+gap)/(mw+gap)));
    if(remplir){
      /* exactement autant de rangées que la place libre en contient */
      var reste=placeRestante(mh), nr=Math.max(1,Math.floor((reste+gap)/(mh+gap)));
      lst=lst.slice(0,parRang*nr);
      lst.forEach(function(e,i){if(e.num!=null)e.num=i+1;});
      mw=Math.max.apply(null,lst.map(function(e){return e.w;}));
      mh=Math.max.apply(null,lst.map(function(e){return e.h;}));
    }
    var rangs=Math.ceil(lst.length/parRang);
    var pas=(larg()-mw)/Math.max(1,parRang-1);
    var y=placeAuto(mh);
    lst.forEach(function(e,i){
      var col=i%parRang;
      if(col===0&&i>0){y+=mh+gap;if(y+mh>basPage()+.5){nouvellePage();y=hautPage();}}
      e.x=arrondi(MARGE+(parRang>1?col*pas:(larg()-mw)/2)+(mw-e.w));e.y=arrondi(y);
      ajoute(e);
    });
  }else if(quoi==='ligne'){
    var lignes=[];
    for(var k=0;k<M.n;k++){var t2=tirerCalcul(M.op,M.a,M.b,M.ret);lignes.push(t2);}
    var deux=M.n>6, moitie=Math.ceil(M.n/(deux?2:1));
    var y1=placeAuto(arrondi(moitie*14*PT*2.2+4));
    [lignes.slice(0,moitie),deux?lignes.slice(moitie):[]].forEach(function(l,ci){
      if(!l.length)return;
      var runs=runsLigne(l,M.op,M.numeros,ci*moitie+1);
      var w=deux?(larg()-8)/2:larg(), h=arrondi(l.length*14*PT*2.2+4);
      ajoute({type:'texte',x:MARGE+ci*(w+8),y:y1,w:w,h:h,taille:14,police:'ecole',numLignes:!!M.numeros,
        gen:{type:'ligne',op:M.op,a:M.a,b:M.b,ret:M.ret},
        couleur:'#14142b',interligne:2.2,align:'left',
        texte:runs.map(function(r){return r.t;}).join(''),riche:runs});
    });
  }else if(quoi==='numeration'){
    var classes=['Millions','Milliers','Unités'];
    classes=classes.slice(classes.indexOf(M.num==='Millions'?'Millions':M.num==='Milliers'?'Milliers':'Unités'));
    var cols=classes.length*3+(+M.dec), tete=[], sous=[], fus=[];
    classes.forEach(function(nom,i){tete.push(nom,'','');sous.push('C','D','U');
      fus.push({y:0,x:i*3,ly:1,lx:3});});
    if(+M.dec){tete.push('Décimales');for(var d=1;d<+M.dec;d++)tete.push('');
      sous=sous.concat(['d','c','m'].slice(0,+M.dec));
      if(+M.dec>1)fus.push({y:0,x:classes.length*3,ly:1,lx:+M.dec});}
    var cel=[tete,sous];for(var r2=0;r2<+M.rg;r2++)cel.push(new Array(cols).fill(''));
    var ht=(2+(+M.rg))*10;
    ajoute({type:'tableau',x:MARGE,y:placeAuto(ht),w:larg(),h:ht,cols:cols,rows:2+(+M.rg),tete:true,
      cellules:cel,fusions:fus,taille:12});
  }
  if(neufs.length===1)delete neufs[0].grp;
  if(remplir)M.n=nAvant;
  /* la sélection : ce qui est sur la page affichée */
  SEL=neufs.filter(function(e){return elements().indexOf(e)>=0;}).map(function(e){return e.id;});PROPS=false;
  empiler();peindreTout();enregistrer();
  etat(neufs.length+' élément'+(neufs.length>1?'s':'')+' posé'+(neufs.length>1?'s, groupés':''));
}
/* de nouveaux nombres pour les calculs sélectionnés, même opération, mêmes chiffres */
function relancerCalculs(){
  modifier(function(x){
    if(x.type!=='calcul')return;
    var t=tirerCalcul(x.op,String(x.a).length,String(x.b).length,MATHS.ret);
    x.a=t.a;x.b=t.b;
  });
}

/* ============================================================
   LE DESSIN : un élément fait de traits, formes et textes
   ------------------------------------------------------------
   Tous les outils du Cartable (horloge, règle, droite graduée,
   formes, frise…) produisent ce même type d'élément :
     {type:'dessin', W0, H0, prims:[…]}
   W0×H0 est la taille d'origine en mm ; l'élément s'agrandit ou
   rétrécit sans se déformer. Chaque primitive :
     l ligne · r rectangle · o cercle/ellipse · p polygone · x texte
   v:'prof'  → seulement dans la version Prof (une réponse) ;
   v:'eleve' → seulement dans la version Élève.
   ============================================================ */
function Lg(x1,y1,x2,y2,c,ep,d,v){return {t:'l',x1:x1,y1:y1,x2:x2,y2:y2,c:c||'#14142b',ep:ep||.4,d:d,v:v};}
function Rc(x,y,w,h,f,c,ep,rx,d,v){return {t:'r',x:x,y:y,w:w,h:h,f:f||'none',c:c===undefined?'#14142b':c,
  ep:ep==null?.4:ep,rx:rx||0,d:d,v:v};}
function Ov(cx,cy,r,f,c,ep,ry,d,v){return {t:'o',cx:cx,cy:cy,r:r,ry:ry,f:f||'none',
  c:c===undefined?'#14142b':c,ep:ep==null?.4:ep,d:d,v:v};}
function Pg(pts,f,c,ep,ferme,d,v){return {t:'p',pts:pts,f:f||'none',c:c===undefined?'#14142b':c,
  ep:ep==null?.4:ep,z:ferme!==false,d:d,v:v};}
function Tx(x,y,s,z,c,a,g,v){return {t:'x',x:x,y:y,s:String(s),z:z||4,c:c||'#14142b',a:a||'m',g:!!g,v:v};}
function arcPts(cx,cy,r,a0,a1,n,ry){var p=[];n=n||28;
  for(var i=0;i<=n;i++){var a=a0+(a1-a0)*i/n;p.push([cx+r*Math.cos(a),cy+(ry||r)*Math.sin(a)]);}return p;}
function polyReg(n,cx,cy,r,rot){var p=[];for(var i=0;i<n;i++){var a=(rot||-Math.PI/2)+i*2*Math.PI/n;
  p.push([cx+r*Math.cos(a),cy+r*Math.sin(a)]);}return p;}
function fleche(x1,y1,x2,y2,c,ep,v){
  var a=Math.atan2(y2-y1,x2-x1), k=2.4;c=c||'#14142b';
  return [Lg(x1,y1,x2-k*.6*Math.cos(a),y2-k*.6*Math.sin(a),c,ep||.5,null,v),
    Pg([[x2,y2],[x2-k*Math.cos(a-.42),y2-k*Math.sin(a-.42)],[x2-k*Math.cos(a+.42),y2-k*Math.sin(a+.42)]],c,c,.1,true,null,v)];
}
function dessin(W0,H0,prims,plus){
  var e={type:'dessin',W0:arrondi(W0),H0:arrondi(H0),prims:prims,w:arrondi(W0),h:arrondi(H0),police:'ecole'};
  for(var k in plus||{})e[k]=plus[k];
  return e;
}
/* un numéro posé à gauche de l'élément (les calculs, dessins à plusieurs
   parties et calculs en ligne ont le leur, à l'intérieur) */
function pastille(e){
  return e.num!=null&&e.type!=='calcul'&&!(e.type==='dessin'&&e.ancres)&&!(e.type==='texte'&&e.numLignes);
}
/* la note : un sticker rond, à bord festonné, « ___ / 20 » */
function stickerNote(e){
  var c=e.couleur||'#f0265c', S=40, cx=20, cy=20, P=[], pts=[];
  for(var i=0;i<=96;i++){var a=i/96*2*Math.PI, r=19.2*(.95+.05*Math.cos(16*a));
    pts.push([cx+r*Math.cos(a),cy+r*Math.sin(a)]);}
  P.push(Pg(pts,c,'none',0));
  P.push(Ov(cx,cy,15.2,'#ffffff','none',0));
  P.push(Ov(cx,cy,15.2,'none',c,.5));
  if(e.texte)P.push(Tx(cx,cy-2.4,e.texte,8,'#14142b','m',true));
  else P.push(Lg(cx-9,cy-1.2,cx+9,cy-1.2,'#8b8299',.35));
  P.push(Lg(cx-7.5,cy+2.2,cx+7.5,cy+2.2,c,.6));
  P.push(Tx(cx,cy+10,String(e.total||20),8.4,c,'m',true));
  return {type:'dessin',W0:S,H0:S,prims:P,w:e.w,h:e.h,x:e.x,y:e.y,police:'titre',centre:true};
}
function svgDessin(e){
  var h='';
  (e.prims||[]).forEach(function(p){
    var cl=p.v?' class="v-'+p.v+'"':'', d=p.d?' stroke-dasharray="'+p.d.join(' ')+'"':'';
    var st=' fill="'+(p.f||'none')+'" stroke="'+(p.c||'none')+'" stroke-width="'+(p.ep||0)+'"'+d+cl;
    if(p.t==='l')h+='<line x1="'+p.x1+'" y1="'+p.y1+'" x2="'+p.x2+'" y2="'+p.y2+'" stroke="'+p.c
      +'" stroke-width="'+p.ep+'" stroke-linecap="round"'+d+cl+'/>';
    else if(p.t==='r')h+='<rect x="'+p.x+'" y="'+p.y+'" width="'+p.w+'" height="'+p.h+'" rx="'+(p.rx||0)+'"'+st+'/>';
    else if(p.t==='o')h+='<ellipse cx="'+p.cx+'" cy="'+p.cy+'" rx="'+p.r+'" ry="'+(p.ry||p.r)+'"'+st+'/>';
    else if(p.t==='p')h+='<'+(p.z?'polygon':'polyline')+' points="'+p.pts.map(function(q){
      return arrondi(q[0],100)+','+arrondi(q[1],100);}).join(' ')+'" stroke-linejoin="round"'+st+'/>';
    else if(p.t==='x')h+='<text x="'+p.x+'" y="'+p.y+'" font-size="'+p.z+'" fill="'+p.c+'" text-anchor="'
      +({m:'middle',s:'start',e:'end'}[p.a]||'middle')+'"'+(p.g?' font-weight="800"':'')+cl+'>'+esc(p.s)+'</text>';
  });
  if(e.num!=null&&e.ancres)e.ancres.forEach(function(a,i){
    h+='<text x="'+a[0]+'" y="'+(a[1]+3.6)+'" font-size="4" font-weight="800" fill="#14142b" '
      +'text-anchor="end" style="font-family:\'Baloo 2\',sans-serif">'+(e.num+i)+'.</text>';});
  var f=(POLICES[e.police||'ecole']||POLICES.ecole)[0].replace(/"/g,"'");
  return '<svg class="des" viewBox="0 0 '+e.W0+' '+e.H0+'" preserveAspectRatio="'
    +(e.centre?'xMidYMid':'xMinYMin')+' meet" '
    +'style="width:100%;height:100%;font-family:'+f+'">'+h+'</svg>';
}

/* ---------- les outils du Cartable ---------- */
var CART={mat:null,outil:null};
var TEINTES_P=['#cfe9fb','#fdf2b3','#ffd7e2','#d5f2dc','#e7defb','#ffe2c9'];
function pad2(n){return (n<10?'0':'')+n;}
/* un espace de réponse : une ligne fine (des espaces insécables
   soulignés), jamais des pointillés */
var TRAIT='\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0';
function trou(){return {t:TRAIT,v:'eleve',u:true};}
/* une ligne fine pour écrire, dans un dessin */
function ligneEcr(x1,x2,y,v){return Lg(x1,y,x2,y,'#8b8299',.3,null,v);}
function lignesTexte(t){return String(t||'').split('\n').map(function(x){return x.trim();}).filter(Boolean);}
function melange(l){l=l.slice();for(var i=l.length-1;i>0;i--){var j=alea(0,i),t=l[i];l[i]=l[j];l[j]=t;}return l;}
/* range des éléments en lignes, dans la largeur utile */
function enRangees(els,gap){
  var x=0,y=0,hr=0,W=larg();
  els.forEach(function(e){
    if(x>0&&x+e.w>W+.1){x=0;y+=hr+gap;hr=0;}
    e.x=x;e.y=y;x+=e.w+gap;hr=Math.max(hr,e.h);
  });
  return els;
}
/* calculs en ligne : « 3 × 7 = …… » côté Élève, la réponse côté Prof */
function texteCalculs(lst,taille,numeros){
  var deux=lst.length>6, moitie=Math.ceil(lst.length/(deux?2:1)), out=[];
  [lst.slice(0,moitie),deux?lst.slice(moitie):[]].forEach(function(l,ci){
    if(!l.length)return;
    var runs=[];
    l.forEach(function(q,i){
      if(i)runs.push({t:'\n'});
      runs.push({t:(numeros?(i+1+ci*moitie)+')  ':'')+q.q+' = '});runs.push(trou());
      runs.push({t:q.r,v:'prof',c:'#f0265c'});
    });
    var w=deux?(larg()-8)/2:larg();
    out.push({type:'texte',x:ci*(w+8),y:0,w:w,h:arrondi(moitie*(taille||14)*PT*2.2+4),taille:taille||14,
      numLignes:!!numeros,police:'ecole',couleur:'#14142b',interligne:2.2,align:'left',
      texte:runs.map(function(r){return r.t;}).join(''),riche:runs});
  });
  return out;
}

var OUTILS={
  /* ======================= MATHS ======================= */
  ecrits:{nom:'Calculs écrits',ico:'',desc:'Posés en colonne : + − × ÷',special:'colonne'},
  mentaux:{nom:'Calculs mentaux',ico:'',desc:'En ligne : 34 + 27 = ____',special:'ligne'},
  numeration:{nom:'Tableau de numération',ico:'',desc:'Unités, milliers, millions, décimales',
    opts:[{id:'num',l:'Jusqu’aux',type:'select',choix:['Unités','Milliers','Millions'],def:'Milliers'},
      {id:'dec',l:'Décimales',type:'select',choix:[['0','Aucune'],'1','2','3'],def:'0'},
      {id:'rg',l:'Lignes à remplir',type:'select',choix:['1','2','3','4','5','6'],def:'2'}],
    faire:function(o){
      var classes=['Millions','Milliers','Unités'];classes=classes.slice(classes.indexOf(o.num));
      var dec=+o.dec, cols=classes.length*3+dec, tete=[], sous=[], fus=[];
      classes.forEach(function(nom,i){tete.push(nom,'','');sous.push('C','D','U');fus.push({y:0,x:i*3,ly:1,lx:3});});
      if(dec){tete.push('Décimales');for(var d=1;d<dec;d++)tete.push('');
        sous=sous.concat(['d','c','m'].slice(0,dec));if(dec>1)fus.push({y:0,x:classes.length*3,ly:1,lx:dec});}
      var cel=[tete,sous];for(var r=0;r<+o.rg;r++)cel.push(new Array(cols).fill(''));
      return [{type:'tableau',x:0,y:0,w:larg(),h:(2+(+o.rg))*10,cols:cols,rows:2+(+o.rg),tete:true,
        cellules:cel,fusions:fus,taille:12}];
    }},
  tables:{nom:'Tables de multiplication',ico:'✖️',desc:'Une table, ou le tableau de Pythagore',
    opts:[{id:'t',l:'Table',type:'select',choix:[['p','Tableau de Pythagore'],'2','3','4','5','6','7','8','9','10'],def:'p'},
      {id:'ordre',l:'Ordre',type:'select',choix:[['o','Dans l’ordre'],['m','Mélangée']],def:'o'}],
    faire:function(o){
      if(o.t==='p'){
        var cel=[['×'].concat([1,2,3,4,5,6,7,8,9,10].map(String))], cr={};
        for(var y=1;y<=10;y++){var r=[String(y)];for(var x=1;x<=10;x++){r.push(String(x*y));
          if(x>0)cr[y+'-'+x]=[{t:String(x*y),v:'prof',c:'#f0265c'}];}cel.push(r);}
        return [{type:'tableau',x:0,y:0,w:larg(),h:11*9,cols:11,rows:11,tete:true,cellules:cel,
          celRiche:cr,fusions:[],taille:12}];
      }
      var n=+o.t, l=[1,2,3,4,5,6,7,8,9,10];if(o.ordre==='m')l=melange(l);
      return texteCalculs(l.map(function(k){return {q:k+' × '+n,r:String(k*n)};}),16,o.num);
    }},
  droite:{nom:'Droite graduée',ico:'',desc:'Des nombres à placer ou à compléter',
    opts:[{id:'debut',l:'Début',type:'nombre',def:0},{id:'fin',l:'Fin',type:'nombre',def:20},
      {id:'pas',l:'Pas',type:'select',choix:['1','2','5','10','100','1000'],def:'1'},
      {id:'vides',l:'Nombres à compléter',type:'select',
        choix:[['aucun','Aucun'],['quelques','Quelques-uns'],['tous','Tous sauf le premier']],def:'quelques'}],
    faire:function(o){
      var a=+o.debut, pas=+o.pas, n=Math.max(1,Math.min(40,Math.round((+o.fin-a)/pas)));
      var W=larg(), x0=8, x1=W-10, y=12, k=(x1-x0)/n, P=[];
      P=P.concat(fleche(x0-4,y,x1+7,y,'#14142b',.6));
      var vides={};
      if(o.vides==='tous')for(var i=1;i<=n;i++)vides[i]=1;
      if(o.vides==='quelques')for(var j=1;j<n;j++)if(HASARD()<.4)vides[j]=1;
      for(var i2=0;i2<=n;i2++){
        var x=x0+i2*k, val=nb(a+i2*pas);
        P.push(Lg(x,y-3,x,y+3,'#14142b',.5));
        if(vides[i2]){P.push(Rc(x-k*.42,y+4.5,k*.84,6,'#fff','#9fb6d4',.3,1));
          P.push(Tx(x,y+8.6,val,3.6,'#f0265c','m',false,'prof'));}
        else P.push(Tx(x,y+8.6,val,3.6));
      }
      return [dessin(W,22,P)];
    }},
  regle:{nom:'Règle graduée',ico:'',desc:'À la taille réelle (imprimer à 100 %)',
    opts:[{id:'l',l:'Longueur',type:'select',choix:[['10','10 cm'],['15','15 cm'],['20','20 cm']],def:'15'},
      {id:'mm',l:'Millimètres',type:'case',def:true}],
    faire:function(o){
      var L=+o.l, W=L*10+10, P=[Rc(0,0,W,20,'#fff8d6','#c9a400',.4,1.5)];
      for(var i=0;i<=L*10;i++){
        if(!o.mm&&i%5)continue;
        var x=5+i, h=i%10===0?7:i%5===0?4.5:2.5;
        P.push(Lg(x,0,x,h,'#14142b',i%10===0?.3:.18));
        if(i%10===0)P.push(Tx(x,h+3.4,i/10,3.2));
      }
      P.push(Tx(W-4,17,'cm',2.6,'#8b8299','e'));
      return [dessin(W,20,P)];
    }},
  horloge:{nom:'Horloges',ico:'',desc:'Lire l’heure, ou dessiner les aiguilles',remplir:'n',
    opts:[{id:'n',l:'Combien',type:'select',choix:['1','2','3','4','6','8'],def:'4'},
      {id:'mode',l:'Exercice',type:'select',choix:[['lire','Lire l’heure (aiguilles dessinées)'],
        ['dessiner','Dessiner les aiguilles (heure écrite)']],def:'lire'},
      {id:'h',l:'Heures',type:'select',choix:[['pile','Heures pile'],['demi','Et demie'],['quart','Et quart, moins le quart'],
        ['cinq','De 5 en 5 minutes'],['min','À la minute']],def:'demi'}],
    faire:function(o){
      var out=[];
      for(var i=0;i<+o.n;i++){
        var hh=alea(1,12), m=0;
        if(o.h==='demi')m=[0,30][alea(0,1)];if(o.h==='quart')m=[0,15,30,45][alea(0,3)];
        if(o.h==='cinq')m=alea(0,11)*5;if(o.h==='min')m=alea(0,59);
        var cx=25,cy=25,r=23,P=[Ov(cx,cy,r,'#fff','#14142b',.8)];
        for(var t=0;t<60;t++){var a=t*Math.PI/30, l=t%5?1.6:3.2;
          P.push(Lg(cx+r*Math.sin(a),cy-r*Math.cos(a),cx+(r-l)*Math.sin(a),cy-(r-l)*Math.cos(a),'#14142b',t%5?.2:.5));}
        for(var k=1;k<=12;k++){var b=k*Math.PI/6;P.push(Tx(cx+(r-7)*Math.sin(b),cy-(r-7)*Math.cos(b)+1.5,k,4.3,'#14142b','m',true));}
        var ah=((hh%12)+m/60)*Math.PI/6, am=m*Math.PI/30, v=o.mode==='dessiner'?'prof':null,
          ch=v?'#f0265c':'#14142b';
        P.push(Lg(cx,cy,cx+11*Math.sin(ah),cy-11*Math.cos(ah),ch,1.6,null,v));
        P.push(Lg(cx,cy,cx+17*Math.sin(am),cy-17*Math.cos(am),ch,.9,null,v));
        P.push(Ov(cx,cy,1.2,'#14142b','none',0));
        var heure=hh+' h '+pad2(m);
        if(o.mode==='lire'){P.push(ligneEcr(cx-17,cx-5,57.5,'eleve'));P.push(Tx(cx,57,'h',4.6,'#14142b','m',false,'eleve'));
          P.push(ligneEcr(cx+5,cx+17,57.5,'eleve'));
          P.push(Tx(cx,57,heure,4.6,'#f0265c','m',true,'prof'));}
        else P.push(Tx(cx,57,heure,4.6,'#14142b','m',true));
        out.push(dessin(50,61,P));
      }
      return enRangees(out,8);
    }},
  thermometre:{nom:'Thermomètre',ico:'',desc:'Lire ou colorier une température',
    opts:[{id:'min',l:'De',type:'nombre',def:-10},{id:'max',l:'À',type:'nombre',def:40},
      {id:'mode',l:'Exercice',type:'select',choix:[['lire','Lire la température'],['colorier','Colorier la température']],def:'lire'}],
    faire:function(o){
      var mn=+o.min, mx=Math.max(mn+10,+o.max), pas=mx-mn>60?2:1, val=mn+alea(1,Math.floor((mx-mn)/pas)-1)*pas;
      var y0=92,y1=10,P=[], Y=function(t){return y0-(t-mn)/(mx-mn)*(y0-y1);};
      P.push(Rc(12,4,8,y0-4,'#fff','#14142b',.6,4));P.push(Ov(16,y0+6,7,'#fff','#14142b',.6));
      var v=o.mode==='colorier'?'prof':null;
      P.push(Rc(14,Y(val),4,y0-Y(val)+3,'#f0265c','none',0,1,null,v));P.push(Ov(16,y0+6,5.2,'#f0265c','none',0,null,null,v));
      for(var t=mn;t<=mx;t+=pas){var y=Y(t), l=t%10===0?6:t%5===0?4:2;
        P.push(Lg(20,y,20+l,y,'#14142b',t%5===0?.35:.2));
        if(t%10===0)P.push(Tx(28,y+1.3,t+'°',3.4,'#14142b','s'));}
      if(o.mode==='lire'){P.push(ligneEcr(6,26,112.5,'eleve'));P.push(Tx(28,112,'°C',4.4,'#14142b','s',false,'eleve'));
        P.push(Tx(20,112,val+' °C',4.4,'#f0265c','m',true,'prof'));}
      else P.push(Tx(20,112,val+' °C',4.4,'#14142b','m',true));
      return [dessin(40,116,P)];
    }},
  eprouvette:{nom:'Éprouvette graduée',ico:'',desc:'Lire un volume en mL',
    opts:[{id:'cap',l:'Capacité',type:'select',choix:[['100','100 mL'],['250','250 mL'],['500','500 mL'],['1000','1 L (1000 mL)']],def:'250'},
      {id:'mode',l:'Exercice',type:'select',choix:[['lire','Lire le volume'],['colorier','Colorier le volume']],def:'lire'}],
    faire:function(o){
      var cap=+o.cap, pas={100:2,250:5,500:10,1000:20}[cap], lab={100:10,250:50,500:50,1000:100}[cap];
      var val=alea(2,cap/pas-2)*pas, y0=100,y1=12, Y=function(v){return y0-v/cap*(y0-y1);}, P=[];
      var v=o.mode==='colorier'?'prof':null;
      P.push(Rc(11,Y(val),20,y0-Y(val),'#9ec4ea','none',0,0,null,v));
      P.push(Pg([[10,6],[10,y0],[32,y0],[32,6]],'none','#14142b',.6,false));
      P.push(Rc(4,y0,34,4,'#e8ddd2','#14142b',.5,1));
      for(var t=0;t<=cap;t+=pas){var y=Y(t), l=t%lab===0?7:3;P.push(Lg(10,y,10+l,y,'#14142b',t%lab===0?.35:.2));
        if(t%lab===0&&t)P.push(Tx(34,y+1.2,nb(t),3.2,'#14142b','s'));}
      P.push(Tx(34,7,'mL',3,'#8b8299','s'));
      if(o.mode==='lire'){P.push(ligneEcr(4,28,113.5,'eleve'));P.push(Tx(30,113,'mL',4.4,'#14142b','s',false,'eleve'));
        P.push(Tx(21,113,nb(val)+' mL',4.4,'#f0265c','m',true,'prof'));}
      else P.push(Tx(21,113,nb(val)+' mL',4.4,'#14142b','m',true));
      return [dessin(48,117,P)];
    }},
  monnaie:{nom:'Pièces et billets',ico:'',desc:'L’euro, à découper',
    opts:[{id:'q',l:'Quoi',type:'select',choix:[['pieces','Les pièces'],['billets','Les billets'],['tout','Pièces et billets']],def:'tout'}],
    faire:function(o){
      var P=[], x=4, y=4, W=larg(), hr=0;
      function place(w,h){if(x+w>W){x=4;y+=hr+5;hr=0;}var p=[x,y];x+=w+5;hr=Math.max(hr,h);return p;}
      if(o.q!=='billets')[['1c',8,'#e8a77a'],['2c',9,'#e8a77a'],['5c',10,'#e8a77a'],['10c',9.5,'#f2cf63'],
        ['20c',10.5,'#f2cf63'],['50c',11.5,'#f2cf63'],['1 €',11,'b'],['2 €',12.5,'b']].forEach(function(c){
        var p=place(c[1]*2,c[1]*2), cx=p[0]+c[1], cy=p[1]+c[1];
        if(c[2]==='b'){P.push(Ov(cx,cy,c[1],'#f2cf63','#14142b',.4));P.push(Ov(cx,cy,c[1]*.68,'#d8dde6','#8b8299',.3));}
        else P.push(Ov(cx,cy,c[1],c[2],'#14142b',.4));
        P.push(Tx(cx,cy+1.6,c[0],c[1]*.55,'#14142b','m',true));
      });
      if(o.q!=='pieces'){if(x>4){x=4;y+=hr+5;hr=0;}
        [['5 €','#d9d9d9'],['10 €','#f4b6b6'],['20 €','#a9c9f0'],['50 €','#f7c48b'],['100 €','#b9e3b0']].forEach(function(b){
          var p=place(52,27);P.push(Rc(p[0],p[1],52,27,b[1],'#14142b',.4,2.5));
          P.push(Rc(p[0]+3,p[1]+3,46,21,'none','#ffffff',.4,1.5));
          P.push(Tx(p[0]+26,p[1]+17,b[0],10,'#14142b','m',true));});}
      return [dessin(W,y+hr+4,P)];
    }},
  formes:{nom:'Formes planes',ico:'',desc:'Carré, triangle, hexagone…',
    opts:[{id:'f',l:'Formes',type:'select',choix:[['toutes','Toutes'],['base','Les 4 de base'],['poly','Les polygones']],def:'toutes'},
      {id:'noms',l:'Noms',type:'select',choix:[['ecrits','Écrits'],['trouver','À trouver (réponse Prof)'],['aucun','Aucun']],def:'trouver'},
      {id:'coul',l:'En couleur',type:'case',def:true}],
    faire:function(o){
      var F=[['carré',function(c){return [[c[0]-12,c[1]-12],[c[0]+12,c[1]-12],[c[0]+12,c[1]+12],[c[0]-12,c[1]+12]];}],
        ['rectangle',function(c){return [[c[0]-15,c[1]-9],[c[0]+15,c[1]-9],[c[0]+15,c[1]+9],[c[0]-15,c[1]+9]];}],
        ['triangle',function(c){return polyReg(3,c[0],c[1]+3,15);}],
        ['cercle',null],
        ['triangle rectangle',function(c){return [[c[0]-13,c[1]-13],[c[0]-13,c[1]+12],[c[0]+13,c[1]+12]];}],
        ['losange',function(c){return [[c[0],c[1]-15],[c[0]+11,c[1]],[c[0],c[1]+15],[c[0]-11,c[1]]];}],
        ['parallélogramme',function(c){return [[c[0]-10,c[1]-9],[c[0]+16,c[1]-9],[c[0]+10,c[1]+9],[c[0]-16,c[1]+9]];}],
        ['trapèze',function(c){return [[c[0]-8,c[1]-9],[c[0]+8,c[1]-9],[c[0]+15,c[1]+9],[c[0]-15,c[1]+9]];}],
        ['pentagone',function(c){return polyReg(5,c[0],c[1]+1,14);}],
        ['hexagone',function(c){return polyReg(6,c[0],c[1],14,0);}],
        ['octogone',function(c){return polyReg(8,c[0],c[1],14,Math.PI/8);}],
        ['ovale',null]];
      if(o.f==='base')F=F.slice(0,4);if(o.f==='poly')F=F.slice(4,11);
      var cw=36, parL=Math.floor(larg()/cw), P=[], A=[];
      F.forEach(function(f,i){
        var c=[(i%parL)*cw+cw/2,Math.floor(i/parL)*44+18], col=o.coul?TEINTES_P[i%TEINTES_P.length]:'#fff';
        A.push([(i%parL)*cw,Math.floor(i/parL)*44]);
        if(f[0]==='cercle')P.push(Ov(c[0],c[1],14,col,'#14142b',.6));
        else if(f[0]==='ovale')P.push(Ov(c[0],c[1],16,col,'#14142b',.6,10));
        else P.push(Pg(f[1](c),col,'#14142b',.6));
        if(o.noms==='ecrits')P.push(Tx(c[0],c[1]+22,f[0],3.6));
        if(o.noms==='trouver'){P.push(ligneEcr(c[0]-14,c[0]+14,c[1]+23,'eleve'));
          P.push(Tx(c[0],c[1]+22,f[0],3.6,'#f0265c','m',false,'prof'));}
      });
      return [dessin(parL*cw,Math.ceil(F.length/parL)*44,P,{ancres:A})];
    }},
  solides:{nom:'Solides (formes 3D)',ico:'',desc:'Cube, pavé, cylindre, cône, pyramide, sphère',
    opts:[{id:'noms',l:'Noms',type:'select',choix:[['ecrits','Écrits'],['trouver','À trouver (réponse Prof)'],['aucun','Aucun']],def:'trouver'},
      {id:'coul',l:'En couleur',type:'case',def:true}],
    faire:function(o){
      var cw=40, parL=Math.floor(larg()/cw), P=[], cach=[1,1];
      var S=['cube','pavé droit','cylindre','cône','pyramide','sphère','prisme'];
      var ANC=[];
      S.forEach(function(n,i){
        var X=(i%parL)*cw, Y=Math.floor(i/parL)*50, col=o.coul?TEINTES_P[i%TEINTES_P.length]:'#fff';
        ANC.push([X,Y]);
        function q(x,y){return [X+x,Y+y];}
        if(n==='cube'||n==='pavé droit'||n==='prisme'){
          var w=n==='pavé droit'?24:n==='prisme'?22:18, h=n==='pavé droit'?13:18, dx=9, dy=-7, x0=6, y0=14;
          if(n==='prisme'){
            var a=q(x0,y0+h),b=q(x0+w,y0+h),c=q(x0+w/2,y0),a2=q(x0+dx,y0+h+dy),b2=q(x0+w+dx,y0+h+dy),c2=q(x0+w/2+dx,y0+dy);
            P.push(Pg([c,c2,b2,b],col,'#14142b',.5));P.push(Pg([a,b,c],col,'#14142b',.5));
            P.push(Lg(a[0],a[1],a2[0],a2[1],'#14142b',.4,cach));P.push(Lg(a2[0],a2[1],b2[0],b2[1],'#14142b',.4,cach));
            P.push(Lg(a2[0],a2[1],c2[0],c2[1],'#14142b',.4,cach));
          }else{
            var A=q(x0,y0),B=q(x0+w,y0),C=q(x0+w,y0+h),D=q(x0,y0+h);
            var A2=q(x0+dx,y0+dy),B2=q(x0+w+dx,y0+dy),C2=q(x0+w+dx,y0+h+dy),D2=q(x0+dx,y0+h+dy);
            P.push(Pg([A,A2,B2,B],col,'#14142b',.5));P.push(Pg([B,B2,C2,C],col,'#14142b',.5));
            P.push(Pg([A,B,C,D],col,'#14142b',.5));
            P.push(Lg(D[0],D[1],D2[0],D2[1],'#14142b',.4,cach));P.push(Lg(D2[0],D2[1],A2[0],A2[1],'#14142b',.4,cach));
            P.push(Lg(D2[0],D2[1],C2[0],C2[1],'#14142b',.4,cach));
          }
        }else if(n==='cylindre'){
          P.push(Pg([q(8,10)].concat(arcPts(X+20,Y+34,12,Math.PI,0,20,4).map(function(p){return p;})).concat([q(32,10)]),
            col,'none',0));
          P.push(Ov(X+20,Y+10,12,col,'#14142b',.5,4));
          P.push(Lg(X+8,Y+10,X+8,Y+34,'#14142b',.5));P.push(Lg(X+32,Y+10,X+32,Y+34,'#14142b',.5));
          P.push(Pg(arcPts(X+20,Y+34,12,0,Math.PI,20,4),'none','#14142b',.5,false));
          P.push(Pg(arcPts(X+20,Y+34,12,Math.PI,2*Math.PI,20,4),'none','#14142b',.4,false,cach));
        }else if(n==='cône'){
          P.push(Pg([q(20,4)].concat(arcPts(X+20,Y+34,12,0,Math.PI,20,4)),col,'#14142b',.5));
          P.push(Pg(arcPts(X+20,Y+34,12,Math.PI,2*Math.PI,20,4),'none','#14142b',.4,false,cach));
        }else if(n==='pyramide'){
          var s1=q(6,34),s2=q(26,34),s3=q(34,27),s4=q(14,27),t=q(20,4);
          P.push(Pg([s1,s2,t],col,'#14142b',.5));P.push(Pg([s2,s3,t],col,'#14142b',.5));
          P.push(Lg(s1[0],s1[1],s4[0],s4[1],'#14142b',.4,cach));P.push(Lg(s4[0],s4[1],s3[0],s3[1],'#14142b',.4,cach));
          P.push(Lg(s4[0],s4[1],t[0],t[1],'#14142b',.4,cach));
        }else if(n==='sphère'){
          P.push(Ov(X+20,Y+21,14,col,'#14142b',.5));
          P.push(Pg(arcPts(X+20,Y+21,14,0,Math.PI,20,4),'none','#14142b',.4,false));
          P.push(Pg(arcPts(X+20,Y+21,14,Math.PI,2*Math.PI,20,4),'none','#14142b',.3,false,cach));
        }
        if(o.noms==='ecrits')P.push(Tx(X+20,Y+44,n,3.6));
        if(o.noms==='trouver'){P.push(ligneEcr(X+6,X+34,Y+45,'eleve'));
          P.push(Tx(X+20,Y+44,n,3.6,'#f0265c','m',false,'prof'));}
      });
      return [dessin(parL*cw,Math.ceil(S.length/parL)*50,P,{ancres:ANC})];
    }},
  papier:{nom:'Papier pointé ou quadrillé',ico:'⠿',desc:'Pour reproduire, tracer, compter',
    opts:[{id:'type',l:'Type',type:'select',choix:[['points','Pointé'],['carres','Quadrillé'],['iso','Pointé isométrique (triangles)']],def:'points'},
      {id:'pas',l:'Écart',type:'select',choix:[['5','5 mm'],['7','7 mm'],['10','1 cm']],def:'10'},
      {id:'h',l:'Hauteur (mm)',type:'nombre',def:100}],
    faire:function(o){
      var pas=+o.pas, W=Math.floor(larg()/pas)*pas, H=Math.max(pas*2,Math.floor(Math.min(+o.h,230)/pas)*pas), P=[];
      if(o.type==='carres'){
        for(var x=0;x<=W+.01;x+=pas)P.push(Lg(x,0,x,H,'#b9cde6',.2));
        for(var y=0;y<=H+.01;y+=pas)P.push(Lg(0,y,W,y,'#b9cde6',.2));
      }else{
        var dy=o.type==='iso'?pas*.866:pas;
        for(var j=0,yy=0;yy<=H+.01;j++,yy=j*dy)
          for(var xx=(o.type==='iso'&&j%2?pas/2:0);xx<=W+.01;xx+=pas)P.push(Ov(xx,yy,.38,'#8b8299','none',0));
      }
      return [dessin(W,H,P,{police:'texte'})];
    }},
  repere:{nom:'Quadrillage repéré',ico:'',desc:'Cases A1, B2… (bataille navale, coder)',
    opts:[{id:'c',l:'Colonnes',type:'select',choix:['6','8','10','12'],def:'10'},
      {id:'r',l:'Lignes',type:'select',choix:['6','8','10','12'],def:'10'},
      {id:'k',l:'Taille des cases',type:'select',choix:[['8','8 mm'],['10','1 cm'],['12','12 mm']],def:'10'}],
    faire:function(o){
      var C=+o.c, Rr=+o.r, k=+o.k, P=[], x0=8, y0=8;
      for(var i=0;i<=C;i++)P.push(Lg(x0+i*k,y0,x0+i*k,y0+Rr*k,'#14142b',.3));
      for(var j=0;j<=Rr;j++)P.push(Lg(x0,y0+j*k,x0+C*k,y0+j*k,'#14142b',.3));
      for(i=0;i<C;i++)P.push(Tx(x0+i*k+k/2,y0-2,String.fromCharCode(65+i),3.8,'#14142b','m',true));
      for(j=0;j<Rr;j++)P.push(Tx(x0-4,y0+j*k+k/2+1.3,j+1,3.8,'#14142b','m',true));
      return [dessin(x0+C*k+1,y0+Rr*k+1,P)];
    }},
  symetrie:{nom:'Symétrie à compléter',ico:'',desc:'Une moitié dessinée, l’autre à colorier',
    opts:[{id:'c',l:'Taille',type:'select',choix:[['8','Petite (8 × 8)'],['12','Moyenne (12 × 10)'],['16','Grande (16 × 12)']],def:'12'}],
    faire:function(o){
      var C=+o.c, Rr=C===8?8:C===12?10:12, k=Math.min(9,larg()/C), P=[], moit=C/2, plein={};
      /* une figure au hasard, collée à l'axe */
      var x=moit-1, y=alea(1,Rr-2);
      for(var n=0;n<C*Rr/6;n++){plein[x+','+y]=1;
        var d=alea(0,3);if(d===0&&x>0)x--;if(d===1&&x<moit-1)x++;if(d===2&&y>0)y--;if(d===3&&y<Rr-1)y++;}
      Object.keys(plein).forEach(function(c){var p=c.split(',');
        P.push(Rc(+p[0]*k,+p[1]*k,k,k,'#c9c1f2','none',0));
        P.push(Rc((C-1-p[0])*k,+p[1]*k,k,k,'#ffc9d6','none',0,0,null,'prof'));});
      for(var i=0;i<=C;i++)P.push(Lg(i*k,0,i*k,Rr*k,'#b9cde6',.25));
      for(var j=0;j<=Rr;j++)P.push(Lg(0,j*k,C*k,j*k,'#b9cde6',.25));
      P.push(Lg(moit*k,-3,moit*k,Rr*k+3,'#f0265c',.8));
      return [dessin(C*k,Rr*k,P,{police:'texte'})];
    }},
  fracBarres:{nom:'Fractions en barres',ico:'▭',desc:'Des barres partagées à lire ou colorier',remplir:'n',
    opts:[{id:'d',l:'Partagées en',type:'select',choix:['2','3','4','5','6','8','10','12'],def:'4'},
      {id:'n',l:'Combien de barres',type:'select',choix:['1','2','3','4','5','6'],def:'4'},
      {id:'mode',l:'Exercice',type:'select',choix:[['lire','Lire la fraction coloriée'],['colorier','Colorier la fraction écrite']],def:'lire'}],
    faire:function(o){
      var d=+o.d, W=larg(), bw=W-34, P=[], A=[];
      for(var i=0;i<+o.n;i++){
        var y=i*18, k=alea(1,d-1), v=o.mode==='colorier'?'prof':null;A.push([-1,y+1]);
        for(var j=0;j<d;j++)P.push(Rc(j*bw/d,y,bw/d,12,j<k?'#cfe9fb':'#fff','#14142b',.5,0,null,j<k?v:null));
        for(j=0;j<d;j++)if(j>=k&&v)P.push(Rc(j*bw/d,y,bw/d,12,'#fff','#14142b',.5));
        if(o.mode==='lire'){P.push(ligneEcr(bw+5,bw+13,y+9,'eleve'));P.push(Tx(bw+16,y+8,'/',4.6,'#14142b','m',false,'eleve'));
          P.push(ligneEcr(bw+19,bw+27,y+9,'eleve'));
          P.push(Tx(bw+16,y+8,k+' / '+d,4.6,'#f0265c','m',true,'prof'));}
        else P.push(Tx(bw+16,y+8,k+' / '+d,4.6,'#14142b','m',true));
      }
      return [dessin(W,+o.n*18-6,P,{ancres:A})];
    }},
  fracDisques:{nom:'Fractions en disques',ico:'',desc:'Des parts de gâteau',remplir:'n',
    opts:[{id:'d',l:'Partagés en',type:'select',choix:['2','3','4','5','6','8','10','12'],def:'6'},
      {id:'n',l:'Combien de disques',type:'select',choix:['1','2','3','4','5','6'],def:'4'},
      {id:'mode',l:'Exercice',type:'select',choix:[['lire','Lire la fraction coloriée'],['colorier','Colorier la fraction écrite']],def:'lire'}],
    faire:function(o){
      var d=+o.d, out=[];
      for(var i=0;i<+o.n;i++){
        var k=alea(1,d-1), v=o.mode==='colorier'?'prof':null, P=[], cx=20, cy=20, r=17;
        for(var j=0;j<d;j++){var a0=-Math.PI/2+j*2*Math.PI/d, a1=a0+2*Math.PI/d;
          P.push(Pg([[cx,cy]].concat(arcPts(cx,cy,r,a0,a1,12)),j<k?'#ffd7e2':'#fff','#14142b',.5,true,null,j<k?v:null));
          if(j<k&&v)P.push(Pg([[cx,cy]].concat(arcPts(cx,cy,r,a0,a1,12)),'none','#14142b',.5));}
        if(o.mode==='lire'){P.push(ligneEcr(cx-14,cx-4,46.5,'eleve'));P.push(Tx(cx,46,'/',4.6,'#14142b','m',false,'eleve'));
          P.push(ligneEcr(cx+4,cx+14,46.5,'eleve'));
          P.push(Tx(cx,46,k+' / '+d,4.6,'#f0265c','m',true,'prof'));}
        else P.push(Tx(cx,46,k+' / '+d,4.6,'#14142b','m',true));
        out.push(dessin(40,49,P));
      }
      return enRangees(out,8);
    }},
  graphique:{nom:'Graphique en barres',ico:'',desc:'Des axes prêts à remplir',
    opts:[{id:'n',l:'Catégories',type:'select',choix:['3','4','5','6','8'],def:'5'},
      {id:'max',l:'Jusqu’à',type:'select',choix:['5','10','20','50','100'],def:'10'}],
    faire:function(o){
      var n=+o.n, mx=+o.max, st=mx<=10?1:mx/10, W=larg(), H=90, x0=14, y0=76, y1=6, P=[];
      for(var v=0;v<=mx;v+=st){var y=y0-v/mx*(y0-y1);
        P.push(Lg(x0,y,W-4,y,'#e3dde9',.2));P.push(Tx(x0-3,y+1.2,nb(v),3,'#14142b','e'));}
      P=P.concat(fleche(x0,y0+2,x0,y1-4,'#14142b',.6)).concat(fleche(x0-2,y0,W-1,y0,'#14142b',.6));
      var cw=(W-x0-8)/n;
      for(var i=0;i<n;i++)P.push(ligneEcr(x0+cw*i+cw*.2,x0+cw*i+cw*.8,y0+9));
      return [dessin(W,H,P)];
    }},

  /* ======================= FRANÇAIS ======================= */
  lignesEcr:{nom:'Lignes d’écriture',ico:'',desc:'Maison, couleurs, Seyès, simples…',
    opts:[{id:'g',l:'Type',type:'select',choix:[['maison','Lignes maison'],['couleurs','Lignes de couleur'],
      ['quatre','4 lignes'],['seyes','Seyès'],['simple','Lignes simples'],['pointille','Pointillés']],def:'maison'},
      {id:'nb',l:'Combien de lignes',type:'select',choix:['1','2','3','4','5','6','8','10','12'],def:'4'}],
    faire:function(o){var e=ligneNeuve(o.g);e.nb=+o.nb;e.h=hauteurBloc(e);e.x=0;e.y=0;return [e];}},
  redaction:{nom:'Cadre de rédaction',ico:'',desc:'Un titre et des lignes',
    opts:[{id:'nb',l:'Lignes',type:'select',choix:['5','8','10','12','15','20'],def:'10'},
      {id:'g',l:'Type de lignes',type:'select',choix:[['seyes','Seyès'],['simple','Simples']],def:'simple'}],
    faire:function(o){
      var t={type:'texte',x:0,y:0,w:20,h:9,texte:'Titre :',taille:13,police:'titre',
        couleur:'#14142b',gras:true,item:true};
      var lt=ligneNeuve('simple');lt.nb=1;lt.h=hauteurBloc(lt);lt.x=21;lt.w=larg()-21;lt.y=0;
      var e=ligneNeuve(o.g);e.nb=+o.nb;e.h=hauteurBloc(e);e.x=0;e.y=12;
      return [t,lt,e];
    }},
  dictee:{nom:'Feuille de dictée',ico:'',desc:'Des lignes numérotées',sansNum:true,
    opts:[{id:'nb',l:'Phrases',type:'select',choix:['5','6','8','10','12','15'],def:'8'}],
    faire:function(o){
      var n=+o.nb, e=ligneNeuve('simple');e.nb=n;e.h=hauteurBloc(e);e.x=9;e.w=larg()-9;e.y=0;
      var nums=[];for(var i=1;i<=n;i++)nums.push(i+'.');
      var pitch=(e.hl||9)+(e.ecart==null?1.5:e.ecart);
      return [{type:'texte',x:0,y:pitch*.18,w:9,h:e.h,texte:nums.join('\n'),taille:12,police:'titre',
        couleur:'#8b8299',gras:true,interligne:arrondi(pitch/(12*PT),100)},e];
    }},
  etiquettesMots:{nom:'Étiquettes-mots',ico:'',desc:'Des mots à découper',
    opts:[{id:'mots',l:'Les mots (séparés par des espaces ou des virgules)',type:'texte',def:'le chat dort sur le canapé'},
      {id:'col',l:'Par ligne',type:'select',choix:['3','4','5','6'],def:'4'}],
    faire:function(o){
      var m=String(o.mots).split(/[\s,;]+/).filter(Boolean), c=+o.col, r=Math.ceil(m.length/c), cel=[];
      for(var i=0;i<r;i++){var l=[];for(var j=0;j<c;j++)l.push(m[i*c+j]||'');cel.push(l);}
      return [{type:'tableau',x:0,y:0,w:larg(),h:r*16,cols:c,rows:r,tete:false,cellules:cel,
        fusions:[],taille:16}];
    }},
  phrase:{nom:'Phrases en désordre',ico:'',desc:'Remettre les mots dans l’ordre',
    opts:[{id:'ph',l:'Une phrase par ligne',type:'texte',def:'Le chat dort sur le canapé.\nMa maman prépare une tarte.'}],
    faire:function(o){
      var out=[], y=0;
      lignesTexte(o.ph).forEach(function(p){
        var m=p.split(/\s+/).filter(Boolean), sh=melange(m);
        if(sh.join(' ')===m.join(' ')&&m.length>1)sh=sh.slice(1).concat(sh[0]);
        out.push({type:'tableau',x:0,y:y,w:larg(),h:14,cols:m.length,rows:1,tete:false,item:true,
          cellules:[sh],fusions:[],taille:14});
        var l=ligneNeuve('simple');l.nb=1;l.h=hauteurBloc(l);l.x=0;l.y=y+17;out.push(l);
        out.push({type:'texte',x:0,y:y+17,w:larg(),h:9,texte:p,taille:13,police:'ecole',
          couleur:'#f0265c',corrige:true});
        y+=31;
      });
      return out;
    }},
  relier:{nom:'Relier',ico:'',desc:'Deux colonnes à relier par un trait',
    opts:[{id:'p',l:'Une paire par ligne : gauche = droite',type:'texte',def:'chat = miaule\nchien = aboie\nvache = meugle\ncanard = cancane'}],
    faire:function(o){
      var pr=lignesTexte(o.p).map(function(l){var x=l.split('=');return [(x[0]||'').trim(),(x[1]||'').trim()];});
      var dr=melange(pr.map(function(x,i){return i;})), W=larg(), bw=W*.32, P=[];
      var A=[];
      pr.forEach(function(x,i){
        var y=i*14;A.push([-1,y+1]);
        P.push(Rc(0,y,bw,10,'#fdf0eb','#e8ddd2',.4,2));P.push(Tx(bw/2,y+6.4,x[0],4.2));
        P.push(Ov(bw+4,y+5,1.3,'#14142b','none',0));
        var j=dr.indexOf(i);
        P.push(Rc(W-bw,j*14,bw,10,'#ecf4fd','#cfe0f2',.4,2));P.push(Tx(W-bw/2,j*14+6.4,x[1],4.2));
        P.push(Ov(W-bw-4,j*14+5,1.3,'#14142b','none',0));
        P.push(Lg(bw+4,y+5,W-bw-4,j*14+5,'#f0265c',.5,null,'prof'));
      });
      return [dessin(W,pr.length*14-4,P,{police:'texte',ancres:A})];
    }},

  /* ======================= SCIENCES ======================= */
  legender:{nom:'Schéma à légender',ico:'',desc:'Un cadre pour l’image, des légendes autour',
    opts:[{id:'n',l:'Légendes',type:'select',choix:['4','6','8'],def:'6'},
      {id:'mots',l:'Les réponses (une par ligne, facultatif)',type:'texte',def:''}],
    faire:function(o){
      var n=+o.n, W=larg(), H=n/2*20+10, rep=lignesTexte(o.mots), bw=44, P=[];
      var cx0=bw+14, cw=W-2*bw-28;
      P.push(Rc(cx0,4,cw,H-8,'#fbfaf8','#c9bfc9',.3,3));
      for(var i=0;i<n;i++){
        var g=i<n/2, k=g?i:i-n/2, y=10+k*20, bx=g?0:W-bw;
        P.push(Rc(bx,y-5,bw,10,'#fff','#9fb6d4',.4,2));
        P.push(Lg(g?bw:W-bw,y,g?cx0+8+k*3:cx0+cw-8-k*3,y+alea(-4,4),'#14142b',.35));
        P.push(Ov(g?cx0+8+k*3:cx0+cw-8-k*3,y,.9,'#14142b','none',0));
        if(rep[i])P.push(Tx(bx+bw/2,y+1.4,rep[i],3.8,'#f0265c','m',false,'prof'));
      }
      return [dessin(W,H,P,{police:'texte'})];
    }},
  cycle:{nom:'Cycle',ico:'',desc:'Des étapes en rond (eau, papillon, saisons…)',
    opts:[{id:'n',l:'Étapes',type:'select',choix:['3','4','5','6'],def:'4'},
      {id:'mots',l:'Les étapes (une par ligne, facultatif)',type:'texte',def:''}],
    faire:function(o){
      var n=+o.n, W=larg(), H=110, cx=W/2, cy=H/2, R=38, bw=46, bh=16, m=lignesTexte(o.mots), P=[];
      for(var i=0;i<n;i++){
        var a=-Math.PI/2+i*2*Math.PI/n, x=cx+R*1.35*Math.cos(a), y=cy+R*Math.sin(a);
        P.push(Rc(x-bw/2,y-bh/2,bw,bh,TEINTES_P[i%TEINTES_P.length],'#14142b',.5,4));
        if(m[i])P.push(Tx(x,y+1.5,m[i],4));
        var a1=a+Math.PI/n-.18, a0=a+.42;
        var pts=arcPts(cx,cy,R*1.05,a0,a+2*Math.PI/n-.42,10,R*.82);
        P.push(Pg(pts,'none','#8b8299',.6,false));
        var e1=pts[pts.length-2], e2=pts[pts.length-1];
        P=P.concat(fleche(e1[0],e1[1],e2[0],e2[1],'#8b8299',.6));
      }
      return [dessin(W,H,P,{police:'texte'})];
    }},
  demarche:{nom:'Démarche scientifique',ico:'',desc:'Question, hypothèse, expérience, observation, conclusion',
    opts:[],
    faire:function(){
      var W=larg(), P=[], T=['Ma question','Mon hypothèse','Mon expérience','Ce que j’observe','Ma conclusion'];
      T.forEach(function(t,i){var y=i*36;
        P.push(Rc(0,y,W,32,'#fff','#e8ddd2',.5,3));P.push(Rc(0,y,W,8,TEINTES_P[i],'none',0,3));
        P.push(Tx(4,y+5.6,t,4.2,'#14142b','s',true));
        for(var k=1;k<=2;k++)P.push(Lg(4,y+8+k*8,W-4,y+8+k*8,'#c3bccd',.25));});
      return [dessin(W,5*36-4,P,{police:'titre'})];
    }},
  observation:{nom:'Tableau d’observation',ico:'',desc:'Date, observation, dessin',
    opts:[{id:'n',l:'Lignes',type:'select',choix:['3','4','5','6','8'],def:'5'}],
    faire:function(o){var n=+o.n, cel=[['Date','Ce que j’observe','Mon dessin']];
      for(var i=0;i<n;i++)cel.push(['','','']);
      return [{type:'tableau',x:0,y:0,w:larg(),h:10+n*24,cols:3,rows:n+1,tete:true,cellules:cel,fusions:[],taille:11}];}},

  /* ======================= HISTOIRE ET GÉOGRAPHIE ======================= */
  frise:{nom:'Frise chronologique',ico:'',desc:'Des années et des événements à placer',
    opts:[{id:'debut',l:'Début',type:'nombre',def:1900},{id:'fin',l:'Fin',type:'nombre',def:2030},
      {id:'pas',l:'Graduation tous les',type:'select',choix:['1','5','10','20','50','100','500','1000'],def:'10'},
      {id:'ev',l:'Cases d’événements',type:'select',choix:['0','3','4','5','6'],def:'4'}],
    faire:function(o){
      var a=+o.debut, b=Math.max(a+1,+o.fin), pas=+o.pas, n=Math.max(1,Math.min(30,Math.round((b-a)/pas)));
      var W=larg(), x0=6, x1=W-10, y=40, k=(x1-x0)/n, P=[Rc(x0,y-2.5,x1-x0,5,'#fdf0eb','none',0)];
      P=P.concat(fleche(x0,y,x1+8,y,'#14142b',.7));
      for(var i=0;i<=n;i++){var x=x0+i*k;P.push(Lg(x,y-3.5,x,y+3.5,'#14142b',.5));
        if(n<=20||i%2===0)P.push(Tx(x,y+9,a+i*pas,3.4));}
      var ev=+o.ev, bw=Math.min(38,(W-10)/Math.max(1,ev)-4);
      for(var j=0;j<ev;j++){var cx=x0+(j+.5)*(x1-x0)/ev;
        P.push(Rc(cx-bw/2,2,bw,22,'#fff','#9fb6d4',.4,2));P.push(Lg(cx,24,cx,y-3,'#9fb6d4',.3));}
      return [dessin(W,52,P)];
    }},
  rose:{nom:'Rose des vents',ico:'',desc:'Les points cardinaux',
    opts:[{id:'noms',l:'Points cardinaux',type:'select',choix:[['ecrits','Écrits'],['trouver','À compléter (réponse Prof)']],def:'trouver'},
      {id:'huit',l:'Avec NE, SE, SO, NO',type:'case',def:true}],
    faire:function(o){
      var c=34, P=[], N=['N','NE','E','SE','S','SO','O','NO'];
      for(var i=0;i<8;i++){
        if(i%2&&!o.huit)continue;
        var a=-Math.PI/2+i*Math.PI/4, L=i%2?14:24, w=i%2?2.6:4;
        var tip=[c+L*Math.cos(a),c+L*Math.sin(a)], l1=[c+w*Math.cos(a-Math.PI/2),c+w*Math.sin(a-Math.PI/2)],
          l2=[c+w*Math.cos(a+Math.PI/2),c+w*Math.sin(a+Math.PI/2)];
        P.push(Pg([tip,l1,[c,c]],i%2?'#cfe9fb':'#2f80c8','#14142b',.4));
        P.push(Pg([tip,l2,[c,c]],'#fff','#14142b',.4));
        var lx=c+(L+5)*Math.cos(a), ly=c+(L+5)*Math.sin(a)+1.5;
        if(o.noms==='ecrits')P.push(Tx(lx,ly,N[i],4.2,'#14142b','m',true));
        else{P.push(Rc(lx-4.5,ly-5,9,6.5,'#fff','#9fb6d4',.3,1,null,'eleve'));
          P.push(Tx(lx,ly,N[i],4.2,'#f0265c','m',true,'prof'));}
      }
      return [dessin(68,68,P)];
    }},
  legendeCarte:{nom:'Légende de carte',ico:'',desc:'Symbole, signification',
    opts:[{id:'n',l:'Lignes',type:'select',choix:['3','4','5','6','8'],def:'5'}],
    faire:function(o){var n=+o.n, cel=[['Symbole','Ce qu’il signifie']];for(var i=0;i<n;i++)cel.push(['','']);
      return [{type:'tableau',x:0,y:0,w:larg()*.7,h:10+n*13,cols:2,rows:n+1,tete:true,cellules:cel,fusions:[],taille:11}];}},

  /* ======================= DESSIN ET CRÉATION ======================= */
  cadreDessin:{nom:'Cadre de dessin',ico:'✎',desc:'« Dessine ici »',
    opts:[{id:'h',l:'Hauteur (mm)',type:'nombre',def:60}],
    faire:function(o){var e=BLOCS.dessin.faire();e.h=Math.max(20,+o.h);e.x=0;e.y=0;e.pointille=false;e.epaisseur=.8;
      return [e];}},
  bd:{nom:'Bande dessinée',ico:'',desc:'Des cases, avec ou sans bulles',
    opts:[{id:'n',l:'Cases',type:'select',choix:['2','3','4','6','8'],def:'6'},
      {id:'bulles',l:'Avec des bulles',type:'case',def:true}],
    faire:function(o){
      var n=+o.n, col=n<=3?n:2, rg=Math.ceil(n/col), W=larg(), cw=(W-(col-1)*5)/col, chh=Math.min(70,(200-(rg-1)*5)/rg), out=[];
      for(var i=0;i<n;i++){var x=(i%col)*(cw+5), y=Math.floor(i/col)*(chh+5);
        out.push({type:'forme',forme:'rect',x:x,y:y,w:cw,h:chh,remplissage:'#ffffff',trait:'#14142b',epaisseur:2,rayon:2,
          item:true});
        if(o.bulles)out.push({type:'forme',forme:'bulle',x:x+4,y:y+4,w:Math.min(50,cw*.55),h:16,remplissage:'#ffffff',
          trait:'#14142b',epaisseur:1,texte:'',taille:11,police:'main'});}
      return out;
    }},
  pixel:{nom:'Quadrillage à colorier',ico:'',desc:'Pixel art, coloriage codé',
    opts:[{id:'c',l:'Colonnes',type:'select',choix:['10','12','15','20','25','30'],def:'15'},
      {id:'r',l:'Lignes',type:'select',choix:['10','12','15','20','25','30'],def:'15'}],
    faire:function(o){
      var C=+o.c, Rr=+o.r, k=Math.min(10,larg()/C,200/Rr), P=[];
      for(var i=0;i<=C;i++)P.push(Lg(i*k,0,i*k,Rr*k,'#8b8299',.25));
      for(var j=0;j<=Rr;j++)P.push(Lg(0,j*k,C*k,j*k,'#8b8299',.25));
      return [dessin(C*k,Rr*k,P,{police:'texte'})];
    }},

  /* ======================= VIE DE CLASSE ======================= */
  checklist:{nom:'Liste à cocher',ico:'',desc:'Ce que j’ai fait',
    opts:[{id:'l',l:'Une ligne par tâche',type:'texte',def:'J’ai écrit mon prénom.\nJ’ai relu mon travail.\nJ’ai rangé mon matériel.'}],
    faire:function(o){var l=lignesTexte(o.l);
      return [{type:'cases',x:0,y:0,w:larg(),h:l.length*8+4,lignes:l,taille:12}];}},
  planTravail:{nom:'Plan de travail',ico:'',desc:'Les tâches de la semaine',
    opts:[{id:'n',l:'Tâches',type:'select',choix:['4','5','6','8','10'],def:'6'}],
    faire:function(o){var n=+o.n, cel=[['Ce que je dois faire','Matière','Fait ✓']];
      for(var i=0;i<n;i++)cel.push(['','','']);
      return [{type:'tableau',x:0,y:0,w:larg(),h:10+n*12,cols:3,rows:n+1,tete:true,cellules:cel,fusions:[],taille:11}];}},
  autoeval:{nom:'Autoévaluation',ico:'',desc:'Des critères et trois visages',
    opts:[{id:'l',l:'Un critère par ligne',type:'texte',def:'J’ai compris la consigne.\nJ’ai travaillé seul(e).\nJ’ai soigné mon écriture.'}],
    faire:function(o){
      var l=lignesTexte(o.l), W=larg(), cw=18, x0=W-3*cw, P=[];
      function visage(cx,cy,hum,col){
        P.push(Ov(cx,cy,5.5,col,'#14142b',.4));P.push(Ov(cx-2,cy-1.6,.7,'#14142b','none',0));P.push(Ov(cx+2,cy-1.6,.7,'#14142b','none',0));
        P.push(Pg(hum>0?arcPts(cx,cy+.2,3,.35,Math.PI-.35,10):hum<0?arcPts(cx,cy+4.6,3,Math.PI+.35,2*Math.PI-.35,10)
          :[[cx-2.6,cy+2.2],[cx+2.6,cy+2.2]],'none','#14142b',.45,false));
      }
      [[1,'#d5f2dc'],[0,'#fdf2b3'],[-1,'#ffd7e2']].forEach(function(v,i){visage(x0+cw*i+cw/2,6,v[0],v[1]);});
      l.forEach(function(t,i){var y=14+i*12;
        P.push(Lg(0,y,W,y,'#e8ddd2',.3));P.push(Tx(2,y+7.4,t,4,'#14142b','s'));
        for(var k=0;k<3;k++)P.push(Ov(x0+cw*k+cw/2,y+6,3.6,'#fff','#c9bfc9',.4));});
      return [dessin(W,14+l.length*12+2,P,{police:'texte'})];
    }}
};
OUTILS.pointe=OUTILS.papier;
var CARTABLE=[
  {id:'maths',nom:'Maths',ico:'',cats:[
    ['Calcul',['ecrits','mentaux','tables','numeration','droite']],
    ['Grandeurs et mesures',['regle','horloge','thermometre','eprouvette','monnaie']],
    ['Géométrie',['formes','solides','papier','repere','symetrie']],
    ['Fractions',['fracBarres','fracDisques']],
    ['Données',['graphique']]]},
  {id:'francais',nom:'Français',ico:'',cats:[
    ['Écrire',['lignesEcr','redaction','dictee']],
    ['Mots et phrases',['etiquettesMots','phrase','relier']]]},
  {id:'sciences',nom:'Sciences',ico:'',cats:[
    ['Observer',['legender','observation','demarche']],
    ['Comprendre',['cycle','thermometre','eprouvette']]]},
  {id:'eveil',nom:'Histoire et géographie',ico:'',cats:[
    ['Le temps',['frise']],
    ['L’espace',['rose','repere','legendeCarte']]]},
  {id:'art',nom:'Dessin et création',ico:'',cats:[
    ['Dessiner',['cadreDessin','bd','pixel']],
    ['Reproduire',['symetrie','papier']]]},
  {id:'classe',nom:'Vie de classe',ico:'',cats:[
    ['S’organiser',['checklist','planTravail']],
    ['Se situer',['autoeval']]]}
];
function matiereCart(id){for(var i=0;i<CARTABLE.length;i++)if(CARTABLE[i].id===id)return CARTABLE[i];return null;}
function panCartable(){
  var m=CART.mat&&matiereCart(CART.mat), t=CART.outil&&OUTILS[CART.outil], h='';
  if(!m){
    return '<h3>Cartable</h3><p class="aide">Des outils prêts à poser, rangés par matière. '
      +'Les réponses vont toutes seules dans la version <b>Prof</b>.</p><div class="cart-mat">'
      +CARTABLE.map(function(x){var n=0;x.cats.forEach(function(c){n+=c[1].length;});
        return '<button data-cmat="'+x.id+'"><em>'+x.ico+'</em><b>'+x.nom+'</b><small>'+n+' outils</small></button>';}).join('')
      +'</div>';
  }
  h='<div class="cart-fil"><button data-cback="racine">Cartable</button>'
    +(t?'<span>›</span><button data-cback="mat">'+m.nom+'</button>':'')+'</div>';
  if(!t){
    return h+'<h3>'+m.ico+' '+m.nom+'</h3>'+m.cats.map(function(c){
      return '<h5>'+c[0]+'</h5><div class="cart-outils">'+c[1].map(function(id){var o=OUTILS[id];
        return '<button data-cout="'+id+'"><em>'+o.ico+'</em><span><b>'+o.nom+'</b><small>'+o.desc+'</small></span></button>';
      }).join('')+'</div>';}).join('');
  }
  if(t.special)return h+'<h3>'+t.ico+' '+t.nom+'</h3>'+panMaths(t.special);
  t._val=t._val||{};
  return h+'<h3>'+t.ico+' '+t.nom+'</h3><p class="aide">'+t.desc+'</p>'
    +(t.opts&&t.opts.length?blocP('Réglages',formOptions(t,t._val,'co_')):'')
    +(t.sansNum?'':blocP('Présentation','<label class="coche"><input type="checkbox" id="co_num"'
      +(t._val.num===false?'':' checked')+'> Numéroter (1, 2, 3…)</label>'))
    +'<button class="b p grand" data-cposer>＋ Ajouter</button>'
    +'<p class="aide" style="margin-top:8px">Déjà posé ? Cliquez-le : vous pourrez le changer ou le '
    +'régénérer ('+ico('regen')+').</p>';
}
/* pose les éléments d'un outil, rangés et groupés, sous ce qui existe */
function poserOutil(id,remplir){
  var t=OUTILS[id];if(!t||!t.faire)return;
  var o={};(t.opts||[]).forEach(function(op){var x=$('#co_'+op.id);if(!x)return;
    o[op.id]=op.type==='case'?x.checked:op.type==='nombre'?(+x.value||0):x.value;});
  o.num=!t.sansNum&&(!$('#co_num')||$('#co_num').checked);
  t._val=clone(o);
  var g0=Math.floor(Math.random()*1e9);
  function fabriquer(oo){HASARD=graine(g0);try{return t.faire(oo);}finally{HASARD=Math.random;}}
  function hauteur(l){var a=Infinity,b=-Infinity;l.forEach(function(e){a=Math.min(a,e.y||0);
    b=Math.max(b,(e.y||0)+e.h);});return b-a;}
  /* « Toute la page » : on ajoute des exercices tant qu'ils tiennent */
  if(t.remplir&&o[t.remplir]==='page')remplir=true;
  if(remplir&&t.remplir){
    o[t.remplir]='1';var un=fabriquer(o), reste=placeRestante(hauteur(un)), k=1;
    for(var n2=2;n2<=60;n2++){o[t.remplir]=String(n2);if(hauteur(fabriquer(o))>reste)break;k=n2;}
    o[t.remplir]=String(k);
  }
  var els=fabriquer(o);
  if(!els||!els.length)return;
  /* chaque élément sait d'où il vient : on pourra changer ses réglages plus tard */
  els.forEach(function(e,i){e.outil=id;e.opts=clone(o);e.graine=g0;e.idx=i;});
  /* les numéros : chaque exercice (ou chaque partie d'un dessin) reçoit
     le sien ; numeroter() les fait se suivre dans un groupe */
  if(o.num){
    var items=els.filter(function(e){return e.item;});
    if(!items.length)items=els.length>1&&els.every(function(e){return e.type===els[0].type&&e.type==='dessin';})
      ?els:[els[0]];
    items.forEach(function(e){if(!e.numLignes)e.num=1;});
  }
  els.forEach(function(e){delete e.item;});
  var x1=Infinity,y1=Infinity,x2=-Infinity,y2=-Infinity;
  els.forEach(function(e){e.x=e.x||0;e.y=e.y||0;x1=Math.min(x1,e.x);y1=Math.min(y1,e.y);
    x2=Math.max(x2,e.x+e.w);y2=Math.max(y2,e.y+e.h);});
  var dx=MARGE+Math.max(0,(larg()-(x2-x1))/2)-x1, dy=placeAuto(y2-y1)-y1, g=els.length>1?'g'+uid():null, z=zMax()+1;
  els.forEach(function(e){e.id=uid();e.z=z++;e.x=arrondi(e.x+dx);e.y=arrondi(e.y+dy);if(g)e.grp=g;
    elements().push(e);});
  SEL=els.map(function(e){return e.id;});PROPS=false;
  empiler();peindreTout();enregistrer();
  etat(t.nom+' posé'+(els.length>1?' (groupé)':''));
}

function dedansElement(e){
  var t=e.type;
  if(t==='texte')
    return '<div class="in'+(e.texte?'':' vide')+'" style="'+styleTexte(e)+'">'
      +(e.texte?'<div class="tt">'+contenu(e)+'</div>':'Texte')+'</div>';

  if(t==='nametag'){
    var c=e.teinte||'#f0265c';
    /* le rond doit être parfaitement rond : sa largeur suit la hauteur du bloc */
    return '<div class="in" style="--nt:'+c+';--nt2:'+c+'">'
      +'<div class="rond" style="background:'+c+';width:'+e.h+'mm;font-size:'
      +(e.h*0.42)+'mm">'+esc(e.lettre||'L')+'</div>'
      +'<div class="bande"><span class="lab">'+esc(e.label||'Prénom')+'</span>'
      +'<span class="trait"></span></div></div>';
  }

  if(t==='consigne')
    return '<div class="in" style="'+styleTexte(e)+'background:'+(e.fond||'#ffd9e4')+';">'
      +(e.puce?'<span class="puce">'+(e.numero||1)+'</span>':'')
      +'<span style="flex:1">'+contenu(e)+'</span></div>';

  if(t==='retiens')
    /* le texte vit dans son propre bloc : en double-cliquant on modifie
       la règle, jamais l'étiquette « Je retiens » */
    return '<div class="in" style="--rt:'+(e.teinte||'#b083f2')+';'+styleTexte(e)+'background:#faf6ff;">'
      +'<span class="et">'+esc(e.etiquette||'Je retiens')+'</span>'
      +'<div class="tx">'+contenu(e)+'</div></div>';

  if(t==='image')
    return e.src?'<div class="in"><img src="'+esc(e.src)+'" alt="" style="object-fit:'
        +(e.ajuste==='contenir'?'contain':'cover')+';border-radius:'+(e.rayon||0)+'mm"></div>'
      :'<div class="in vide">Image</div>';

  if(t==='calcul')return '<div class="in">'+svgCalcul(e)+'</div>';
  if(t==='dessin')return '<div class="in">'+svgDessin(e)+'</div>';

  if(t==='lignes'){
    var n=Math.max(1,e.nb||5),h='',i;
    var g=e.lignage||'simple';
    var hl=e.hl||HL[g]||10;
    if(g==='maison'||g==='couleurs'||g==='quatre'){
      for(i=0;i<n;i++){
        h+='<div class="lgm'+(g==='quatre'?' quatre':'')+'" style="height:'+hl+'mm">'
          +'<div class="ciel"></div><div class="herbe"></div><div class="terre"></div>'
          +(g==='maison'?'<div class="deco">'+decorMaison()+'</div>':'')
          +'</div>';
      }
    }else{
      for(i=0;i<n;i++)
        h+='<div class="lg" style="height:'+hl+'mm">'+(g==='seyes'
          ?'<i style="top:25%"></i><i style="top:50%"></i><i style="top:75%"></i>':'')+'</div>';
    }
    return '<div class="in" style="--ecart:'+(e.ecart==null?1.5:e.ecart)+'mm">'+h+'</div>';
  }

  if(t==='tableau'){
    var c=e.cols||3,r=e.rows||3,cel=e.cellules,fu=e.fusions||[],h2='<table>';
    /* une fusion = {y,x,ly,lx} : la case en haut à gauche s'étire,
       les cases recouvertes disparaissent. */
    function couverte(y,x){
      for(var i=0;i<fu.length;i++){var f=fu[i];
        if(y>=f.y&&y<f.y+f.ly&&x>=f.x&&x<f.x+f.lx&&!(y===f.y&&x===f.x))return true;}
      return false;
    }
    function etire(y,x){
      for(var i=0;i<fu.length;i++){var f=fu[i];if(f.y===y&&f.x===x)return f;}
      return null;
    }
    for(var y=0;y<r;y++){
      h2+='<tr>';
      for(var x=0;x<c;x++){
        if(couverte(y,x))continue;
        var f2=etire(y,x), v=(cel&&cel[y]&&cel[y][x])||'';
        h2+='<td data-y="'+y+'" data-x="'+x+'" class="'+(e.tete&&y===0?'tete':'')+'"'
          +(f2&&f2.ly>1?' rowspan="'+f2.ly+'"':'')+(f2&&f2.lx>1?' colspan="'+f2.lx+'"':'')
          +' style="'+(e.decoupe?'border-style:dashed;':'')
          +'font-size:'+(e.taille||11)+'pt">'
          +(e.celRiche&&e.celRiche[y+'-'+x]?richeHtml(e.celRiche[y+'-'+x]):esc(v))+'</td>';
      }
      h2+='</tr>';
    }
    return '<div class="in" style="--tb:'+(e.trait||'#c9bfc9')+';--tbt:'+(e.fond||'#fdf0eb')+'">'
      +h2+'</table></div>';
  }

  if(t==='cases'){
    var li=lignesRiches(e).map(function(x){
      return '<div class="cs"><b></b><span>'+richeHtml(x)+'</span></div>';
    }).join('');
    return '<div class="in" style="font-size:'+(e.taille||11)+'pt">'+li+'</div>';
  }

  if(t==='bareme')return '<div class="in">'+svgDessin(stickerNote(e))+'</div>';

  if(t==='forme'){
    var r2=(e.rayon||0),tr=e.trait||'#14142b',ep=e.epaisseur==null?.5:e.epaisseur;
    var tirets=e.pointille?' stroke-dasharray="2.4 1.8"':'';
    var corps;
    if(e.forme==='cercle')
      corps='<ellipse cx="50" cy="50" rx="49" ry="49" fill="'+(e.remplissage||'none')
        +'" stroke="'+tr+'" stroke-width="'+ep+'" vector-effect="non-scaling-stroke"'+tirets+'/>';
    else if(e.forme==='ligne')
      corps='<line x1="0" y1="50" x2="100" y2="50" stroke="'+tr+'" stroke-width="'+ep
        +'" vector-effect="non-scaling-stroke"'+tirets+'/>';
    else if(e.forme==='fleche')
      corps='<line x1="0" y1="50" x2="92" y2="50" stroke="'+tr+'" stroke-width="'+ep
        +'" vector-effect="non-scaling-stroke"'+tirets+'/>'
        +'<path d="M92 42 L100 50 L92 58 Z" fill="'+tr+'"/>';
    else if(e.forme==='etoile')
      corps='<path d="M50 2 L61 37 L98 37 L68 59 L79 95 L50 73 L21 95 L32 59 L2 37 L39 37 Z" fill="'
        +(e.remplissage||'#f5c518')+'" stroke="'+tr+'" stroke-width="'+ep
        +'" vector-effect="non-scaling-stroke"/>';
    else if(e.forme==='bulle')
      corps='<path d="M8 2 H92 A6 6 0 0 1 98 8 V62 A6 6 0 0 1 92 68 H34 L20 82 L22 68 H8 '
        +'A6 6 0 0 1 2 62 V8 A6 6 0 0 1 8 2 Z" fill="'+(e.remplissage||'#cfe6fb')
        +'" stroke="'+tr+'" stroke-width="'+ep+'" vector-effect="non-scaling-stroke" '
        +'transform="scale(1,1.22)"/>';
    else
      corps='<rect x="0.5" y="0.5" width="99" height="99" rx="'+(r2*2)+'" fill="'
        +(e.remplissage||'none')+'" stroke="'+tr+'" stroke-width="'+ep
        +'" vector-effect="non-scaling-stroke"'+tirets+'/>';
    /* la zone de texte existe toujours : on peut écrire dans une forme
       d'un simple double-clic, même si elle est vide */
    var dedans='<div class="dedans'+((e.texte||e.legende)?'':' creux')+'" style="'
      +styleTexte(e)+'background:none"><div class="tt">'+(e.texte?contenu(e):esc(e.legende||''))
      +'</div></div>';
    return '<div class="in"><svg viewBox="0 0 100 100" preserveAspectRatio="none">'
      +corps+'</svg>'+dedans+'</div>';
  }
  return '<div class="in"></div>';
}

/* Le gabarit est commun, mais chaque page peut s'en affranchir :
   une page peut masquer l'en-tête et/ou le pied pour elle seule. */
function aEntete(p){return (R.doc.gabarit||{}).entete!==false && !p.sansEntete;}
function aPied(p){return (R.doc.gabarit||{}).pied!==false && !p.sansPied;}

function peindrePages(){
  /* un texte en cours d'écriture est d'abord validé : sinon la page
     serait redessinée avec l'ancien texte */
  if(EDIT)return EDIT.fini();
  var g=R.doc.gabarit||{}, lst=pages(), h='';
  lst.forEach(function(p,i){
    var f=fmtDe(p), L=dimDe(p)[0], H=dimDe(p)[1];
    h+='<div class="pslot">'
      +'<div class="pg f-'+f.t+'-'+f.o+'" data-page="'+i+'" '
      +'style="--pw:'+L+'mm;--ph:'+H+'mm;--hh:'+HAUT+'mm;--fh:'+BAS+'mm">';

    /* En haut à gauche : l'étiquette prénom, directement, rien autour.
       En haut à droite : le numéro de page. Pas de fond : la feuille
       reste blanche, c'est l'étiquette qui apporte la couleur. */
    if(aEntete(p)){
      h+='<div class="gab-h"><img class="ciel" src="'+esc(cielSrc(g))+'" alt="">'
        +courbeHaut()+'</div>'
        +'<img class="etiq" src="'+esc(nametagSrc(g))+'" alt="" '
        +'style="width:'+(g.ntW||92)+'mm">'
        +'<div class="nopage">'+(i+1)+'</div>';
    }
    /* Le pied de page du site : bloc dégradé aux coins hauts arrondis,
       et la barre crème avec le titre de l'activité. */
    if(aPied(p)){
      h+='<div class="gab-f">'+fondPied()
        +'<div class="barre"><span class="ti">'
        +esc(g.titre||R.titre||'Ressources Laé')+'</span>'
        +'<span class="ad">ressourceslae.com</span></div></div>';
    }

    p.el.forEach(function(e){
      h+='<div class="el'+(e.corrige?' corrige':'')+(e.eleveSeul?' eleve-seul':'')
        +(e.verrou?' verrou':'')+(e.grp?' groupe':'')
        +(SEL.indexOf(e.id)>=0?' sel':'')
        +(e.type==='lignes'?' '+(e.lignage||'simple'):'')+'" data-t="'+e.type+'" data-id="'+e.id
        +'" data-p="'+i+'"'
        +' style="left:'+e.x+'mm;top:'+e.y+'mm;width:'+e.w+'mm;height:'+e.h+'mm;'
        +(e.rot?'transform:rotate('+e.rot+'deg);':'')+'z-index:'+(e.z||1)+'">'
        +dedansElement(e)+(pastille(e)?'<span class="num-el">'+e.num+'.</span>':'')+'</div>';
    });
    h+='</div>';
    if(i===PAGE)h+='<div class="pg-outils">'
      +'<button data-pg-sens="'+i+'" title="Vertical / horizontal">'+DX_I('pivoter')+'</button>'
      +'<button data-pg-copier="'+i+'" title="Dupliquer la page">'+DX_I('dupliquer')+'</button>'
      +'<button data-pg-niveau="'+i+'" title="Copier cette page vers un autre niveau de difficulté">'+DX_I('niveaux')+'</button>'
      +'<button data-pg-suppr="'+i+'" title="Supprimer la page">'+DX_I('poubelle')+'</button></div>';
    var nc=cachesDe(p).length;
    if(nc)h+='<button class="alerte-caches" data-reparer="'+i+'">'+nc+' élément'+(nc>1?'s':'')
      +' caché'+(nc>1?'s':'')+' (sous le pied de page ou hors de la feuille) · <b>Remettre en place</b></button>';
    h+='<div class="num-ecran">Page '+(i+1)+' · '+f.t.toUpperCase()+' '+f.o+'</div></div>';
  });
  $('#pages').innerHTML=h;
  if(SEL.length===1&&$('.el.sel')&&!bloque(elementPar(SEL[0])))poser($('.el.sel'));
  barreVolante();
  majInfo();
}

/* ============================================================
   LA BARRE FLOTTANTE
   Les réglages les plus courants viennent au-dessus de l'élément,
   pour ne pas avoir à traverser l'écran à chaque retouche.
   ============================================================ */
/* les couleurs de la barre flottante : celles du site */
var COULEURS_TEXTE=['#14142b','#f0265c','#fa5a3c','#1c5b4a','#2f80c8','#6e5fd8','#8b8299'];
function barreVolante(){
  var v=$('.volante');
  var n=SEL.length&&$('.el.sel'), e=n&&elementPar(SEL[0]);
  if(!e){if(v)v.remove();return;}
  var sc=$('#scene'), rs=sc.getBoundingClientRect(), rn=n.getBoundingClientRect();

  var txt=/^(texte|consigne|retiens|cases|forme|tableau|nametag|bareme)$/.test(e.type);
  /* le verrou et le groupe */
  var vr=e.verrou||'';
  var verrou='<span class="vis-m"><button class="vis-b'+(vr?' v-lock':'')+'" data-vismenu '
    +'title="'+(vr==='tout'?'Verrouillé : plus aucune modification':vr==='pos'?'Position verrouillée':'Verrouiller')
    +'">'+ico(vr?'cadenas':'ouvert')+'</button>'
    +'<span class="vis-l"><span class="vis-t">Verrou</span>'
    +'<button data-vver="" class="'+(vr?'':'on')+'">'+DX_I('ouvert')+' Libre</button>'
    +'<button data-vver="pos" class="'+(vr==='pos'?'on':'')+'">'+DX_I('cadenas')+' Position <small>ne bouge plus</small></button>'
    +'<button data-vver="tout" class="'+(vr==='tout'?'on':'')+'">'+DX_I('cadenas')+' Tout <small>plus aucune modification</small></button>'
    +'</span></span>';
  var tb='';
  if(e.type==='tableau'&&SEL.length===1){
    var plus=CEL&&CEL.id===e.id&&(CEL.y2>CEL.y1||CEL.x2>CEL.x1);
    tb='<button data-vtb="fusion" title="Fusionner les cases choisies"'+(plus?'':' disabled')+'>⊞</button>'
      +'<button data-vtb="defusion" title="Séparer les cases fusionnées">⊟</button>'
      +'<button data-vtb="col+" title="Insérer une colonne (après la case choisie)">⇥＋</button>'
      +'<button data-vtb="col-" title="Supprimer la colonne choisie">⇥－</button>'
      +'<button data-vtb="row+" title="Insérer une ligne (sous la case choisie)">⤓＋</button>'
      +'<button data-vtb="row-" title="Supprimer la ligne choisie">⤓－</button><span class="sep"></span>';
  }
  if(e.type==='bareme'&&SEL.length===1)
    tb+=[5,10,20,25,50,100].map(function(n){
      return '<button data-vtotal="'+n+'" class="'+((e.total||20)===n?'on':'')+'" title="Note sur '+n+'">/'+n+'</button>';
    }).join('')+'<span class="sep"></span>';
  var memeGrp=SEL.length>1&&SEL.every(function(id){var x=elementPar(id);return x&&x.grp&&x.grp===e.grp;});
  var grp=SEL.length>1?'<button data-vgrp="'+(memeGrp?'non':'oui')+'" title="'
    +(memeGrp?'Dégrouper (⇧⌘G)':'Grouper (⌘G)')+'">'+ico(memeGrp?'degrouper':'grouper')+'</button>':'';
  if(SEL.some(function(id){return regenerable(elementPar(id));}))
    grp='<button data-vregen title="Régénérer : nouveau contenu, mêmes réglages">'+ico('regen')+'</button>'+grp;
  if(vr==='tout'){
    /* verrouillé : seule la clé reste */
    var hv='<div class="volante">'+verrou+'</div>';
    var dv;
    if(v&&v._h===hv)dv=v;else{if(v)v.remove();dv=document.createElement('div');
      dv.innerHTML=hv;dv=dv.firstChild;dv._h=hv;sc.appendChild(dv);}
    var ht=rn.top-rs.top+sc.scrollTop-dv.offsetHeight-12;
    if(ht<4)ht=rn.bottom-rs.top+sc.scrollTop+12;
    dv.style.top=ht+'px';
    dv.style.left=borne(rn.left-rs.left+sc.scrollLeft+(rn.width-dv.offsetWidth)/2,8,
      sc.scrollWidth-dv.offsetWidth-8)+'px';
    return;
  }
  /* en premier : qui voit cet élément — ou la lettre, le mot sélectionné.
     Un seul bouton ; le choix se fait dans son menu (survol ou clic). */
  var h='<div class="volante"><span class="vis-m"><button class="vis-b" data-vismenu></button>'
    +'<span class="vis-l"><span class="vis-t"></span>'
    +'<button data-vvue="tous"><i class="pt-tous"></i>Tous <small>élève et prof</small></button>'
    +'<button data-vvue="eleve"><i class="pt-eleve"></i>Élève seulement</button>'
    +'<button data-vvue="prof"><i class="pt-prof"></i>Prof seulement <small>corrigé</small></button>'
    +'</span></span>'+verrou+grp+'<span class="sep"></span>'+tb;
  if(txt&&e.type!=='nametag'){
    h+='<select data-vpolice>'+Object.keys(POLICES).map(function(k){
        return '<option value="'+k+'"'+((e.police||'texte')===k?' selected':'')+'>'
          +POLICES[k][1].split(' (')[0]+'</option>';}).join('')+'</select>'
      +'<button data-vtaille="-1">A−</button><button data-vtaille="1">A+</button>'
      +'<span class="sep"></span>'
      +'<button data-vstyle="gras" class="'+(e.gras?'on':'')+'"><b>G</b></button>'
      +'<button data-vstyle="italique" class="'+(e.italique?'on':'')+'"><i>I</i></button>'
      +'<button data-vstyle="souligne" class="'+(e.souligne?'on':'')+'"><u>S</u></button>'
      +'<span class="sep"></span>'
      +'<span class="sep"></span>'
      +'<button data-vlien="1" title="Lien : sélectionnez le texte, puis collez l’adresse (⌘V) ou cliquez ici">'+DX_I('lien')+'</button>'
      +COULEURS_TEXTE.map(function(c){
        return '<button data-vcouleur="'+c+'" class="vc" title="Couleur du texte">'
          +'<span class="pt" style="background:'+c+'"></span></button>';}).join('')
      +'<span class="sep"></span>'
      +'<button data-valign="left" title="À gauche">'+DX_I('alg')+'</button><button data-valign="center" title="Centré">'+DX_I('alc')+'</button>'
      +'<button data-valign="right" title="À droite">'+DX_I('ald')+'</button>'
      +'<span class="sep"></span>';
  }
  h+='<button data-dx-calques title="Calques">'+DX_I('calques')+'</button>'
    
    +'<button data-vcopie title="Dupliquer">'+DX_I('dupliquer')+'</button>'

    +'<button data-vsuppr title="Supprimer">'+DX_I('poubelle')+'</button></div>';

  /* la même barre est gardée telle quelle : sinon un menu ouvert se
     refermerait tout seul à chaque retouche */
  var d;
  if(v&&v._h===h)d=v;
  else{
    if(v)v.remove();
    d=document.createElement('div');d.innerHTML=h;d=d.firstChild;d._h=h;
    sc.appendChild(d);
  }
  /* sur un petit écran, la barre passe sur deux lignes */
  d.style.maxWidth=(sc.clientWidth-16)+'px';
  majVisible();
  var haut=rn.top-rs.top+sc.scrollTop-d.offsetHeight-12;
  if(haut<4)haut=rn.bottom-rs.top+sc.scrollTop+12;
  d.style.top=haut+'px';
  var g=rn.left-rs.left+sc.scrollLeft+(rn.width-d.offsetWidth)/2;
  d.style.left=borne(g,8,sc.scrollWidth-d.offsetWidth-8)+'px';
}

/* les poignées autour de l'élément sélectionné */
function poser(n){
  var d=document.createElement('div');
  d.className='poignees';
  d.innerHTML=['nw','n','ne','e','se','s','sw','w'].map(function(p){
    return '<span class="pn '+p+'" data-pn="'+p+'"></span>';}).join('')
    +'<span class="pn rot" data-pn="rot"></span>'
    /* un tableau sélectionné : on choisit des cases en glissant dedans,
       on le déplace par ✥, on l'agrandit par les « + » */
    +(n.dataset.t==='tableau'?'<span class="pn deplace" data-pn="deplace" title="Déplacer le tableau">✥</span>'
      +'<button class="tb-plus col" data-tbplus="col+" title="Ajouter une colonne">+</button>'
      +'<button class="tb-plus row" data-tbplus="row+" title="Ajouter une ligne">+</button>':'');
  n.appendChild(d);
}

function majInfo(){
  var i=$('#infoSel');if(!i)return;
  if(!SEL.length)return void(i.textContent='Rien de sélectionné');
  if(SEL.length>1)return void(i.textContent=SEL.length+' éléments sélectionnés');
  var e=elementPar(SEL[0]);
  i.textContent=e?(nomType(e.type)+' — '+arrondi(e.w)+' × '+arrondi(e.h)+' mm'):'';
}
function nomType(t){
  return {texte:'Texte',consigne:'Consigne',image:'Image',forme:'Forme',lignes:'Lignes',
    tableau:'Tableau',cases:'Cases',retiens:'Je retiens',bareme:'Barème',calcul:'Calcul',dessin:'Dessin'}[t]||t;
}

/* ============================================================
   POSER UN BLOC SUR LA PAGE
   On le glisse sous ce qui existe déjà, dans les marges.
   ============================================================ */
function placeLibre(h){
  var p=pageCourante(), bas=(aEntete(p)?HAUT+5:MARGE);
  elements().forEach(function(e){bas=Math.max(bas,e.y+e.h+5);});
  var limite=PH()-(aPied(p)?BAS+3:MARGE)-h-2;
  return Math.min(bas,Math.max(MARGE,limite));
}
function hautPage(){return aEntete(pageCourante())?HAUT+5:MARGE;}
function basPage(){var p=pageCourante();return PH()-(aPied(p)?BAS+3:MARGE);}
function nouvellePage(){
  pages().splice(PAGE+1,0,{el:[],f:clone(fmtDe(pageCourante()))});PAGE++;
  etat('Plus de place : la suite va sur une nouvelle page ('+(PAGE+1)+')');
}
/* comme placeLibre, mais si le bloc ne tient plus, on passe à une page neuve */
function placeAuto(h){
  /* le vrai bas de ce qui existe (placeLibre, lui, remonte le bloc pour
     qu'il tienne… quitte à chevaucher) */
  var bas=hautPage();
  elements().forEach(function(e){bas=Math.max(bas,e.y+e.h+5);});
  if(elements().length&&bas+h>basPage()+.5&&h<=basPage()-hautPage()){nouvellePage();return hautPage();}
  return placeLibre(h);
}
function zMax(){var m=1;elements().forEach(function(e){m=Math.max(m,e.z||1);});return m;}

function poserBloc(cle){
  var b=BLOCS[cle];if(!b)return;
  var e=b.faire();
  e.id=uid();e.z=zMax()+1;
  if(e.x==null)e.x=MARGE;
  e.y=placeAuto(e.h);
  if(e.type==='consigne'){
    /* numéro provisoire : numeroter() le remet à sa place dans l'ordre */
    var n=0;elements().forEach(function(x){if(x.type==='consigne')n++;});
    e.numero=n+1;
  }
  if(ROLE==='prof'&&OUTIL==='corrige')e.corrige=true;
  elements().push(e);
  SEL=[e.id];PROPS=false;empiler();peindreTout();enregistrer();
}

function ajouterElement(e){
  e.id=uid();e.z=zMax()+1;
  if(e.x==null)e.x=MARGE;
  if(e.y==null)e.y=placeAuto(e.h);
  elements().push(e);SEL=[e.id];PROPS=false;empiler();peindreTout();enregistrer();
}

/* ============================================================
   DÉPLACER, REDIMENSIONNER, FAIRE PIVOTER
   ============================================================ */
var geste=null;

function mmParPx(){
  var p=$('.pg[data-page="'+PAGE+'"]');
  if(!p)return 1;
  return PL()/p.getBoundingClientRect().width;
}

/* les repères sur lesquels on vient se coller */
function reperes(saufIds){
  var L=PL(), H=PH();
  var pc=pageCourante();
  var v=[MARGE,L/2,L-MARGE], h=[HAUT+5,H/2,H-BAS-3];
  if(!aEntete(pc))h[0]=MARGE;
  if(!aPied(pc))h[2]=H-MARGE;
  elements().forEach(function(e){
    if(saufIds.indexOf(e.id)>=0)return;
    v.push(e.x,e.x+e.w/2,e.x+e.w);
    h.push(e.y,e.y+e.h/2,e.y+e.h);
  });
  return {v:v,h:h};
}
function coller(val,liste,seuil){
  var best=null,d=seuil;
  liste.forEach(function(r){var x=Math.abs(val-r);if(x<d){d=x;best=r;}});
  return best;
}
function montrerGuides(xs,ys){
  var p=$('.pg[data-page="'+PAGE+'"]');if(!p)return;
  $$('.guide',p).forEach(function(n){n.remove();});
  xs.forEach(function(x){
    var d=document.createElement('div');d.className='guide v';d.style.left=x+'mm';p.appendChild(d);});
  ys.forEach(function(y){
    var d=document.createElement('div');d.className='guide h';d.style.top=y+'mm';p.appendChild(d);});
}
function cacherGuides(){$$('.guide').forEach(function(n){n.remove();});}

function demarrerGeste(ev,mode,coin){
  var k=mmParPx();
  geste={mode:mode,coin:coin,k:k,x0:ev.clientX,y0:ev.clientY,
    dep:SEL.filter(function(id){return !bloque(elementPar(id));})
      .map(function(id){var e=elementPar(id);return {id:id,x:e.x,y:e.y,w:e.w,h:e.h,rot:e.rot||0};}),
    bouge:false};
  document.addEventListener('pointermove',pendantGeste);
  document.addEventListener('pointerup',finirGeste);
}

function pendantGeste(ev){
  if(!geste)return;
  var dx=(ev.clientX-geste.x0)*geste.k, dy=(ev.clientY-geste.y0)*geste.k;
  geste.cx=ev.clientX;geste.cy=ev.clientY;
  /* en déplaçant, l'élément peut sortir de sa feuille pour aller sur une autre */
  if(geste.mode==='bouge'&&!geste.vol){geste.vol=true;$('#scene').classList.add('en-vol');
    var ps=$('.pg[data-page="'+PAGE+'"]');if(ps)ps.parentNode.classList.add('source');}
  if(!geste.bouge&&Math.abs(dx)+Math.abs(dy)<0.6)return;
  geste.bouge=true;
  var libre=ev.altKey, carre=ev.shiftKey;
  var rep=reperes(SEL), gx=[], gy=[];

  geste.dep.forEach(function(d){
    var e=elementPar(d.id);if(!e)return;

    if(geste.mode==='bouge'){
      var nx=d.x+dx, ny=d.y+dy;
      if(!libre&&geste.dep.length===1){
        var sx=coller(nx,rep.v,1.3);
        if(sx==null){var sc=coller(nx+d.w/2,rep.v,1.3);if(sc!=null){nx=sc-d.w/2;gx.push(sc);}
          else{var sr=coller(nx+d.w,rep.v,1.3);if(sr!=null){nx=sr-d.w;gx.push(sr);}}}
        else{nx=sx;gx.push(sx);}
        var sy=coller(ny,rep.h,1.3);
        if(sy==null){var sm=coller(ny+d.h/2,rep.h,1.3);if(sm!=null){ny=sm-d.h/2;gy.push(sm);}
          else{var sb2=coller(ny+d.h,rep.h,1.3);if(sb2!=null){ny=sb2-d.h;gy.push(sb2);}}}
        else{ny=sy;gy.push(sy);}
      }
      e.x=arrondi(borne(nx,-PL(),2*PL()));
      e.y=arrondi(borne(ny,-PH()*3,PH()*4));

    }else if(geste.mode==='taille'){
      var c=geste.coin, x=d.x,y=d.y,w=d.w,h=d.h;
      if(c.indexOf('e')>=0)w=d.w+dx;
      if(c.indexOf('w')>=0){w=d.w-dx;x=d.x+dx;}
      if(c.indexOf('s')>=0)h=d.h+dy;
      if(c.indexOf('n')>=0){h=d.h-dy;y=d.y+dy;}
      if(carre&&c.length===2){var r=d.w/d.h;h=w/r;if(c.indexOf('n')>=0)y=d.y+d.h-h;}
      w=Math.max(6,w);h=Math.max(5,h);
      if(!libre){
        var k1=coller(x,rep.v,1.3);if(k1!=null&&c.indexOf('w')>=0){w+=x-k1;x=k1;gx.push(k1);}
        var k2=coller(x+w,rep.v,1.3);if(k2!=null&&c.indexOf('e')>=0){w=k2-x;gx.push(k2);}
        var k3=coller(y+h,rep.h,1.3);if(k3!=null&&c.indexOf('s')>=0){h=k3-y;gy.push(k3);}
      }
      e.x=arrondi(x);e.y=arrondi(y);e.w=arrondi(Math.max(6,w));e.h=arrondi(Math.max(5,h));

    }else if(geste.mode==='tourne'){
      var n=$('.el[data-id="'+d.id+'"]');if(!n)return;
      var r2=n.getBoundingClientRect();
      var a=Math.atan2(ev.clientY-(r2.top+r2.height/2),ev.clientX-(r2.left+r2.width/2));
      var deg=a*180/Math.PI+90;
      if(!libre)deg=Math.round(deg/15)*15;
      e.rot=Math.round(deg);
    }
  });
  montrerGuides(gx,gy);
  peindrePagesLeger();
  majInfo();
}

/* ------------------------------------------------------------
   LE LASSO : appuyer dans le vide et glisser, comme sur le bureau
   du Mac. Tout ce que le rectangle touche est sélectionné (avec ⇧,
   ça s'ajoute à la sélection).
   ------------------------------------------------------------ */
function demarrerLasso(ev){
  var x0=ev.clientX, y0=ev.clientY, ajout=ev.shiftKey, base=SEL.slice(), boite=null;
  function bouge(m){
    var x1=m.clientX, y1=m.clientY;
    if(!boite){
      if(Math.abs(x1-x0)+Math.abs(y1-y0)<5)return;
      boite=document.createElement('div');boite.className='lasso';document.body.appendChild(boite);
    }
    var l=Math.min(x0,x1), t=Math.min(y0,y1);
    boite.style.cssText='left:'+l+'px;top:'+t+'px;width:'+Math.abs(x1-x0)+'px;height:'+Math.abs(y1-y0)+'px';
    m.preventDefault();
  }
  function fin(m){
    document.removeEventListener('pointermove',bouge);
    document.removeEventListener('pointerup',fin);
    if(!boite)return;
    var r=boite.getBoundingClientRect();boite.remove();
    /* les éléments touchés, page par page : on garde la page la plus touchée */
    var parPage={};
    $$('#pages .el').forEach(function(n){
      if(getComputedStyle(n).display==='none')return;
      var b=n.getBoundingClientRect();
      if(b.right<r.left||b.left>r.right||b.bottom<r.top||b.top>r.bottom)return;
      var pg=+n.dataset.p;(parPage[pg]=parPage[pg]||[]).push(n.dataset.id);
    });
    var pagesTouchees=Object.keys(parPage);
    if(!pagesTouchees.length)return;
    /* la page affichée devient celle où le lasso a commencé, si elle est touchée */
    if(pagesTouchees.indexOf(String(PAGE))<0)PAGE=+pagesTouchees[0];
    var ids=ajout?base:[];
    pagesTouchees.forEach(function(k){parPage[k].forEach(function(id){
      membres(id).forEach(function(x){if(ids.indexOf(x)<0)ids.push(x);});});});
    SEL=ids;PROPS=true;peindreTout();
    etat(SEL.length+' élément'+(SEL.length>1?'s':'')+' sélectionné'+(SEL.length>1?'s':''));
  }
  document.addEventListener('pointermove',bouge);
  document.addEventListener('pointerup',fin);
}

/* un rendu rapide pendant le geste : on ne refait pas tout le HTML */
function peindrePagesLeger(){
  SEL.forEach(function(id){
    var e=elementPar(id), n=$('.el[data-id="'+id+'"]');
    if(!e||!n)return;
    n.style.left=e.x+'mm';n.style.top=e.y+'mm';
    n.style.width=e.w+'mm';n.style.height=e.h+'mm';
    n.style.transform=e.rot?'rotate('+e.rot+'deg)':'';
  });
}

function finirGeste(){
  document.removeEventListener('pointermove',pendantGeste);
  document.removeEventListener('pointerup',finirGeste);
  cacherGuides();
  $('#scene').classList.remove('en-vol');
  $$('.pslot.source').forEach(function(x){x.classList.remove('source');});
  if(geste&&geste.bouge&&geste.mode==='bouge')changerDePage(geste.cx,geste.cy);
  if(geste&&geste.bouge){empiler();peindreTout();enregistrer();}
  geste=null;
}
/* lâché au-dessus d'une autre feuille : les éléments y sont rangés, à
   l'endroit exact où on les a posés */
function changerDePage(cx,cy){
  if(cx==null)return;
  var cible=null;
  document.elementsFromPoint(cx,cy).forEach(function(n){
    if(!cible&&n.classList&&n.classList.contains('pg'))cible=n;});
  var src=$('.pg[data-page="'+PAGE+'"]');
  if(cible&&cible!==src){
    var j=+cible.dataset.page, rs=src.getBoundingClientRect(), rc=cible.getBoundingClientRect(), k=mmParPx();
    var ox=(rs.left-rc.left)*k, oy=(rs.top-rc.top)*k, pg=pages(), dest=pg[j], D=dimDe(dest);
    var bouges=pg[PAGE].el.filter(function(e){return SEL.indexOf(e.id)>=0;});
    pg[PAGE].el=pg[PAGE].el.filter(function(e){return SEL.indexOf(e.id)<0;});
    bouges.forEach(function(e){
      e.x=arrondi(borne(e.x+ox,-e.w+5,D[0]-5));e.y=arrondi(borne(e.y+oy,-e.h+5,D[1]-5));
      dest.el.push(e);
    });
    PAGE=j;etat(bouges.length+' élément'+(bouges.length>1?'s':'')+' déplacé'+(bouges.length>1?'s':'')
      +' sur la page '+(j+1));
    return;
  }
  /* lâché hors de toute feuille : on le ramène dans la sienne */
  var P0=pages()[PAGE], D0=dimDe(P0);
  P0.el.forEach(function(e){if(SEL.indexOf(e.id)<0)return;
    e.x=arrondi(borne(e.x,-e.w+5,D0[0]-5));e.y=arrondi(borne(e.y,-e.h+5,D0[1]-5));});
}

/* ============================================================
   LES PANNEAUX
   ============================================================ */
function peindrePanneau(){
  var p=$('#panneau');
  if(SEL.length&&PROPS)return void(p.innerHTML=panneauElement());
  p.innerHTML=({
    blocs:panBlocs,texte:panTexte,images:panImages,formes:panFormes,
    lignes:panLignes,tableau:panTableau,maths:panMaths,cartable:panCartable,corrige:panCorrige,
    gabarit:panGabarit
  }[OUTIL]||panBlocs)();
  if(OUTIL==='images')chargerImages();
}

function panBlocs(){
  return '<h3>Blocs</h3><p class="aide">Cliquez : le bloc se pose tout seul sous ce qui existe déjà, '
    +'bien aligné dans les marges.</p>'
    +'<h5>En-tête du document</h5><div class="blocs">'
      +['titre','soustitre'].map(carteBloc).join('')+'</div>'
    +'<h5>Écrire</h5><div class="blocs">'
      +['paragraphe','trous','colonne','tableau'].map(carteBloc).join('')+'</div>'
    +'<h5>Blocs pédagogiques</h5><div class="blocs">'
      +['consigne','retiens','cases','etiquettes','bareme','bulle','dessin']
        .map(carteBloc).join('')+'</div>'
    +'<h5>Lignes d’écriture</h5><div class="blocs">'
      +['maison','maisonc','quatre','lignes'].map(carteBloc).join('')+'</div>';
}
function carteBloc(c){
  var b=BLOCS[c];
  return '<button data-bloc="'+c+'"><em>'+b.icone+'</em>'+esc(b.nom)+'</button>';
}

function panTexte(){
  return '<h3>Texte</h3><p class="aide">Posez une zone de texte, puis double-cliquez dessus '
    +'pour écrire directement sur la page. La petite barre qui apparaît au-dessus règle la '
    +'police, la taille, le gras et l’alignement.</p><div class="blocs large">'
    +['titre','soustitre','paragraphe','trous','colonne'].map(carteBloc).join('')+'</div>';
}

function panFormes(){
  var f=[['rect','▭','Rectangle'],['cercle','◯','Cercle'],['ligne','━','Ligne'],
         ['fleche','→','Flèche'],['etoile','★','Étoile']];
  return '<h3>Formes</h3><p class="aide">Pour encadrer, séparer, décorer ou réserver une zone de dessin.</p>'
    +'<div class="blocs">'+f.map(function(x){
      return '<button data-forme="'+x[0]+'"><em>'+x[1]+'</em>'+x[2]+'</button>';}).join('')
    +'</div><h5>Zone de dessin</h5><div class="blocs large">'+carteBloc('dessin')+'</div>';
}

function apercuLigne(g){
  if(g==='maison')
    return '<span class="apercu-lg" style="background:linear-gradient(#cfe6fb 0 30%,'
      +'#fdf8cf 30% 70%,#e6e0d2 70% 100%);box-shadow:inset 0 0 0 .5px #8a6436"></span>';
  if(g==='couleurs')
    return '<span class="apercu-lg" style="background:linear-gradient(#cfe6fb 0 30%,'
      +'#fdf8cf 30% 70%,#e6e0d2 70% 100%)"></span>';
  if(g==='quatre')
    return '<span class="apercu-lg" style="background:linear-gradient(transparent 0 29%,'
      +'#9fc0e6 29% 31%,transparent 31% 69%,#2f9e5e 69% 71%,transparent 71% 99%,'
      +'#8a6436 99% 100%)"></span>';
  if(g==='seyes')
    return '<span class="apercu-lg" style="background:linear-gradient(transparent 0 48%,'
      +'#2f80c8 48% 52%,transparent 52%)"></span>';
  return '<span class="apercu-lg" style="background:linear-gradient(transparent 0 48%,'
    +'#c3bccd 48% 52%,transparent 52%)"></span>';
}
function panLignes(){
  var l=[['maison','Maison — avec le décor','Le ciel, l’herbe et la terre, plus la maison, '
          +'le soleil et le ver pour se repérer.'],
         ['couleurs','Maison — couleurs seules','Les mêmes quatre zones colorées, sans dessin.'],
         ['quatre','Quatre lignes','Les quatre lignes seules, sans couleur.'],
         ['seyes','Lignage Seyès','Avec les interlignes, pour les plus grands.'],
         ['simple','Lignes simples','Une simple ligne par ligne.']];
  return '<h3>Lignes d’écriture</h3>'
    +'<p class="aide">Une pression pose une rangée de lignes. Le réglage « nombre de lignes » '
    +'ajoute les suivantes.</p>'
    +'<div class="blocs large">'+l.map(function(x){
      return '<button data-lignage="'+x[0]+'" style="flex-direction:column;align-items:stretch">'
        +apercuLigne(x[0])
        +'<span style="font-size:12.5px">'+x[1]+'</span>'
        +'<span style="font-family:var(--texte);font-weight:600;font-size:11px;color:var(--doux);'
        +'margin-top:3px;line-height:1.35">'+x[2]+'</span></button>';
    }).join('')+'</div>';
}

function panTableau(){
  return '<h3>Tableau</h3><p class="aide">Posez-le, puis cliquez une case pour la régler. '
    +'Double-clic pour écrire dedans.</p>'
    +'<div class="ch duo"><div><label>Colonnes</label><input type="number" id="tbC" value="3" min="1" max="12"></div>'
    +'<div><label>Lignes</label><input type="number" id="tbR" value="3" min="1" max="20"></div></div>'
    +'<div class="bascule on" id="tbTete"><span>Première ligne en en-tête</span><i></i></div>'
    +'<button class="b p" data-tableau style="width:100%">Insérer le tableau</button>'
    +'<h5>Étiquettes</h5><div class="blocs large">'+carteBloc('etiquettes')+'</div>';
}

function blocP(titre,html){return '<div class="bloc-p"><h6>'+titre+'</h6>'+html+'</div>';}
function selP(id,v,l){return '<select id="'+id+'">'+l.map(function(x){
  var val=Array.isArray(x)?x[0]:x, lib=Array.isArray(x)?x[1]:x;
  return '<option value="'+val+'"'+(String(v)===String(val)?' selected':'')+'>'+lib+'</option>';}).join('')+'</select>';}
/* les réglages d'un calcul : opération, nombres (servent à poser ET à changer) */
function formCalcul(g,pre,attrOp){
  var div=g.op===':', ch=[1,2,3,4,5,6];
  return blocP('Opération','<div class="ops-ico">'+[['+','Addition'],['-','Soustraction'],['x','Multiplication'],
      [':','Division']].map(function(o){
      return '<button '+attrOp+'="'+o[0]+'" class="'+(g.op===o[0]?'on':'')+'" title="'+o[1]+'">'+SIGNES[o[0]]+'</button>';
    }).join('')+'</div>')
    +blocP('Nombres','<div class="ch duo"><div><label>'+(div?'Dividende':'1er nombre')+'</label>'
      +selP(pre+'A',g.a,ch.map(function(n){return [n,n+' chiffre'+(n>1?'s':'')];}))+'</div>'
      +'<div><label>'+(div?'Diviseur':'2e nombre')+'</label>'
      +selP(pre+'B',g.b,ch.map(function(n){return [n,n+' chiffre'+(n>1?'s':'')];}))+'</div></div>'
      +'<div class="ch"><label>'+(div?'Reste':'Retenue')+'</label>'+selP(pre+'R',g.ret,div
        ?[['mix','Au hasard'],['avec','Avec reste'],['sans','Sans reste']]
        :[['mix','Au hasard'],['avec','Avec retenue'],['sans','Sans retenue']])+'</div>');
}
function panMaths(type){
  var M=MATHS;M.type=type||M.type||'colonne';
  var ecrit=M.type==='colonne', div=M.op===':';
  return '<p class="aide">'+(ecrit?'Posés en colonne, dans un quadrillage.':'À faire de tête : 34 + 27 = ____')
    +' Les réponses vont dans la version <b>Prof</b>.</p>'
    +formCalcul({op:M.op,a:M.a,b:M.b,ret:M.ret},'m','data-mop')
    +blocP('Présentation',(ecrit?'<label class="coche"><input type="checkbox" id="mQ"'+(M.quad?' checked':'')
        +'> Quadrillage</label>'
      +(div?'':'<label class="coche"><input type="checkbox" id="mC"'+(M.cases?' checked':'')
        +'> Cases pour les retenues</label><label class="coche"><input type="checkbox" id="mCoul"'
        +(M.coul?' checked':'')+'> Couleurs (unités, dizaines…)</label>'):'')
      +'<label class="coche"><input type="checkbox" id="mNum"'+(M.numeros?' checked':'')+'> Numéroter (1, 2, 3…)</label>')
    +blocP('Combien',selP('mN',M.n,[1,2,3,4,5,6,8,9,10,12,15,20,['page','Toute la page']]))
    +'<button class="b p grand" data-majouter>＋ Ajouter</button>'
    +'<p class="aide" style="margin-top:8px">Déjà posés ? Cliquez-les : vous pourrez les changer ou les '
    +'régénérer ('+ico('regen')+').</p>';
}
function lireMaths(){
  function v(id){var x=$('#'+id);return x?x.value:null;}
  var M=MATHS;
  if(v('mA'))M.a=+v('mA');if(v('mB'))M.b=+v('mB');if(v('mN'))M.n=v('mN')==='page'?'page':+v('mN');
  if(v('mR'))M.ret=v('mR');if($('#mQ'))M.quad=$('#mQ').checked;if($('#mC'))M.cases=$('#mC').checked;
  if($('#mCoul'))M.coul=$('#mCoul').checked;if($('#mNum'))M.numeros=$('#mNum').checked;
  if(v('mT'))M.num=v('mT');if(v('mDec')!=null)M.dec=+v('mDec');if(v('mRg'))M.rg=+v('mRg');
}

function panCorrige(){
  var n=0;
  ['1','2','3'].forEach(function(k){
    (R.doc.niveaux[k].pages||[]).forEach(function(p){
      p.el.forEach(function(e){if(e.corrige)n++;});});
  });
  return '<h3>Le corrigé</h3>'
    +'<p class="aide">La version Prof, c’est exactement la version Élève <b>plus</b> les éléments '
    +'marqués « corrigé ». Vous n’avez donc jamais deux mises en page à tenir à jour.</p>'
    +'<div class="bascule'+(ROLE==='prof'?' on':'')+'" data-voirprof>'
      +'<span>Afficher la version Prof</span><i></i></div>'
    +'<p class="aide"><b>Un mot, une lettre :</b> double-cliquez dans le texte, sélectionnez-le, '
    +'puis « ✓ Prof » dans la barre au-dessus. Il passe en rose et laisse sa place vide '
    +'sur la feuille de l’élève.</p>'
    +'<p class="aide"><b>Un élément entier :</b> cliquez-le, puis « ✓ Prof ».</p>'
    +'<p class="aide"><b>L’inverse</b> (des pointillés que le prof ne doit pas voir, par '
    +'exemple) : « Élève ». Collés à une réponse « ✓ Prof », les deux s’échangent '
    +'d’une version à l’autre.</p>'
    +'<h5>Dans toute la ressource</h5>'
    +'<p class="aide"><b>'+n+'</b> élément'+(n>1?'s':'')+' de corrigé.</p>'
    +'<button class="b" data-ajouter-reponse style="width:100%">＋ Ajouter une réponse ici</button>';
}

function panGabarit(){
  var g=R.doc.gabarit||{};
  return '<h3>Gabarit Laé</h3><p class="aide">L’en-tête et le pied de page sont les mêmes sur '
    +'toutes les pages de la ressource.</p>'
    +'<div class="bascule'+(g.entete!==false?' on':'')+'" data-gab="entete">'
      +'<span>En-tête (ciel et logo)</span><i></i></div>'
    +'<div class="bascule'+(g.pied!==false?' on':'')+'" data-gab="pied">'
      +'<span>Pied de page (vague et titre)</span><i></i></div>'
    +'<h5>L’étiquette prénom</h5>'
    +'<div style="background:var(--cream);border:2px solid var(--trait);border-radius:14px;'
      +'padding:9px;margin-bottom:9px;text-align:center">'
      +'<img src="'+esc(nametagSrc(g))+'" style="max-width:100%;display:block" alt=""></div>'
    +'<div class="ch"><label>Largeur sur la feuille (mm)</label>'
      +'<input type="number" id="gNtW" value="'+(g.ntW||92)+'" min="40" max="200"></div>'
    +'<button class="b" id="gLogo" style="width:100%;margin-bottom:7px">'
      +'Remplacer l’étiquette</button>'
    +(g.nametag?'<button class="b sm d" data-glogo-sup style="width:100%">'
      +'Revenir à l’étiquette Laé</button>':'')
    +'<p class="aide" style="margin-top:7px">L’étiquette de l’Académie Laé est mise par défaut. '
      +'Un PNG à fond transparent donne le meilleur rendu.</p>'
    +'<h5>Cette page seulement (page '+(PAGE+1)+')</h5>'
    +'<div class="bascule'+(pageCourante().sansEntete?'':' on')+'" data-pgent>'
      +'<span>En-tête sur cette page</span><i></i></div>'
    +'<div class="bascule'+(pageCourante().sansPied?'':' on')+'" data-pgpied>'
      +'<span>Pied sur cette page</span><i></i></div>'
    +'<div class="ch"><label>Format de cette page</label><div class="rang">'
      +'<button data-pgfmt="a4" class="'+(fmtDe(pageCourante()).t==='a4'?'on':'')+'">A4</button>'
      +'<button data-pgfmt="a3" class="'+(fmtDe(pageCourante()).t==='a3'?'on':'')+'">A3</button>'
      +'</div></div>'
    +'<h5>Le titre dans le pied de page</h5>'
    +'<div class="ch"><input type="text" id="gTitre" value="'+esc(g.titre||'')+'" placeholder="'
      +esc(R.titre||'Titre de l’activité')+'"></div>'
    +'<p class="aide">Vide, c’est le titre de la ressource qui s’affiche.</p>';
}

function panImages(){
  return '<h3>Images</h3><p class="aide">Déposez vos illustrations : elles restent dans votre '
    +'bibliothèque pour les ressources suivantes.</p>'
    +'<button class="b p" id="televerser" style="width:100%">＋ Téléverser une image</button>'
    +'<h5>Ma bibliothèque</h5><div class="blocs" id="biblio">'
    +'<p class="aide" style="grid-column:1/-1">Chargement…</p></div>';
}

/* ---------- le panneau de l'élément sélectionné ---------- */
/* ------------------------------------------------------------
   RÉGLER CE QUI EST DÉJÀ POSÉ
   On sélectionne (un calcul, toute une série, un dessin du Cartable,
   des lignes) et on change une option : seuls ces éléments changent,
   à leur place, avec leurs numéros et leurs nombres.
   ------------------------------------------------------------ */
function formOptions(t,vals,pre){
  return (t.opts||[]).map(function(op){
    if(pre==='co_'&&t.remplir===op.id&&op.type==='select'&&!op.choix.some(function(c){return c[0]==='page';}))
      op=Object.assign({},op,{choix:op.choix.concat([['page','Toute la page']])});
    var v=vals[op.id]!=null?vals[op.id]:op.def, id=pre+op.id;
    if(op.type==='case')return '<label class="coche"><input type="checkbox" id="'+id+'"'+(v?' checked':'')+'> '+op.l+'</label>';
    if(op.type==='texte')return '<div class="ch"><label>'+op.l+'</label><textarea id="'+id+'" rows="4">'+esc(v)+'</textarea></div>';
    if(op.type==='nombre')return '<div class="ch"><label>'+op.l+'</label><input type="number" id="'+id+'" value="'+esc(v)+'"></div>';
    return '<div class="ch"><label>'+op.l+'</label><select id="'+id+'">'+op.choix.map(function(c){
      var val=Array.isArray(c)?c[0]:c, lib=Array.isArray(c)?c[1]:c;
      return '<option value="'+esc(val)+'"'+(String(v)===String(val)?' selected':'')+'>'+esc(lib)+'</option>';}).join('')
      +'</select></div>';
  }).join('');
}
function selType(){
  var els=SEL.map(elementPar).filter(Boolean);
  if(!els.length)return null;
  if(els.every(function(e){return e.type==='calcul';}))return {k:'calcul',els:els};
  if(els.every(function(e){return e.type==='texte'&&e.gen&&e.gen.type==='ligne';}))return {k:'ligne',els:els};
  if(els.every(function(e){return e.type==='dessin'&&e.outil&&e.outil===els[0].outil;}))
    return {k:'outil',els:els,t:OUTILS[els[0].outil]};
  if(els.every(function(e){return e.type==='lignes';}))return {k:'lignes',els:els};
  return {k:'autre',els:els};
}
function reglagesSel(){
  var st=selType();if(!st)return '';
  var els=st.els, h='', tous=function(f){return els.every(f);};
  if(st.k==='calcul'||st.k==='ligne'){
    var g=genDe(els[0]);
    h+='<div class="carte-r"><b>'+(st.k==='calcul'?'Calculs écrits':'Calculs mentaux')+' · '
      +els.length+' sélectionné'+(els.length>1?'s':'')+'</b>'
      +'<button class="b p grand" data-regen>'+ico('regen')+' Régénérer</button>'
      +'<small>Nouveaux nombres, mêmes réglages, même place.</small></div>'
      +formCalcul(g,'r','data-rop');
    if(st.k==='calcul')h+=blocP('Présentation',
      [['rQ','Quadrillage',function(e){return e.quad!==false;}],
        ['rC','Cases pour les retenues',function(e){return !!e.cases;}],
        ['rCo','Couleurs (unités, dizaines…)',function(e){return !!e.couleurs;}]].map(function(o){
        return '<label class="coche"><input type="checkbox" id="'+o[0]+'"'+(tous(o[2])?' checked':'')+'> '+o[1]+'</label>';
      }).join(''));
  }
  if(st.k==='outil'&&st.t){
    h+='<div class="carte-r"><b>'+st.t.ico+' '+st.t.nom+' · '+els.length+' sélectionné'+(els.length>1?'s':'')+'</b>'
      +'<button class="b p grand" data-regen>'+ico('regen')+' Régénérer</button>'
      +'<small>Nouveau contenu, mêmes réglages, même place.</small></div>'
      +blocP('Réglages',formOptions(st.t,els[0].opts||{},'eo_'));
  }
  if(st.k==='lignes'&&els.length>1){
    h+='<h5>Réglages de ces lignes</h5><div class="ch"><label>Type de lignes</label><select id="rLg">'
      +[['maison','Lignes maison'],['couleurs','Lignes de couleur'],['quatre','4 lignes'],['seyes','Seyès'],
        ['simple','Lignes simples']].map(function(g){
        return '<option value="'+g[0]+'"'+(els[0].lignage===g[0]?' selected':'')+'>'+g[1]+'</option>';}).join('')
      +'</select></div>';
  }
  /* le numéro, pour tout ce qui peut en avoir un */
  var num=els.filter(function(e){return !(e.type==='texte'&&e.numLignes)&&e.type!=='consigne';});
  if(num.length)h+='<label class="coche"><input type="checkbox" id="rNum"'
    +(num.every(function(e){return e.num!=null;})?' checked':'')+'> Numéro (1, 2, 3…)</label>';
  return h?h+'<p class="aide" style="margin-top:4px">Seuls les éléments sélectionnés changent. '
    +'Dans un groupe, double-cliquez (ou ⌥ + clic) pour n’en prendre qu’un.</p>':'';
}
/* redessine un élément du Cartable avec d'autres réglages, même hasard */
function regenerer(e,o){
  var t=OUTILS[e.outil];if(!t||!t.faire)return;
  HASARD=graine(e.graine||1);
  var els;try{els=t.faire(o);}finally{HASARD=Math.random;}
  var n=els&&els[e.idx||0];if(!n||n.type!==e.type)return;
  if(e.type==='dessin'){
    var k=e.w/(e.W0||e.w);
    e.prims=n.prims;e.W0=n.W0;e.H0=n.H0;e.w=arrondi(n.W0*k);e.h=arrondi(n.H0*k);
    if(n.ancres)e.ancres=n.ancres;else delete e.ancres;
  }
  e.opts=clone(o);
}
/* changer l'opération ou les chiffres de calculs déjà posés : seuls ceux-là */
function changerCalculs(g){
  var calc=[];
  modifier(function(x){
    if(x.type==='calcul'){regenererCalcul(x,g);calc.push(x);}
    else if(x.type==='texte'&&x.gen&&x.gen.type==='ligne')regenererLigne(x,g);
  });
  if(calc.length>1){reflowCalculs(calc);empiler();peindreTout();enregistrer();}
  etat('Calculs changés : '+SIGNES[g.op]+' · '+g.a+' et '+g.b+' chiffre'+(g.b>1?'s':''));
}
function appliquerReglage(id,cible){
  var st=selType();if(!st)return;
  if(/^r[ABR]$/.test(id)&&(st.k==='calcul'||st.k==='ligne')){
    var g=clone(genDe(st.els[0]));
    g.a=+$('#rA').value;g.b=+$('#rB').value;g.ret=$('#rR').value;
    return changerCalculs(g);
  }
  if(id==='rNum'){
    modifier(function(x){if(x.type==='texte'&&x.numLignes)return;x.num=cible.checked?1:null;});return;}
  if(st.k==='calcul'&&{rQ:1,rC:1,rCo:1}[id]){
    var prop={rQ:'quad',rC:'cases',rCo:'couleurs'}[id];
    modifier(function(x){
      if(x.type!=='calcul')return;
      var L0=layoutCalcul(x), c=x.w/L0.cols;
      x[prop]=cible.checked&&!(x.op===':'&&prop!=='quad');
      var L1=layoutCalcul(x);x.w=arrondi(L1.cols*c);x.h=arrondi(L1.rows*c);
    });return;
  }
  if(id==='rLg'){modifier(function(x){if(x.type!=='lignes')return;
    x.lignage=cible.value;x.hl=HL[x.lignage]||10;x.ecart=/maison|couleurs|quatre/.test(x.lignage)?4:1.5;
    x.h=hauteurBloc(x);});return;}
  if(st.k==='outil'&&id.indexOf('eo_')===0){
    var o=clone(st.els[0].opts||{});
    (st.t.opts||[]).forEach(function(op){var x=$('#eo_'+op.id);if(!x)return;
      o[op.id]=op.type==='case'?x.checked:op.type==='nombre'?(+x.value||0):x.value;});
    modifier(function(x){if(x.type==='dessin'&&x.outil===st.els[0].outil)regenerer(x,o);});
  }
}

function panneauElement(){
  if(SEL.length>1){
    return '<h3>'+SEL.length+' éléments</h3>'+reglagesSel()+'<p class="aide">Alignez-les ou groupez-les.</p>'
      +'<h5>Aligner</h5><div class="rang">'
      +[['g','⇤'],['cx','↔'],['d','⇥'],['h','⇡'],['cy','↕'],['b','⇣']].map(function(a){
        return '<button data-aligner="'+a[0]+'">'+a[1]+'</button>';}).join('')+'</div>'
      +'<h5>Répartir</h5><div class="rang">'
      +'<button data-repartir="h">Horizontalement</button>'
      +'<button data-repartir="v">Verticalement</button></div>'
      +outilsCommuns();
  }
  var e=elementPar(SEL[0]);
  if(!e)return panBlocs();
  var h='<h3>'+nomType(e.type)+'</h3>'+reglagesSel();

  /* le texte, sous toutes ses formes */
  if(e.type==='texte'||e.type==='consigne'||e.type==='retiens'||e.type==='cases'){
    var champ=e.type==='cases'?(e.lignes||[]).join('\n'):(e.texte||'');
    h+='<div class="ch"><label>'+(e.type==='cases'?'Une proposition par ligne':'Texte')+'</label>'
      +'<textarea id="pTexte">'+esc(champ)+'</textarea></div>';
  }
  if(e.type==='retiens')
    h+='<div class="ch"><label>Étiquette</label><input type="text" id="pEtiquette" value="'
      +esc(e.etiquette||'Je retiens')+'"></div>';
  if(e.type==='consigne')
    h+='<div class="ch duo"><div><label>Numéro</label><input type="number" id="pNumero" value="'
      +(e.numero||1)+'" min="1" max="99"></div>'
      +'<div><label>Puce</label><div class="rang"><button data-puce="1" class="'+(e.puce!==false?'on':'')
      +'">Oui</button><button data-puce="0" class="'+(e.puce===false?'on':'')+'">Non</button></div></div></div>';

  if(e.type==='texte'||e.type==='consigne'||e.type==='retiens'||e.type==='cases'){
    h+='<h5>Mise en forme</h5>'
      +'<div class="ch duo"><div><label>Taille</label><input type="number" id="pTaille" step="0.5" value="'
        +(e.taille||11)+'" min="5" max="60"></div>'
      +'<div><label>Interligne</label><input type="number" id="pInter" step="0.1" value="'
        +(e.interligne||1.4)+'" min="1" max="4"></div></div>';
    if(e.type==='texte')
      h+='<div class="ch"><label>Police</label><select id="pPolice">'
        +Object.keys(POLICES).map(function(k){
          return '<option value="'+k+'"'+((e.police||'texte')===k?' selected':'')+'>'+POLICES[k][1]+'</option>';
        }).join('')+'</select></div>';
    h+='<div class="rang" style="margin-bottom:12px">'
      +'<button data-style="gras" class="'+(e.gras?'on':'')+'"><b>G</b></button>'
      +'<button data-style="italique" class="'+(e.italique?'on':'')+'"><i>I</i></button>'
      +'<button data-style="souligne" class="'+(e.souligne?'on':'')+'"><u>S</u></button>'
      +'<button data-align="left" class="'+((e.align||'left')==='left'?'on':'')+'">⬅</button>'
      +'<button data-align="center" class="'+(e.align==='center'?'on':'')+'">⬌</button>'
      +'<button data-align="right" class="'+(e.align==='right'?'on':'')+'">➡</button></div>'
      +'<h5>Couleur du texte</h5><div class="teintes">'+TEINTES.map(function(c){
        return '<button data-couleur="'+c+'" class="'+(e.couleur===c?'on':'')
          +'" style="background:'+c+'"></button>';}).join('')+'</div>';
  }

  /* le fameux rectangle derrière la consigne */
  if(e.type==='consigne'||e.type==='texte'){
    h+='<h5>'+(e.type==='consigne'?'Rectangle derrière la consigne':'Fond')+'</h5>'
      +'<div class="teintes">'+TEINTES.map(function(c){
        return '<button data-fond="'+c+'" class="'+(e.fond===c?'on':'')
          +'" style="background:'+c+'"></button>';}).join('')
      +'</div><div class="rang" style="margin-top:7px">'
      +'<button data-fond="" >Sans fond</button>'
      +'<button data-pleine>Pleine largeur</button></div>';
  }

  if(e.type==='retiens')
    h+='<h5>Couleur du cadre</h5><div class="teintes">'+TEINTES.slice(8).map(function(c){
      return '<button data-teinte="'+c+'" class="'+(e.teinte===c?'on':'')
        +'" style="background:'+c+'"></button>';}).join('')+'</div>';

  if(e.type==='nametag')
    h+='<div class="ch duo"><div><label>Intitulé</label><input type="text" id="pLabel" value="'
      +esc(e.label||'Prénom')+'"></div><div><label>Lettre</label><input type="text" id="pLettre" '
      +'maxlength="2" value="'+esc(e.lettre||'L')+'"></div></div>'
      +'<h5>Couleur</h5><div class="teintes">'+TEINTES.slice(8).map(function(c){
        return '<button data-teinte="'+c+'" class="'+(e.teinte===c?'on':'')
          +'" style="background:'+c+'"></button>';}).join('')+'</div>';

  if(e.type==='lignes'){
    h+='<div class="ch"><label>Type de lignes</label><select id="pLignage">'
      +[['maison','Maison — avec décor'],['couleurs','Maison — couleurs seules'],
        ['quatre','Quatre lignes'],['seyes','Lignage Seyès'],['simple','Lignes simples'],
        ['pointille','Lignes pointillées']].map(function(p){
        return '<option value="'+p[0]+'"'+(e.lignage===p[0]?' selected':'')+'>'+p[1]+'</option>';
      }).join('')+'</select></div>'
      +'<div class="ch duo"><div><label>Nombre de rangées</label><input type="number" id="pNb" '
      +'value="'+(e.nb||1)+'" min="1" max="40"></div>'
      +'<div><label>Hauteur d’une rangée</label><input type="number" id="pHl" step="0.5" value="'
      +(e.hl||HL[e.lignage]||10)+'" min="4" max="60"></div></div>'
      +'<div class="ch"><label>Écart entre les rangées (mm)</label><input type="number" '
      +'id="pEcart" step="0.5" value="'+(e.ecart==null?1.5:e.ecart)+'" min="0" max="20"></div>'
      +'<p class="aide">La hauteur d’une rangée ne change pas quand vous en ajoutez : '
      +'c’est le bloc qui s’allonge.</p>';
  }

  if(e.type==='tableau'){
    h+='<h5>Colonnes et lignes</h5><div class="rang" style="margin-bottom:9px">'
      +'<button data-tb="col-">− colonne</button><button data-tb="col+">＋ colonne</button></div>'
      +'<div class="rang" style="margin-bottom:12px">'
      +'<button data-tb="row-">− ligne</button><button data-tb="row+">＋ ligne</button></div>'
      +'<div class="bascule'+(e.tete?' on':'')+'" data-tbtete>'
      +'<span>Première ligne en en-tête</span><i></i></div>'
      +'<h5>Fusionner</h5>'
      +(CEL&&CEL.id===e.id
        ? '<p class="aide">Cases choisies : de L'+(CEL.y1+1)+'C'+(CEL.x1+1)
          +' à L'+(CEL.y2+1)+'C'+(CEL.x2+1)+'.</p>'
        : '<p class="aide">Cliquez une case, puis <b>Maj + clic</b> sur une autre pour choisir '
          +'un rectangle de cases.</p>')
      +'<div class="rang"><button data-tb="fusion">Fusionner</button>'
      +'<button data-tb="defusion">Séparer</button></div>'
      +'<h5>Couleurs</h5><div class="teintes">'+TEINTES.slice(0,8).map(function(c){
        return '<button data-tbfond="'+c+'" class="'+(e.fond===c?'on':'')
          +'" style="background:'+c+'"></button>';}).join('')+'</div>'
      +'<div class="teintes" style="margin-top:6px">'+TEINTES.slice(8).map(function(c){
        return '<button data-tbtrait="'+c+'" class="'+(e.trait===c?'on':'')
          +'" style="background:'+c+'"></button>';}).join('')+'</div>';
  }

  if(e.type==='bareme')
    h+='<div class="ch"><label>Note sur</label><input type="number" id="pTotal" value="'
      +(e.total||20)+'" min="1" max="100"></div>';

  if(e.type==='forme'){
    h+='<h5>Remplissage</h5><div class="teintes">'+TEINTES.map(function(c){
        return '<button data-remplissage="'+c+'" class="'+(e.remplissage===c?'on':'')
          +'" style="background:'+c+'"></button>';}).join('')
      +'</div><div class="rang" style="margin-top:7px"><button data-remplissage="">Transparent</button></div>'
      +'<h5>Trait</h5><div class="teintes">'+TEINTES.slice(8).map(function(c){
        return '<button data-trait="'+c+'" class="'+(e.trait===c?'on':'')
          +'" style="background:'+c+'"></button>';}).join('')+'</div>'
      +'<div class="ch duo" style="margin-top:9px"><div><label>Épaisseur</label>'
      +'<input type="number" id="pEp" step="0.1" value="'+(e.epaisseur==null?.5:e.epaisseur)+'" min="0" max="5"></div>'
      +'<div><label>Pointillé</label><div class="rang">'
      +'<button data-pointille="1" class="'+(e.pointille?'on':'')+'">Oui</button>'
      +'<button data-pointille="0" class="'+(!e.pointille?'on':'')+'">Non</button></div></div></div>'
      +'<div class="ch"><label>Légende (facultative)</label><input type="text" id="pLegende" value="'
      +esc(e.legende||'')+'"></div>';
  }

  if(e.type==='image')
    h+='<div class="ch"><label>Cadrage</label><div class="rang">'
      +'<button data-ajuste="couvrir" class="'+(e.ajuste!=='contenir'?'on':'')+'">Remplir</button>'
      +'<button data-ajuste="contenir" class="'+(e.ajuste==='contenir'?'on':'')+'">Entier</button></div></div>'
      +'<div class="ch"><label>Coins arrondis (mm)</label><input type="number" id="pRayon" value="'
      +(e.rayon||0)+'" min="0" max="30"></div>';

  /* position exacte, pour les perfectionnistes */
  h+='<h5>Position (mm)</h5>'
    +'<div class="ch duo"><div><label>X</label><input type="number" id="pX" step="0.5" value="'+arrondi(e.x)+'"></div>'
    +'<div><label>Y</label><input type="number" id="pY" step="0.5" value="'+arrondi(e.y)+'"></div></div>'
    +'<div class="ch duo"><div><label>Largeur</label><input type="number" id="pW" step="0.5" value="'+arrondi(e.w)+'"></div>'
    +'<div><label>Hauteur</label><input type="number" id="pH" step="0.5" value="'+arrondi(e.h)+'"></div></div>'
    +'<div class="ch duo"><div><label>Rotation</label><input type="number" id="pRot" value="'+(e.rot||0)+'"></div>'
    +'<div><label>&nbsp;</label><button class="b" data-pleine style="width:100%">Pleine largeur</button></div></div>';

  h+='<div class="bascule'+(e.corrige?' on':'')+'" data-corrige>'
    +'<span>Seulement dans la version Prof</span><i></i></div>'
    +'<div class="bascule'+(e.eleveSeul?' on':'')+'" data-eleveseul>'
    +'<span>Seulement dans la version Élève</span><i></i></div>'
    +'<p class="aide">Pour un seul mot : double-cliquez dans le texte, sélectionnez le mot, '
    +'puis « ✓ Prof » ou « Élève » dans la barre au-dessus.</p>';

  return h+outilsCommuns();
}

function outilsCommuns(){
  return '<h5>Disposition</h5><div class="rang">'
    +'<button data-dx-calques title="Calques">'+DX_I('calques')+'</button>'
    +'<button data-copier-el title="Dupliquer">'+DX_I('dupliquer')+'</button>'
    +'<button data-suppr-el class="d" title="Supprimer">'+DX_I('poubelle')+'</button></div>'
    +'<h5>Commentaire</h5><div class="ch"><textarea id="pNote" placeholder="Une note pour vous-même…"></textarea></div>'
    +'<button class="b sm" data-note style="width:100%">Enregistrer le commentaire</button>';
}

/* ---------- appliquer une modification ---------- */
/* tout l'élément réservé à une version (un second clic le rend aux deux) */
function reserver(v){
  /* depuis le panneau, les interrupteurs basculent */
  var e=elementPar(SEL[0]);
  if(v!=='tous'&&e&&(v==='prof'?e.corrige:e.eleveSeul)&&arguments[1]==='bascule')v='tous';
  modifier(function(x){
    delete x.corrige;delete x.eleveSeul;
    if(v==='prof')x.corrige=true;else if(v==='eleve')x.eleveSeul=true;
    /* tout l'élément décide : ses passages réservés redeviennent normaux */
    passagesDe(x).forEach(function(r){delete r.v;});
  });
  etat(v==='tous'?'Élément visible partout':'Élément visible seulement dans la version '
    +(v==='prof'?'Prof':'Élève')+(ROLE!==v?' — en pâle ici, absent du PDF '+(ROLE==='prof'?'Prof':'Élève'):''));
}
/* ============================================================
   GROUPER ET VERROUILLER
   e.grp    : les éléments d'un même groupe se sélectionnent et se
              déplacent ensemble (⌘G / ⇧⌘G).
   e.verrou : 'pos'  → l'élément ne bouge plus, mais on peut encore
                       écrire dedans et changer son style ;
              'tout' → plus rien ne change (ni texte, ni style, ni
                       suppression) tant qu'on ne le déverrouille pas.
   ============================================================ */
function membres(id){
  var e=elementPar(id);if(!e||!e.grp)return [id];
  var l=[];pages().forEach(function(p){(p.el||[]).forEach(function(x){if(x.grp===e.grp)l.push(x.id);});});
  return l;
}
function bloque(e,pourTout){return !!e&&(e.verrou==='tout'||(!pourTout&&e.verrou==='pos'));}
function grouper(oui){
  var els=SEL.map(elementPar).filter(Boolean);
  /* un groupe peut continuer sur d'autres pages (une longue série de
     calculs) : on emmène tous ses membres, où qu'ils soient */
  var anciens={};els.forEach(function(e){if(e.grp)anciens[e.grp]=1;});
  pages().forEach(function(p){(p.el||[]).forEach(function(e){
    if(e.grp&&anciens[e.grp]&&els.indexOf(e)<0)els.push(e);});});
  if(oui){
    if(els.length<2)return etat('Sélectionnez au moins deux éléments (⇧ + clic)');
    var g='g'+uid();els.forEach(function(e){e.grp=g;});etat('Éléments groupés');
  }else{els.forEach(function(e){delete e.grp;});etat('Groupe défait');}
  empiler();peindreTout();enregistrer();
}
function verrouiller(v){
  SEL.forEach(function(id){var e=elementPar(id);if(!e)return;if(v)e.verrou=v;else delete e.verrou;});
  etat(v==='tout'?'Verrouillé : plus aucune modification':v==='pos'?'Position verrouillée'
    :'Déverrouillé');
  empiler();peindreTout();enregistrer();
}
/* un élément verrouillé « tout » ne se modifie plus */
function modifier(f){
  SEL.forEach(function(id){var e=elementPar(id);if(e&&!bloque(e,true))f(e);});
  empiler();peindreTout();enregistrer();
}
function modifierSansRedessiner(f){
  SEL.forEach(function(id){var e=elementPar(id);if(e&&!bloque(e,true))f(e);});
  peindrePages();enregistrer();
}

/* ============================================================
   LES TABLEAUX
   Ajouter, retirer, fusionner — comme dans Word, mais en gardant
   ce qui est déjà écrit dans les cases.
   ============================================================ */
function grille(e){
  var g=[];
  for(var y=0;y<(e.rows||3);y++){
    g.push([]);
    for(var x=0;x<(e.cols||3);x++)g[y].push((e.cellules&&e.cellules[y]&&e.cellules[y][x])||'');
  }
  return g;
}
/* ajouter / retirer une ligne ou une colonne à la position k (par défaut
   à la fin). Les fusions et la mise en forme des cases suivent. */
function tableauOp(e,op,k){
  var g=grille(e), ligne=op.charAt(0)==='r', plus=op.slice(-1)==='+';
  var n=ligne?e.rows:e.cols;
  if(!plus&&n<=1)return;
  var at=k==null?(plus?n:n-1):k;
  if(ligne){
    if(plus)g.splice(at,0,new Array(e.cols).fill(''));else g.splice(at,1);
    e.h=arrondi(Math.max(8,e.h+(plus?1:-1)*e.h/n));e.rows+=plus?1:-1;
  }else{
    g.forEach(function(r){if(plus)r.splice(at,0,'');else r.splice(at,1);});
    var cw=e.w/n;
    if(plus&&e.w+cw<=larg()+.5)e.w=arrondi(e.w+cw);
    if(!plus)e.w=arrondi(Math.max(10,e.w-cw));
    e.cols+=plus?1:-1;
  }
  e.cellules=g;
  /* les fusions : décalées, agrandies, réduites ou retirées */
  var K=ligne?'y':'x', LK=ligne?'ly':'lx';
  e.fusions=(e.fusions||[]).map(function(f){
    f=clone(f);
    if(plus){if(f[K]>=at)f[K]++;else if(f[K]+f[LK]>at)f[LK]++;}
    else{if(f[K]>at)f[K]--;else if(f[K]+f[LK]>at){f[LK]--;if(f[LK]<1)return null;}}
    return f;
  }).filter(function(f){return f&&(f.ly>1||f.lx>1)&&f.y+f.ly<=e.rows&&f.x+f.lx<=e.cols;});
  /* la mise en forme des cases suit sa case */
  if(e.celRiche){
    var nv={};
    Object.keys(e.celRiche).forEach(function(c){
      var q=c.split('-'), y=+q[0], x=+q[1], v=ligne?y:x;
      if(!plus&&v===at)return;
      if(plus&&v>=at)v++;else if(!plus&&v>at)v--;
      nv[ligne?(v+'-'+x):(y+'-'+v)]=e.celRiche[c];
    });
    e.celRiche=nv;
  }
}
function fusionner(e){
  if(!CEL||CEL.id!==e.id)return alert('Choisissez d’abord des cases : cliquez-en une, '
    +'puis Maj + clic sur une autre.');
  var f={y:CEL.y1,x:CEL.x1,ly:CEL.y2-CEL.y1+1,lx:CEL.x2-CEL.x1+1};
  if(f.ly===1&&f.lx===1)return;
  defusionnerZone(e,f);
  e.fusions=(e.fusions||[]);e.fusions.push(f);
}
function defusionnerZone(e,f){
  e.fusions=(e.fusions||[]).filter(function(x){
    return !(x.y<f.y+f.ly&&x.y+x.ly>f.y&&x.x<f.x+f.lx&&x.x+x.lx>f.x);});
}
function defusionner(e){
  if(!CEL||CEL.id!==e.id)return;
  defusionnerZone(e,{y:CEL.y1,x:CEL.x1,ly:CEL.y2-CEL.y1+1,lx:CEL.x2-CEL.x1+1});
}
function marquerCases(){
  $$('.el[data-t=tableau] td.vise').forEach(function(t){t.classList.remove('vise');});
  if(!CEL)return;
  var n=$('.el[data-id="'+CEL.id+'"]');if(!n)return;
  $$('td',n).forEach(function(t){
    var y=+t.dataset.y,x=+t.dataset.x;
    if(y>=CEL.y1&&y<=CEL.y2&&x>=CEL.x1&&x<=CEL.x2)t.classList.add('vise');
  });
}

/* ============================================================
   ÉCRIRE DIRECTEMENT SUR LA PAGE
   Un double-clic et on tape, comme dans Word.
   ============================================================ */
/* ============================================================
   ÉCRIRE SUR LA FEUILLE
   Double-clic sur un texte : on écrit directement dedans, le mot
   visé est sélectionné. La barre flottante s'applique alors au
   passage sélectionné seulement ; sans sélection, à tout le bloc.
   ============================================================ */
var EDIT=null;          /* {cible, e, fini} pendant qu'on écrit */
function cmd(c,v){try{return document.execCommand(c,false,v);}catch(x){return false;}}
function editer(n,pt){
  if(EDIT)EDIT.fini();
  var id=n.closest('.el').dataset.id, e=elementPar(id);
  if(!e)return;
  var cible=n;
  cible.setAttribute('contenteditable','true');
  /* pendant l'écriture, on voit tout : les passages Prof en rose pâle,
     les passages Élève en bleu pâle */
  cible.classList.add('tout-voir');
  cible.style.outline='2px solid var(--mauve)';
  cible.focus();
  cmd('styleWithCSS',true);
  var sel=window.getSelection(),rg=null;
  if(pt&&document.caretRangeFromPoint)rg=document.caretRangeFromPoint(pt.x,pt.y);
  if(rg&&cible.contains(rg.startContainer)){
    /* le mot sous la souris, comme dans Word */
    var nd=rg.startContainer, o=rg.startOffset;
    if(nd.nodeType===3){
      var tx=nd.nodeValue, lettre=/[\wÀ-ÿœŒ-]/;
      if(o>=tx.length||!lettre.test(tx[o]))o=Math.max(0,o-1);
      var a=o, z=o;
      if(lettre.test(tx[o]||'')){
        while(a>0&&lettre.test(tx[a-1]))a--;
        while(z<tx.length&&lettre.test(tx[z]))z++;
      }
      rg.setStart(nd,a);rg.setEnd(nd,z);
    }
    sel.removeAllRanges();sel.addRange(rg);
  }else{
    rg=document.createRange();rg.selectNodeContents(cible);sel.removeAllRanges();sel.addRange(rg);
  }
  function fini(){
    if(!EDIT||EDIT.cible!==cible||EDIT.pause)return;
    EDIT=null;
    cible.removeEventListener('blur',fini);
    var runs=lireRiche(cible);
    cible.removeAttribute('contenteditable');cible.style.outline='';
    cible.classList.remove('tout-voir');
    var v=runs.map(function(r){return r.t;}).join('').replace(/\n{3,}/g,'\n\n');
    var td=cible.tagName==='TD';
    var style=(RICHES.test(e.type)||td)&&runs.some(function(r){return Object.keys(r).length>1;});
    if(td){
      /* une case de tableau : son texte brut, et sa mise en forme à part */
      var cy=+cible.dataset.y, cx=+cible.dataset.x;
      if(!e.cellules){e.cellules=[];
        for(var q=0;q<(e.rows||3);q++)e.cellules.push(new Array(e.cols||3).fill(''));}
      while(e.cellules.length<=cy)e.cellules.push([]);
      e.cellules[cy][cx]=v.trim();
      e.celRiche=e.celRiche||{};
      if(style)e.celRiche[cy+'-'+cx]=runs;else delete e.celRiche[cy+'-'+cx];
    }else if(e.type==='cases'){
      e.lignes=v.split('\n').filter(function(x){return x.trim();});
      if(style){
        /* on recolle les lignes, sans les lignes vides */
        e.riche=[];
        lignesRiches({riche:runs}).forEach(function(l,k){
          if(k)e.riche.push({t:'\n'});
          l.forEach(function(r){e.riche.push(r);});
        });
      }else delete e.riche;
    }else{
      e.texte=v;
      if(style)e.riche=runs;else delete e.riche;
      if(e.type==='forme')delete e.legende;
    }
    empiler();peindreTout();enregistrer();
  }
  EDIT={cible:cible,e:e,fini:fini};
  cible.addEventListener('blur',fini);
}
/* le passage sélectionné dans le texte en cours d'écriture, s'il y en a un */
function selectionEcrite(){
  if(!EDIT)return null;
  var s=window.getSelection();
  if(!s.rangeCount||s.isCollapsed)return null;
  var r=s.getRangeAt(0);
  return EDIT.cible.contains(r.commonAncestorContainer)?r:null;
}
/* Entoure chaque bout de texte sélectionné d'un <span>, sans passer
   par les commandes du navigateur (Safari et Chrome ne les font pas
   pareil). fn(span) règle ensuite le span. La sélection est gardée. */
function envelopperSelection(fn){
  var r=selectionEcrite();if(!r)return [];
  var c=EDIT.cible, nodes=[], w=document.createTreeWalker(c,NodeFilter.SHOW_TEXT), n;
  while((n=w.nextNode()))if(r.intersectsNode(n)&&n.nodeValue.length)nodes.push(n);
  var spans=[];
  nodes.forEach(function(n){
    var a=0, b=n.nodeValue.length;
    if(n===r.startContainer)a=r.startOffset;
    if(n===r.endContainer)b=r.endOffset;
    if(a>=b)return;
    if(b<n.nodeValue.length)n.splitText(b);
    if(a>0)n=n.splitText(a);
    var sp=document.createElement('span');
    n.parentNode.insertBefore(sp,n);sp.appendChild(n);
    fn(sp);spans.push(sp);
  });
  if(spans.length){
    var rg=document.createRange();rg.setStartBefore(spans[0]);rg.setEndAfter(spans[spans.length-1]);
    var sel=window.getSelection();sel.removeAllRanges();sel.addRange(rg);
  }
  return spans;
}
/* ------------------------------------------------------------
   LE BOUTON DIT TOUJOURS LA VÉRITÉ
   Sans écriture : l'état de l'élément. Pendant l'écriture : l'état
   de la lettre / du mot sous le curseur ou sélectionné (« Mélangé »
   si la sélection couvre plusieurs états).
   ------------------------------------------------------------ */
var NOMS_VUE={tous:'Tous',eleve:'Élève',prof:'Prof',mixte:'Mélangé'};
function etatSelection(){
  var s=window.getSelection();if(!EDIT||!s.rangeCount)return null;
  var r=s.getRangeAt(0), c=EDIT.cible;
  if(!c.contains(r.commonAncestorContainer))return null;
  if(r.collapsed)return vueDe(r.startContainer,c)||'tous';
  var vus={}, w=document.createTreeWalker(c,NodeFilter.SHOW_TEXT), n;
  while((n=w.nextNode())){
    if(!r.intersectsNode(n)||!n.nodeValue.trim())continue;
    if(n===r.startContainer&&r.startOffset>=n.nodeValue.length)continue;
    if(n===r.endContainer&&r.endOffset===0)continue;
    vus[vueDe(n,c)||'tous']=1;
  }
  var k=Object.keys(vus);
  return k.length===1?k[0]:k.length?'mixte':'tous';
}
function majVisible(){
  var b=$('.volante .vis-b'), e=SEL.length&&elementPar(SEL[0]);
  if(!b||!e)return;
  var v=e.corrige?'prof':e.eleveSeul?'eleve':'tous', quoi='Élément';
  if(v==='tous'){
    var es=etatSelection();
    if(es){v=es;quoi=window.getSelection().isCollapsed?'Ici':'Sélection';}
    else if(passagesDe(e).some(function(r){return r.v&&r.t.trim();}))v='mixte';
  }
  b.className='vis-b v-'+v;
  b.innerHTML=DX_I('oeilp')+' <b>'+NOMS_VUE[v]+'</b> ▾';
  var t=$('.volante .vis-t');
  if(t)t.textContent=(quoi==='Élément'?'Tout l’élément':quoi==='Ici'?'À cet endroit du texte'
    :'Le texte sélectionné')+(v==='mixte'?' : plusieurs réglages':'');
  $$('.volante .vis-l [data-vvue]').forEach(function(x){
    x.classList.toggle('on',x.dataset.vvue===v);});
}

/* « Tous / Élève / Prof » sur le passage choisi (même une seule lettre) */
function vueSelection(v){
  var spans=envelopperSelection(function(sp){
    sp.setAttribute('data-v',v);sp.className='rv'+(v?' v-'+v:'');
    /* une réponse s'écrit en rose, comme les éléments du corrigé */
    if(v==='prof')sp.style.color='#f0265c';
  });
  if(!spans.length)return;
  majVisible();
  etat(v==='prof'?'Passage visible seulement dans la version Prof'
    :v==='eleve'?'Passage visible seulement dans la version Élève':'Passage visible partout');
}
/* un lien sur le passage sélectionné seulement */
function lierSelection(url){
  url=String(url).trim();if(!url)return;
  if(/^www\./i.test(url))url='https://'+url;
  if(!/^(https?:|mailto:)/i.test(url))url='https://'+url;
  var spans=envelopperSelection(function(sp){
    sp.setAttribute('data-href',url);sp.className='lien';
    sp.style.color='#2f80c8';sp.style.textDecoration='underline';
  });
  if(spans.length)etat('Lien ajouté : '+url);
}

/* A+ / A− sur le passage choisi seulement */
function tailleSelection(delta){
  envelopperSelection(function(sp){
    var px=parseFloat(getComputedStyle(sp.parentElement).fontSize);
    sp.style.fontSize=Math.max(5,Math.round((px*.75+delta)*2)/2)+'pt';
  });
}
/* double-clic : trouver où écrire dans l'élément */
function ouvrirEcriture(id,x,y){
  var el=$('.el[data-id="'+id+'"]');if(!el)return;
  if(bloque(elementPar(id),true))
    return etat('Élément verrouillé : déverrouillez-le d’abord (dans la barre)');
  /* rien à écrire dedans (calcul, dessin…) : le double-clic le prend seul
     dans son groupe, pour le régler à part */
  var t0=el.dataset.t;
  if(!/^(texte|consigne|retiens|forme|cases|tableau)$/.test(t0)){
    SEL=[id];PROPS=true;peindreTout();
    return etat('Seul cet élément est sélectionné');
  }
  var t=el.dataset.t, sous=document.elementFromPoint(x,y);
  var td=sous&&sous.closest&&sous.closest('td');
  if(t==='tableau'&&td&&el.contains(td))return editer(td,{x:x,y:y});
  var inn=$('.in',el);if(!inn)return;
  var cible=inn;
  /* le texte vit dans un seul bloc (.tt) : les passages en gras ou en
     couleur restent ainsi sur la même ligne */
  if(t==='texte'&&!inn.querySelector('.tt')){
    inn.classList.remove('vide');inn.innerHTML='<div class="tt"></div>';
  }
  if(t==='consigne')cible=inn.querySelector('span:last-child')||inn;
  else if(t==='retiens'||t==='bareme')cible=inn.querySelector('.tx')||inn;
  else if(t==='forme')cible=inn.querySelector('.dedans .tt')||inn;
  else if(t==='texte')cible=inn.querySelector('.tt');
  else if(t!=='cases')return;   /* image, lignes : rien à écrire */
  editer(cible,{x:x,y:y});
}
function editerCase(td){
  var el=td.closest('.el'), e=elementPar(el.dataset.id);if(!e)return;
  var y=td.parentNode.rowIndex, x=td.cellIndex;
  td.setAttribute('contenteditable','true');td.focus();
  function fini(){
    td.removeAttribute('contenteditable');
    if(!e.cellules){
      e.cellules=[];for(var r=0;r<(e.rows||3);r++){e.cellules.push(new Array(e.cols||3).fill(''));}
    }
    while(e.cellules.length<=y)e.cellules.push([]);
    e.cellules[y][x]=td.innerText.trim();
    td.removeEventListener('blur',fini);
    empiler();peindreTout();enregistrer();
  }
  td.addEventListener('blur',fini);
}

/* ============================================================
   LES PAGES ET LE ZOOM
   ============================================================ */
function ajusterZoom(){
  var s=$('#scene');if(!s)return;
  var large=0;pages().forEach(function(p){large=Math.max(large,dimDe(p)[0]);});
  var px=(s.clientWidth-120)/(large*96/25.4);
  appliquerZoom(borne(px,0.2,1.25));
}
function appliquerZoom(z){
  ZOOM=z;
  var haut=0;pages().forEach(function(p){haut+=dimDe(p)[1];});
  $('#pages').style.transform='scale('+z+')';
  $('#pages').style.marginBottom=((z-1)*haut*3.78)+'px';
  $('#zVal').textContent=Math.round(z*100)+' %';
  barreVolante();
}
/* ============================================================
   CHANGER LE FORMAT D'UNE PAGE
   Tout ce qui est posé dessus suit : les lignes d'écriture
   s'allongent, les blocs pleine largeur restent pleine largeur,
   les proportions sont conservées. On ne refait pas la mise en
   page à la main.
   ============================================================ */
function changerFormat(i,quoi){
  var p=pages()[i];p.f=fmtDe(p);
  var avant=dimDe(p), aL=avant[0], aH=avant[1];
  if(quoi==='t')p.f.t=p.f.t==='a4'?'a3':'a4';
  else p.f.o=p.f.o==='portrait'?'paysage':'portrait';
  var apres=dimDe(p), bL=apres[0], bH=apres[1];

  var g=R.doc.gabarit||{};
  var hautA=(g.entete===false?MARGE:HAUT), basA=(g.pied===false?MARGE:BAS);
  var utileA=aL-2*MARGE, utileB=bL-2*MARGE;
  var vertA=aH-hautA-basA, vertB=bH-hautA-basA;
  var kx=utileB/utileA, ky=vertB/vertA;

  p.el.forEach(function(e){
    var pleine=Math.abs(e.x-MARGE)<1.5&&Math.abs(e.w-utileA)<2.5;
    e.x=arrondi(MARGE+(e.x-MARGE)*kx);
    e.w=arrondi(pleine?utileB:e.w*kx);
    e.y=arrondi(hautA+(e.y-hautA)*ky);
    /* Les HAUTEURS ne changent pas : le texte garde sa taille en points,
       un bloc rétréci le rognerait. Seuls la largeur et la place suivent
       le nouveau format. */
    if(e.type==='lignes')e.h=hauteurBloc(e);
    /* on ne laisse rien déborder sous le pied de page */
    e.y=arrondi(borne(e.y,MARGE,Math.max(MARGE,bH-basA-e.h)));
  });
  SEL=[];empiler();ajusterZoom();peindreTout();enregistrer();
  etat(p.f.t.toUpperCase()+' '+p.f.o);
}

/* ============================================================
   TOUTES LES PAGES (comme la vue grille de Canva)
   On voit toutes les pages de la version, on les glisse pour
   changer l'ordre, on en ajoute en vertical ou en horizontal.
   ============================================================ */
var TIRE=null;
function ouvrirGrille(){
  if(EDIT)EDIT.fini();
  var g=$('#grille');
  if(!g){
    g=document.createElement('div');g.id='grille';g.className='vue-pages';
    $('#scene').appendChild(g);
    g.addEventListener('click',clicGrille);
    g.addEventListener('dragstart',function(e){
      var c=e.target.closest('[data-gr]');if(!c)return;
      TIRE=+c.dataset.gr;c.classList.add('tire');
      e.dataTransfer.effectAllowed='move';e.dataTransfer.setData('text/plain',String(TIRE));
    });
    g.addEventListener('dragover',function(e){
      var c=e.target.closest('[data-gr]');if(!c||TIRE==null)return;
      e.preventDefault();
      var r=c.getBoundingClientRect(), apres=e.clientX>r.left+r.width/2;
      $$('.gr-carte',g).forEach(function(x){x.classList.remove('avant','apres');});
      c.classList.add(apres?'apres':'avant');
    });
    g.addEventListener('drop',function(e){
      var c=e.target.closest('[data-gr]');if(!c||TIRE==null)return;
      e.preventDefault();
      var i=+c.dataset.gr, de=TIRE, vers=i+(c.classList.contains('apres')?1:0);
      TIRE=null;
      if(vers>de)vers--;
      if(vers===de)return peindreGrille();
      var p=pages(), m=p.splice(de,1)[0];p.splice(vers,0,m);
      PAGE=vers;SEL=[];empiler();peindreTout();enregistrer();
      etat('Page déplacée');
    });
    g.addEventListener('dragend',function(){TIRE=null;
      $$('.gr-carte',g).forEach(function(x){x.classList.remove('tire','avant','apres');});});
  }
  peindreGrille();
}
function fermerGrille(){var g=$('#grille');if(g)g.remove();}
function peindreGrille(){
  var g=$('#grille');if(!g)return;
  var lst=pages();
  var h='<div class="gr-tete"><div><b>Toutes les pages</b><small>Niveau '+NIV+' · '
    +(ROLE==='prof'?'Prof':'Élève')+' — glissez une page pour changer l’ordre, '
    +'cliquez-la pour l’ouvrir.</small></div>'
    +'<button class="b sm" data-gr-ajout="portrait">＋ Page verticale</button>'
    +'<button class="b sm" data-gr-ajout="paysage">＋ Page horizontale</button>'
    +'<button class="b sm p" data-gr-fermer>Fermer</button></div><div class="gr-pages">';
  lst.forEach(function(p,i){
    var d=dimDe(p), f=fmtDe(p), H=210, W=Math.round(H*d[0]/d[1]);
    h+='<div class="gr-carte'+(i===PAGE?' on':'')+'" draggable="true" data-gr="'+i+'">'
      +'<div class="gr-vue" style="width:'+W+'px;height:'+H+'px"></div>'
      +'<div class="gr-bas"><b>'+(i+1)+'</b><small>'+f.t.toUpperCase()+' '
      +(f.o==='paysage'?'horizontale':'verticale')+'</small>'
      +'<button data-gr-sens title="Vertical / horizontal">'+DX_I('pivoter')+'</button>'
      +'<button data-gr-copie title="Dupliquer la page">'+DX_I('dupliquer')+'</button>'
      +'<button data-gr-niveau title="Copier vers un autre niveau">'+DX_I('niveaux')+'</button>'
      +'<button data-gr-suppr title="Supprimer la page">'+DX_I('poubelle')+'</button></div></div>';
  });
  g.innerHTML=h+'</div>';
  /* les vignettes : une copie réduite de la vraie page */
  lst.forEach(function(p,i){
    var src=$('#pages .pg[data-page="'+i+'"]'), box=$('[data-gr="'+i+'"] .gr-vue',g);
    if(!src||!box)return;
    var c=src.cloneNode(true);c.removeAttribute('data-page');
    $$('.poignees,.pn,.guide',c).forEach(function(x){x.remove();});
    $$('.sel',c).forEach(function(x){x.classList.remove('sel');});
    c.style.transform='scale('+(box.clientWidth/(dimDe(p)[0]*96/25.4))+')';
    box.appendChild(c);
  });
}
function clicGrille(e){
  var b=e.target.closest('[data-gr-ajout]');
  if(b){
    pages().push({el:[],f:{t:'a4',o:b.dataset.grAjout}});
    PAGE=pages().length-1;SEL=[];empiler();peindreTout();enregistrer();
    return etat('Page '+(PAGE+1)+' ajoutée');
  }
  if(e.target.closest('[data-gr-fermer]'))return fermerGrille();
  var c=e.target.closest('[data-gr]');if(!c)return;
  var i=+c.dataset.gr;
  if(e.target.closest('[data-gr-sens]'))return changerFormat(i,'o');
  if(e.target.closest('[data-gr-copie]'))return pageAjouter(i,true);
  if(e.target.closest('[data-gr-niveau]')){fermerGrille();return fenetreCopierPage(i);}
  if(e.target.closest('[data-gr-suppr]'))return pageSupprimer(i);
  /* ouvrir la page */
  fermerGrille();
  var m=$('#minis [data-page="'+i+'"]');if(m)m.click();
}

/* ------------------------------------------------------------
   DIFFÉRENCIER : copier une page du niveau 1 vers le niveau 2 (ou 3)
   et la modifier là-bas. Le niveau d'arrivée devient « personnalisé ».
   ------------------------------------------------------------ */
function fenetreCopierPage(i){
  var autres=['1','2','3'].filter(function(n){return n!==NIV;});
  var v=fenetre('<h3>Copier la page '+(i+1)+'</h3>'
    +'<p class="sous">Vers un autre niveau, pour l’adapter (nombres, difficulté, couleurs…). '
    +'Tout est copié tel quel : mise en page, numéros, réponses.</p>'
    +autres.map(function(n){
      var nb=(R.doc.niveaux[n].pages||[]).length;
      return '<h5>Niveau '+n+'</h5><div class="rang">'
        +'<button class="b p" data-cp="'+n+'|fin">À la fin du niveau '+n+'</button>'
        +(i<nb?'<button class="b" data-cp="'+n+'|remplacer">Remplacer sa page '+(i+1)+'</button>':'')
        +'</div>';}).join('')
    +'<div class="fin"><button class="b" data-x>Annuler</button></div>');
  v.addEventListener('click',function(ev){
    var b=ev.target.closest('[data-cp]');if(!b)return;
    var x=b.dataset.cp.split('|');v.remove();copierPageVers(i,x[0],x[1]==='remplacer');
  });
}
function copierPageVers(i,n,remplacer){
  var src=clone(pages()[i]), ng=nouveauxGroupes();
  src.el.forEach(function(e){e.id=uid();ng(e);});
  var dest=R.doc.niveaux[n];dest.lie=false;
  var k;
  if(remplacer&&i<dest.pages.length){dest.pages[i]=src;k=i;}else{dest.pages.push(src);k=dest.pages.length-1;}
  R.doc.actives=R.doc.actives||{};R.doc.actives[n+'-eleve']=true;R.doc.actives[n+'-prof']=true;
  NIV=n;PAGE=k;SEL=[];
  /* pas de propager() : copier n'est pas « modifier le niveau 1 » */
  PILE=PILE.slice(0,PILE_POS+1);PILE.push(JSON.stringify(R.doc));PILE_POS=PILE.length-1;
  majBoutonsPile();peindreTout();enregistrer();
  etat('Page copiée dans le niveau '+n+' : modifiez-la ici');
}

function pageAjouter(i,copie){
  var p=pages();
  var neuve=copie?clone(p[i]):{el:[]};
  if(copie)neuve.el.forEach(function(e){e.id=uid();});
  p.splice(i+1,0,neuve);PAGE=i+1;SEL=[];
  empiler();peindreTout();enregistrer();
}
function pageSupprimer(i){
  var p=pages();
  if(p.length<=1)return alert('Il faut au moins une page.');
  if(!confirm('Supprimer la page '+(i+1)+' de ce niveau ?'))return;
  p.splice(i,1);PAGE=Math.max(0,i-1);SEL=[];
  empiler();peindreTout();enregistrer();
}

/* ============================================================
   DUPLIQUER UN NIVEAU VERS UN AUTRE
   On part d'un niveau qui marche et on n'ajuste que ce qui change.
   ============================================================ */
function fenetreDupliquer(){
  var v=fenetre('<h3>Dupliquer un niveau</h3>'
    +'<p class="sous">Copiez la mise en page d’un niveau vers un autre. Vous n’aurez plus qu’à '
    +'modifier ce qui change réellement : les nombres, la difficulté, les mots.</p>'
    +'<div class="ch"><label>Copier le niveau</label><select id="dpDe">'
      +['1','2','3'].map(function(n){return '<option value="'+n+'"'+(n===NIV?' selected':'')
        +'>Niveau '+n+'</option>';}).join('')+'</select></div>'
    +'<div class="ch"><label>Vers</label><select id="dpVers">'
      +['1','2','3'].map(function(n){return '<option value="'+n+'"'+(n!==NIV?' selected':'')
        +'>Niveau '+n+'</option>';}).join('')+'</select></div>'
    +'<p class="sous" style="color:var(--rose)">Le contenu actuel du niveau de destination sera remplacé.</p>'
    +'<div class="fin"><button class="b" data-x>Annuler</button>'
    +'<button class="b p" data-ok>Dupliquer</button></div>');
  v.addEventListener('click',function(ev){
    if(!ev.target.hasAttribute('data-ok'))return;
    var de=$('#dpDe').value, vers=$('#dpVers').value;
    if(de===vers)return alert('Choisissez deux niveaux différents.');
    R.doc.niveaux[vers]=clone(R.doc.niveaux[de]);
    R.doc.niveaux[vers].pages.forEach(function(p){p.el.forEach(function(e){e.id=uid();});});
    NIV=vers;PAGE=0;SEL=[];v.remove();
    empiler();peindreTout();enregistrer(true);
    etat('Niveau '+vers+' créé');
  });
}

/* ============================================================
   ACTUALISER LES AUTRES NIVEAUX
   ============================================================ */
function fenetreActualiser(){
  var autres=['1','2','3'].filter(function(n){return n!==NIV;});
  var v=fenetre('<h3>Actualiser les autres niveaux</h3>'
    +'<p class="sous">Recopier le <b>niveau '+NIV+'</b> tel qu’il est maintenant vers les '
    +'niveaux cochés. Leur contenu actuel sera remplacé — y compris leur corrigé.</p>'
    +autres.map(function(n){
      var vide=!R.doc.niveaux[n].pages.some(function(p){return p.el.length;});
      return '<div class="bascule'+(estLie(n)||vide?' on':'')+'" data-cible="'+n+'">'
        +'<span>Niveau '+n+(estLie(n)?' — lié, se met à jour tout seul':vide?' — vide':'')+'</span>'
        +'<i></i></div>';
    }).join('')
    +'<p class="sous" style="margin:14px 0 0">Un niveau devient <b>indépendant</b> dès que vous '
    +'le modifiez directement. Ce bouton sert à le remettre d’aplomb quand vous le décidez.</p>'
    +'<div class="fin"><button class="b" data-x>Annuler</button>'
    +'<button class="b p" data-ok>Actualiser</button></div>');
  v.addEventListener('click',function(ev){
    var b=ev.target.closest('[data-cible]');
    if(b)return void b.classList.toggle('on');
    if(!ev.target.hasAttribute('data-ok'))return;
    var faits=[];
    $$('[data-cible].on',v).forEach(function(x){
      recopierNiveau(NIV,x.dataset.cible);faits.push(x.dataset.cible);
    });
    v.remove();
    if(!faits.length)return;
    pretPourPile=false;peindreTout();pretPourPile=true;
    PILE=PILE.slice(0,PILE_POS+1);PILE.push(JSON.stringify(R.doc));PILE_POS=PILE.length-1;
    majBoutonsPile();enregistrer(true);
    etat('Niveau'+(faits.length>1?'x':'')+' '+faits.join(' et ')+' actualisé'
      +(faits.length>1?'s':''));
  });
}

/* ============================================================
   CLASSER LA RESSOURCE
   ============================================================ */
/* ------------------------------------------------------------
   LE RÉFÉRENCEMENT (ce que Google affiche)
   Titre ≤ 60 caractères, description ≤ 155. Proposés tout seuls à
   partir du titre et de la description ; on peut les retoucher.
   Rangés dans R.doc.seo, envoyés à Shopify à la publication.
   ------------------------------------------------------------ */
/* le texte sans mise en forme : chaque ligne devient une phrase */
function texteBrut(t){
  return String(t||'').replace(/\*\*/g,'').split(/\n+/).map(function(l){
    l=l.replace(/^\s*[-•*]\s+/,'').trim();
    return l&&!/[.!?:;,…]$/.test(l)?l+'.':l;
  }).filter(Boolean).join(' ').replace(/\s+/g,' ').trim();
}
function couperA(t,max){
  t=texteBrut(t);if(t.length<=max)return t;
  var c=t.slice(0,max-1), i=c.lastIndexOf(' ');
  return (i>max*.6?c.slice(0,i):c).replace(/[\s,;:.–-]+$/,'')+'…';
}
function seoAuto(titre,desc){
  var t=String(titre||'Ressource Laé').replace(/\s+/g,' ').trim(), suf=' | Ressources Laé';
  /* le titre le plus complet qui tient dans 60 caractères */
  var court=t.split(/\s+[-–]\s+/)[0], choix=[t+suf,t,court+suf,court], tt=null;
  choix.forEach(function(c){if(!tt&&c.length<=60)tt=c;});
  return {titre:tt||couperA(court,60),
    desc:couperA(desc||(t+' : exercices à imprimer en PDF, avec la version Prof.'),155)};
}
function seoDe(){
  var a=seoAuto(R.titre,R.description), s0=(R.doc&&R.doc.seo)||{};
  return {titre:s0.titre||a.titre,desc:s0.desc||a.desc,manuel:!!(s0.titre||s0.desc)};
}

function fenetreClasser(){
  var choisies=classesDe(R);
  var niveaux=CLASSES.map(function(c){
    return '<div class="cl-rang"><span>'+c.nom+'</span>'+c.niveaux.map(function(n){
      return '<button type="button" data-cl="'+n[0]+'" class="'+(choisies.indexOf(n[0])>=0?'on':'')+'" title="'
        +n[1]+'">'+n[0].toUpperCase()+'</button>';
    }).join('')+'</div>';}).join('');
  var v=fenetre('<h3>Classer la ressource</h3>'
    +'<p class="sous">Ce classement range la fiche dans le tableau de bord et prépare les '
    +'étiquettes de la boutique.</p>'
    +'<div class="ch"><label>Classes <small>une ou plusieurs : la fiche apparaîtra dans chacune</small></label>'
      +'<div class="choix-classes">'+niveaux+'</div><input type="hidden" id="cNiveau" value="'+(choisies[0]||'')+'"></div>'
    +'<div class="ch"><label>Matière</label><select id="cMatiere"></select></div>'
    +'<div class="ch"><label>Sujet</label><select id="cSujetL"></select>'
      +'<input type="text" id="cSujet" placeholder="Nouveau sujet (s’écrira ainsi sur le site)" '
      +'style="margin-top:8px" hidden></div>'
    +'<p class="aide" id="cTags" style="margin:-4px 0 12px"></p>'
    +'<div class="ch"><label>Description pour la boutique</label>'
      +'<textarea id="cDesc" rows="7" placeholder="Ce que l’enfant apprend avec cette fiche.">'
      +esc(R.description||'')+'</textarea>'
      +'<p class="aide" style="margin:6px 0 0">Une ligne vide = nouveau paragraphe · une ligne qui '
      +'commence par « - » = une puce · <b>**texte**</b> = en gras.</p></div>'
    +'<h5>Sur Google</h5>'
    +'<div class="ch"><label>Titre Google <small id="cSeoTn"></small></label>'
      +'<input type="text" id="cSeoT" maxlength="70" value="'+esc(seoDe().titre)+'"></div>'
    +'<div class="ch"><label>Description Google <small id="cSeoDn"></small></label>'
      +'<textarea id="cSeoD" rows="3" maxlength="200">'+esc(seoDe().desc)+'</textarea></div>'
    +'<div class="seo-apercu" id="cSeoA"></div>'
    +'<p class="aide" style="margin-top:4px">Proposés tout seuls à partir du titre et de la description. '
    +'<button class="lien-b" data-seo-auto>↺ Revenir à la proposition</button></p>'
    +'<div class="ch"><label>État</label><div class="rang">'
      +[['brouillon','Brouillon'],['pret','Prêt'],['en_ligne','En ligne']].map(function(e){
        return '<button data-etat="'+e[0]+'" class="'+((R.etat||'brouillon')===e[0]?'on':'')
          +'">'+e[1]+'</button>';}).join('')+'</div></div>'
    +'<div class="fin"><button class="b" data-x>Annuler</button>'
    +'<button class="b p" data-ok>Enregistrer</button></div>');
  var etatChoisi=R.etat||'brouillon';
  /* le référencement suit la description tant qu'on ne l'a pas retouché */
  var seoTouche={t:!!(R.doc.seo&&R.doc.seo.titre),d:!!(R.doc.seo&&R.doc.seo.desc)};
  function majSeo(force){
    var a=seoAuto(R.titre,$('#cDesc').value.trim());
    if(force||!seoTouche.t)$('#cSeoT').value=a.titre;
    if(force||!seoTouche.d)$('#cSeoD').value=a.desc;
    if(force)seoTouche={t:false,d:false};
    var lt=$('#cSeoT').value.length, ld=$('#cSeoD').value.length;
    $('#cSeoTn').textContent=lt+' / 60';$('#cSeoTn').className=lt>60?'trop':'';
    $('#cSeoDn').textContent=ld+' / 155';$('#cSeoDn').className=ld>155?'trop':'';
    $('#cSeoA').innerHTML='<b>'+esc($('#cSeoT').value)+'</b><i>ressourceslae.com › products</i><span>'
      +esc($('#cSeoD').value)+'</span>';
  }
  $('#cDesc').addEventListener('input',function(){majSeo(false);});
  $('#cSeoT').addEventListener('input',function(){seoTouche.t=true;majSeo(false);});
  $('#cSeoD').addEventListener('input',function(){seoTouche.d=true;majSeo(false);});
  v.addEventListener('click',function(ev){if(ev.target.closest('[data-seo-auto]')){ev.preventDefault();majSeo(true);}});
  majSeo(false);
  /* les listes suivent la classe puis la matière choisies */
  function opts(l,actuel,vide){
    if(actuel&&l.indexOf(actuel)<0)l=[actuel].concat(l);
    return '<option value="">'+vide+'</option>'+l.map(function(x){
      return '<option'+(x===actuel?' selected':'')+'>'+esc(x)+'</option>';}).join('');
  }
  function sujet(){
    var l=$('#cSujetL').value;return l==='__autre'?$('#cSujet').value.trim():l;
  }
  function majMatieres(){
    var m=$('#cMatiere').value||R.matiere||'';
    $('#cMatiere').innerHTML=opts(matieresDe($('#cNiveau').value),m,'—');
    majSujets();
  }
  function majSujets(){
    var s=sujet()||R.sujet||'';
    var l=sujetsDe($('#cNiveau').value,$('#cMatiere').value);
    $('#cSujetL').innerHTML=opts(l,s,'— choisir —')
      +'<option value="__autre">✎ Autre sujet…</option>';
    majTags();
  }
  function majTags(){
    $('#cSujet').hidden=$('#cSujetL').value!=='__autre';
    var m=$('#cMatiere').value, s=sujet(), t=[];
    choisies.forEach(function(n){t.push('niveau_'+n);});
    if(m)t.push('matiere_'+poigneeDe(m));
    if(s)t.push('domaine_'+poigneeDe(s));
    $('#cTags').innerHTML='Étiquettes de la boutique : <b>'+(t.join(', ')||'aucune')+'</b>';
  }
  majMatieres();
  $('#cNiveau').addEventListener('change',majMatieres);
  v.addEventListener('click',function(ev){
    var b=ev.target.closest('[data-cl]');if(!b)return;
    var n=b.dataset.cl,i=choisies.indexOf(n);
    if(i>=0)choisies.splice(i,1);else choisies.push(n);
    choisies=trierClasses(choisies);
    $$('[data-cl]',v).forEach(function(x){x.classList.toggle('on',choisies.indexOf(x.dataset.cl)>=0);});
    var avant=$('#cNiveau').value;$('#cNiveau').value=choisies[0]||'';
    if(avant!==$('#cNiveau').value)majMatieres();else majTags();
  });
  $('#cMatiere').addEventListener('change',majSujets);
  $('#cSujetL').addEventListener('change',function(){
    majTags();if(!$('#cSujet').hidden)$('#cSujet').focus();});
  $('#cSujet').addEventListener('input',majTags);
  v.addEventListener('click',function(ev){
    var b=ev.target.closest('[data-etat]');
    if(b){etatChoisi=b.dataset.etat;$$('[data-etat]',v).forEach(function(x){
      x.classList.toggle('on',x===b);});return;}
    if(!ev.target.hasAttribute('data-ok'))return;
    R.doc.classes=choisies.slice();
    R.niveau=choisies[0]||null;
    R.cycle=R.niveau?(R.niveau[0]==='p'?'primaire':'secondaire'):null;
    R.matiere=$('#cMatiere').value||null;
    R.sujet=sujet()||null;
    R.description=$('#cDesc').value.trim()||null;
    /* le référencement : gardé seulement s'il a été retouché à la main */
    var auto=seoAuto(R.titre,R.description), st=$('#cSeoT').value.trim(), sd=$('#cSeoD').value.trim();
    R.doc.seo={titre:st&&st!==auto.titre?st:'',desc:sd&&sd!==auto.desc?sd:''};
    R.etat=etatChoisi;
    R.tags=etiquettes();
    v.remove();enregistrer(true);etat('Classement enregistré');
  });
}
function etiquettes(){
  var t=[];
  cyclesDe(R).forEach(function(c){t.push('cycle_'+c);});
  classesDe(R).forEach(function(n){t.push('niveau_'+n);});
  if(R.matiere)t.push('matiere_'+poigneeDe(R.matiere));
  if(R.sujet)t.push('domaine_'+poigneeDe(R.sujet));
  return t;
}

/* ============================================================
   LES COMMENTAIRES
   ============================================================ */
function fenetreNotes(){
  sb.from('ressource_notes').select('*').eq('ressource_id',R.id)
    .order('created_at',{ascending:false}).then(function(r){
    var l=r.data||[];
    var v=fenetre('<h3>Commentaires</h3>'
      +'<p class="sous">Vos notes de travail. Elles ne sortent jamais sur les feuilles imprimées.</p>'
      +(l.length?'<div class="liste-export">'+l.map(function(n){
        return '<div class="'+(n.resolu?'fait':'')+'"><span style="flex:1">'+esc(n.texte)+'</span>'
          +'<span class="st">'+esc(n.version||'')+'</span>'
          +'<button class="b sm" data-resoudre="'+n.id+'">'+(n.resolu?'Rouvrir':'Fait')+'</button>'
          +'<button class="b sm d" data-noteSup="'+n.id+'">×</button></div>';
      }).join('')+'</div>':'<p class="sous">Aucun commentaire pour l’instant.</p>')
      +'<div class="ch"><label>Nouveau commentaire</label>'
      +'<textarea id="nvNote" placeholder="À revoir : les nombres du niveau 3 sont trop faciles."></textarea></div>'
      +'<div class="fin"><button class="b" data-x>Fermer</button>'
      +'<button class="b p" data-ok>Ajouter</button></div>');
    v.addEventListener('click',function(ev){
      var a=ev.target.closest('[data-resoudre]'),b=ev.target.closest('[data-noteSup]');
      if(a)return void sb.from('ressource_notes').update({resolu:!l.filter(function(x){
        return String(x.id)===a.dataset.resoudre;})[0].resolu}).eq('id',a.dataset.resoudre)
        .then(function(){v.remove();fenetreNotes();});
      if(b)return void sb.from('ressource_notes').delete().eq('id',b.dataset.noteSup)
        .then(function(){v.remove();fenetreNotes();});
      if(!ev.target.hasAttribute('data-ok'))return;
      var t=$('#nvNote').value.trim();if(!t)return;
      sb.from('ressource_notes').insert({ressource_id:R.id,texte:t,
        version:'Niveau '+NIV+' · '+(ROLE==='prof'?'Prof':'Élève'),
        element_id:SEL[0]||null,auteur:moi}).then(function(){v.remove();etat('Commentaire ajouté');});
    });
  });
}

/* ============================================================
   LA BIBLIOTHÈQUE D'IMAGES
   ============================================================ */
function chargerImages(){
  sb.from('ressource_images').select('*').order('created_at',{ascending:false}).limit(60)
    .then(function(r){
      var b=$('#biblio');if(!b)return;
      var l=r.data||[];
      if(!l.length)return void(b.innerHTML='<p class="aide" style="grid-column:1/-1">'
        +'Votre bibliothèque est vide.</p>');
      b.innerHTML=l.map(function(i){
        var u=sb.storage.from('ressources').getPublicUrl(i.chemin).data.publicUrl;
        return '<button data-img="'+esc(u)+'" data-l="'+(i.largeur||0)+'" data-h="'+(i.hauteur||0)
          +'" style="padding:0;overflow:hidden;aspect-ratio:1"><img src="'+esc(u)
          +'" style="width:100%;height:100%;object-fit:cover;display:block" alt=""></button>';
      }).join('');
    });
}
function televerser(files){
  if(!files||!files.length)return;
  /* le logo reste dans le document : il doit suivre la ressource
     partout, y compris dans le PDF, sans dépendre du réseau. */
  if(POUR_COVER){
    POUR_COVER=false;
    var c2=new FileReader();
    c2.onload=function(){
      R.cover=c2.result;R.doc.coverPerso=true;enregistrer(true);etat('Vignette enregistrée');
      if(fenetreExport.redessine)fenetreExport.redessine();
    };
    c2.readAsDataURL(files[0]);
    return;
  }
  if(POUR_LOGO){
    POUR_LOGO=false;
    var l=new FileReader();
    l.onload=function(){
      R.doc.gabarit.nametag=l.result;
      empiler();peindreTout();enregistrer(true);etat('Étiquette enregistrée');
    };
    l.readAsDataURL(files[0]);
    return;
  }
  etat('Envoi des images…',true);
  var faits=0;
  [].slice.call(files).forEach(function(f){
    var nom=Date.now()+'-'+Math.random().toString(36).slice(2,7)+'-'+poigneeDe(f.name)
      +'.'+(f.name.split('.').pop()||'png');
    var img=new Image(), url=URL.createObjectURL(f);
    img.onload=function(){
      sb.storage.from('ressources').upload(nom,f,{upsert:false}).then(function(r){
        if(r.error)throw r.error;
        return sb.from('ressource_images').insert({nom:f.name,chemin:nom,
          largeur:img.naturalWidth,hauteur:img.naturalHeight,auteur:moi});
      }).then(function(){
        faits++;URL.revokeObjectURL(url);
        if(faits===files.length){etat('Images ajoutées');chargerImages();}
      }).catch(function(e){etat('Envoi impossible');console.warn(e);});
    };
    img.src=url;
  });
}

/* ============================================================
   L'EXPORT : les 6 PDF et la vignette
   ------------------------------------------------------------
   On imprime la page telle qu'elle est à l'écran : c'est le même
   HTML, la même CSS, les mêmes polices, en millimètres. Le PDF
   est donc exactement l'aperçu, en texte net et sélectionnable.
   ============================================================ */
function nomFichier(niv,role){
  return (R.poignee||poigneeDe(R.titre))+'-'+(role==='prof'?'prof':'eleve')+'-'+niv;
}

/* Quelles versions existent vraiment dans cette ressource ?
   Au premier passage on devine : un niveau sans contenu n'existe
   pas, et la version Prof n'existe que s'il y a un corrigé.
   Ensuite, c'est Pierre qui décide, et son choix est conservé. */
function versionsPossibles(){
  var l=[];
  ['1','2','3'].forEach(function(n){
    var pg=(R.doc.niveaux[n]||{pages:[]}).pages||[];
    var rempli=pg.some(function(p){return (p.el||[]).length;});
    var corrige=pg.some(function(p){return (p.el||[]).some(function(e){return e.corrige;});});
    l.push({cle:n+'-eleve',niv:n,role:'eleve',libelle:'Niveau '+n+' — Élève',
      devine:rempli,vide:!rempli});
    l.push({cle:n+'-prof',niv:n,role:'prof',libelle:'Niveau '+n+' — Prof',
      devine:rempli&&corrige,vide:!rempli,
      note:rempli&&!corrige?'aucun corrigé posé':''});
  });
  return l;
}
/* par défaut, les six versions existent : on retire ce qu'on ne fait pas */
function actives(){
  R.doc.actives=R.doc.actives||{};
  versionsPossibles().forEach(function(v){
    if(R.doc.actives[v.cle]==null)R.doc.actives[v.cle]=true;});
  return R.doc.actives;
}

/* toutes les pages de tous les niveaux ont-elles le même format ? */
function formatsMelanges(){
  var vus={};
  ['1','2','3'].forEach(function(n){
    ((R.doc.niveaux[n]||{}).pages||[]).forEach(function(p){
      var d=dimDe(p);vus[d[0]+'x'+d[1]]=1;});
  });
  return Object.keys(vus).length>1;
}

function fenetreExport(){
  var a=actives(), vs=versionsPossibles();

  function corps(){
    var choisies=vs.filter(function(v){return a[v.cle];});
    return '<h3>Télécharger et publier</h3>'
      +'<p class="sous">Quatre étapes, dans l’ordre. Vous pouvez vous arrêter après '
      +'n’importe laquelle.</p>'

      +'<h5>1 · Les versions de cette ressource</h5>'
      +'<p class="aide">Toutes les ressources n’ont pas les trois niveaux. '
      +'Cochez ce qui existe vraiment.</p>'
      +'<div class="versions">'+vs.map(function(v){
        return '<button data-v="'+v.cle+'" class="'+(a[v.cle]?'on':'')+'">'
          +'<b>'+v.libelle+'</b>'
          +'<small>'+(v.vide?'niveau vide':(v.note||cheminZip(v.niv,v.role)))+'</small>'
          +'</button>';}).join('')+'</div>'

      +'<h5>2 · La vignette de la boutique</h5>'
      +'<div class="vignette">'
        +(R.cover?'<img src="'+esc(R.cover)+'" alt="">':'<span>aucune</span>')
        +'<div><button class="b sm p" data-cov-auto>Modifier la miniature</button>'
        +'<button class="b sm" data-cov-fichier>Déposer mon image</button>'
        +'<p class="aide" style="margin:6px 0 0">Portrait 2:3 (1200 × 1800), faite à partir '
        +'des pages du niveau 1 élève.</p></div></div>'

      +'<h5>3 · Les PDF</h5>'
      +(choisies.length
        ? '<p class="aide">'+choisies.length+' PDF, fabriqués ici même, sans fenêtre '
          +'d’impression, chaque page à son format. Ils arrivent dans <b>un seul fichier '
          +'.zip</b>, rangés par niveau, avec la vignette.</p>'
          +'<div class="liste-export" id="lx">'+choisies.map(function(v,k){
            return '<div data-i="'+k+'"><span style="flex:1">'+v.libelle+'</span>'
              +'<span class="st">'+esc(cheminZip(v.niv,v.role))+'</span></div>';
          }).join('')+'</div>'
          +'<button class="b p" data-go style="width:100%">⇩ Télécharger les '
          +choisies.length+' PDF</button>'
        : '<p class="aide">Cochez au moins une version.</p>')

      +'<h5>4 · La boutique</h5>'
      +'<p class="aide">Crée (ou met à jour) la fiche produit sur ressourceslae.com, en brouillon : '
      +'titre, description, étiquettes, prix, vignette <b>et les PDF</b>, rangés tout seuls '
      +'dans leurs métachamps. Un seul clic.</p>'
      +(R.shopify_id?'<p class="aide" style="color:var(--green)"><b>Déjà publiée.</b> '
        +'Republier mettra la fiche à jour.</p>':'')
      +'<div class="rang"><button class="b" data-recap>Voir le récapitulatif</button>'
      +'<button class="b p" data-shopify>'
      +(R.shopify_id?'Mettre à jour la fiche':'Publier sur Shopify')+'</button></div>'
      +'<div class="fin"><button class="b" data-x>Fermer</button></div>';
  }

  var v=fenetre(corps());
  function redessine(){v.querySelector('.boite').innerHTML=corps();}

  v.addEventListener('click',function(ev){
    var b=ev.target.closest('[data-v]');
    if(b){a[b.dataset.v]=!a[b.dataset.v];enregistrer();return redessine();}
    if(ev.target.closest('[data-cov-auto]'))return editeurMiniature();
    if(ev.target.closest('[data-cov-fichier]')){POUR_COVER=true;return $('#fichierImg').click();}
    if(ev.target.closest('[data-recap]'))return fenetreRecap();
    if(ev.target.closest('[data-shopify]'))return publierShopify(ev.target);
    if(!ev.target.closest('[data-go]'))return;

    /* les PDF sont dessinés ici (ressources-pdf.js), puis rangés dans un .zip */
    var choisies=vs.filter(function(x){return a[x.cle];});
    var go=ev.target.closest('[data-go]'), txt=go.textContent;
    $$('.boite button',v).forEach(function(x){x.disabled=true;});
    go.textContent='Fabrication des PDF…';
    function fin(){$$('.boite button',v).forEach(function(x){x.disabled=false;});go.textContent=txt;}
    exporterZip(choisies,function(i,st){
      var ligne=$('[data-i="'+i+'"]',v);if(!ligne)return;
      ligne.className=st==='encours'?'encours':'fait';
      $('.st',ligne).textContent=st==='encours'?'en cours…':st==='vide'?'niveau vide':'fait ✓';
    }).then(function(z){
      fin();etat('PDF prêts : '+z.nom);
    }).catch(function(e){
      fin();console.error(e);
      alert('Les PDF n’ont pas pu être fabriqués.\n\n'+(e.message||e));
    });
  });
  fenetreExport.redessine=redessine;
}

/* ============================================================
   PUBLIER SUR LA BOUTIQUE
   Le jeton Shopify vit uniquement dans shopify-lae.php, sur le
   serveur. Le navigateur ne fait que demander ; il ne détient
   rien.
   ============================================================ */
/* Récupérer le jeton de session.
   Safari fait parfois échouer getSession() ; dans ce cas on va
   relire le jeton là où Supabase l'enregistre. */
function jetonRange(){
  try{
    for(var i=0;i<localStorage.length;i++){
      var cle=localStorage.key(i);
      if(cle.indexOf('supabase.auth.token')<0&&!/^sb-.*-auth-token$/.test(cle))continue;
      var v=JSON.parse(localStorage.getItem(cle)||'null');
      var t=v&&(v.access_token||(v.currentSession&&v.currentSession.access_token));
      if(t)return t;
    }
  }catch(e){}
  return null;
}
function jeton(){
  return Promise.resolve().then(function(){return sb.auth.getSession();})
    .then(function(r){
      var j=r&&r.data&&r.data.session&&r.data.session.access_token;
      return j||jetonRange();
    })
    .catch(function(){return jetonRange();})
    .then(function(j){
      if(!j)throw new Error('Connexion introuvable. Rechargez la page et reconnectez-vous '
        +'depuis le Journal.');
      return j;
    });
}

/* Une copie faite avant oct. 2026 a gardé le produit Shopify de son
   original : les deux fiches s'écrasaient l'une l'autre. Si une autre
   ressource, plus ANCIENNE, pointe sur le même produit, celle-ci est la
   copie : on la détache, et elle crée son propre produit. */
function sansJumeau(){
  if(!R.shopify_id)return;
  return sb.from('ressources').select('id,created_at').eq('shopify_id',R.shopify_id)
    .order('created_at',{ascending:true}).then(function(r){
      var l=(r&&r.data)||[];
      if(l.length>1&&String(l[0].id)!==String(R.id)){R.shopify_id=null;enregistrer(true);}
    });
}
function publierShopify(bouton){
  if(!R.titre||R.titre==='Nouvelle ressource')
    return alert('Donnez d’abord un vrai titre à la ressource.');
  var txt=bouton.textContent;
  bouton.textContent='Publication…';bouton.disabled=true;
  /* Promise.resolve().then(...) : même une erreur immédiate tombe
     dans le .catch, le bouton ne peut plus rester bloqué. */
  Promise.resolve().then(sansJumeau).then(jeton).then(function(j){
    return fetch('/shopify-lae.php',{method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({jeton:j,titre:R.titre,description:R.description||'',
        seo_titre:seoDe().titre,seo_description:seoDe().desc,
        tags:etiquettes(),cover:R.cover||'',produit_id:R.shopify_id||null})});
  }).then(function(r){
    return r.text().then(function(t){
      var d;try{d=JSON.parse(t);}catch(e){
        throw new Error('Réponse inattendue du serveur ('+r.status+').');}
      if(!r.ok)throw new Error(d.erreur||('Erreur '+r.status));
      return d;
    });
  }).then(function(d){
    R.shopify_id=d.id;R.etat='en_ligne';enregistrer(true);
    bouton.textContent='Publié ✓';bouton.disabled=false;
    fenetreApresPublication(d);
    return envoyerPdfs(d);
  }).catch(function(e){
    bouton.textContent=txt;bouton.disabled=false;
    alert('Publication impossible.\n\n'+(e.message||e));
  });
}

/* ------------------------------------------------------------
   LES PDF PARTENT TOUT SEULS DANS SHOPIFY
   Chaque PDF est fabriqué ici, puis envoyé à shopify-lae.php qui
   le dépose dans les fichiers de la boutique et le range dans le
   bon métachamp (academie.file_eleve_1, file_prof_1, …).
   ------------------------------------------------------------ */
function cleMetachamp(v){return 'file_'+(v.role==='prof'?'prof':'eleve')+'_'+v.niv;}
function fenetreApresPublication(d){
  var vs=versionsPossibles().filter(function(x){return actives()[x.cle];});
  fenetre('<h3>Publication sur ressourceslae.com</h3>'
    +'<p class="sous">La fiche est en <b>brouillon</b> : rien n’est visible par le public tant '
    +'que vous ne la publiez pas vous-même dans Shopify.</p>'
    +'<div class="liste-export" id="lxShop">'
      +'<div class="fait"><span style="flex:1">Titre, description, étiquettes, prix</span>'
      +'<span class="st">fait ✓</span></div>'
      +'<div class="'+(R.cover?'fait':'')+'"><span style="flex:1">Vignette</span><span class="st">'
      +(R.cover?'fait ✓':'aucune')+'</span></div>'
      +vs.map(function(v){
        return '<div data-mc="'+cleMetachamp(v)+'"><span style="flex:1">'+esc(v.libelle)
          +'</span><span class="st">en attente</span></div>';}).join('')
    +'</div>'
    +'<p class="aide" id="shopMsg">Les PDF sont fabriqués puis envoyés un par un. '
    +'Gardez cette fenêtre ouverte.</p>'
    +'<div class="fin">'
      +(d.admin?'<a class="b p" target="_blank" rel="noopener" href="'+esc(d.admin)
        +'">Ouvrir la fiche dans Shopify</a>':'')
      +'<button class="b" data-x>Fermer</button></div>');
}
function ligneShop(cle,classe,texte){
  var l=$('#lxShop [data-mc="'+cle+'"]');if(!l)return;
  l.className=classe;$('.st',l).textContent=texte;
}
function envoyerPdfs(d){
  var vs=versionsPossibles().filter(function(x){return actives()[x.cle];});
  if(!vs.length||!d.id)return;
  var erreurs=0, j;
  vs.forEach(function(v){ligneShop(cleMetachamp(v),'encours','fabrication…');});
  return jeton().then(function(t){j=t;return fabriquerPdfs(vs);}).then(function(l){
    return l.reduce(function(pr,x){
      var cle=cleMetachamp(x);
      return pr.then(function(){
        if(!x.pdf){ligneShop(cle,'','niveau vide');return;}
        ligneShop(cle,'encours','envoi…');
        return fetch('/shopify-lae.php',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({jeton:j,action:'fichier',produit_id:d.id,cle:cle,
            nom:(R.poignee||poigneeDe(R.titre))+'-'+(x.role==='prof'?'prof':'eleve')+'-'+x.niv+'.pdf',
            pdf:enBase64(x.pdf)})})
        .then(function(r){return r.text().then(function(t){
          var o;try{o=JSON.parse(t);}catch(e){throw new Error('Réponse inattendue ('+r.status+')');}
          if(!r.ok)throw new Error(o.erreur||('Erreur '+r.status));
          ligneShop(cle,'fait','dans '+cle+' ✓');
        });})
        .catch(function(e){erreurs++;ligneShop(cle,'','échec');
          var m=$('#shopMsg');if(m)m.innerHTML='<b style="color:var(--g1)">'+esc(e.message||e)+'</b>';});
      });
    },Promise.resolve());
  }).then(function(){
    var m=$('#shopMsg');
    if(m&&!erreurs)m.innerHTML='<b style="color:var(--green)">Tout est en ligne dans la fiche '
      +'(en brouillon).</b> Il ne reste qu’à la publier dans Shopify quand vous voulez.';
    etat(erreurs?'PDF : '+erreurs+' envoi(s) en échec':'PDF envoyés dans Shopify');
  }).catch(function(e){
    var m=$('#shopMsg');if(m)m.innerHTML='<b style="color:var(--g1)">'+esc(e.message||e)+'</b>';
  });
}

/* Le format du papier doit être annoncé AVANT d'imprimer.
   Safari ne sait pas gérer plusieurs formats dans un même
   document : s'il en trouve un plus large que la feuille, il
   réduit TOUT pour le faire entrer — d'où la page décalée et
   rapetissée. On lui donne donc la taille exacte. */
function fixerPapier(){
  var v=document.getElementById('papier');
  if(!v){v=document.createElement('style');v.id='papier';document.head.appendChild(v);}
  var tailles={};
  pages().forEach(function(p){var d=dimDe(p);tailles[d[0]+'x'+d[1]]=(tailles[d[0]+'x'+d[1]]||0)+1;});
  var cles=Object.keys(tailles);
  /* on prend le format le plus fréquent */
  cles.sort(function(a,b){return tailles[b]-tailles[a];});
  var d=(cles[0]||'210x297').split('x');
  v.textContent='@page{size:'+d[0]+'mm '+d[1]+'mm;margin:0}';
  return cles.length>1;      /* vrai si la version mélange les formats */
}

/* imprime une version précise, avec le bon nom proposé par le navigateur */
function imprimer(niv,role,nomPropose){
  var titreAvant=document.title;
  NIV=niv;ROLE=role;SEL=[];
  peindreTout();
  fixerPapier();
  var s=$('#scene');s.classList.add('apercu');
  var z=ZOOM;$('#pages').style.transform='';
  document.title=nomPropose;
  window.print();
  document.title=titreAvant;
  s.classList.remove('apercu');
  $('#pages').style.transform='scale('+z+')';
}

/* la vignette : dessinée au carré, aux couleurs de la marque */
function faireCover(telecharger){
  var c=document.createElement('canvas');c.width=1200;c.height=1200;
  var x=c.getContext('2d');
  var d=x.createLinearGradient(0,0,1200,1200);
  d.addColorStop(0,'#ff7e01');d.addColorStop(.45,'#fa5a3c');d.addColorStop(1,'#ff4375');
  x.fillStyle=d;x.fillRect(0,0,1200,1200);
  x.fillStyle='#fff8f2';
  arrondiRect(x,80,80,1040,1040,56);x.fill();

  x.textAlign='center';x.fillStyle='#8b8299';
  x.font='600 38px "DM Sans",sans-serif';
  x.fillText(((nomClasses(classesDe(R))||'Académie Laé')+' · '+(R.matiere||'')).toUpperCase().slice(0,40),600,250);

  x.fillStyle='#14142b';
  var mots=(R.titre||'Ressource Laé').split(' '), lignes=[], cur='';
  x.font='400 92px "DM Serif Display",Georgia,serif';
  mots.forEach(function(m){
    var t=cur?cur+' '+m:m;
    if(x.measureText(t).width>880&&cur){lignes.push(cur);cur=m;}else cur=t;
  });
  if(cur)lignes.push(cur);
  lignes=lignes.slice(0,4);
  var y=560-(lignes.length-1)*56;
  lignes.forEach(function(l){x.fillText(l,600,y);y+=112;});

  if(R.sujet){
    x.fillStyle='#8b8299';x.font='400 42px "DM Sans",sans-serif';
    x.fillText(R.sujet.slice(0,46),600,y+30);
  }
  x.fillStyle='#f0265c';x.font='700 34px "DM Sans",sans-serif';
  x.fillText('3 NIVEAUX  ·  ÉLÈVE + PROF',600,1000);
  x.fillStyle='#14142b';x.font='700 40px "DM Sans",sans-serif';
  x.fillText('ressourceslae.com',600,1075);

  R.cover=miniature(c,420);
  enregistrer(true);
  if(telecharger){
    c.toBlob(function(b){
      var a=document.createElement('a');
      a.href=URL.createObjectURL(b);
      a.download=(R.poignee||poigneeDe(R.titre))+'-cover.png';
      a.click();setTimeout(function(){URL.revokeObjectURL(a.href);},2000);
    },'image/png');
  }
}
function arrondiRect(x,a,b,w,h,r){
  x.beginPath();x.moveTo(a+r,b);x.arcTo(a+w,b,a+w,b+h,r);x.arcTo(a+w,b+h,a,b+h,r);
  x.arcTo(a,b+h,a,b,r);x.arcTo(a,b,a+w,b,r);x.closePath();
}
function miniature(c,t){
  var m=document.createElement('canvas');m.width=t;m.height=t;
  m.getContext('2d').drawImage(c,0,0,t,t);
  return m.toDataURL('image/jpeg',.8);
}

function fenetreRecap(){
  var a=actives();
  var t=['TITRE','  '+(R.titre||''),'',
    'DESCRIPTION','  '+(R.description||'(à compléter dans « Classer »)'),'',
    'ÉTIQUETTES (tags Shopify)','  '+etiquettes().join(', '),'',
    'MODÈLE DE PRODUIT','  ressources-template','',
    'PRIX','  0 € — produit non physique','',
    'MÉTACHAMPS (espace « academie »)'].join('\n');
  versionsPossibles().forEach(function(v){
    if(!a[v.cle])return;
    t+='\n  '+(v.role==='prof'?'file_prof_':'file_eleve_')+v.niv
      +'  →  '+cheminZip(v.niv,v.role);
  });
  t+='\n\nIMAGE DU PRODUIT\n  '+(R.doc.coverPerso?'cover.png':'miniature.jpg')+' (dans le .zip)';
  var v=fenetre('<h3>Récapitulatif pour la boutique</h3>'
    +'<p class="sous">À recopier dans Shopify au moment de créer la fiche produit.</p>'
    +'<div class="recap" id="rc">'+esc(t)+'</div>'
    +'<div class="fin"><button class="b" data-x>Fermer</button>'
    +'<button class="b p" data-copier2>Copier</button></div>');
  v.addEventListener('click',function(ev){
    if(!ev.target.hasAttribute('data-copier2'))return;
    navigator.clipboard.writeText(t).then(function(){ev.target.textContent='Copié ✓';});
  });
}

/* ---------- petite fabrique de fenêtres ---------- */
function fenetre(html){
  var v=document.createElement('div');
  v.className='voile';
  v.innerHTML='<div class="boite">'+html+'</div>';
  document.body.appendChild(v);
  v.addEventListener('click',function(e){
    if(e.target===v||e.target.hasAttribute('data-x'))v.remove();
  });
  return v;
}

/* ============================================================
   ALIGNER ET RÉPARTIR
   ============================================================ */
function alignerSel(quoi){
  var els=SEL.map(elementPar).filter(Boolean);if(els.length<2)return;
  var g=Math.min.apply(null,els.map(function(e){return e.x;}));
  var d=Math.max.apply(null,els.map(function(e){return e.x+e.w;}));
  var h=Math.min.apply(null,els.map(function(e){return e.y;}));
  var b=Math.max.apply(null,els.map(function(e){return e.y+e.h;}));
  els.forEach(function(e){
    if(quoi==='g')e.x=g;
    else if(quoi==='d')e.x=d-e.w;
    else if(quoi==='cx')e.x=(g+d)/2-e.w/2;
    else if(quoi==='h')e.y=h;
    else if(quoi==='b')e.y=b-e.h;
    else if(quoi==='cy')e.y=(h+b)/2-e.h/2;
    e.x=arrondi(e.x);e.y=arrondi(e.y);
  });
  empiler();peindreTout();enregistrer();
}
function repartirSel(sens){
  var els=SEL.map(elementPar).filter(Boolean);if(els.length<3)return;
  var cle=sens==='h'?'x':'y', dim=sens==='h'?'w':'h';
  els.sort(function(a,b){return a[cle]-b[cle];});
  var deb=els[0][cle], fin=els[els.length-1][cle]+els[els.length-1][dim];
  var total=els.reduce(function(s,e){return s+e[dim];},0);
  var vide=(fin-deb-total)/(els.length-1), pos=deb;
  els.forEach(function(e){e[cle]=arrondi(pos);pos+=e[dim]+vide;});
  empiler();peindreTout();enregistrer();
}

/* ============================================================
   LE BRANCHEMENT DE TOUS LES BOUTONS
   ============================================================ */
var presse=null;

function brancher(){

  /* ---------- tableau de bord ---------- */
  $('#nav').addEventListener('click',function(e){
    var b=e.target.closest('button');if(!b)return;
    if(b.dataset.f==='tout')FILTRE.cycle=FILTRE.niveau=FILTRE.matiere=null;
    else{
      FILTRE.cycle=b.dataset.cycle||null;
      FILTRE.niveau=b.dataset.niveau||null;
      FILTRE.matiere=b.dataset.matiere||null;
    }
    peindreNav();peindreListe();
  });
  $('#liste').addEventListener('click',function(e){
    var a;
    if((a=e.target.closest('[data-copier]')))return e.stopPropagation(),dupliquer(a.dataset.copier);
    if((a=e.target.closest('[data-suppr]')))return e.stopPropagation(),supprimer(a.dataset.suppr);
    if((a=e.target.closest('[data-neuve]')))return creer();
    if((a=e.target.closest('[data-ouvrir]')))return ouvrir(a.dataset.ouvrir);
  });
  $('#neuve').addEventListener('click',creer);
  $('#cherche').addEventListener('input',function(){FILTRE.texte=this.value;peindreListe();});
  $('#tri').addEventListener('change',function(){FILTRE.tri=this.value;peindreListe();});

  /* ---------- barre du haut de l'atelier ---------- */
  $('#retour').addEventListener('click',fermer);
  $('#nomRes').addEventListener('input',function(){
    R.titre=this.value;
    /* Le nom des fichiers exportés suit le titre, sinon il resterait
       « nouvelle-ressource » pour toujours. On garde le petit suffixe
       d'origine : deux fiches au même titre ne s'écrasent jamais. */
    var bout=(R.poignee||'').split('-').pop();
    if(!/^[a-z0-9]{3,5}$/.test(bout))bout=Date.now().toString(36).slice(-4);
    R.poignee=poigneeDe(R.titre)+'-'+bout;
    enregistrer();peindrePages();
  });
  $('#selVersion').addEventListener('click',function(e){
    var b=e.target.closest('[data-nivmenu]');if(b)ouvrirMenuNiveau(b);
  });
  document.addEventListener('click',function(e){
    var m=$('#menuNiv');if(!m)return;
    var b=e.target.closest('#menuNiv [data-aller]');
    if(b){var x=b.dataset.aller.split('|');m.remove();return allerA(x[0],x[1]);}
    b=e.target.closest('#menuNiv [data-pc]');
    if(b)return actionParcours(b.dataset.pc,b.dataset.n);
    if(!e.target.closest('#menuNiv')&&!e.target.closest('#selVersion'))m.remove();
  });
  $('#btnApercu').addEventListener('click',function(){REEL=!REEL;SEL=[];peindreTout();
    etat(REEL?'Aperçu : exactement comme le PDF':'Édition : ce qui est masqué reste en pâle');});
  $('#btnGrille').addEventListener('click',ouvrirGrille);
  $('#annuler').addEventListener('click',reculer);
  $('#refaire').addEventListener('click',avancer);
  $('#historique').addEventListener('click',fenetreHistorique);
  $('#btnActualiser').addEventListener('click',fenetreActualiser);
  $('#btnDupliquer').addEventListener('click',fenetreDupliquer);
  $('#btnNotes').addEventListener('click',fenetreNotes);
  $('#btnClasser').addEventListener('click',fenetreClasser);
  $('#btnExport').addEventListener('click',fenetreExport);

  /* ---------- la barre d'outils ---------- */
  $('#rail').addEventListener('click',function(e){
    var b=e.target.closest('button');if(!b)return;
    OUTIL=b.dataset.outil;SEL=[];PROPS=false;
    $$('#rail button').forEach(function(x){x.classList.toggle('on',x===b);});
    document.body.classList.remove('sans-panneau');
    peindreTout();
  });

  /* ---------- le panneau : clics ---------- */
  $('#panneau').addEventListener('click',function(e){
    if(e.target.closest('[data-relancer-outil]')){
      modifier(function(x){if(x.type==='dessin'&&x.outil){x.graine=Math.floor(Math.random()*1e9);
        regenerer(x,x.opts||{});}});
      return etat('Nouveau tirage');
    }
    var cb=e.target.closest('[data-cmat],[data-cout],[data-cback],[data-cposer]');
    if(cb){
      if(cb.dataset.cmat){CART.mat=cb.dataset.cmat;CART.outil=null;}
      else if(cb.dataset.cout)CART.outil=cb.dataset.cout;
      else if(cb.dataset.cback==='racine'){CART.mat=null;CART.outil=null;}
      else if(cb.dataset.cback==='mat')CART.outil=null;
      else if(cb.hasAttribute('data-cposer'))return poserOutil(CART.outil,cb.hasAttribute('data-remplir'));
      $('#panneau').scrollTop=0;return peindrePanneau();
    }
    if(e.target.closest('[data-majouter]')){lireMaths();
      return poserMaths(MATHS.type||'colonne',MATHS.n==='page');}
    if(e.target.closest('[data-regen]'))return regenererSel();
    var rop=e.target.closest('[data-rop]');
    if(rop){var gg=clone(genDe(SEL.map(elementPar).filter(Boolean)[0])||{op:'+',a:2,b:2,ret:'mix'});
      gg.op=rop.dataset.rop;return changerCalculs(gg);}
    var mb=e.target.closest('[data-mop],[data-mposer],[data-mrelancer]');
    if(mb){
      lireMaths();
      if(mb.dataset.mop){MATHS.op=mb.dataset.mop;return peindrePanneau();}
      if(mb.hasAttribute('data-mrelancer'))return regenererSel();
      if(mb.dataset.mposer)return poserMaths(mb.dataset.mposer,mb.hasAttribute('data-remplir'));
      if(!SEL.some(function(id){var x=elementPar(id);return x&&x.type==='calcul';}))
        return etat('Sélectionnez d’abord des calculs en colonne');
      return relancerCalculs();
    }
    var b=e.target.closest('button,[data-gab],[data-corrige],[data-eleveseul],[data-tbtete],[data-voirprof]');
    if(!b)return;
    var d=b.dataset;

    if(d.bloc)return poserBloc(d.bloc);
    if(d.forme)return ajouterElement({type:'forme',w:60,h:40,forme:d.forme,
      remplissage:d.forme==='etoile'?'#f5c518':'none',trait:'#14142b',epaisseur:.5});
    if(d.lignage)return ajouterElement(ligneNeuve(d.lignage));
    if(b.hasAttribute('data-tableau'))return ajouterElement({type:'tableau',x:MARGE,w:larg(),h:38,
      cols:+$('#tbC').value||3,rows:+$('#tbR').value||3,fusions:[],
      tete:$('#tbTete').classList.contains('on')});
    if(b.id==='tbTete')return void b.classList.toggle('on');
    if(d.img)return ajouterElement({type:'image',w:60,
      h:Math.round(60*((+d.h||1)/(+d.l||1))*10)/10||45,src:d.img});
    if(b.id==='televerser')return $('#fichierImg').click();
    if(b.id==='gLogo'){POUR_LOGO=true;return $('#fichierImg').click();}
    if(b.hasAttribute('data-glogo-sup')){
      delete R.doc.gabarit.nametag;empiler();peindreTout();enregistrer();return;
    }

    if(b.hasAttribute('data-voirprof')){ROLE=ROLE==='prof'?'eleve':'prof';return peindreTout();}
    if(b.hasAttribute('data-ajouter-reponse')){
      ROLE='prof';
      return ajouterElement({type:'texte',x:MARGE,w:larg(),h:10,texte:'Réponse attendue',
        taille:11,police:'sans',align:'left',couleur:'#f0265c',gras:true,corrige:true});
    }

    if(d.gab){
      var g=R.doc.gabarit;g[d.gab]=g[d.gab]===false;
      empiler();peindreTout();enregistrer();return;
    }
    if(d.gteinte){R.doc.gabarit.teinte=d.gteinte;empiler();peindreTout();enregistrer();return;}
    if(b.hasAttribute('data-pgent')){
      var pc=pageCourante();pc.sansEntete=!pc.sansEntete;
      empiler();peindreTout();enregistrer();return;
    }
    if(b.hasAttribute('data-pgpied')){
      var pc2=pageCourante();pc2.sansPied=!pc2.sansPied;
      empiler();peindreTout();enregistrer();return;
    }
    if(d.pgfmt){
      if(fmtDe(pageCourante()).t!==d.pgfmt)changerFormat(PAGE,'t');
      return;
    }

    if(d.aligner)return alignerSel(d.aligner);
    if(d.repartir)return repartirSel(d.repartir);

    /* les réglages de l'élément sélectionné */
    if(d.style)return modifier(function(x){x[d.style]=!x[d.style];});
    if(d.align)return modifier(function(x){x.align=d.align;});
    if(d.couleur!=null&&b.hasAttribute('data-couleur'))return modifier(function(x){x.couleur=d.couleur;});
    if(b.hasAttribute('data-fond'))return modifier(function(x){x.fond=d.fond||null;});
    if(d.teinte)return modifier(function(x){x.teinte=d.teinte;});
    if(b.hasAttribute('data-remplissage'))return modifier(function(x){x.remplissage=d.remplissage||'none';});
    if(d.trait)return modifier(function(x){x.trait=d.trait;});
    if(d.pointille!=null&&b.hasAttribute('data-pointille'))
      return modifier(function(x){x.pointille=d.pointille==='1';});
    if(d.puce!=null&&b.hasAttribute('data-puce'))return modifier(function(x){x.puce=d.puce==='1';});
    if(d.ajuste)return modifier(function(x){x.ajuste=d.ajuste;});
    if(b.hasAttribute('data-pleine'))return modifier(function(x){x.x=MARGE;x.w=larg();});
    if(b.hasAttribute('data-corrige'))return reserver('prof','bascule');
    if(b.hasAttribute('data-eleveseul'))return reserver('eleve','bascule');
    if(b.hasAttribute('data-tbtete'))return modifier(function(x){x.tete=!x.tete;});
    if(d.tb){
      var e2=elementPar(SEL[0]);if(!e2)return;
      if(d.tb==='fusion')fusionner(e2);
      else if(d.tb==='defusion')defusionner(e2);
      else tableauOp(e2,d.tb);
      empiler();peindreTout();marquerCases();enregistrer();return;
    }
    if(d.tbfond)return modifier(function(x){x.fond=d.tbfond;});
    if(d.tbtrait)return modifier(function(x){x.trait=d.tbtrait;});
    if(d.plan)return modifier(function(x){
      x.z=d.plan==='avant'?zMax()+1:Math.max(0,(x.z||1)-2);});
    if(b.hasAttribute('data-copier-el'))return copierColler();
    if(b.hasAttribute('data-suppr-el'))return effacerSel();
    if(b.hasAttribute('data-note')){
      var t=$('#pNote').value.trim();if(!t)return;
      sb.from('ressource_notes').insert({ressource_id:R.id,texte:t,element_id:SEL[0]||null,
        version:'Niveau '+NIV+' · '+(ROLE==='prof'?'Prof':'Élève'),auteur:moi})
        .then(function(){$('#pNote').value='';etat('Commentaire ajouté');});
      return;
    }
  });

  /* ---------- le panneau : champs ---------- */
  $('#panneau').addEventListener('input',function(e){
    var id=e.target.id, v=e.target.value;
    if(id==='gTitre'||id==='gNtW'){
      var g=R.doc.gabarit;
      if(id==='gTitre')g.titre=v;
      if(id==='gNtW'){var w=parseFloat(v);if(!isNaN(w))g.ntW=borne(w,40,200);}
      return void(peindrePages(),enregistrer());
    }
    if(!SEL.length)return;
    var n=parseFloat(v);
    var carte={pTaille:'taille',pInter:'interligne',pNb:'nb',pCols:'cols',pRows:'rows',
      pTotal:'total',pEp:'epaisseur',pRayon:'rayon',pX:'x',pY:'y',pW:'w',pH:'h',pRot:'rot',
      pEcart:'ecart'};
    if((id==='pNb'||id==='pHl'||id==='pEcart')&&!isNaN(n))
      return modifierSansRedessiner(function(x){
        x[{pNb:'nb',pHl:'hl',pEcart:'ecart'}[id]]=n;
        if(x.type==='lignes')x.h=hauteurBloc(x);
      });
    if(carte[id]&&!isNaN(n))return modifierSansRedessiner(function(x){x[carte[id]]=n;});
    if(id==='pLabel')return modifierSansRedessiner(function(x){x.label=v;});
    if(id==='pLettre')return modifierSansRedessiner(function(x){x.lettre=v.slice(0,2);});
    if(id==='pTexte')return modifierSansRedessiner(function(x){
      if(x.type==='cases')x.lignes=v.split('\n').filter(function(l){return l.trim();});
      else x.texte=v;
      delete x.riche;});
    if(id==='pEtiquette')return modifierSansRedessiner(function(x){x.etiquette=v;});
    if(id==='pLegende')return modifierSansRedessiner(function(x){x.legende=v;});
    if(id==='pNumero'&&!isNaN(n))return modifierSansRedessiner(function(x){x.numero=n;x.numeroManuel=true;});
  });
  $('#panneau').addEventListener('change',function(e){
    var rid=e.target.id||'';
    if(/^(rQ|rC|rCo|rNum|rLg|rA|rB|rR)$/.test(rid)||rid.indexOf('eo_')===0)return appliquerReglage(rid,e.target);
    /* les options de l'outil Maths s'appliquent aussi aux calculs sélectionnés */
    var mo={mQ:'quad',mC:'cases',mCoul:'couleurs',mNum:'num'}[e.target.id];
    if(mo){
      lireMaths();
      var calc=SEL.map(elementPar).filter(function(x){return x&&x.type==='calcul';});
      if(!calc.length)return;
      var ordre=calc.slice().sort(function(a,b){return (a.y-b.y)||(a.x-b.x);});
      modifier(function(x){
        if(x.type!=='calcul')return;
        var L0=layoutCalcul(x), c=x.w/L0.cols;
        if(mo==='num')x.num=e.target.checked&&calc.length>1?ordre.indexOf(x)+1:null;
        else x[mo]=e.target.checked&&!(x.op===':'&&mo!=='quad');
        var L1=layoutCalcul(x);x.w=arrondi(L1.cols*c);x.h=arrondi(L1.rows*c);
      });
      return;
    }
    if(!SEL.length)return;
    if(e.target.id==='pPolice')return modifier(function(x){x.police=e.target.value;});
    if(e.target.id==='pLignage')return modifier(function(x){
      x.lignage=e.target.value;x.hl=HL[x.lignage]||10;x.h=hauteurBloc(x);});
  });
  $('#panneau').addEventListener('blur',function(){if(SEL.length)empiler();},true);

  /* ---------- la scène ---------- */
  var sc=$('#scene');
  sc.addEventListener('pointerdown',function(e){
    var pn=e.target.closest('.pn');
    if(pn){
      e.preventDefault();
      if(pn.dataset.pn==='deplace')return demarrerGeste(e,'bouge');
      return demarrerGeste(e,pn.dataset.pn==='rot'?'tourne':'taille',pn.dataset.pn);
    }
    if(e.target.closest('.pg-outils')||e.target.closest('#grille'))return;
    var tp=e.target.closest('[data-tbplus]');
    if(tp){
      e.preventDefault();
      var et=elementPar(SEL[0]);if(!et||bloque(et,true))return;
      tableauOp(et,tp.dataset.tbplus);
      empiler();peindreTout();marquerCases();enregistrer();
      return etat(tp.dataset.tbplus==='col+'?'Colonne ajoutée':'Ligne ajoutée');
    }
    /* la barre flottante : on garde l'élément sélectionné et, si l'on
       écrit, le passage sélectionné (pas de perte du focus) */
    if(e.target.closest('.volante')){
      if(!e.target.closest('select'))e.preventDefault();
      else if(EDIT)EDIT.fini();
      return;
    }
    var el=e.target.closest('.el');
    var pg=e.target.closest('.pg');
    if(pg)PAGE=+pg.dataset.page;
    if(!el){
      if(SEL.length&&!e.shiftKey){SEL=[];peindreTout();}
      else peindreMinis();
      /* on glisse dans le vide : un rectangle sélectionne tout ce qu'il touche */
      if(e.button===0||e.pointerType!=='mouse')demarrerLasso(e);
      return;
    }
    if(e.target.closest('[contenteditable="true"]'))return;
    var id=el.dataset.id;
    /* le double-clic est repéré ici : le premier clic redessine la page,
       et Safari n'envoie alors plus de « dblclick » */
    var now=Date.now(), dc=brancher.dc;
    brancher.dc={id:id,t:now,x:e.clientX,y:e.clientY};
    if(dc&&dc.id===id&&now-dc.t<450&&Math.abs(e.clientX-dc.x)<8&&Math.abs(e.clientY-dc.y)<8){
      brancher.dc=null;e.preventDefault();
      if(SEL.indexOf(id)<0){SEL=[id];peindreTout();}
      return ouvrirEcriture(id,e.clientX,e.clientY);
    }
    /* choisir des cases dans un tableau déjà sélectionné */
    var td=e.target.closest('td');
    if(td&&el.dataset.t==='tableau'&&SEL.indexOf(id)>=0){
      var y=+td.dataset.y,x=+td.dataset.x;
      if(e.shiftKey&&CEL&&CEL.id===id){
        CEL={id:id,y1:Math.min(CEL.a,y),y2:Math.max(CEL.a,y),
             x1:Math.min(CEL.b,x),x2:Math.max(CEL.b,x),a:CEL.a,b:CEL.b};
      }else CEL={id:id,y1:y,y2:y,x1:x,x2:x,a:y,b:x};
      marquerCases();peindrePanneau();barreVolante();
      /* glisser d'une case à l'autre choisit un bloc de cases (comme dans
         un tableur) ; le tableau se déplace par sa poignée ✥ */
      e.preventDefault();
      var tableau=el;
      var suivre=function(m){
        var t=document.elementFromPoint(m.clientX,m.clientY), c=t&&t.closest&&t.closest('td');
        if(!c||!tableau.contains(c))return;
        var cy=+c.dataset.y, cx=+c.dataset.x;
        CEL={id:id,y1:Math.min(CEL.a,cy),y2:Math.max(CEL.a,cy),x1:Math.min(CEL.b,cx),x2:Math.max(CEL.b,cx),
          a:CEL.a,b:CEL.b};
        marquerCases();
      };
      var lacher=function(){document.removeEventListener('pointermove',suivre);
        document.removeEventListener('pointerup',lacher);peindrePanneau();barreVolante();};
      document.addEventListener('pointermove',suivre);document.addEventListener('pointerup',lacher);
      return;
    }
    if(CEL&&CEL.id!==id)CEL=null;
    var mb=e.altKey?[id]:membres(id);   /* ⌥ + clic : un seul élément du groupe */
    if(e.shiftKey||e.metaKey||e.ctrlKey){
      if(SEL.indexOf(id)>=0)SEL=SEL.filter(function(x){return mb.indexOf(x)<0;});
      else SEL=SEL.concat(mb.filter(function(x){return SEL.indexOf(x)<0;}));
    }else if(SEL.indexOf(id)<0)SEL=mb;
    PROPS=true;
    peindreTout();
    e.preventDefault();
    demarrerGeste(e,'bouge');
  });
  document.addEventListener('selectionchange',function(){if(EDIT)majVisible();});
  document.addEventListener('paste',function(ev){
    if(!EDIT||!selectionEcrite())return;
    var t=((ev.clipboardData||window.clipboardData).getData('text/plain')||'').trim();
    if(!/^(https?:\/\/|www\.|mailto:)\S+$/i.test(t))return;
    ev.preventDefault();lierSelection(t);
  });
  sc.addEventListener('click',function(ev){
    var ln=ev.target.closest('.lien');
    if(ln&&(ev.metaKey||ev.ctrlKey)&&!EDIT)(/^(https?:\/\/|mailto:|\/(?!\/))/i.test(String(ln.dataset.href||'').trim())&&window.open(ln.dataset.href,'_blank','noopener'));
  });
  sc.addEventListener('mousedown',function(e){
    if(e.target.closest('.volante')&&!e.target.closest('select'))e.preventDefault();
  });
  sc.addEventListener('click',function(e){
    var a;
    if((a=e.target.closest('[data-pg-ajouter]')))return pageAjouter(+a.dataset.pgAjouter,false);
    if((a=e.target.closest('[data-pg-copier]')))return pageAjouter(+a.dataset.pgCopier,true);
    if((a=e.target.closest('[data-pg-niveau]')))return fenetreCopierPage(+a.dataset.pgNiveau);
    if((a=e.target.closest('[data-reparer]'))){var nf=remettreEnPlace(+a.dataset.reparer);
      empiler();peindreTout();enregistrer();return etat(nf+' élément'+(nf>1?'s':'')+' remis en place');}
    if((a=e.target.closest('[data-pg-suppr]')))return pageSupprimer(+a.dataset.pgSuppr);
    if((a=e.target.closest('[data-pg-format]')))
      return changerFormat(+a.dataset.pgFormat,'t');
    if((a=e.target.closest('[data-pg-sens]')))
      return changerFormat(+a.dataset.pgSens,'o');
    /* la barre flottante */
    var b=e.target.closest('.volante button');if(!b)return;
    var d=b.dataset;
    if(b.hasAttribute('data-vismenu'))return b.parentNode.classList.toggle('open');
    if(d.vver!=null){if(EDIT)EDIT.fini();return verrouiller(d.vver);}
    if(d.vgrp){if(EDIT)EDIT.fini();return grouper(d.vgrp==='oui');}
    if(b.hasAttribute('data-vregen')){if(EDIT)EDIT.fini();return regenererSel();}
    if(d.vtotal){if(EDIT)EDIT.fini();return modifier(function(x){if(x.type==='bareme')x.total=+d.vtotal;});}
    if(d.vtb){
      if(EDIT)EDIT.fini();
      var et=elementPar(SEL[0]);if(!et||bloque(et,true))return;
      var choix=CEL&&CEL.id===et.id;
      if(d.vtb==='fusion')fusionner(et);
      else if(d.vtb==='defusion')defusionner(et);
      else{
        var k=null;
        if(choix)k=d.vtb==='col+'?CEL.x2+1:d.vtb==='col-'?CEL.x1:d.vtb==='row+'?CEL.y2+1:CEL.y1;
        tableauOp(et,d.vtb,k);
        if(choix&&/-$/.test(d.vtb))CEL=null;
      }
      empiler();peindreTout();marquerCases();enregistrer();return;
    }
    if(d.vlien!=null){
      if(!EDIT||!selectionEcrite())
        return etat('Double-cliquez dans le texte, sélectionnez les mots, puis (ou collez le lien)');
      if(d.vlien==='1'){
        /* la petite fenêtre ne doit pas faire perdre la sélection */
        var rg=selectionEcrite().cloneRange();EDIT.pause=true;
        var u=prompt('Adresse du lien (https://…)');
        EDIT.pause=false;EDIT.cible.focus();
        var sl=window.getSelection();sl.removeAllRanges();sl.addRange(rg);
        if(u)lierSelection(u);
      }
      return;
    }
    if(d.vvue){var m=b.closest('.vis-m');if(m)m.classList.remove('open');}
    if(EDIT){
      /* un passage est sélectionné : on ne change que lui */
      if((d.vstyle||d.vtaille||d.vcouleur||d.vvue)&&selectionEcrite()){
        if(d.vvue)vueSelection(d.vvue==='tous'?'':d.vvue);
        else if(d.vstyle)cmd({gras:'bold',italique:'italic',souligne:'underline'}[d.vstyle]);
        else if(d.vcouleur)cmd('foreColor',d.vcouleur);
        else tailleSelection(+d.vtaille);
        return;
      }
      EDIT.fini();
    }
    if(d.vcouleur)return modifier(function(x){x.couleur=d.vcouleur;});
    if(d.vtaille)return modifier(function(x){
      x.taille=Math.max(5,Math.round(((x.taille||11)+(+d.vtaille))*2)/2);});
    if(d.vstyle)return modifier(function(x){x[d.vstyle]=!x[d.vstyle];});
    if(d.valign)return modifier(function(x){x.align=d.valign;});
    if(d.vplan)return modifier(function(x){
      x.z=d.vplan==='avant'?zMax()+1:Math.max(0,(x.z||1)-2);});
    if(b.hasAttribute('data-vcopie'))return copierColler();
    if(d.vvue)return reserver(d.vvue);
    if(b.hasAttribute('data-vsuppr'))return effacerSel();
  });
  sc.addEventListener('change',function(e){
    if(e.target.hasAttribute('data-vpolice'))
      modifier(function(x){x.police=e.target.value;});
  });
  sc.addEventListener('scroll',function(){
    clearTimeout(brancher.ts);brancher.ts=setTimeout(barreVolante,60);
  });

  /* ---------- barre du bas ---------- */
  $('#zMoins').addEventListener('click',function(){appliquerZoom(borne(ZOOM-.1,.2,3));});
  $('#zPlus').addEventListener('click',function(){appliquerZoom(borne(ZOOM+.1,.2,3));});
  $('#zAjust').addEventListener('click',ajusterZoom);

  /* Le zoom au pincement.
     Sur un trackpad, le pincement arrive comme une molette avec Ctrl ;
     Safari envoie en plus ses propres événements de geste ; sur écran
     tactile, ce sont deux doigts. Les trois sont pris en charge. */
  sc.addEventListener('wheel',function(e){
    if(!e.ctrlKey&&!e.metaKey)return;
    e.preventDefault();
    appliquerZoom(borne(ZOOM*(1-e.deltaY*0.01),.2,3));
  },{passive:false});

  var zDepart=1;
  sc.addEventListener('gesturestart',function(e){e.preventDefault();zDepart=ZOOM;});
  sc.addEventListener('gesturechange',function(e){
    e.preventDefault();appliquerZoom(borne(zDepart*e.scale,.2,3));
  });
  sc.addEventListener('gestureend',function(e){e.preventDefault();});

  var ecart0=0;
  function ecart(t){
    var dx=t[0].clientX-t[1].clientX, dy=t[0].clientY-t[1].clientY;
    return Math.sqrt(dx*dx+dy*dy);
  }
  sc.addEventListener('touchstart',function(e){
    if(e.touches.length!==2)return;
    ecart0=ecart(e.touches);zDepart=ZOOM;
  },{passive:true});
  sc.addEventListener('touchmove',function(e){
    if(e.touches.length!==2||!ecart0)return;
    e.preventDefault();
    appliquerZoom(borne(zDepart*ecart(e.touches)/ecart0,.2,3));
  },{passive:false});
  sc.addEventListener('touchend',function(){ecart0=0;});
  $('#minis').addEventListener('click',function(e){
    var b=e.target.closest('[data-page]');if(!b)return;
    PAGE=+b.dataset.page;SEL=[];peindreTout();
    var p=$('.pg[data-page="'+PAGE+'"]');
    if(p)p.scrollIntoView({behavior:'smooth',block:'center'});
  });
  $('#pageNeuve').addEventListener('click',function(){pageAjouter(pages().length-1,false);});
  $('#fichierImg').addEventListener('change',function(){televerser(this.files);this.value='';});

  /* ---------- le clavier ---------- */
  document.addEventListener('keydown',function(e){
    if($('#atelier').hidden)return;
    /* la cible peut être le document lui-même quand rien n'a le focus :
       on ne suppose donc pas qu'elle a getAttribute. */
    var t=e.target||{};
    var dans=/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName||'')
      || (t.getAttribute&&t.getAttribute('contenteditable')==='true');
    var cmd=e.metaKey||e.ctrlKey;

    if(EDIT&&e.key==='Escape'){e.preventDefault();return EDIT.fini();}
    if($('#grille')&&e.key==='Escape'){e.preventDefault();return fermerGrille();}
    if($('#menuNiv')&&e.key==='Escape'){$('#menuNiv').remove();return;}
    if(EDIT&&e.key==='Enter'&&EDIT.cible.contains(t)){
      e.preventDefault();document.execCommand('insertLineBreak');return;
    }
    if(e.key==='Escape'){
      var v=$('.voile');if(v)return v.remove();
      if(SEL.length){SEL=[];peindreTout();}
      return;
    }
    /* une fenêtre est ouverte (miniature, export…) : les raccourcis de
       l'atelier dorment. Sinon un ⌘Z tapé dans la fenêtre annulait, en
       dessous, les modifications de la fiche elle-même. */
    if($('.voile'))return;
    if(cmd&&e.key.toLowerCase()==='z'){
      if(dans)return;
      e.preventDefault();return e.shiftKey?avancer():reculer();
    }
    if(cmd&&e.key.toLowerCase()==='s'){e.preventDefault();return enregistrer(true);}
    if(dans)return;

    if(cmd&&e.key.toLowerCase()==='d'){e.preventDefault();return copierColler();}
    if(cmd&&e.key.toLowerCase()==='g'){e.preventDefault();return grouper(!e.shiftKey);}
    if(cmd&&e.key.toLowerCase()==='c'){
      presse=SEL.map(function(id){return clone(elementPar(id));}).filter(Boolean);
      presse.src=NIV+'|'+PAGE;
      return etat(presse.length+' copié'+(presse.length>1?'s':''));
    }
    if(cmd&&e.key.toLowerCase()==='v'){
      if(!presse||!presse.length)return;
      e.preventDefault();
      var neufs=[], ng=nouveauxGroupes();
      presse.forEach(function(c){
        var n=clone(c);n.id=uid();n.z=zMax()+1;ng(n);
        if(presse.src===NIV+'|'+PAGE){n.x+=4;n.y+=4;}
        elements().push(n);neufs.push(n.id);
      });
      SEL=neufs;empiler();peindreTout();enregistrer();return;
    }
    if(cmd&&e.key.toLowerCase()==='a'){
      e.preventDefault();SEL=elements().map(function(x){return x.id;});return peindreTout();
    }
    if(e.key==='Delete'||e.key==='Backspace'){e.preventDefault();return effacerSel();}

    var pas=e.shiftKey?5:(e.altKey?0.2:1);
    var dx=0,dy=0;
    if(e.key==='ArrowLeft')dx=-pas; else if(e.key==='ArrowRight')dx=pas;
    else if(e.key==='ArrowUp')dy=-pas; else if(e.key==='ArrowDown')dy=pas;
    if(dx||dy){
      if(!SEL.length)return;
      e.preventDefault();
      SEL.forEach(function(id){var x=elementPar(id);
        if(x&&!bloque(x)){x.x=arrondi(x.x+dx);x.y=arrondi(x.y+dy);}});
      peindrePagesLeger();majInfo();
      clearTimeout(brancher.tc);
      brancher.tc=setTimeout(function(){empiler();enregistrer();},600);
    }
  });

  window.addEventListener('beforeunload',function(e){
    if(R&&minuteur){enregistrer(true);e.preventDefault();e.returnValue='';}
  });
  window.addEventListener('resize',function(){
    clearTimeout(brancher.tr);
    brancher.tr=setTimeout(function(){if(R&&!$('#atelier').hidden)appliquerZoom(ZOOM);},200);
  });
}

/* une copie de groupe forme un nouveau groupe */
function nouveauxGroupes(){var m={};return function(c){if(c.grp)c.grp=m[c.grp]||(m[c.grp]='g'+uid());};}
function copierColler(){
  var neufs=[], ng=nouveauxGroupes();
  SEL.forEach(function(id){
    var c=clone(elementPar(id));if(!c)return;
    c.id=uid();c.x+=4;c.y+=4;c.z=zMax()+1;ng(c);
    elements().push(c);neufs.push(c.id);
  });
  if(!neufs.length)return;
  SEL=neufs;empiler();peindreTout();enregistrer();
}
function effacerSel(){
  if(!SEL.length)return;
  var gardes=0;
  pages().forEach(function(p){p.el=p.el.filter(function(e){
    if(SEL.indexOf(e.id)<0)return true;
    if(bloque(e,true)){gardes++;return true;}
    return false;});});
  if(gardes)etat(gardes+' élément(s) verrouillé(s) gardé(s)');
  SEL=[];empiler();peindreTout();enregistrer();
}

/* ============================================================
   LES PDF, FABRIQUÉS DANS LA PAGE
   ------------------------------------------------------------
   Plus de fenêtre d'impression : chaque PDF est dessiné ici, en
   JavaScript, avec jsPDF. Le modèle de la ressource est déjà en
   millimètres et en points, exactement les unités du papier :
   on recopie donc l'aperçu tel quel, sans aucune conversion.

   • chaque page porte SA taille (A4, A3, portrait, paysage) :
     plus jamais de feuille rapetissée ;
   • le texte reste du vrai texte, dans les vraies polices du site
     (Baloo 2, Nunito, Caveat, Andika), embarquées dans le PDF ;
   • tout part dans UN seul .zip, rangé par niveau.

   Les polices sont dans /polices (allégées : alphabet latin seul).
   jsPDF et fflate (le .zip) ne sont chargés qu'au premier export :
   l'outil reste léger le reste du temps. Tout est gratuit et
   tourne dans le navigateur, sans serveur.

   ============================================================ */

var PDF_LIBS=[
  'https://cdn.jsdelivr.net/npm/jspdf@2.5.2/dist/jspdf.umd.min.js',
  'https://cdn.jsdelivr.net/npm/fflate@0.8.2/umd/index.js'
];
var PT=25.4/72;                  /* 1 point = 0,3528 mm */
var PX=25.4/96;                  /* 1 pixel CSS = 0,2646 mm (traits des formes) */
var V_POLICES='1';               /* à incrémenter si un fichier de /polices change */

/* ---------- charger jsPDF et fflate, une seule fois ---------- */
var _outils=null;
function pdfOutils(){
  if(_outils)return _outils;
  _outils=PDF_LIBS.reduce(function(p,src){
    return p.then(function(){return new Promise(function(ok,ko){
      var s=document.createElement('script');s.src=src;s.onload=ok;
      s.onerror=function(){ko(new Error('Impossible de charger '+src.split('/').pop()
        +'. Vérifiez la connexion internet.'));};
      document.head.appendChild(s);
    });});
  },Promise.resolve()).catch(function(e){_outils=null;throw e;});
  return _outils;
}

/* ============================================================
   LES POLICES
   ============================================================ */
/* Pour chaque police : les graisses disponibles, droites et italiques.
   Baloo 2 et Caveat n'ont pas d'italique : on garde la version droite,
   comme le fait le navigateur quand il n'en trouve pas. */
var FAMILLES={
  titre:{f:'baloo2',poids:[500,600,700,800],ital:[]},
  texte:{f:'nunito',poids:[500,600,700,800],ital:[500,700]},
  main: {f:'caveat',poids:[500,700],ital:[]},
  ecole:{f:'andika',poids:[400,700],ital:[400,700]}
};
/* hauteur au-dessus et en dessous de la ligne de base, en fraction de
   la taille (lu dans les fichiers) : sert à placer le texte au même
   endroit que le navigateur dans sa ligne. normal = interligne
   « normal » du navigateur. */
var METRIQUES={titre:[1.078,.524],texte:[1.011,.353],main:[.96,.3],ecole:[1.2207,.3906],
               mono:[.928,.236]};
var B64={};                      /* fichier → contenu en base64, gardé en mémoire */

function plusProche(liste,p){
  var m=liste[0];
  liste.forEach(function(w){
    var d=Math.abs(w-p), dm=Math.abs(m-p);
    if(d<dm||(d===dm&&w>m&&p>=500))m=w;
  });
  return m;
}
/* police + graisse + italique  →  la police jsPDF à utiliser */
function fonte(police,poids,ital){
  if(police==='mono')
    return {fam:'courier',style:poids>=600?(ital?'bolditalic':'bold'):(ital?'italic':'normal'),
      met:'mono'};
  var F=FAMILLES[police]||FAMILLES.texte, k=FAMILLES[police]?police:'texte';
  if(ital&&F.ital.length)return {fam:F.f+'-'+plusProche(F.ital,poids)+'i',style:'normal',met:k};
  return {fam:F.f+'-'+plusProche(F.poids,poids),style:'normal',met:k};
}
function fichiersDe(cle,ital){
  var F=FAMILLES[cle], l=F.poids.map(function(w){return F.f+'-'+w;});
  if(ital)l=l.concat(F.ital.map(function(w){return F.f+'-'+w+'i';}));
  return l;
}
function enBase64(buf){
  var u=new Uint8Array(buf), s='', pas=0x8000;
  for(var i=0;i<u.length;i+=pas)s+=String.fromCharCode.apply(null,u.subarray(i,i+pas));
  return btoa(s);
}
/* ne télécharge que les polices dont la ressource se sert */
function preparerPolices(versions){
  var ital=false, besoin={titre:1,texte:1};
  versions.forEach(function(v){
    (R.doc.niveaux[v.niv].pages||[]).forEach(function(p){
      (p.el||[]).forEach(function(e){
        if(FAMILLES[e.police])besoin[e.police]=1;
        if(e.italique||passagesDe(e).some(function(r){return r.i;}))ital=true;
      });
    });
  });
  var l=[];
  Object.keys(besoin).forEach(function(k){l=l.concat(fichiersDe(k,ital));});
  return Promise.all(l.map(function(f){
    if(B64[f])return null;
    if(window.DOCS&&DOCS.b64Police)return DOCS.b64Police(f).then(function(s){B64[f]=s;});
    return fetch('/polices/'+f+'.ttf?v='+V_POLICES).then(function(r){
      if(!r.ok)throw new Error('Police introuvable : /polices/'+f+'.ttf');
      return r.arrayBuffer();
    }).then(function(b){B64[f]=enBase64(b);});
  })).then(function(){return l;});
}
/* une police n'entre dans le PDF que s'il s'en sert vraiment :
   chaque police embarquée pèse 40 à 120 Ko */
function utiliser(doc,f){
  var l=doc.__lae||(doc.__lae={});
  if(f.fam!=='courier'&&!l[f.fam]){
    if(!B64[f.fam])f={fam:'helvetica',style:'normal'};
    else{doc.addFileToVFS(f.fam+'.ttf',B64[f.fam]);doc.addFont(f.fam+'.ttf',f.fam,'normal');l[f.fam]=1;}
  }
  doc.setFont(f.fam,f.style);
}

/* ============================================================
   LES IMAGES (ciel, étiquette, images déposées)
   Chargées une seule fois pour les six PDF.
   ============================================================ */
var IMGS={};
function lireBlob(b){
  return new Promise(function(ok,ko){
    var f=new FileReader();f.onload=function(){ok(f.result);};f.onerror=ko;f.readAsDataURL(b);
  });
}
function tailleImage(url){
  return new Promise(function(ok,ko){
    var i=new Image();i.onload=function(){ok(i);};i.onerror=function(){ko(new Error('image illisible'));};
    i.src=url;
  });
}
function chargerImagePdf(src){
  if(IMGS[src])return IMGS[src];
  IMGS[src]=fetch(src).then(function(r){
    if(!r.ok)throw new Error('HTTP '+r.status);return r.blob();
  }).then(function(b){
    return lireBlob(b).then(function(url){
      return tailleImage(url).then(function(im){
        var fmt=/png/.test(b.type)?'PNG':/jpe?g/.test(b.type)?'JPEG':null, data=url;
        if(!fmt){   /* webp, gif, svg… : on repasse par un canevas en PNG */
          var c=document.createElement('canvas');
          var k=im.naturalWidth?1:1;
          c.width=im.naturalWidth||1200;c.height=im.naturalHeight||1200;
          c.getContext('2d').drawImage(im,0,0,c.width,c.height);
          data=c.toDataURL('image/png');fmt='PNG';
        }
        return {data:data,fmt:fmt,w:im.naturalWidth||1,h:im.naturalHeight||1,el:im,
          cle:'im'+Object.keys(IMGS).indexOf(src)};
      });
    });
  }).catch(function(e){
    console.warn('Image ignorée dans le PDF :',src.slice(0,80),e);
    delete IMGS[src];
    return null;
  });
  return IMGS[src];
}
/* toutes les images des versions choisies, en parallèle */
function preparerImages(versions){
  var g=R.doc.gabarit||{}, srcs={};
  versions.forEach(function(v){
    (R.doc.niveaux[v.niv].pages||[]).forEach(function(p){
      if(aEntete(p)){srcs[cielSrc(g)]=1;srcs[nametagSrc(g)]=1;}
      (p.el||[]).forEach(function(e){if(e.type==='image'&&e.src)srcs[e.src]=1;});
    });
  });
  var l=Object.keys(srcs), res={};
  return Promise.all(l.map(function(s){
    return chargerImagePdf(s).then(function(d){res[s]=d;});
  })).then(function(){return res;});
}

/* le dégradé du pied : peint une fois dans un canevas, posé en image
   à l'intérieur de la courbe (qui, elle, reste vectorielle et nette) */
var DEGRADES={};
function degradePied(L){
  if(DEGRADES[L])return DEGRADES[L];
  var c=document.createElement('canvas');c.width=Math.round(L*6);c.height=Math.round(BAS*6);
  var x=c.getContext('2d');
  /* même repère que le SVG de l'écran : le dégradé va de (0,0) à
     (0,82 ; 1) de la boîte, puis la boîte est étirée */
  x.setTransform(c.width,0,0,c.height,0,0);
  var d=x.createLinearGradient(0,0,.82,1);
  d.addColorStop(0,'#f0265c');d.addColorStop(.48,'#fa5a3c');d.addColorStop(1,'#ff8a3d');
  x.fillStyle=d;x.fillRect(0,0,1,1);
  DEGRADES[L]={data:c.toDataURL('image/jpeg',.95),fmt:'JPEG',w:c.width,h:c.height,cle:'pied'+L};
  return DEGRADES[L];
}

/* ============================================================
   LE CRAYON : quelques primitives écrites directement en PDF
   ------------------------------------------------------------
   jsPDF compte en mm depuis le haut ; le PDF compte en points
   depuis le bas. X() et Y() font la traduction.
   ============================================================ */
function Crayon(doc,H){
  this.doc=doc;this.K=doc.internal.scaleFactor;this.H=H;this.s=[];
}
Crayon.prototype={
  n:function(v){return (Math.round(v*1000)/1000).toString();},
  X:function(x){return this.n(x*this.K);},
  Y:function(y){return this.n((this.H-y)*this.K);},
  m:function(x,y){this.s.push(this.X(x)+' '+this.Y(y)+' m');this.cx=x;this.cy=y;return this;},
  l:function(x,y){this.s.push(this.X(x)+' '+this.Y(y)+' l');this.cx=x;this.cy=y;return this;},
  c:function(a,b,c,d,x,y){
    this.s.push(this.X(a)+' '+this.Y(b)+' '+this.X(c)+' '+this.Y(d)+' '+this.X(x)+' '+this.Y(y)+' c');
    this.cx=x;this.cy=y;return this;},
  z:function(){this.s.push('h');return this;},
  vider:function(){var t=this.s.join('\n');this.s=[];return t;},
  ecrire:function(t){this.doc.internal.write(t);},

  /* rectangle aux coins arrondis ; rx/ry différents = coins ovales
     (comme un SVG étiré) ; coins = [haut-g, haut-d, bas-d, bas-g] */
  rrect:function(x,y,w,h,rx,ry,coins){
    if(ry==null)ry=rx;
    rx=Math.max(0,Math.min(rx||0,w/2));ry=Math.max(0,Math.min(ry||0,h/2));
    var k=.5523, c=coins||[1,1,1,1];
    function r(i){return c[i]?1:0;}
    var a=rx*r(0),b=ry*r(0);this.m(x+a,y);
    a=rx*r(1);b=ry*r(1);this.l(x+w-a,y);
    if(a)this.c(x+w-a+a*k,y, x+w,y+b-b*k, x+w,y+b);
    a=rx*r(2);b=ry*r(2);this.l(x+w,y+h-b);
    if(a)this.c(x+w,y+h-b+b*k, x+w-a+a*k,y+h, x+w-a,y+h);
    a=rx*r(3);b=ry*r(3);this.l(x+a,y+h);
    if(a)this.c(x+a-a*k,y+h, x,y+h-b+b*k, x,y+h-b);
    a=rx*r(0);b=ry*r(0);this.l(x,y+b);
    if(a)this.c(x,y+b-b*k, x+a-a*k,y, x+a,y);
    return this.z();
  },
  ellipse:function(cx,cy,rx,ry){
    var k=.5523;
    this.m(cx+rx,cy).c(cx+rx,cy+ry*k, cx+rx*k,cy+ry, cx,cy+ry)
      .c(cx-rx*k,cy+ry, cx-rx,cy+ry*k, cx-rx,cy)
      .c(cx-rx,cy-ry*k, cx-rx*k,cy-ry, cx,cy-ry)
      .c(cx+rx*k,cy-ry, cx+rx,cy-ry*k, cx+rx,cy);
    return this.z();
  },
  /* un tracé SVG (M L H V C A Z, absolus), posé par la fonction f(u,v) → [x,y] */
  svg:function(d,f){
    var t=d.match(/[MLHVCAZ]|-?\d*\.?\d+(?:e[-+]?\d+)?/gi)||[], i=0, cmd='', u=0, v=0, me=this;
    function num(){return parseFloat(t[i++]);}
    function P(a,b){u=a;v=b;return f(a,b);}
    while(i<t.length){
      if(/[A-Z]/i.test(t[i]))cmd=t[i++].toUpperCase();
      var p;
      if(cmd==='M'){p=P(num(),num());me.m(p[0],p[1]);cmd='L';}
      else if(cmd==='L'){p=P(num(),num());me.l(p[0],p[1]);}
      else if(cmd==='H'){p=P(num(),v);me.l(p[0],p[1]);}
      else if(cmd==='V'){p=P(u,num());me.l(p[0],p[1]);}
      else if(cmd==='C'){
        var a=f(num(),num()), b=f(num(),num());p=P(num(),num());
        me.c(a[0],a[1],b[0],b[1],p[0],p[1]);
      }else if(cmd==='A'){
        /* seuls des quarts de cercle sont utilisés (coins de la bulle) */
        num();num();num();num();var sw=num();
        var u0=u,v0=v,u1=num(),v1=num();
        var c1=[u0,v1],c2=[u1,v0], cr=function(c){return (u0-c[0])*(v1-c[1])-(v0-c[1])*(u1-c[0]);};
        var centre=(cr(c1)>0)===(sw===1)?c1:c2, coin=centre===c1?c2:c1, k=.5523;
        var q1=f(u0+(coin[0]-u0)*k,v0+(coin[1]-v0)*k), q2=f(u1+(coin[0]-u1)*k,v1+(coin[1]-v1)*k);
        p=P(u1,v1);me.c(q1[0],q1[1],q2[0],q2[1],p[0],p[1]);
      }else if(cmd==='Z'){me.z();}
      else i++;
    }
    return this;
  },

  /* peindre le tracé en cours : o = {fond, trait, ep (mm), tirets [mm,mm], rond} */
  peindre:function(o){
    var t=this.vider(), op='', pre=[];
    var f=couleurPdf(o.fond), s=couleurPdf(o.trait);
    if(f){pre.push(f+' rg');op='f';}
    if(s&&o.ep>0){
      pre.push(s+' RG',this.n(o.ep*this.K)+' w',(o.rond?'1 J 1 j':'0 J 0 j'),
        o.tirets?'['+o.tirets.map(function(v){return this.n(v*this.K);},this).join(' ')+'] 0 d':'[] 0 d');
      op=op?'B':'S';
    }
    if(!op)return;
    this.ecrire(pre.join('\n')+'\n'+t+'\n'+op);
  },
  /* tout ce qui suit est rogné au tracé en cours */
  rogner:function(){this.ecrire(this.vider()+'\nW n');},
  /* une ligne droite */
  trait:function(x1,y1,x2,y2,o){this.m(x1,y1).l(x2,y2);this.peindre(o);}
};

/* '#abc', '#aabbcc' → 'r g b' entre 0 et 1 ; 'none' → null */
function couleurPdf(c){
  if(!c||c==='none'||c==='transparent')return null;
  var h=String(c).trim(), r,g,b,m;
  if(h[0]==='#'){
    h=h.slice(1);if(h.length===3)h=h.replace(/./g,'$&$&');
    r=parseInt(h.slice(0,2),16);g=parseInt(h.slice(2,4),16);b=parseInt(h.slice(4,6),16);
  }else if((m=h.match(/rgba?\(([^)]+)\)/))){
    var p=m[1].split(',').map(parseFloat), a=p[3]==null?1:p[3];
    r=p[0]*a+255*(1-a);g=p[1]*a+255*(1-a);b=p[2]*a+255*(1-a);
  }else return null;
  if(isNaN(r))return null;
  return [r,g,b].map(function(v){return (Math.round(v/255*1000)/1000).toString();}).join(' ');
}

/* ============================================================
   LE TEXTE
   La ligne fait taille × interligne ; le texte est centré dans
   sa ligne comme dans le navigateur (moitié de l'interligne en
   haut, moitié en bas). Les retours à la ligne sont conservés.
   ============================================================ */
function couper(doc,txt,w){
  var out=[];
  String(txt==null?'':txt).split('\n').forEach(function(par){
    if(!par){out.push('');return;}
    if(doc.getTextWidth(par)<=w+.01){out.push(par);return;}
    doc.splitTextToSize(par,Math.max(w,1)).forEach(function(l){out.push(l);});
  });
  return out;
}
/* o = {txt, x, y, w, h, police, poids, ital, taille(pt), couleur, align,
        lh (interligne ou 'normal'), souligne, milieu (centrer en hauteur), mesure} */
function poserTexte(cr,o){
  var doc=cr.doc, f=fonte(o.police,o.poids||500,o.ital), m=METRIQUES[f.met];
  utiliser(doc,f);doc.setFontSize(o.taille);
  var S=o.taille*PT, L=S*(o.lh==='normal'||!o.lh?(o.lh==='normal'?m[0]+m[1]:1.4):o.lh);
  var lignes=couper(doc,o.txt,o.w), tot=lignes.length*L;
  if(o.mesure)return tot;
  var y0=o.milieu?o.y+(o.h-tot)/2:o.y, base=(L-(m[0]+m[1])*S)/2+m[0]*S;
  doc.setTextColor(o.couleur||'#14142b');
  lignes.forEach(function(l,k){
    if(!l)return;
    var lw=doc.getTextWidth(l), x=o.x;
    if(o.align==='center')x=o.x+(o.w-lw)/2;
    else if(o.align==='right')x=o.x+o.w-lw;
    var yb=y0+k*L+base;
    doc.text(l,x,yb,{baseline:'alphabetic'});
    if(o.souligne)cr.trait(x,yb+S*.11,x+lw,yb+S*.11,{trait:o.couleur||'#14142b',ep:Math.max(.15,S*.06)});
  });
  return tot;
}
/* Le texte enrichi : des passages de styles différents sur une même
   ligne. Comme dans le navigateur, chaque passage garde sa propre
   hauteur de ligne (interligne × sa taille) et la ligne prend la plus
   haute ; tous les passages partagent la même ligne de base. */
function poserRiche(cr,runs,o){
  var doc=cr.doc, W=o.w, toks=[];
  function st(r){
    return {poids:r.g===true?700:r.g===false?500:(o.poids||500),
      ital:r.i==null?!!o.ital:r.i, u:!!(r.u||o.souligne), c:r.c||o.couleur||INK, z:r.z||o.taille,
      blanc:!!r.blanc, l:r.l||null};
  }
  function mesure(k){
    var f=fonte(o.police,k.st.poids,k.st.ital);utiliser(doc,f);doc.setFontSize(k.st.z);
    k.f=f;k.w=doc.getTextWidth(k.t);return k.w;
  }
  runs.forEach(function(r){
    var y=st(r);
    String(r.t).split(/(\n| +)/).forEach(function(t){
      if(t)toks.push({t:t,st:y,nl:t==='\n',sp:/^ +$/.test(t)});
    });
  });
  /* découpe en lignes */
  var lignes=[[]], x=0;
  function neuve(){lignes.push([]);x=0;}
  toks.forEach(function(k){
    if(k.nl)return neuve();
    var l=lignes[lignes.length-1];
    mesure(k);
    if(!k.sp&&x+k.w>W+.01&&l.some(function(z){return !z.sp;})){neuve();l=lignes[lignes.length-1];}
    if(!k.sp&&k.w>W+.01){
      /* un mot plus long que la ligne : coupé lettre à lettre */
      var a='';
      k.t.split('').forEach(function(ch){
        var essai={t:a+ch,st:k.st};mesure(essai);
        if(x+essai.w>W+.01&&a){var m={t:a,st:k.st};mesure(m);lignes[lignes.length-1].push(m);neuve();a=ch;}
        else a+=ch;
      });
      if(a){var m={t:a,st:k.st};mesure(m);lignes[lignes.length-1].push(m);x+=m.w;}
      return;
    }
    l.push(k);x+=k.w;
  });
  if(lignes.length>1&&!lignes[lignes.length-1].length)lignes.pop();
  /* hauteur de chaque ligne */
  var base=fonte(o.police,o.poids||500,o.ital), lhN=o.lh==='normal';
  function boite(met,z){
    var m=METRIQUES[met], S=z*PT, L=lhN?(m[0]+m[1])*S:(o.lh||1.4)*S, demi=(L-(m[0]+m[1])*S)/2;
    return [m[0]*S+demi,m[1]*S+demi];
  }
  var infos=lignes.map(function(l){
    var b=boite(base.met,o.taille), haut=b[0], bas=b[1];
    l.forEach(function(k){var q=boite(k.f.met,k.st.z);haut=Math.max(haut,q[0]);bas=Math.max(bas,q[1]);});
    while(l.length&&l[l.length-1].sp)l=l.slice(0,-1);
    var w=l.reduce(function(a,k){return a+k.w;},0);
    return {l:l,haut:haut,h:haut+bas,w:w};
  });
  var tot=infos.reduce(function(a,i){return a+i.h;},0);
  if(o.mesure)return tot;
  var y=o.milieu?o.y+(o.h-tot)/2:o.y;
  infos.forEach(function(i){
    var x0=o.x;
    if(o.align==='center')x0=o.x+(W-i.w)/2;else if(o.align==='right')x0=o.x+W-i.w;
    var yb=y+i.haut;
    i.l.forEach(function(k){
      if(!k.sp&&!k.st.blanc){
        utiliser(doc,k.f);doc.setFontSize(k.st.z);doc.setTextColor(k.st.c);
        doc.text(k.t,x0,yb,{baseline:'alphabetic'});
      }
      if(k.st.l&&!k.st.blanc){var Sz=k.st.z*PT;
        try{doc.link(x0,yb-Sz*.9,k.w,Sz*1.2,{url:k.st.l});}catch(er){}}
      if(k.st.u&&!k.st.blanc){var S=k.st.z*PT;
        cr.trait(x0,yb+S*.11,x0+k.w,yb+S*.11,{trait:k.st.c,ep:Math.max(.15,S*.06)});}
      x0+=k.w;
    });
    y+=i.h;
  });
  return tot;
}
/* les passages tels que les voit la version en cours de fabrication */
var ROLE_PDF='eleve';
function runsPour(runs){
  var out=[];
  runs.forEach(function(r,i){
    var so=sortDuPassage(runs,i,ROLE_PDF);
    if(so==='cache')return;
    var c=clone(r);if(so==='blanc')c.blanc=true;out.push(c);
  });
  return out;
}
/* le texte d'un élément : enrichi s'il l'est, simple sinon */
function ecrireTexte(cr,e,o){
  if(e.riche&&e.riche.length)return poserRiche(cr,runsPour(e.riche),o);
  return poserTexte(cr,o);
}

/* un seul mot ou une seule ligne, centré verticalement sur cy */
function poserMot(cr,txt,x,cy,police,poids,taillePt,couleur){
  var doc=cr.doc, f=fonte(police,poids,false), m=METRIQUES[f.met], S=taillePt*PT;
  utiliser(doc,f);doc.setFontSize(taillePt);doc.setTextColor(couleur);
  doc.text(String(txt),x,cy-(m[0]+m[1])*S/2+m[0]*S,{baseline:'alphabetic'});
  return doc.getTextWidth(String(txt));
}
function largeurMot(cr,txt,police,poids,taillePt){
  var f=fonte(police,poids,false);utiliser(cr.doc,f);cr.doc.setFontSize(taillePt);
  return cr.doc.getTextWidth(String(txt));
}
var MM=1/PT;      /* une taille en mm → en points */

/* ============================================================
   UN DESSIN PAR TYPE D'ÉLÉMENT
   Chaque fonction lit exactement les propriétés que lit
   dedansElement() dans ressources.js, avec les valeurs de
   ressources.css.
   ============================================================ */
var INK='#14142b', ROSE='#f0265c';

/* le texte des blocs « texte » (styleTexte) */
function styleDe(e,poidsDefaut){
  return {police:e.police||'texte',poids:e.gras?700:(poidsDefaut||500),ital:!!e.italique,
    taille:e.taille||11,couleur:e.couleur||INK,align:e.align||'left',lh:e.interligne||1.4,
    souligne:!!e.souligne};
}
function avec(o,p){for(var k in p)o[k]=p[k];return o;}
function rayonDe(e,def){return e.rayon?e.rayon:def;}

var DESSIN={
  texte:function(cr,e){
    if(!e.texte)return;
    var p=e.padding||0;
    cr.rrect(e.x,e.y,e.w,e.h,e.rayon||0);
    if(e.fond){cr.peindre({fond:e.fond});cr.rrect(e.x,e.y,e.w,e.h,e.rayon||0);}
    cr.rogner();
    ecrireTexte(cr,e,avec(styleDe(e),{txt:e.texte,x:e.x+p,y:e.y+p,w:e.w-2*p,h:e.h-2*p}));
  },

  consigne:function(cr,e){
    var r=e.rayon?e.rayon:Math.min(e.w,e.h)/2;
    cr.rrect(e.x,e.y,e.w,e.h,r);cr.peindre({fond:e.fond||'#ffd9e4'});
    cr.rrect(e.x,e.y,e.w,e.h,r);cr.rogner();
    var py=e.padding||2.6, px=e.padding||4, x=e.x+px, w=e.w-2*px, cy=e.y+e.h/2;
    var st=styleDe(e,700);
    if(e.puce){
      cr.ellipse(x+3.7,cy,3.7,3.7);cr.peindre({fond:'#ffffff'});
      var n=String(e.numero||1), nw=largeurMot(cr,n,'titre',800,4*MM);
      poserMot(cr,n,x+3.7-nw/2,cy,'titre',800,4*MM,st.couleur);
      x+=10.2;w-=10.2;
    }
    ecrireTexte(cr,e,avec(st,{txt:e.texte||'',x:x,y:e.y+py,w:w,h:e.h-2*py,milieu:true}));
  },

  retiens:function(cr,e){
    var t=e.teinte||'#b083f2', r=rayonDe(e,4), st=styleDe(e);
    cr.rrect(e.x,e.y,e.w,e.h,r);cr.peindre({fond:'#faf6ff'});
    cr.rrect(e.x+.4,e.y+.4,e.w-.8,e.h-.8,Math.max(0,r-.4));cr.peindre({trait:t,ep:.8});
    var b=.8, pt=e.padding||4, pr=e.padding||4, pb=e.padding||3.4, pl=e.padding||4;
    ecrireTexte(cr,e,avec(st,{txt:e.texte||'',x:e.x+b+pl,y:e.y+b+pt,w:e.w-2*b-pl-pr,
      h:e.h-2*b-pt-pb}));
    /* l'étiquette qui chevauche le bord du haut */
    var et=e.etiquette||'Je retiens', tp=3*MM, ew=largeurMot(cr,et,'titre',800,tp)+6,
      eh=3*(e.interligne||1.4)+1.4, ex=e.x+b+4, ey=e.y+b-3;
    cr.rrect(ex,ey,ew,eh,eh/2);cr.peindre({fond:t});
    poserMot(cr,et,ex+3,ey+eh/2,'titre',800,tp,'#ffffff');
  },

  cases:function(cr,e){
    var li=lignesRiches(e).map(runsPour).filter(function(l){
      return l.some(function(r){return !r.blanc&&r.t.trim();});}), pt=e.taille||11, col=e.corrige?ROSE:INK;
    cr.rrect(e.x,e.y,e.w,e.h,0);cr.rogner();
    var tw=e.w-7.4, base={police:'texte',poids:600,taille:pt,couleur:col,align:'left',lh:'normal'};
    var hs=li.map(function(x){return Math.max(4.8,poserRiche(cr,x,avec(avec({},base),
      {w:tw,mesure:true})));});
    var tot=hs.reduce(function(a,b){return a+b;},0)+Math.max(0,li.length-1)*2.2;
    var y=e.y+(e.h-tot)/2;
    li.forEach(function(x,i){
      var cy=y+hs[i]/2;
      cr.rrect(e.x+.25,cy-2.4+.25,4.3,4.3,1.15);cr.peindre({trait:INK,ep:.5});
      poserRiche(cr,x,avec(avec({},base),{x:e.x+7.4,y:y,w:tw,h:hs[i],milieu:true}));
      y+=hs[i]+2.2;
    });
  },

  bareme:function(cr,e){DESSIN.dessin(cr,stickerNote(e));},

  nametag:function(cr,e){
    var c=e.teinte||'#f0265c', h=e.h, cy=e.y+h/2;
    /* le bandeau blanc, qui sort de derrière le rond */
    var bx=e.x+h-4, bw=e.w-(h-4);
    cr.rrect(bx+.35,e.y+.35,bw-.7,h-.7,(h-.7)/2,null,[0,1,1,0]);
    cr.peindre({fond:'#ffffff',trait:c,ep:.7});
    var lab=e.label||'Prénom', lx=bx+.7+6;
    var lw=poserMot(cr,lab,lx,cy,'titre',700,3.4*MM,c);
    var t0=lx+lw+2, t1=e.x+e.w-.7-4;
    if(t1>t0)cr.trait(t0,cy+1.5,t1,cy+1.5,{trait:'#c9bfc9',ep:.4,tirets:[0,.8],rond:true});
    /* le rond, par-dessus */
    cr.ellipse(e.x+h/2,cy,h/2,h/2);cr.peindre({fond:c});
    var L=e.lettre||'L', tp=h*.42*MM, w=largeurMot(cr,L,'titre',800,tp);
    poserMot(cr,L,e.x+h/2-w/2,cy,'titre',800,tp,'#ffffff');
  },

  image:function(cr,e,imgs){
    var im=e.src&&imgs[e.src];if(!im)return;
    cr.rrect(e.x,e.y,e.w,e.h,e.rayon||0);cr.rogner();
    poserImage(cr,im,e.x,e.y,e.w,e.h,.5,.5,e.ajuste==='contenir');
  },

  lignes:function(cr,e){
    var n=Math.max(1,e.nb||5), g=e.lignage||'simple', hl=e.hl||HL[g]||10;
    var ec=e.ecart==null?1.5:e.ecart, x=e.x, w=e.w;
    for(var i=0;i<n;i++){
      var y=e.y+i*(hl+ec);
      if(g==='maison'||g==='couleurs'||g==='quatre'){
        var q=g==='quatre';
        cr.doc.saveGraphicsState();
        cr.rrect(x,y,w,hl,1.2);cr.rogner();
        if(!q){
          cr.rrect(x,y,w,hl/3,0);cr.peindre({fond:'#cfe6fb'});
          cr.rrect(x,y+hl/3,w,hl/3,0);cr.peindre({fond:'#fdf8cf'});
          cr.rrect(x,y+hl*2/3,w,hl/3,0);cr.peindre({fond:'#e6e0d2'});
        }
        cr.trait(x,y+.25,x+w,y+.25,{trait:q?'#9fc0e6':'#5b8fd0',ep:.5});
        cr.trait(x,y+hl/3+.25,x+w,y+hl/3+.25,{trait:'#f2b705',ep:.5,tirets:[1.5,1.5]});
        cr.trait(x,y+hl*2/3+.25,x+w,y+hl*2/3+.25,{trait:'#2f9e5e',ep:.5});
        cr.trait(x,y+hl-.25,x+w,y+hl-.25,{trait:'#8a6436',ep:.5});
        if(g==='maison')dessinerDecor(cr,x,y,hl);
        cr.doc.restoreGraphicsState();
      }else{
        var yb=y+hl;
        if(g==='seyes')[.25,.5,.75].forEach(function(k){
          var yy=y+(hl-.35)*k+.11;cr.trait(x,yy,x+w,yy,{trait:'#d2e4f5',ep:.22});});
        if(g==='pointille')cr.trait(x,yb-.225,x+w,yb-.225,{trait:'#b9b0c4',ep:.45,tirets:[0,.9],rond:true});
        else cr.trait(x,yb-.175,x+w,yb-.175,{trait:g==='seyes'?'#2f80c8':'#c3bccd',ep:.35});
      }
    }
  },

  tableau:function(cr,e){
    var C=e.cols||3, Rw=e.rows||3, cel=e.cellules, fu=e.fusions||[];
    var cw=e.w/C, rh=e.h/Rw, tr=e.trait||'#c9bfc9', col=e.corrige?ROSE:INK;
    function couverte(y,x){
      for(var i=0;i<fu.length;i++){var f=fu[i];
        if(y>=f.y&&y<f.y+f.ly&&x>=f.x&&x<f.x+f.lx&&!(y===f.y&&x===f.x))return true;}
      return false;
    }
    function etire(y,x){for(var i=0;i<fu.length;i++){var f=fu[i];if(f.y===y&&f.x===x)return f;}return null;}
    /* comme le navigateur : chaque rangée prend la hauteur de son texte
       (l'en-tête en Baloo est un peu plus haute), puis le reste de la
       hauteur est réparti au prorata */
    var S=(e.taille||11)*PT, nat=[], som=0, hy=[], cum=0;
    for(var y=0;y<Rw;y++){
      var m=METRIQUES[e.tete&&y===0?'titre':'texte'];
      nat[y]=(m[0]+m[1])*S+3.6+.45;som+=nat[y];
    }
    for(y=0;y<Rw;y++){hy[y]=cum;cum+=e.h>som?nat[y]*e.h/som:rh;}
    hy[Rw]=cum;
    var cases=[];
    for(y=0;y<Rw;y++)for(var x=0;x<C;x++){
      if(couverte(y,x))continue;
      var f=etire(y,x), lx=f?f.lx:1, ly=f?f.ly:1;
      cases.push({x:e.x+x*cw,y:e.y+hy[y],w:cw*lx,h:hy[Math.min(Rw,y+ly)]-hy[y],tete:e.tete&&y===0,
        v:(cel&&cel[y]&&cel[y][x])||'', r:e.celRiche&&e.celRiche[y+'-'+x]});
    }
    cases.forEach(function(c){if(c.tete){cr.rrect(c.x,c.y,c.w,c.h,0);cr.peindre({fond:e.fond||'#fdf0eb'});}});
    cases.forEach(function(c){
      if(!c.v)return;
      cr.doc.saveGraphicsState();cr.rrect(c.x,c.y,c.w,c.h,0);cr.rogner();
      var oc={txt:c.v,x:c.x+1.8,y:c.y+1.8,w:c.w-3.6,h:c.h-3.6,milieu:true,
        police:c.tete?'titre':'texte',poids:c.tete?700:600,taille:e.taille||11,couleur:col,
        align:'center',lh:'normal'};
      if(c.r)poserRiche(cr,runsPour(c.r),oc);else poserTexte(cr,oc);
      cr.doc.restoreGraphicsState();
    });
    cases.forEach(function(c){
      cr.rrect(c.x,c.y,c.w,c.h,0);
      cr.peindre({trait:tr,ep:.45,tirets:e.decoupe?[1.35,1.35]:null});
    });
  },

  dessin:function(cr,e){
    var s=Math.min(e.w/e.W0,e.h/e.H0), X=e.x, Y=e.y;
    if(e.centre){X+=(e.w-e.W0*s)/2;Y+=(e.h-e.H0*s)/2;}
    function x(v){return X+v*s;}function y(v){return Y+v*s;}
    if(e.num!=null&&e.ancres)e.ancres.forEach(function(a,i){
      var nm=(e.num+i)+'.', pt=4*s*MM, wn=largeurMot(cr,nm,'titre',800,pt);
      poserMot(cr,nm,x(a[0])-wn,y(a[1]+2.2),'titre',800,pt,INK);});
    (e.prims||[]).forEach(function(p){
      if(p.v&&p.v!==ROLE_PDF)return;
      var st={fond:p.f,trait:p.c,ep:(p.ep||0)*s,tirets:p.d?p.d.map(function(v){return v*s;}):null,rond:p.t==='l'};
      if(p.t==='l')cr.trait(x(p.x1),y(p.y1),x(p.x2),y(p.y2),st);
      else if(p.t==='r'){cr.rrect(x(p.x),y(p.y),p.w*s,p.h*s,(p.rx||0)*s);cr.peindre(st);}
      else if(p.t==='o'){cr.ellipse(x(p.cx),y(p.cy),p.r*s,(p.ry||p.r)*s);cr.peindre(st);}
      else if(p.t==='p'){p.pts.forEach(function(q,i){if(i)cr.l(x(q[0]),y(q[1]));else cr.m(x(q[0]),y(q[1]));});
        if(p.z)cr.z();cr.peindre(st);}
      else if(p.t==='x'){
        var pt=p.z*s*MM, pol=e.police||'ecole', g=p.g?700:500, w=largeurMot(cr,p.s,pol,g,pt);
        var x0=p.a==='e'?x(p.x)-w:p.a==='s'?x(p.x):x(p.x)-w/2;
        /* le y du SVG est la ligne de base : on la convertit en centre */
        var m=METRIQUES[fonte(pol,g,false).met], S=pt*PT;
        poserMot(cr,p.s,x0,y(p.y)-(m[0]-m[1])*S/2,pol,g,pt,p.c||INK);
      }
    });
  },

  calcul:function(cr,e){
    var L=layoutCalcul(e), c=Math.min(e.w/L.cols,e.h/L.rows), W=L.cols*c, H=L.rows*c, X=e.x, Y=e.y;
    L.fonds.forEach(function(k){cr.rrect(X+k.c*c,Y+k.r0*c,c,(k.r1-k.r0)*c,0);cr.peindre({fond:k.col});});
    if(e.quad!==false){
      for(var i=0;i<=L.cols;i++)cr.trait(X+i*c,Y,X+i*c,Y+H,{trait:'#cfe0f2',ep:.2});
      for(var j=0;j<=L.rows;j++)cr.trait(X,Y+j*c,X+W,Y+j*c,{trait:'#cfe0f2',ep:.2});
    }
    L.cases.forEach(function(k){var s=c*.56;
      cr.rrect(X+k[0]*c+(c-s)/2,Y+k[1]*c+(c-s)/2,s,s,s*.18);cr.peindre({trait:'#9fb6d4',ep:.25});});
    L.lignes.forEach(function(l){cr.trait(X+l[0]*c,Y+l[1]*c,X+l[2]*c,Y+l[3]*c,{trait:INK,ep:.5});});
    L.cells.forEach(function(k){
      var rep=/rep|ret/.test(k.k);
      if(rep&&ROLE_PDF!=='prof')return;
      var mm=k.k==='ret'?c*.36:k.k==='repp'||k.k==='num'?c*.5:k.k==='lab'?c*.4:c*.64, pt=mm*MM;
      var gras=k.k==='num'||k.k==='lab'?700:500, t=k.t+(k.k==='num'?'.':'');
      var w=largeurMot(cr,t,e.police||'ecole',gras,pt);
      poserMot(cr,t,X+k.c*c+(c-w)/2,Y+k.r*c+c/2,e.police||'ecole',gras,pt,
        rep?ROSE:k.k==='lab'?k.col:(e.couleur||INK));
    });
  },

  forme:function(cr,e){
    var tr=e.trait||INK, ep=(e.epaisseur==null?.5:e.epaisseur)*PX;
    var tir=e.pointille?[2.4*PX,1.8*PX]:null, X=e.x, Y=e.y, W=e.w, H=e.h;
    function f(u,v){return [X+u/100*W,Y+v/100*H];}
    cr.rrect(X,Y,W,H,0);cr.rogner();
    var fo=e.forme;
    if(fo==='cercle'){
      cr.ellipse(X+W/2,Y+H/2,W*.49,H*.49);cr.peindre({fond:e.remplissage,trait:tr,ep:ep,tirets:tir});
    }else if(fo==='ligne'){
      cr.trait(X,Y+H/2,X+W,Y+H/2,{trait:tr,ep:ep,tirets:tir});
    }else if(fo==='fleche'){
      cr.trait(X,Y+H/2,X+W*.92,Y+H/2,{trait:tr,ep:ep,tirets:tir});
      cr.svg('M92 42 L100 50 L92 58 Z',f);cr.peindre({fond:tr});
    }else if(fo==='etoile'){
      cr.svg('M50 2 L61 37 L98 37 L68 59 L79 95 L50 73 L21 95 L32 59 L2 37 L39 37 Z',f);
      cr.peindre({fond:e.remplissage||'#f5c518',trait:tr,ep:ep});
    }else if(fo==='bulle'){
      cr.svg('M8 2 H92 A6 6 0 0 1 98 8 V62 A6 6 0 0 1 92 68 H34 L20 82 L22 68 H8 '
        +'A6 6 0 0 1 2 62 V8 A6 6 0 0 1 8 2 Z',function(u,v){return f(u,v*1.22);});
      cr.peindre({fond:e.remplissage||'#cfe6fb',trait:tr,ep:ep});
    }else{
      var r=(e.rayon||0)*2;
      cr.rrect(X+W*.005,Y+H*.005,W*.99,H*.99,r/100*W,r/100*H);
      cr.peindre({fond:e.remplissage,trait:tr,ep:ep,tirets:tir});
    }
    var t=e.texte||e.legende;
    if(t){
      var p=e.padding||3;
      (e.texte?ecrireTexte:function(c,x,o){return poserTexte(c,o);})(cr,e,avec(styleDe(e),{txt:t,x:X+p,y:Y+p,w:W-2*p,h:H-2*p,milieu:true,
        align:e.align||'center'}));
    }
  }
};

/* une image posée « en couvrant » ou « en contenant » dans une boîte */
function poserImage(cr,im,x,y,w,h,px,py,contenir){
  var r=im.w/im.h, dw, dh;
  if(contenir?(r>w/h):(r<w/h)){dw=w;dh=w/r;}else{dh=h;dw=h*r;}
  cr.doc.addImage(im.data,im.fmt,x+(w-dw)*px,y+(h-dh)*py,dw,dh,im.cle,'FAST');
}

/* le petit décor des lignes maison (même dessin que decorMaison()) */
function dessinerDecor(cr,x0,y0,hl){
  var s=hl/100;
  function f(u,v){return [x0+u*s,y0+v*s];}
  function ligne(a,b,c,d,col,ep){var p=f(a,b),q=f(c,d);cr.trait(p[0],p[1],q[0],q[1],{trait:col,ep:ep*s,rond:true});}
  function rond(cx,cy,r,fond,trait,ep){var p=f(cx,cy);cr.ellipse(p[0],p[1],r*s,r*s);
    cr.peindre({fond:fond,trait:trait,ep:(ep||0)*s});}
  function rect(a,b,w,h,fond,trait,ep){var p=f(a,b);cr.rrect(p[0],p[1],w*s,h*s,0);
    cr.peindre({fond:fond,trait:trait,ep:ep*s});}
  function chemin(d,fond,trait,ep,rd){cr.svg(d,f);cr.peindre({fond:fond,trait:trait,ep:ep*s,rond:rd});}
  /* soleil */
  [[14,1,14,5],[4,11,.5,11],[6.5,4,4,1.6],[21.5,4,24,1.6],[6.5,18,4,20.4]].forEach(function(l){
    ligne(l[0],l[1],l[2],l[3],'#f2b705',1.7);});
  rond(14,11,6,'#ffd93d','#f2b705',1.2);
  /* maison */
  rect(30,16.5,5,10,'#9ec4ea','#5b8fd0',1.1);
  chemin('M20 29 L42 11 L64 29 Z','#9ec4ea','#5b8fd0',1.4,true);
  rect(26,29,32,41,'#ffe84d','#f2b705',1.4);
  rect(36,46,13,24,null,'#f2b705',1.2);
  /* fleur */
  ligne(12,46,12,70,'#2f9e5e',1.3);
  [[12,42,3.4],[7.6,45,3.2],[16.4,45,3.2],[9.4,50,3.2],[14.6,50,3.2]].forEach(function(c){
    rond(c[0],c[1],c[2],'#ff6b8a');});
  rond(12,46,2.6,'#ffd93d');
  /* herbe */
  ['M4 70 C 4 65, 6 63, 7 61','M9 70 C 9 66, 11 64, 13 62','M20 70 C 20 66, 22 64, 23 62',
   'M62 70 C 62 66, 64 64, 66 62','M68 70 C 68 65, 70 63, 71 61'].forEach(function(d){
    chemin(d,null,'#2f9e5e',1.2,true);});
  /* marches */
  chemin('M26 70 L26 92 L58 92 L58 70 Z','#c89b63','#8a6436',1.2);
  chemin('M34 78 L42 78 L42 85 L50 85',null,'#8a6436',1.2);
  /* ver de terre */
  chemin('M5 86 C 8 82, 12 82, 14 86 C 16 90, 12 92, 9 90',null,'#e58fa8',2,true);
  rond(5.6,86.4,1,'#14142b');
}

/* ============================================================
   LE GABARIT : ciel + étiquette + numéro en haut, vague + barre
   crème en bas. Mêmes mesures que ressources.css.
   ============================================================ */
function dessinerHaut(cr,L,imgs,g){
  var ciel=imgs[cielSrc(g)];
  cr.doc.saveGraphicsState();
  cr.rrect(0,0,L,HAUT,0);cr.rogner();
  if(ciel)poserImage(cr,ciel,0,0,L,HAUT,.5,.42,false);
  cr.doc.restoreGraphicsState();
  /* la courbe blanche par-dessus, hors du cadre rogné : elle déborde
     un peu sous le ciel, sinon un fil de ciel reste visible au bord */
  var bh=HAUT*.46, by=HAUT-bh+.3;
  cr.svg('M0 58 C 76 84, 154 91, 228 84 C 302 77, 350 64, 400 68 L400 100 L0 100 Z',
    function(u,v){return [u/400*L,by+v/100*bh];});
  cr.peindre({fond:'#ffffff'});
}
/* L'étiquette est un PNG transparent : telle quelle, elle pèserait près
   de 500 Ko dans CHAQUE PDF. On la peint donc, avec son ombre, sur le
   morceau de ciel (et de courbe) qu'elle recouvre, et on pose le tout
   en JPEG : même rendu, dix fois plus léger. */
var ETIQS={};
function etiquetteSurCiel(L,g,nt,ciel){
  var w=g.ntW||92, h=w*nt.h/nt.w, m=2.5, x0=9-m, y0=6-m, W=w+2*m, H=h+2*m, k=11;
  var cle=L+'|'+w+'|'+nametagSrc(g)+'|'+cielSrc(g);
  if(ETIQS[cle])return ETIQS[cle];
  var c=document.createElement('canvas');c.width=Math.round(W*k);c.height=Math.round(H*k);
  var x=c.getContext('2d');
  x.fillStyle='#ffffff';x.fillRect(0,0,c.width,c.height);
  x.setTransform(k,0,0,k,-x0*k,-y0*k);          /* on dessine en mm de la page */
  x.save();x.beginPath();x.rect(0,0,L,HAUT);x.clip();
  var r=ciel.w/ciel.h, dw, dh;
  if(r<L/HAUT){dw=L;dh=L/r;}else{dh=HAUT;dw=HAUT*r;}
  x.drawImage(ciel.el,(L-dw)*.5,(HAUT-dh)*.42,dw,dh);
  x.restore();
  var bh=HAUT*.46, by=HAUT-bh+.3, sx=L/400, sy=bh/100;
  x.fillStyle='#ffffff';x.beginPath();x.moveTo(0,by+58*sy);
  x.bezierCurveTo(76*sx,by+84*sy,154*sx,by+91*sy,228*sx,by+84*sy);
  x.bezierCurveTo(302*sx,by+77*sy,350*sx,by+64*sy,400*sx,by+68*sy);
  x.lineTo(L,by+bh);x.lineTo(0,by+bh);x.closePath();x.fill();
  x.shadowColor='rgba(20,20,43,.14)';x.shadowBlur=1.2*k;x.shadowOffsetY=.5*k;
  x.drawImage(nt.el,9,6,w,h);
  ETIQS[cle]={data:c.toDataURL('image/jpeg',.9),fmt:'JPEG',x:x0,y:y0,w:W,h:H,cle:'etq'+w+'-'+L};
  return ETIQS[cle];
}
/* posée juste après le ciel : ce rectangle de ciel ne doit jamais
   recouvrir un élément placé dans le bandeau */
function dessinerEtiquette(cr,L,imgs,g){
  var nt=imgs[nametagSrc(g)], ciel=imgs[cielSrc(g)], w=g.ntW||92;
  if(nt&&ciel){
    var e=etiquetteSurCiel(L,g,nt,ciel);
    cr.doc.addImage(e.data,e.fmt,e.x,e.y,e.w,e.h,e.cle,'FAST');
  }else if(nt)cr.doc.addImage(nt.data,nt.fmt,9,6,w,w*nt.h/nt.w,nt.cle,'FAST');
}
function dessinerNumero(cr,L,i){
  var x=L-9-13, y=8, doc=cr.doc;
  doc.saveGraphicsState();
  doc.setGState(new doc.GState({opacity:.8,'stroke-opacity':.95}));
  cr.rrect(x,y,13,13,4.2);cr.peindre({fond:'#ffffff'});
  cr.rrect(x+.3,y+.3,12.4,12.4,3.9);cr.peindre({trait:'#ffffff',ep:.6});
  doc.restoreGraphicsState();
  var n=String(i+1), w2=largeurMot(cr,n,'titre',800,5.4*MM);
  poserMot(cr,n,x+6.5-w2/2,y+6.5,'titre',800,5.4*MM,INK);
}
function dessinerPied(cr,L,H,g){
  var by=H-BAS, deg=degradePied(L);
  cr.doc.saveGraphicsState();
  cr.svg('M0 32 C 50 12, 98 5, 172 14 C 246 23, 330 30, 400 14 L400 100 L0 100 Z',
    function(u,v){return [u/400*L,by+v/100*BAS];});
  cr.rogner();
  cr.doc.addImage(deg.data,deg.fmt,0,by,L,BAS,deg.cle,'FAST');
  cr.doc.restoreGraphicsState();
  /* la barre crème */
  var bh=Math.max(9.5,4.2*METRIQUES.titre[0]+4.2*METRIQUES.titre[1]+3.2), bx=6, bw=L-12,
    byy=H-4-bh, cy=byy+bh/2;
  cr.rrect(bx,byy,bw,bh,4.6);cr.peindre({fond:'#fff6e9'});
  var ad='ressourceslae.com', aw=largeurMot(cr,ad,'titre',700,3*MM);
  poserMot(cr,ad,bx+bw-6-aw,cy,'titre',700,3*MM,ROSE);
  var ti=g.titre||R.titre||'Ressources Laé', max=bw-12-aw-4;
  if(largeurMot(cr,ti,'titre',800,4.2*MM)>max){
    while(ti.length>1&&largeurMot(cr,ti+'…','titre',800,4.2*MM)>max)ti=ti.slice(0,-1);
    ti=ti.replace(/\s+$/,'')+'…';
  }
  poserMot(cr,ti,bx+6,cy,'titre',800,4.2*MM,INK);
}

/* ============================================================
   UNE PAGE, PUIS UN DOCUMENT
   ============================================================ */
function dessinerElement(cr,e,imgs){
  var doc=cr.doc;
  doc.saveGraphicsState();
  if(e.rot){
    /* rotation autour du centre, comme transform-origin:center */
    var K=cr.K, px=(e.x+e.w/2)*K, py=(cr.H-e.y-e.h/2)*K, a=-e.rot*Math.PI/180;
    var c=Math.cos(a), s=Math.sin(a);
    cr.ecrire([c,s,-s,c,px-c*px+s*py,py-s*px-c*py].map(function(v){return cr.n(v);}).join(' ')+' cm');
  }
  try{if(DESSIN[e.type])DESSIN[e.type](cr,e,imgs);}
  catch(err){console.warn('Élément non dessiné',e.type,err);}
  if(pastille(e)){var nm=e.num+'.', wn=largeurMot(cr,nm,'titre',800,4.2*MM);
    poserMot(cr,nm,e.x-2-wn,e.y+3,'titre',800,4.2*MM,INK);}
  doc.restoreGraphicsState();
}
function dessinerPagePdf(doc,p,i,role,imgs){
  var d=dimDe(p), L=d[0], H=d[1], g=R.doc.gabarit||{}, cr=new Crayon(doc,H);
  /* la version Élève ne contient AUCUN élément du corrigé */
  var els=(p.el||[]).filter(function(e){return visibleDans(e,role);})
    .map(function(e,k){return {e:e,k:k};})
    .sort(function(a,b){return ((a.e.z||1)-(b.e.z||1))||(a.k-b.k);})
    .map(function(o){return o.e;});
  if(aEntete(p)){dessinerHaut(cr,L,imgs,g);dessinerEtiquette(cr,L,imgs,g);}
  if(aPied(p))dessinerPied(cr,L,H,g);
  /* le numéro est au niveau 2 : sous les éléments de niveau 2 et plus,
     au-dessus des autres (comme à l'écran) */
  els.filter(function(e){return (e.z||1)<2;}).forEach(function(e){dessinerElement(cr,e,imgs);});
  if(aEntete(p))dessinerNumero(cr,L,i);
  els.filter(function(e){return (e.z||1)>=2;}).forEach(function(e){dessinerElement(cr,e,imgs);});
}
function faireUnPdf(niv,role,polices,imgs){
  ROLE_PDF=role;
  var pg=(R.doc.niveaux[niv]||{}).pages||[];
  if(!pg.length)return null;
  var JS=window.jspdf.jsPDF, doc=null;
  pg.forEach(function(p,i){
    var d=dimDe(p), o=d[0]>d[1]?'landscape':'portrait';
    if(!doc){
      doc=new JS({unit:'mm',format:[d[0],d[1]],orientation:o,compress:true});
    }else doc.addPage([d[0],d[1]],o);
    dessinerPagePdf(doc,p,i,role,imgs);
  });
  doc.setProperties({title:(R.titre||'Ressource Laé')+' — Niveau '+niv+' — '
    +(role==='prof'?'Prof':'Élève'),author:'Ressources Laé',creator:'ressourceslae.com'});
  return new Uint8Array(doc.output('arraybuffer'));
}

/* ============================================================
   LA MINIATURE DE LA BOUTIQUE (façon Twinkl)
   Un collage 1200 × 1800 (2:3, le format des cartes du site) :
   fond orange Laé, cadre du titre blanc à contour bleu nuit,
   les pages du niveau 1 élève posées autour, et une pastille
   « N pages / N calculs » en bas à droite.
   Tout se règle dans l'éditeur ; la mise en page est gardée
   dans R.doc.mini et redessinée avec les vraies pages à chaque
   export, pour rester à jour si les pages changent.
   ============================================================ */
var MW=1200, MH=1800;
var MINI_POLICE='ui-rounded,"SF Pro Rounded","Nunito",system-ui,sans-serif';
var MINI_NUIT='#1f2a5a', MINI_ORANGE='#fa5a3c';
var PDFJS='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
var _pdfjs=null;
function pdfjsPret(){
  if(_pdfjs)return _pdfjs;
  _pdfjs=new Promise(function(ok,ko){
    var s=document.createElement('script');s.src=PDFJS+'pdf.min.js';
    s.onload=function(){
      window.pdfjsLib.GlobalWorkerOptions.workerSrc=PDFJS+'pdf.worker.min.js';ok(window.pdfjsLib);};
    s.onerror=function(){_pdfjs=null;
      ko(new Error('Impossible de charger pdf.js. Vérifiez la connexion internet.'));};
    document.head.appendChild(s);
  });
  return _pdfjs;
}
/* le PDF du niveau 1 élève, fabriqué ici même */
function pdfNiveau1(){
  return fabriquerPdfs([{niv:'1',role:'eleve'}]).then(function(l){
    var u=l[0]&&l[0].pdf;
    if(!u)throw new Error('Le niveau 1 élève est vide : il n’y a aucune page à montrer.');
    return u;
  });
}
/* un PDF → une image par page (8 au plus), 900 px de large */
function pagesDuPdf(u){
  return pdfjsPret().then(function(lib){return lib.getDocument({data:u.slice()}).promise;})
    .then(function(doc){
      var l=[], pr=Promise.resolve();
      for(var i=1;i<=Math.min(doc.numPages,8);i++)(function(i){
        pr=pr.then(function(){return doc.getPage(i);}).then(function(p){
          var v=p.getViewport({scale:900/p.getViewport({scale:1}).width});
          var c=document.createElement('canvas');
          c.width=Math.round(v.width);c.height=Math.round(v.height);
          return p.render({canvasContext:c.getContext('2d'),viewport:v}).promise
            .then(function(){l.push(c);});
        });
      })(i);
      return pr.then(function(){return {pages:l,total:doc.numPages};});
    });
}
/* combien d'exercices numérotés dans le niveau 1 élève */
function compterExos(){
  var n=0, calculs=true;
  ((R.doc.niveaux['1']||{}).pages||[]).forEach(function(p){(p.el||[]).forEach(function(e){
    if(e.corrige)return;
    if(e.type==='dessin'&&e.ancres&&e.ancres.length){n+=e.ancres.length;calculs=false;}
    else if(e.num!=null){n++;if(e.type!=='calcul')calculs=false;}
  });});
  return {n:n,mot:calculs?'calculs':'exercices'};
}
/* titre et sous-titre proposés, tirés du titre de la ressource :
   « 140 calculs écrits sans report : additions à 1 chiffre - Maths (Primaire 1) »
   → « ADDITIONS À 1 CHIFFRE » + « écrits sans report » */
function textesMini(){
  var t=String(R.titre||'').replace(/\s*[-–]\s*[^-–]*\([^)]*\)\s*$/,'').trim(), s='';
  var i=t.indexOf(':');
  if(i>0){s=t.slice(0,i).trim().replace(/^\d+\s+\S+\s+/,'');t=t.slice(i+1).trim();}
  return {titre:t.toUpperCase(),sous:s};
}
/* la mise en page validée (oct. 2026) ; x, y = centre ; r en degrés.
   (Plus de bandeau de l'année d'office : on l'ajoute soi-même si on veut.) */
function miniDefaut(n){
  var tx=textesMini(), o=[];
  if(n>=4)o.push({t:'page',src:3,x:1050,y:330,w:470,r:9});
  if(n>=3)o.push({t:'page',src:2,x:905,y:520,w:470,r:-5});
  o.push({t:'titre',x:440,y:400,w:760,h:560,r:-2});
  if(n>=2)o.push({t:'page',src:1,x:300,y:1290,w:560,r:8});
  o.push({t:'page',src:0,x:790,y:1240,w:820,r:-3});
  o.push({t:'badge',x:975,y:1615,w:360,h:190,r:3});
  return {titre:tx.titre,sous:tx.sous,b1:'',b2:'',objets:o};
}
/* un bandeau (pastille pleine, texte espacé) */
function bandeauDefaut(){
  return {t:'bandeau',x:600,y:860,w:520,h:104,r:-2,txt:'NOUVEAU',fond:MINI_NUIT,couleur:'#ffffff'};
}
function miniTextesPastille(m,info){
  var t=info.total;
  return [m.b1||(t+' page'+(t>1?'s':'')),
    m.b2!=null&&m.b2!==''?m.b2:(info.exos.n?info.exos.n+' '+info.exos.mot:'')];
}

/* ---------- les polices de la miniature ----------
   « rond » = la police de base (celle des miniatures déjà faites) */
var POLICES_MINI={
  rond:[MINI_POLICE,'Arrondie (de base)'],
  titre:["'Baloo 2',"+MINI_POLICE,'Baloo 2'],
  texte:["'Nunito',"+MINI_POLICE,'Nunito'],
  ecole:["'Andika',"+MINI_POLICE,'Andika (scolaire)'],
  main:["'Caveat',cursive",'Caveat (manuscrite)'],
  classique:["Georgia,'Times New Roman',serif",'Classique'],
  impact:["'Arial Black','Helvetica Neue',Arial,sans-serif",'Bâton épais']
};
function famMini(o){return (POLICES_MINI[(o&&o.police)||'rond']||POLICES_MINI.rond)[0];}
function fonteMini(o,poids,taille){return poids+' '+taille+'px '+famMini(o);}
/* les polices utilisées doivent être chargées avant de dessiner */
function policesMiniPretes(m){
  if(!document.fonts||!document.fonts.load)return Promise.resolve();
  var l={};(m&&m.objets||[]).forEach(function(o){if(o.police&&o.police!=='rond')l[o.police]=1;});
  l.ecole=1;
  return Promise.all(Object.keys(l).map(function(k){
    var f=famMini({police:k});
    return Promise.all([document.fonts.load('900 40px '+f),document.fonts.load('700 40px '+f)]).catch(function(){});
  })).then(function(){},function(){});
}
/* le texte, avec son contour s'il en a un (épaisseur et couleur au choix) */
function texteMini(x,o,t,X,Y){
  var ep=+(o&&o.contourEp)||0;
  if(ep>0){
    var sh=x.shadowColor;
    x.lineJoin='round';x.miterLimit=2;x.lineWidth=ep*2;x.strokeStyle=o.contour||'#ffffff';
    x.strokeText(t,X,Y);x.shadowColor='transparent';x.fillText(t,X,Y);x.shadowColor=sh;return;
  }
  x.fillText(t,X,Y);
}

function dimObjet(o,imgs){
  if(o.t==='symbole')return {w:o.w,h:o.w};
  if(o.t==='outil'){var im=imageOutil(o);return {w:o.w,h:im?o.w*im.height/im.width:o.w*.6};}
  if(o.t!=='page')return {w:o.w,h:o.h||100};
  var im2=imgs[o.src];return im2?{w:o.w,h:o.w*im2.height/im2.width}:null;
}
/* une ligne de texte qui ne déborde jamais : la taille baisse s'il le faut */
function ajuster(x,t,taille,larg,o){
  x.font=fonteMini(o,900,taille);
  var w=x.measureText(t).width;
  if(w>larg){taille*=larg/w;x.font=fonteMini(o,900,taille);}
  return taille;
}
function cheminArrondi(x,w,h,r){arrondiRect(x,-w/2,-h/2,w,h,r);}
function dessinerCadre(x,o){
  var s=o.w/(o.t==='titre'?760:360), r=(o.t==='titre'?44:34)*s;
  if(o.fond==='none'){x.shadowColor='transparent';}
  else{
    cheminArrondi(x,o.w,o.h,r);
    if(o.fond)x.fillStyle=o.fond;
    else{var g=x.createLinearGradient(0,-o.h/2,0,o.h/2);
      g.addColorStop(0,'#ffffff');g.addColorStop(1,'#fff6ee');x.fillStyle=g;}
    x.fill();
  }
  x.shadowColor='transparent';
  if(o.bord!=='none'){
    cheminArrondi(x,o.w-10*s,o.h-10*s,r-5*s);
    x.strokeStyle=o.bord||MINI_NUIT;x.lineWidth=10*s;x.stroke();
  }
  return s;
}
/* le bandeau : une pastille pleine, texte espacé */
function dessinerBandeau(x,o){
  if(o.fond!=='none'){cheminArrondi(x,o.w,o.h,o.h/2);x.fillStyle=o.fond||MINI_NUIT;x.fill();}
  x.shadowColor='transparent';
  if(o.bord&&o.bord!=='none'){cheminArrondi(x,o.w-8,o.h-8,o.h/2-4);x.strokeStyle=o.bord;x.lineWidth=8;x.stroke();}
  var t=String(o.txt||'').toUpperCase(), taille=ajuster(x,t,o.h*.46,o.w-o.h*.9,o);
  x.textAlign='center';x.textBaseline='middle';x.fillStyle=o.couleur||'#ffffff';
  if('letterSpacing' in x)x.letterSpacing=Math.round(taille*.06)+'px';
  texteMini(x,o,t,0,taille*.04);
  if('letterSpacing' in x)x.letterSpacing='0px';
}
/* un texte libre, avec ou sans fond, avec ou sans contour ; sa hauteur suit le texte */
function dessinerTexteLibre(x,o){
  var taille=o.taille||64, pad=o.fond?taille*.45:0, larg=o.w-2*pad, lignes=[];
  x.font=fonteMini(o,o.gras===false?700:900,taille);
  String(o.txt||'').split('\n').forEach(function(l){
    var cur='';
    l.split(/\s+/).forEach(function(mot){var t=cur?cur+' '+mot:mot;
      if(x.measureText(t).width>larg&&cur){lignes.push(cur);cur=mot;}else cur=t;});
    lignes.push(cur);
  });
  var lh=taille*1.18;o.h=Math.round(lignes.length*lh+2*pad+2*(+o.contourEp||0));
  if(o.fond){cheminArrondi(x,o.w,o.h,Math.min(o.h/2,taille*.6));x.fillStyle=o.fond;x.fill();}
  x.shadowColor='transparent';
  x.textAlign='center';x.textBaseline='top';x.fillStyle=o.couleur||MINI_NUIT;
  var y=-o.h/2+pad+(+o.contourEp||0)+(lh-taille)/2;
  lignes.forEach(function(l){texteMini(x,o,l,0,y);y+=lh;});
}
function dessinerTitre(x,o,m,s){
  var larg=o.w-100*s, src=String(m.titre||'').split('\n').map(function(l){return l.trim();})
    .filter(Boolean), taille=112*s, lignes=[], lh=0, tot=0, sous=String(m.sous||'').trim();
  for(;taille>24*s;taille-=4*s){
    x.font=fonteMini(o,900,taille);
    lignes=[];
    src.forEach(function(l){
      var cur='';
      l.split(/\s+/).forEach(function(mot){
        var t=cur?cur+' '+mot:mot;
        if(x.measureText(t).width>larg&&cur){lignes.push(cur);cur=mot;}else cur=t;
      });
      if(cur)lignes.push(cur);
    });
    lh=taille*1.29;
    tot=lignes.length*lh+(sous?(36+64)*s:0);
    var large=lignes.some(function(l){return x.measureText(l).width>larg;});
    if(tot<=o.h-90*s&&!large)break;
  }
  x.textAlign='center';x.textBaseline='top';x.fillStyle=o.couleur||MINI_NUIT;
  var y=-tot/2;
  lignes.forEach(function(l){texteMini(x,o,l,0,y);y+=lh;});
  if(sous){
    ajuster(x,sous,Math.min(64*s,taille*.6),larg,o);
    x.fillStyle=o.couleur2||MINI_ORANGE;texteMini(x,o,sous,0,y+36*s-(lh-taille));
  }
}
function dessinerPastille(x,o,m,info,s){
  var t=miniTextesPastille(m,info), larg=o.w-44*s;
  x.textAlign='center';x.textBaseline='top';
  if(!t[1]){
    var a=ajuster(x,t[0],76*s,larg,o);x.fillStyle=o.couleur||MINI_NUIT;texteMini(x,o,t[0],0,-a*.62);return;}
  ajuster(x,t[0],76*s,larg,o);x.fillStyle=o.couleur||MINI_NUIT;texteMini(x,o,t[0],0,-o.h/2+14*s);
  ajuster(x,t[1],52*s,larg,o);x.fillStyle=o.couleur2||MINI_ORANGE;texteMini(x,o,t[1],0,-o.h/2+108*s);
}
/* un symbole (+, −, ×, ?, ★…), seul ou dans une forme pleine */
var SYMBOLES_MINI=['+','−','×','÷','=','<','>','≠','?','!','✓','✗','★','♥','½','%','€','→','123','ABC','a','é'];
function dessinerSymbole(x,o){
  var w=o.w, rond=o.forme!=='carre';
  if(o.fond){
    if(rond){x.beginPath();x.arc(0,0,w/2,0,Math.PI*2);}else cheminArrondi(x,w,w,w*.22);
    x.fillStyle=o.fond;x.fill();
  }
  x.shadowColor='transparent';
  if(o.bord&&o.bord!=='none'&&o.fond){
    var e=w*.05;if(rond){x.beginPath();x.arc(0,0,w/2-e/2,0,Math.PI*2);}else cheminArrondi(x,w-e,w-e,w*.2);
    x.strokeStyle=o.bord;x.lineWidth=e;x.stroke();
  }
  var t=String(o.s||'+'), taille=(o.fond?.62:.9)*w*(t.length>1?1/Math.max(1,t.length*.62):1);
  x.font=fonteMini(o,900,taille);x.textAlign='center';x.textBaseline='middle';
  x.fillStyle=o.couleur||(o.fond?'#ffffff':MINI_NUIT);
  texteMini(x,o,t,0,taille*.05);
}

/* ---------- les éléments du Cartable, en exemple sur la miniature ----------
   L'objet garde l'outil, ses réglages et sa graine : il se redessine à
   l'identique à chaque export (version Élève, sans les réponses). */
var MINI_CALCULS=[['+','Addition posée'],['-','Soustraction posée'],['x','Multiplication posée'],[':','Division posée']];
function outilsMini(){
  /* seulement ceux qui ont un exemple à montrer */
  var l=[];for(var id in OUTILS){var t=OUTILS[id];if(t.faire&&imageOutil({outil:id,graine:1}))l.push([id,t.ico||'•',t.nom]);}return l;
}
function elementsOutil(o){
  HASARD=graine(o.graine||1);
  try{
    if(o.outil==='calcul'){
      var op=o.op||'+', c=tirerCalcul(op,op===':'?3:3,op==='x'||op===':'?1:3,'mix')||{a:345,b:127};
      return [{type:'calcul',x:0,y:0,w:60,h:60,op:op,a:c.a,b:c.b,cases:op!==':',quad:true}];
    }
    var t=OUTILS[o.outil];if(!t||!t.faire)return [];
    var opts=clone(o.opts||{});
    (t.opts||[]).forEach(function(op){if(opts[op.id]==null)opts[op.id]=op.def;
      /* un seul exemple suffit sur une miniature */
      if(op.id==='n'&&o.opts==null&&op.choix)opts.n=String((op.choix[0]&&op.choix[0][0])||op.choix[0]);});
    opts.num=false;
    return t.faire(opts)||[];
  }catch(e){return [];}
  finally{HASARD=Math.random;}
}
var _imgOutil={};
function imageOutil(o){
  var cle=JSON.stringify([o.outil,o.op,o.opts,o.graine]);
  if(_imgOutil[cle]!==undefined)return _imgOutil[cle];
  var els=elementsOutil(o), k=12, x1=Infinity,y1=Infinity,x2=-Infinity,y2=-Infinity;
  els=els.filter(function(e){return /^(dessin|calcul|tableau|texte|consigne|lignes)$/.test(e.type);});
  /* des lignes d'écriture : un bout suffit en exemple */
  els.forEach(function(e){if(e.type==='lignes'){e.w=Math.min(e.w,110);e.nb=Math.min(e.nb||3,3);e.h=hauteurBloc(e);}});
  els.forEach(function(e){
    if(e.type==='calcul'){var L=layoutCalcul(e);e.w=L.cols*7.5;e.h=L.rows*7.5;}
    x1=Math.min(x1,e.x||0);y1=Math.min(y1,e.y||0);x2=Math.max(x2,(e.x||0)+e.w);y2=Math.max(y2,(e.y||0)+e.h);});
  if(!els.length){_imgOutil[cle]=null;return null;}
  var pad=6, c=document.createElement('canvas');
  c.width=Math.ceil((x2-x1+2*pad)*k);c.height=Math.ceil((y2-y1+2*pad)*k);
  var x=c.getContext('2d');x.scale(k,k);x.translate(pad-x1,pad-y1);
  els.forEach(function(e){x.save();x.translate(e.x||0,e.y||0);
    try{dessinerElMini(x,e);}catch(err){}x.restore();});
  _imgOutil[cle]=c;return c;
}
var FAM_ECOLE="'Andika','Nunito',sans-serif";
function dessinerElMini(x,e){
  x.lineCap='round';x.lineJoin='round';
  if(e.type==='dessin'){
    var s=Math.min(e.w/e.W0,e.h/e.H0), ox=e.centre?(e.w-e.W0*s)/2:0, oy=e.centre?(e.h-e.H0*s)/2:0;
    x.translate(ox,oy);x.scale(s,s);
    (e.prims||[]).forEach(function(p){
      if(p.v==='prof')return;
      x.setLineDash(p.d||[]);
      function peindre(){if(p.f&&p.f!=='none'){x.fillStyle=p.f;x.fill();}
        if(p.c&&p.c!=='none'&&p.ep){x.strokeStyle=p.c;x.lineWidth=p.ep;x.stroke();}}
      if(p.t==='l'){x.beginPath();x.moveTo(p.x1,p.y1);x.lineTo(p.x2,p.y2);x.strokeStyle=p.c||'#14142b';x.lineWidth=p.ep||.4;x.stroke();}
      else if(p.t==='r'){x.beginPath();if(p.rx)arrondiRect(x,p.x,p.y,p.w,p.h,p.rx);else x.rect(p.x,p.y,p.w,p.h);peindre();}
      else if(p.t==='o'){x.beginPath();x.ellipse(p.cx,p.cy,p.r,p.ry||p.r,0,0,Math.PI*2);peindre();}
      else if(p.t==='p'){x.beginPath();(p.pts||[]).forEach(function(q,i){if(i)x.lineTo(q[0],q[1]);else x.moveTo(q[0],q[1]);});
        if(p.z)x.closePath();peindre();}
      else if(p.t==='x'){x.font=(p.g?'800 ':'500 ')+p.z+'px '+FAM_ECOLE;x.fillStyle=p.c||'#14142b';
        x.textAlign={m:'center',s:'left',e:'right'}[p.a]||'center';x.textBaseline='alphabetic';x.fillText(p.s,p.x,p.y);}
      x.setLineDash([]);
    });
  }else if(e.type==='lignes'){
    /* comme dans le PDF : maison / couleurs / 4 lignes / Seyès / simples / pointillés */
    var n=Math.max(1,e.nb||3), g=e.lignage||'simple', hl=e.hl||HL[g]||10, ec=e.ecart==null?1.5:e.ecart, w=e.w;
    function tr(y,col,ep,d){x.beginPath();x.setLineDash(d||[]);x.moveTo(0,y);x.lineTo(w,y);x.strokeStyle=col;x.lineWidth=ep;x.stroke();x.setLineDash([]);}
    for(var i=0;i<n;i++){
      var y=i*(hl+ec);
      if(g==='maison'||g==='couleurs'||g==='quatre'){
        x.save();x.beginPath();arrondiRect(x,0,y,w,hl,1.2);x.clip();
        if(g!=='quatre'){x.fillStyle='#cfe6fb';x.fillRect(0,y,w,hl/3);x.fillStyle='#fdf8cf';x.fillRect(0,y+hl/3,w,hl/3);
          x.fillStyle='#e6e0d2';x.fillRect(0,y+hl*2/3,w,hl/3);}
        tr(y+.25,g==='quatre'?'#9fc0e6':'#5b8fd0',.5);tr(y+hl/3+.25,'#f2b705',.5,[1.5,1.5]);
        tr(y+hl*2/3+.25,'#2f9e5e',.5);tr(y+hl-.25,'#8a6436',.5);
        if(g==='maison')decorMini(x,y,hl);
        x.restore();
      }else{
        var yb=y+hl;
        if(g==='seyes')[.25,.5,.75].forEach(function(k){tr(y+(hl-.35)*k+.11,'#d2e4f5',.22);});
        if(g==='pointille')tr(yb-.225,'#b9b0c4',.45,[.01,.9]);
        else tr(yb-.175,g==='seyes'?'#2f80c8':'#c3bccd',.35);
      }
    }
  }else if(e.type==='calcul'){
    var L=layoutCalcul(e), c=7.5;
    L.fonds.forEach(function(f){x.fillStyle=f.col;x.fillRect(f.c*c,f.r0*c,c,(f.r1-f.r0)*c);});
    if(e.quad!==false){x.strokeStyle='#c9d3e6';x.lineWidth=.2;
      for(var i=0;i<=L.cols;i++){x.beginPath();x.moveTo(i*c,0);x.lineTo(i*c,L.rows*c);x.stroke();}
      for(var j=0;j<=L.rows;j++){x.beginPath();x.moveTo(0,j*c);x.lineTo(L.cols*c,j*c);x.stroke();}}
    L.cases.forEach(function(k){var s2=c*.56;x.beginPath();arrondiRect(x,k[0]*c+(c-s2)/2,k[1]*c+(c-s2)/2,s2,s2,s2*.18);
      x.strokeStyle='#8b8299';x.lineWidth=.3;x.stroke();});
    L.lignes.forEach(function(l){x.beginPath();x.moveTo(l[0]*c,l[1]*c);x.lineTo(l[2]*c,l[3]*c);x.strokeStyle='#14142b';x.lineWidth=.5;x.stroke();});
    x.textAlign='center';x.textBaseline='middle';
    L.cells.forEach(function(k){if(/rep|ret/.test(k.k))return;
      var pt=k.k==='num'?c*.5:k.k==='lab'?c*.4:c*.64;
      x.font=(k.k==='num'||k.k==='lab'?'800 ':'600 ')+pt+'px '+FAM_ECOLE;x.fillStyle=k.k==='lab'?k.col:'#14142b';
      x.fillText(k.t,k.c*c+c/2,k.r*c+c/2+pt*.05);});
  }else if(e.type==='tableau'){
    var cw=e.w/e.cols, rh=e.h/e.rows, pris={};
    (e.fusions||[]).forEach(function(f){for(var a=f.y;a<f.y+f.ly;a++)for(var b=f.x;b<f.x+f.lx;b++)pris[a+'-'+b]=f;});
    x.strokeStyle='#14142b';x.lineWidth=.3;x.textAlign='center';x.textBaseline='middle';
    for(var r=0;r<e.rows;r++)for(var cc=0;cc<e.cols;cc++){
      var f=pris[r+'-'+cc];if(f&&(f.y!==r||f.x!==cc))continue;
      var w=(f?f.lx:1)*cw, h=(f?f.ly:1)*rh;
      if(e.tete&&r===0){x.fillStyle='#f6f1ea';x.fillRect(cc*cw,r*rh,w,h);}
      x.strokeRect(cc*cw,r*rh,w,h);
      var t=((e.cellules||[])[r]||[])[cc];
      if(t){x.font=(e.tete&&r<2?'800 ':'500 ')+Math.min(rh*.5,(e.taille||12)*PT)+'px '+FAM_ECOLE;x.fillStyle='#14142b';
        x.fillText(String(t),cc*cw+w/2,r*rh+h/2);}
    }
  }else{
    /* texte : les passages « Prof » sont retirés, les trous restent soulignés */
    var runs=e.riche&&e.riche.length?e.riche:[{t:e.texte||''}], taille=(e.taille||11)*PT, lh=taille*(e.interligne||1.4);
    var X=0,Y=taille;
    x.textBaseline='alphabetic';x.textAlign='left';
    runs.forEach(function(rn){
      if(rn.v==='prof')return;
      String(rn.t).split('\n').forEach(function(part,i){
        if(i){X=0;Y+=lh;}
        if(!part)return;
        x.font=(rn.g||e.gras?'800 ':'500 ')+(rn.z?rn.z*PT:taille)+'px '+FAM_ECOLE;x.fillStyle=rn.c||e.couleur||'#14142b';
        var w=x.measureText(part).width;
        if(rn.u){x.beginPath();x.moveTo(X,Y+1);x.lineTo(X+w,Y+1);x.strokeStyle='#8b8299';x.lineWidth=.3;x.stroke();}
        else x.fillText(part,X,Y);
        X+=w;
      });
    });
  }
}
/* le petit décor des lignes maison (même dessin que dans le PDF) */
function decorMini(x,y0,hl){
  x.save();x.translate(0,y0);x.scale(hl/100,hl/100);x.lineCap='round';x.lineJoin='round';
  function P(d,f,c,ep){var p=new Path2D(d);if(f){x.fillStyle=f;x.fill(p);}if(c){x.strokeStyle=c;x.lineWidth=ep;x.stroke(p);}}
  function O(cx,cy,r,f,c,ep){P('M'+(cx+r)+' '+cy+' A'+r+' '+r+' 0 1 0 '+(cx-r)+' '+cy+' A'+r+' '+r+' 0 1 0 '+(cx+r)+' '+cy+' Z',f,c,ep);}
  [[14,1,14,5],[4,11,.5,11],[6.5,4,4,1.6],[21.5,4,24,1.6],[6.5,18,4,20.4]].forEach(function(l){
    P('M'+l[0]+' '+l[1]+' L'+l[2]+' '+l[3],null,'#f2b705',1.7);});
  O(14,11,6,'#ffd93d','#f2b705',1.2);
  P('M30 16.5 h5 v10 h-5 Z','#9ec4ea','#5b8fd0',1.1);
  P('M20 29 L42 11 L64 29 Z','#9ec4ea','#5b8fd0',1.4);
  P('M26 29 h32 v41 h-32 Z','#ffe84d','#f2b705',1.4);
  P('M36 46 h13 v24 h-13 Z',null,'#f2b705',1.2);
  P('M12 46 L12 70',null,'#2f9e5e',1.3);
  [[12,42,3.4],[7.6,45,3.2],[16.4,45,3.2],[9.4,50,3.2],[14.6,50,3.2]].forEach(function(c){O(c[0],c[1],c[2],'#ff6b8a');});
  O(12,46,2.6,'#ffd93d');
  ['M4 70 C 4 65, 6 63, 7 61','M9 70 C 9 66, 11 64, 13 62','M20 70 C 20 66, 22 64, 23 62',
   'M62 70 C 62 66, 64 64, 66 62','M68 70 C 68 65, 70 63, 71 61'].forEach(function(d){P(d,null,'#2f9e5e',1.2);});
  P('M26 70 L26 92 L58 92 L58 70 Z','#c89b63','#8a6436',1.2);
  P('M34 78 L42 78 L42 85 L50 85',null,'#8a6436',1.2);
  P('M5 86 C 8 82, 12 82, 14 86 C 16 90, 12 92, 9 90',null,'#e58fa8',2);
  O(5.6,86.4,1,'#14142b');
  x.restore();
}
/* en mode démo seulement : de quoi vérifier les exemples à la main */
if(/[?&]demo=1/.test(location.search))window.__laeMini={imageOutil:function(o){return imageOutil(o);}};
function dessinerOutil(x,o){
  var im=imageOutil(o), d=dimObjet(o,[]);
  if(o.fond!=='none'){
    var p=o.w*.05;cheminArrondi(x,d.w+2*p,d.h+2*p,o.w*.05);x.fillStyle=o.fond||'#ffffff';x.fill();
  }
  x.shadowColor='transparent';
  if(im)x.drawImage(im,-d.w/2,-d.h/2,d.w,d.h);
}

/* dessine toute la miniature ; sel = l'objet entouré dans l'éditeur */
function dessinerMini(cv,m,imgs,info,sel){
  var x=cv.getContext('2d'), k=cv.width/MW;
  x.setTransform(k,0,0,k,0,0);
  var g=x.createLinearGradient(0,0,0,MH);
  g.addColorStop(0,m.fond1||'rgb(255,150,70)');g.addColorStop(1,m.fond2||m.fond1||'rgb(255,90,60)');
  x.fillStyle=g;x.fillRect(0,0,MW,MH);
  m.objets.forEach(function(o,i){
    var d=dimObjet(o,imgs);if(!d)return;
    x.save();x.translate(o.x,o.y);x.rotate(o.r*Math.PI/180);
    /* l'ombre ne suit pas l'échelle du canevas : on la met à l'échelle à la main */
    x.shadowColor='rgba(60,20,0,.43)';x.shadowBlur=32*k;x.shadowOffsetX=6*k;x.shadowOffsetY=14*k;
    if(o.t==='page'){
      x.fillStyle='#fff';x.fillRect(-d.w/2,-d.h/2,d.w,d.h);
      x.shadowColor='transparent';x.drawImage(imgs[o.src],-d.w/2,-d.h/2,d.w,d.h);
    }else if(o.t==='bandeau')dessinerBandeau(x,o);
    else if(o.t==='texte'){if(!o.fond)x.shadowColor='transparent';dessinerTexteLibre(x,o);}
    else if(o.t==='symbole'){if(!o.fond)x.shadowColor='transparent';dessinerSymbole(x,o);}
    else if(o.t==='outil')dessinerOutil(x,o);
    else{
      var s=dessinerCadre(x,o);
      if(o.t==='titre')dessinerTitre(x,o,m,s);else dessinerPastille(x,o,m,info,s);
    }
    if(sel===i){
      d=dimObjet(o,imgs);
      x.shadowColor='transparent';x.strokeStyle='#2f80ff';x.lineWidth=6;x.setLineDash([18,12]);
      x.strokeRect(-d.w/2-10,-d.h/2-10,d.w+20,d.h+20);x.setLineDash([]);
    }
    x.restore();
  });
}
function rendreMini(m,imgs,info,larg){
  var c=document.createElement('canvas');c.width=larg;c.height=Math.round(larg*MH/MW);
  dessinerMini(c,m,imgs,info,-1);return c;
}
/* la mise en page enregistrée, débarrassée des pages qui n'existent plus.
   Rien n'est ajouté d'office : une miniature déjà faite reste telle quelle. */
function miniDe(imgs){
  var m=R.doc.mini&&R.doc.mini.objets?clone(R.doc.mini):miniDefaut(imgs.length);
  m.objets=m.objets.filter(function(o){return o.t!=='page'||imgs[o.src];});
  if(m.titre==null){var tx=textesMini();m.titre=tx.titre;m.sous=tx.sous;}
  return m;
}
/* R.cover (aperçu + image Shopify) : 900 × 1350 en JPEG */
function garderCover(m,imgs,info){
  R.cover=rendreMini(m,imgs,info,900).toDataURL('image/jpeg',.86);
}

/* ---------- l'éditeur ----------
   À gauche, la miniature reste en place ; à droite, une barre d'outils
   (chaque bouton ouvre son menu) et les réglages de l'élément choisi,
   rangés en volets qui s'ouvrent un à la fois. */
var ICO_MINI={
  page:'<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8.5 8h7M8.5 11.5h7M8.5 15h4"/>',
  texte:'<path d="M5 6V4.5h14V6M12 4.5v15M9 19.5h6"/>',
  symbole:'<path d="M7 4v6M4 7h6M14.5 7h6M4.5 15.5l5 5M9.5 15.5l-5 5M17.5 14v.01M17.5 21v.01M14.5 17.5h6"/>',
  outil:'<rect x="3.5" y="3.5" width="17" height="17" rx="3"/><path d="M3.5 12h17M12 3.5v17"/>',
  fond:'<path d="M12 3.5c3.5 4.2 6 7.3 6 10.2a6 6 0 0 1-12 0c0-2.9 2.5-6 6-10.2z"/>',
  base:'<path d="M4 12a8 8 0 1 0 2.4-5.7L4 8.7"/><path d="M4 4v4.7h4.7"/>',
  devant:'<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M4 16V5a1 1 0 0 1 1-1h11"/>',
  derriere:'<rect x="4" y="4" width="12" height="12" rx="2"/><path d="M20 8v11a1 1 0 0 1-1 1H8"/>',
  monte:'<path d="M12 19V5M6 11l6-6 6 6"/>',descend:'<path d="M12 5v14M6 13l6 6 6-6"/>',
  poubelle:'<path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13"/>',de:'<rect x="4" y="4" width="16" height="16" rx="4"/><path d="M9 9h.01M15 9h.01M12 12h.01M9 15h.01M15 15h.01"/>'
};
function icoMini(n){return '<svg viewBox="0 0 24 24" class="mini-ic">'+ICO_MINI[n]+'</svg>';}
function editeurMiniature(){
  var v=fenetre('<h3>La miniature</h3><p class="sous">Préparation des pages du niveau 1…</p>');
  var boite=v.querySelector('.boite');boite.classList.add('boite-mini');
  var m, imgs, info, sel=-1, cv, glisse=null, volet='texte', menu=null;
  pdfNiveau1().then(pagesDuPdf).then(function(r){
    imgs=r.pages;info={total:r.total,exos:compterExos()};
    m=miniDe(imgs);return policesMiniPretes(m);
  }).then(function(){if(m)monter();}).catch(function(e){
    boite.innerHTML='<h3>La miniature</h3><p class="sous">'+esc(e.message||e)+'</p>'
      +'<div class="fin"><button class="b" data-x>Fermer</button></div>';
  });

  function nomObjet(o){
    return o.t==='titre'?'Cadre du titre':o.t==='badge'?'Pastille':o.t==='bandeau'?'Bandeau'
      :o.t==='texte'?'Texte':o.t==='symbole'?'Symbole « '+o.s+' »'
      :o.t==='outil'?(o.outil==='calcul'?'Calcul posé':((OUTILS[o.outil]||{}).nom||'Élément')):'Page '+(o.src+1)+' du PDF';}
  /* une couleur : le sélecteur du système + les teintes du site */
  function couleurs(prop,val,vide){
    return '<div class="mini-coul"><input type="color" data-c="'+prop+'" value="'+(/^#[0-9a-f]{6}$/i.test(val||'')?val:'#ffffff')+'">'
      +['#ffffff','#1f2a5a','#fa5a3c','#f0265c','#ffd93d','#2f9e5e','#2f80c8','#6e5fd8','#14142b'].map(function(c){
        return '<button data-cv="'+prop+'|'+c+'" style="background:'+c+'"'+(val===c?' class="on"':'')+'></button>';}).join('')
      +(vide?'<button data-cv="'+prop+'|" class="sans'+(!val||val==='none'?' on':'')+'" title="'+vide+'">∅</button>':'')
      +'</div>';
  }
  function bloc(id,titre,corps){
    return '<details class="mini-volet" data-volet="'+id+'"'+(volet===id?' open':'')+'><summary>'+titre+'</summary>'
      +'<div class="mini-volet-in">'+corps+'</div></details>';
  }
  var aTexte={titre:1,badge:1,bandeau:1,texte:1,symbole:1};
  function panneauSel(){
    var o=m.objets[sel];
    if(!o)return '<p class="aide mini-vide">Cliquez un élément sur la miniature pour le régler, '
      +'glissez-le pour le déplacer. La barre du haut ajoute des pages, des textes, des symboles et des éléments.</p>';
    var max=o.t==='page'?1400:o.t==='titre'?1150:o.t==='symbole'?600:o.t==='outil'?1100:700,
        min=o.t==='page'?150:o.t==='titre'?360:o.t==='symbole'?60:180, h='';
    h+='<div class="mini-tete"><b>'+esc(nomObjet(o))+'</b>'
      +(o.t!=='titre'?'<button class="mini-ib" data-act="suppr" title="Retirer">'+icoMini('poubelle')+'</button>':'')+'</div>';
    /* le contenu */
    var c='';
    if(o.t==='page')c+='<label>Page du PDF<select data-o="src">'+imgs.map(function(_,i){
        return '<option value="'+i+'"'+(i===o.src?' selected':'')+'>Page '+(i+1)+'</option>';}).join('')+'</select></label>';
    if(o.t==='bandeau')c+='<label>Texte<input data-o="txt" value="'+esc(o.txt||'')+'"></label>';
    if(o.t==='texte')c+='<label>Texte<textarea data-o="txt" rows="2">'+esc(o.txt||'')+'</textarea></label>'
        +'<label>Taille des lettres<input type="range" data-o="taille" min="28" max="200" value="'+(o.taille||64)+'"></label>'
        +'<label class="coche"><input type="checkbox" data-o="gras"'+(o.gras===false?'':' checked')+'> Gras</label>';
    if(o.t==='symbole')c+='<div class="mini-grille">'+SYMBOLES_MINI.map(function(sy){
        return '<button data-sym="'+esc(sy)+'" class="'+(sy===o.s?'on':'')+'">'+esc(sy)+'</button>';}).join('')+'</div>'
      +'<div class="mini-seg"><button data-forme="rond" class="'+(o.forme!=='carre'?'on':'')+'">● Rond</button>'
      +'<button data-forme="carre" class="'+(o.forme==='carre'?'on':'')+'">■ Carré</button></div>';
    if(o.t==='outil')c+='<button class="b sm" data-act="de">'+icoMini('de')+' Autres nombres</button>';
    if(o.t==='titre')c+='<p class="aide" style="margin:0">Le texte du titre se change dans « Textes de la miniature ».</p>';
    if(aTexte[o.t])c+='<label>Police<select data-o="police">'+Object.keys(POLICES_MINI).map(function(k){
        return '<option value="'+k+'"'+((o.police||'rond')===k?' selected':'')+' style="font-family:'+POLICES_MINI[k][0].replace(/"/g,"'")+'">'
          +POLICES_MINI[k][1]+'</option>';}).join('')+'</select></label>';
    if(c)h+=bloc('texte',o.t==='page'||o.t==='outil'?'Contenu':'Texte',c);
    /* le style : boîte derrière et/ou contour autour du texte */
    if(o.t!=='page'){
      var st='';
      if(aTexte[o.t]){
        var mode=o.fond&&o.fond!=='none'?'boite':(+o.contourEp>0?'contour':'aucun');
        if(o.t==='titre'||o.t==='badge'||o.t==='bandeau')mode=o.fond==='none'?(+o.contourEp>0?'contour':'aucun'):'boite';
        st+='<div class="mini-seg"><button data-style="aucun" class="'+(mode==='aucun'?'on':'')+'">Aa Sans fond</button>'
          +'<button data-style="boite" class="'+(mode==='boite'?'on':'')+'">▣ Boîte</button>'
          +'<button data-style="contour" class="'+(mode==='contour'?'on':'')+'">◌ Contour</button></div>';
      }
      if(o.t==='outil'||mode==='boite'||!aTexte[o.t]){
        st+='<label>'+(o.t==='outil'?'Feuille derrière':'Couleur de la boîte')+'</label>'
          +couleurs('fond',o.fond&&o.fond!=='none'?o.fond:(o.t==='bandeau'?MINI_NUIT:o.t==='outil'&&o.fond!=='none'?'#ffffff':''),o.t==='outil'?'Sans feuille':'');
        if(o.t==='titre'||o.t==='badge'||o.t==='bandeau'||o.t==='symbole')
          st+='<label>Bord de la boîte</label>'+couleurs('bord',o.bord||(o.t==='titre'||o.t==='badge'?MINI_NUIT:''),'Sans bord');
      }
      if(aTexte[o.t])st+='<label>Contour du texte <small>'+(+o.contourEp||0)+' px</small>'
          +'<input type="range" data-o="contourEp" min="0" max="30" value="'+(+o.contourEp||0)+'"></label>'
          +(+o.contourEp>0?couleurs('contour',o.contour||'#ffffff'):'');
      if(aTexte[o.t])st+='<label>'+(o.t==='titre'?'Couleur du titre':o.t==='badge'?'Couleur ligne 1':'Couleur du texte')+'</label>'
          +couleurs('couleur',o.couleur||(o.t==='bandeau'||(o.t==='symbole'&&o.fond)?'#ffffff':MINI_NUIT))
          +(o.t==='titre'||o.t==='badge'?'<label>'+(o.t==='titre'?'Couleur du sous-titre':'Couleur ligne 2')+'</label>'
            +couleurs('couleur2',o.couleur2||MINI_ORANGE):'');
      h+=bloc('style','Style et couleurs',st);
    }
    /* la place */
    h+=bloc('place','Taille, rotation, ordre',
      '<label>Taille<input type="range" data-o="w" min="'+min+'" max="'+max+'" value="'+Math.round(o.w)+'"></label>'
      +'<label>Rotation <small>'+o.r+'°</small><input type="range" data-o="r" min="-30" max="30" step="0.5" value="'+o.r+'"></label>'
      +'<div class="mini-ordre">'
      +'<button class="mini-ib" data-act="devant" title="Tout devant">'+icoMini('devant')+'</button>'
      +'<button class="mini-ib" data-act="avant" title="Avancer">'+icoMini('monte')+'</button>'
      +'<button class="mini-ib" data-act="arriere" title="Reculer">'+icoMini('descend')+'</button>'
      +'<button class="mini-ib" data-act="derriere" title="Tout derrière">'+icoMini('derriere')+'</button></div>');
    return h;
  }
  function menuHtml(n){
    if(n==='page')return '<p class="mini-pop-t">Ajouter une page</p><div class="mini-pages">'+imgs.map(function(c,i){
        return '<button data-addpage="'+i+'"><img src="'+c.toDataURL('image/jpeg',.6)+'" alt=""><span>'+(i+1)+'</span></button>';}).join('')+'</div>';
    if(n==='texte')return '<p class="mini-pop-t">Ajouter un texte</p><div class="mini-liste">'
      +'<button data-addtexte="simple"><b style="font-weight:900">Aa</b> Texte simple</button>'
      +'<button data-addtexte="boite"><b class="mini-ex-boite">Aa</b> Texte dans une boîte</button>'
      +'<button data-addtexte="contour"><b class="mini-ex-contour">Aa</b> Texte avec contour</button>'
      +'<button data-addtexte="bandeau"><b class="mini-ex-bandeau">AA</b> Bandeau</button></div>';
    if(n==='symbole')return '<p class="mini-pop-t">Ajouter un symbole</p><div class="mini-grille">'
      +SYMBOLES_MINI.map(function(sy){return '<button data-addsym="'+esc(sy)+'">'+esc(sy)+'</button>';}).join('')+'</div>';
    if(n==='outil')return '<p class="mini-pop-t">Ajouter un élément en exemple</p><div class="mini-liste mini-liste-2">'
      +MINI_CALCULS.map(function(c){return '<button data-addcalc="'+c[0]+'"><b>'+SIGNES[c[0]]+'</b> '+c[1]+'</button>';}).join('')
      +outilsMini().map(function(t){return '<button data-addoutil="'+t[0]+'"><b>'+t[1]+'</b> '+esc(t[2])+'</button>';}).join('')+'</div>';
    if(n==='fond')return '<p class="mini-pop-t">Fond de la miniature</p><div class="mini-fond">'
      +'<label>Haut<input type="color" data-fond="fond1" value="'+(m.fond1||'#ff9646')+'"></label>'
      +'<label>Bas<input type="color" data-fond="fond2" value="'+(m.fond2||'#ff5a3c')+'"></label></div>'
      +'<div class="mini-grille">'+[['#ff9646','#ff5a3c'],['#7fc8f8','#2f80c8'],['#a8e6b8','#2f9e5e'],['#d6c8ff','#6e5fd8'],
        ['#ffd1e1','#f0265c'],['#fff1b8','#ffb72b'],['#2a3570','#14142b'],['#fff8f2','#ffe2c9']].map(function(p){
        return '<button data-fondp="'+p[0]+'|'+p[1]+'" style="background:linear-gradient('+p[0]+','+p[1]+')"></button>';}).join('')+'</div>'
      +'<button class="b sm" data-act="fondbase">Orange Laé</button>';
    return '';
  }
  function monter(){
    var p=miniTextesPastille({b1:'',b2:''},info);
    boite.innerHTML='<h3>La miniature</h3>'
      +'<p class="sous">Elle part dans le .zip et sur la fiche Shopify. Les pages sont celles '
      +'du niveau 1 élève ; elles se mettent à jour toutes seules à chaque export.</p>'
      +'<div class="mini-ed"><div class="mini-toile"><canvas width="600" height="900"></canvas></div>'
      +'<div class="mini-cote">'
      +'<div class="mini-barre">'
        +[['page','Page'],['texte','Texte'],['symbole','Symbole'],['outil','Élément'],['fond','Fond']].map(function(b){
          return '<button data-menu="'+b[0]+'" class="'+(menu===b[0]?'on':'')+'" title="'+b[1]+'">'+icoMini(b[0])+'<span>'+b[1]+'</span></button>';}).join('')
        +'<button data-act="reset" title="Revenir à la mise en page de base">'+icoMini('base')+'<span>De base</span></button>'
      +'</div>'
      +'<div class="mini-pop"'+(menu?'':' hidden')+'>'+(menu?menuHtml(menu):'')+'</div>'
      +'<div class="mini-defile">'
      +'<details class="mini-volet mini-textes"'+(sel<0?' open':'')+'><summary>Textes de la miniature</summary><div class="mini-volet-in">'
      +'<label>Titre <small>(Entrée = nouvelle ligne)</small><textarea data-m="titre" rows="3">'+esc(m.titre)+'</textarea></label>'
      +'<label>Sous-titre<input data-m="sous" value="'+esc(m.sous)+'"></label>'
      +'<label>Pastille, ligne 1<input data-m="b1" value="'+esc(m.b1)+'" placeholder="'+esc(p[0])+'"></label>'
      +'<label>Pastille, ligne 2<input data-m="b2" value="'+esc(m.b2)+'" placeholder="'+esc(p[1]||'(vide)')+'"></label>'
      +'</div></details>'
      +'<div class="mini-sel" id="miniSel">'+panneauSel()+'</div>'
      +'</div></div></div>'
      +'<div class="fin"><button class="b" data-x>Annuler</button>'
      +'<button class="b p" data-act="ok">Enregistrer la miniature</button></div>';
    cv=boite.querySelector('canvas');
    redessiner();
    cv.addEventListener('pointerdown',appui);
    cv.addEventListener('pointermove',bouge);
    cv.addEventListener('pointerup',lache);cv.addEventListener('pointercancel',lache);
  }
  function redessiner(){dessinerMini(cv,m,imgs,info,sel);}
  function majSel(){boite.querySelector('#miniSel').innerHTML=panneauSel();}
  function ouvrirMenu(n){
    menu=menu===n?null:n;
    var pop=boite.querySelector('.mini-pop');pop.hidden=!menu;pop.innerHTML=menu?menuHtml(menu):'';
    $$('[data-menu]',boite).forEach(function(b){b.classList.toggle('on',b.dataset.menu===menu);});
  }
  function ajouter(o){
    /* chaque ajout se pose un peu à côté du précédent, jamais pile dessus */
    var n=m.objets.filter(function(x){return x.t!=='page'&&x.t!=='titre'&&x.t!=='badge';}).length%6;
    o.x=Math.round(360+(n%3)*240);o.y=Math.round(760+Math.floor(n/3)*300);
    m.objets.push(o);sel=m.objets.length-1;volet=o.t==='outil'?'place':'texte';menu=null;
    var ext=boite.querySelector('.mini-textes');if(ext)ext.open=false;
    var pop=boite.querySelector('.mini-pop');pop.hidden=true;
    $$('[data-menu]',boite).forEach(function(b){b.classList.remove('on');});
    majSel();redessiner();
  }
  function point(ev){
    var b=cv.getBoundingClientRect();
    return {x:(ev.clientX-b.left)*MW/b.width,y:(ev.clientY-b.top)*MH/b.height};
  }
  function touche(p){
    for(var i=m.objets.length-1;i>=0;i--){
      var o=m.objets[i], d=dimObjet(o,imgs);if(!d)continue;
      var a=-o.r*Math.PI/180, dx=p.x-o.x, dy=p.y-o.y;
      var lx=dx*Math.cos(a)-dy*Math.sin(a), ly=dx*Math.sin(a)+dy*Math.cos(a);
      if(Math.abs(lx)<=d.w/2&&Math.abs(ly)<=d.h/2)return i;
    }
    return -1;
  }
  function appui(ev){
    var p=point(ev), avant=sel;sel=touche(p);
    if(sel!==avant){var ext=boite.querySelector('.mini-textes');if(ext&&sel>=0)ext.open=false;majSel();}
    redessiner();
    if(sel<0)return;
    var o=m.objets[sel];glisse={dx:p.x-o.x,dy:p.y-o.y};
    cv.setPointerCapture(ev.pointerId);cv.style.cursor='grabbing';
  }
  function bouge(ev){
    if(!glisse||sel<0)return;
    var p=point(ev), o=m.objets[sel];
    o.x=Math.round(p.x-glisse.dx);o.y=Math.round(p.y-glisse.dy);redessiner();
  }
  function lache(){glisse=null;cv.style.cursor='';}

  /* un seul volet ouvert à la fois : le panneau ne s'allonge jamais à l'infini */
  boite.addEventListener('toggle',function(ev){
    var d=ev.target;if(!d.classList||!d.classList.contains('mini-volet')||!d.open)return;
    if(d.dataset.volet)volet=d.dataset.volet;
    $$('.mini-volet',boite).forEach(function(x){if(x!==d)x.open=false;});
  },true);
  boite.addEventListener('input',function(ev){
    var t=ev.target;
    if(t.dataset.m){m[t.dataset.m]=t.value;return redessiner();}
    if(t.dataset.fond){m[t.dataset.fond]=t.value;return redessiner();}
    var oc=m.objets[sel];
    if(oc&&t.dataset.c){oc[t.dataset.c]=t.value;return redessiner();}
    var o=m.objets[sel];if(!o||!t.dataset.o)return;
    var k=t.dataset.o;
    if(k==='txt'){o.txt=t.value;return redessiner();}
    if(k==='taille'){o.taille=+t.value;return redessiner();}
    if(k==='gras'){o.gras=t.checked;return redessiner();}
    if(k==='police'){o.police=t.value==='rond'?undefined:t.value;
      return policesMiniPretes(m).then(redessiner);}
    if(k==='contourEp'){var avant=+o.contourEp>0;o.contourEp=+t.value;if(!o.contour)o.contour='#ffffff';
      if(!o.contourEp)delete o.contourEp;
      var sm=t.parentNode.querySelector('small');if(sm)sm.textContent=(+t.value)+' px';
      if(avant!==(+t.value>0))majSel();return redessiner();}
    if(k==='w'){var f=+t.value/o.w;o.w=+t.value;if(o.h&&o.t!=='texte')o.h*=f;}
    else if(k==='r'){o.r=+t.value;var sm2=t.parentNode.querySelector('small');if(sm2)sm2.textContent=o.r+'°';}
    else if(k==='src')o.src=+t.value;
    redessiner();
  });
  boite.addEventListener('click',function(ev){
    var q;
    if((q=ev.target.closest('[data-menu]')))return ouvrirMenu(q.dataset.menu);
    if((q=ev.target.closest('[data-addpage]')))
      return ajouter({t:'page',src:+q.dataset.addpage,x:600,y:900,w:500,r:0});
    if((q=ev.target.closest('[data-addtexte]'))){
      var ty=q.dataset.addtexte;
      if(ty==='bandeau')return ajouter(bandeauDefaut());
      return ajouter({t:'texte',x:600,y:860,w:700,r:0,txt:'Nouveau texte',taille:80,
        couleur:ty==='boite'?'#ffffff':MINI_NUIT,fond:ty==='boite'?MINI_NUIT:'',
        contourEp:ty==='contour'?10:undefined,contour:ty==='contour'?'#ffffff':undefined});
    }
    if((q=ev.target.closest('[data-addsym]')))
      return ajouter({t:'symbole',s:q.dataset.addsym,x:600,y:900,w:220,r:0,fond:MINI_NUIT,couleur:'#ffffff'});
    if((q=ev.target.closest('[data-addcalc]')))
      return ajouter({t:'outil',outil:'calcul',op:q.dataset.addcalc,graine:Math.floor(Math.random()*1e9),x:600,y:900,w:380,r:-4});
    if((q=ev.target.closest('[data-addoutil]'))){
      var no={t:'outil',outil:q.dataset.addoutil,graine:Math.floor(Math.random()*1e9),x:600,y:900,w:560,r:3};
      if(!imageOutil(no)){etat('Cet outil n’a pas d’exemple à montrer');return;}
      return ajouter(no);
    }
    if((q=ev.target.closest('[data-fondp]'))){var fp=q.dataset.fondp.split('|');m.fond1=fp[0];m.fond2=fp[1];
      $$('[data-fond]',boite).forEach(function(i){i.value=m[i.dataset.fond];});return redessiner();}
    var o=m.objets[sel];
    if((q=ev.target.closest('[data-sym]'))&&o){o.s=q.dataset.sym;majSel();return redessiner();}
    if((q=ev.target.closest('[data-forme]'))&&o){o.forme=q.dataset.forme;majSel();return redessiner();}
    if((q=ev.target.closest('[data-style]'))&&o){
      var stl=q.dataset.style, cadre=o.t==='titre'||o.t==='badge'||o.t==='bandeau';
      if(stl==='boite'){if(cadre){if(o.fond==='none')delete o.fond;}else o.fond=o.fond&&o.fond!=='none'?o.fond:MINI_NUIT;
        if((o.t==='texte'||o.t==='symbole')&&(!o.couleur||o.couleur===MINI_NUIT))o.couleur='#ffffff';delete o.contourEp;}
      else{if(cadre){o.fond='none';o.bord='none';}else o.fond='';
        if(stl==='contour'){o.contourEp=o.contourEp||10;o.contour=o.contour||'#ffffff';}else delete o.contourEp;
        /* sans boîte, un texte blanc deviendrait invisible : il repasse en bleu nuit */
        if((o.t==='texte'||o.t==='symbole')&&/^#fff(fff)?$/i.test(o.couleur||''))o.couleur=MINI_NUIT;}
      volet='style';majSel();return redessiner();
    }
    var cvb=ev.target.closest('[data-cv]');
    if(cvb){var cq=cvb.dataset.cv.split('|');if(o){o[cq[0]]=cq[1]||(cq[0]==='bord'||(cq[0]==='fond'&&o.t==='outil')?'none':'');
      if(!o[cq[0]])delete o[cq[0]];majSel();redessiner();}return;}
    var b=ev.target.closest('[data-act]');if(!b)return;
    var a=b.dataset.act;
    if(a==='fondbase'){delete m.fond1;delete m.fond2;$$('[data-fond]',boite).forEach(function(i){
      i.value=i.dataset.fond==='fond1'?'#ff9646':'#ff5a3c';});return redessiner();}
    if(a==='de'&&o){o.graine=Math.floor(Math.random()*1e9);return redessiner();}
    if(a==='ok'){
      policesMiniPretes(m).then(function(){
        R.doc.mini=m;R.doc.coverPerso=false;garderCover(m,imgs,info);
        enregistrer(true);etat('Miniature enregistrée');v.remove();
        if(fenetreExport.redessine)fenetreExport.redessine();
      });
      return;
    }
    if(a==='reset'){if(!confirm('Revenir à la mise en page de base ? Les ajouts seront retirés.'))return;
      m=miniDefaut(imgs.length);sel=-1;menu=null;return monter();}
    if(o){
      m.objets.splice(sel,1);
      if(a==='suppr')sel=-1;
      else{
        var ou=a==='devant'?m.objets.length:a==='derriere'?0
          :a==='avant'?Math.min(sel+1,m.objets.length):Math.max(sel-1,0);
        m.objets.splice(ou,0,o);sel=ou;
      }
    }
    majSel();redessiner();
  });
}

/* la miniature pour le .zip, refaite avec les pages du moment.
   u1 = le PDF niveau 1 élève s'il vient d'être fabriqué. */
function miniatureZip(u1){
  function vieille(){
    return coverPng().then(function(p){return p?{nom:'cover.png',data:p}:null;});}
  if(R.doc.coverPerso)return vieille();
  var id=R.id;
  return (u1?Promise.resolve(u1):pdfNiveau1()).then(pagesDuPdf).then(function(r){
    if(!R||R.id!==id)throw new Error('ressource changée entre-temps');
    var info={total:r.total,exos:compterExos()}, m=miniDe(r.pages);
    return policesMiniPretes(m).then(function(){return [r,info,m];});
  }).then(function(z){
    var r=z[0],info=z[1],m=z[2];
    garderCover(m,r.pages,info);enregistrer(true);
    return new Promise(function(ok){rendreMini(m,r.pages,info,MW).toBlob(ok,'image/jpeg',.9);});
  }).then(function(b){return b.arrayBuffer();})
    .then(function(a){return {nom:'miniature.jpg',data:new Uint8Array(a)};})
    .catch(vieille);
}

/* ============================================================
   LE .ZIP
   <Titre> (<classe>_<matiere>_<sujet>)/Niveau N/eleve.pdf …
   ============================================================ */
function cheminZip(niv,role){return 'Niveau '+niv+'/'+(role==='prof'?'prof':'eleve')+'.pdf';}
function dossierZip(){
  var titre=String(R.titre||'Ressource Laé').replace(/[\/\\:*?"<>|]+/g,'-')
    .replace(/\s+/g,' ').trim()||'Ressource Laé';
  var p=[R.niveau,R.matiere,R.sujet].filter(Boolean).map(poigneeDe);
  return titre+(p.length?' ('+p.join('_')+')':'');
}
/* la vignette en PNG ; dessinée automatiquement s'il n'y en a pas */
function coverPng(){
  if(!R.cover)faireCover(false);
  if(!R.cover)return Promise.resolve(null);
  return tailleImage(R.cover).then(function(im){
    var c=document.createElement('canvas');c.width=im.naturalWidth;c.height=im.naturalHeight;
    c.getContext('2d').drawImage(im,0,0);
    return new Promise(function(ok){c.toBlob(ok,'image/png');});
  }).then(function(b){return b?b.arrayBuffer():null;})
    .then(function(a){return a?new Uint8Array(a):null;})
    .catch(function(){return null;});
}
/* laisse la page afficher « en cours… » entre deux PDF ; onglet caché :
   le navigateur ralentit les minuteries, on n'attend donc pas */
function pause(){
  return new Promise(function(ok){if(document.hidden)ok();else setTimeout(ok,30);});
}

/* versions = [{niv, role}], suivi(i, 'encours'|'fait'|'erreur') */
/* fabrique les PDF des versions demandées : [{niv, role, pdf (Uint8Array) ou null}] */
function fabriquerPdfs(versions,suivi){
  var polices, imgs, out=[];
  suivi=suivi||function(){};
  return pdfOutils()
    .then(function(){return preparerPolices(versions);}).then(function(l){polices=l;})
    .then(function(){return preparerImages(versions);}).then(function(m){imgs=m;})
    .then(function(){
      return versions.reduce(function(pr,v,i){
        return pr.then(function(){suivi(i,'encours');return pause();}).then(function(){
          var u=faireUnPdf(v.niv,v.role,polices,imgs);
          out.push({niv:v.niv,role:v.role,pdf:u});
          suivi(i,u?'fait':'vide');
        });
      },Promise.resolve());
    })
    .then(function(){return out;});
}
function exporterZip(versions,suivi){
  var fichiers={}, dossier=dossierZip(), u1=null;
  return fabriquerPdfs(versions,suivi).then(function(l){
      l.forEach(function(x){
        if(x.pdf)fichiers[dossier+'/'+cheminZip(x.niv,x.role)]=[x.pdf,{level:0}];
        if(x.pdf&&x.niv==='1'&&x.role==='eleve')u1=x.pdf;});
    })
    .then(function(){return miniatureZip(u1);}).then(function(f){
      if(f)fichiers[dossier+'/'+f.nom]=[f.data,{level:0}];
      var zip=fflate.zipSync(fichiers);
      var blob=new Blob([zip],{type:'application/zip'});
      exporterZip.dernier={nom:dossier+'.zip',blob:blob,fichiers:Object.keys(fichiers)};
      var a=document.createElement('a');
      a.href=URL.createObjectURL(blob);a.download=dossier+'.zip';
      document.body.appendChild(a);a.click();a.remove();
      setTimeout(function(){URL.revokeObjectURL(a.href);},60000);
      return exporterZip.dernier;
    });
}

/* ============================================================
   EN ROUTE
   ============================================================ */
/* Docs Laé : c'est docs-lae-plus.js qui lance demarrer() */


